import React, { Fragment, Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { v4 as uuid } from "uuid";
import {
  COMPANY_NAME,
  KYC_URL,
  APP_URL,
  AGENT_PORTAL_URL,
  AGENT_SERVER_URL,
} from "../../../config/config";

import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import CreateIcon from "@material-ui/icons/Create";
import RestoreIcon from "@material-ui/icons/Restore";
import { ValidateEmail } from "../../../config/utility";

import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import DataTableExtended from "../../../components/Tables/DataTableExtended";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import Tooltip from "@material-ui/core/Tooltip";
import $ from "jquery";
import { withRouter, Link } from "react-router-dom";
import MenuItem from "@material-ui/core/MenuItem";
import { listForms } from "./../../../config/forms_api_calls";
import PasswordStrengthBar from "react-password-strength-bar";
import {
  listClientAllowedServices,
  getClientSettings,
  getAgreementPdf,
  getClientInfo,
  updateClientAllowedServices,
  listClients,
  listServicesGroups,
  listAssignedServicesWithProjection,
  listAssignedServicesAgreements,
  assignServicesToCompany,
  revokeClientSignedAgreements,
  sendUnsignedClientEmail,
  submitClientServicesData,
  getClientKycDetail,
  initiateClientKyc,
  emailKycDetails,
  resendActivation,
  notifyClientLogin,
  sendClientLoginUrlEmail,
  sendClientResetPasswordEmail,
  getCreditApplications,
  rejectCreditApplication,
  approveCreditApplication,
  listAgents,
  sendClientInvite,
  submitKycApproval,
  client_LoginSso,
  listAgentSharelinks,
  editClient,
  approveClientSignedAgreement,
  getClientArchivedAgreements,
  getClientArchivedAgreementsSingle,
  deleteClientArchivedAgreement,
  deleteClientAssignedAgreement,
  getServiceAgreement,
  addNewClientServiceAgreement,
  updateClientPremission,
  updateClientPremissionDirect,
  getClientAssignedForms,
  viewClientFormSubmission,
  allClientRejections,
  approveClientSubmission,
  rejectClientSubmission,
  listAllForms,
  assignFormToClients,
  getClientArchivedForms,
  unarchiveClientSubmission,
  unrevokeClientSubmission,
  updateClientPremissionMeta,
  listAllClientAgreements,
  assignAgreementsToClients,
  reassignClientArchivedAgreement,
  getMandatoryClientAgreements,
  getUnsignedClientAgreements,
  getEditClientEmailPreview,
  sendSubmissionLinkByEmail,
  getFccFiler,
  checkFilerIdExists,
  isFccIntegrationEnabled,
  approveClient,
  updateClientFilerIdAndOcn,
  getClientOcns,
  saveClientOcns,
  revokeClientFcc,
  rejectClientFccFiler,
  listParentEligibleClients,
  convertClientToSubClient,
  addClientCredit,
  getClientCreditSummary,
  getClientCreditLedger,
} from "./../../../config/api_calls";
import PaginatedTable from "../../../components/Tables/PaginatedTable";
import {
  ListClientAssignRoles,
  editClientAssignRole,
  get_onboarding_user,
  save_onboarding_user,
} from "../../../config/client_role_api_calls";
import { getClientAgreementSigneeDetails } from "../../../config/signed_agreements_api_calls";
import {
  getIntegration,
  getCustomSettings,
  getForgotPasswordLink,
  getClientRegistrationSettings,
  getOutboundSBCConfig,
  getSipnavAccountDetails,
} from "./../../../config/reseller_api_calls";
import {
  getClientNotificationSettings,
  submitClientNotificationSettings,
} from "./../../../config/general_api_calls";
import { addSettings, addMsaInfo } from "../../../actions";
import DataTable from "../../../components/Tables/DataTable";
import { tableLoader } from "../../../components/ContentLoaders/table_loader";
import { FormLoader } from "../../../components/ContentLoaders/newLoaders/Form";
import { HelpLinksLoader } from "../../../components/ContentLoaders/newLoaders/HelpLinksLoader";
import MsaWarning from "../ExtraComponents/MsaWarning";
import SettingsError from "../ExtraComponents/SettingsError";
import PageTitle from "../ExtraComponents/PageTitle";
import HelperClass from "./../../../config/helperClass";
import MutextField from "@material-ui/core/TextField";
import dateFormat, { masks } from "dateformat";
import {
  THEME_TEXT_COLOR,
  THEME_COLOR,
  columnsClients,
} from "./../../../config/config";
import makeAnimated from "react-select/animated";
import countryList from "react-select-country-list";
//import { CKEditor } from "@ckeditor/ckeditor5-react";
//import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import Chip from "@material-ui/core/Chip";
import RichTextEditorComponent from "../../../components/Reseller/RichTextEditorComponent";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import Checkbox from "@material-ui/core/Checkbox";
import { PhoneNumberUtil } from "google-libphonenumber";
import Autocomplete from "@material-ui/lab/Autocomplete";
import ReactPhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import localization from "../../../localization/localization";
import UserPermissionHelper from "../../../components/Reseller/UserPermissionHelper";
import FccFilerAutocomplete from "../../../components/InputFields/FccFilerAutocomplete";
import NotificationToast from "../../../components/Notification/NotificationToast";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

const MuiTextField = MutextField;
const animatedComponents = makeAnimated();
const auth = new HelperClass();
class ViewClient extends Component {
  constructor() {
    super();
    this.state = {
      toastMessage: "",
      toastType: "success",
      toastTitle: "",
      tableData: [],
      tableLoader: true,
      formLoader: true,
      signupLoader: true,
      sharelinkLoader: false,
      showServiceLoader: true,
      value: "",
      didArray: [],
      tfnArray: [],
      termArray: [],
      smsArray: [],
      liveagentArray: [],
      ivrArray: [],
      teamsArray: [],
      tfnTermArray: [],
      azTermArray: [],
      cnamArray: [],

      did_service: "",
      tfn_service: "",
      term_service: "",
      sms_service: "",
      ivr_service: "",
      teams_service: "",
      tfn_term_service: "",
      az_term_service: "",
      cnam_service: "",
      liveagent_service: "",

      loginErrorMessage: "",
      login_url: "",
      showLoginModal: false,

      filer_id: "",

      signedData: [],
      unsignedData: [],
      isRevokeReasonActive: false,
      revoke_reason: "",
      unsigned_email_agreement_accountno: 0,
      liveagent_service: "",
      serviceData: [],
      serviceAssignedData: [],
      packagesAssignedData: [],
      client_services_welcome_content: "",
      client_services_email: "",
      company_id: "",
      company_title: "",
      successMessage: "",
      successMessageAgreements: "",
      disabled: false,
      disabledDirect: false,
      showSendEmail: false,
      nrc_did: "",
      mrc_did: "",
      rate_did: "",
      nrc_tfn: "",
      mrc_tfn: "",
      rate_tfn: "",
      rate_term: "",
      rate_ivr: "",
      rate_liveagent: "",
      rate_smsin: 0,
      rate_smsout: 0,
      errorMessage: "",
      errorMessageAgreements: "",
      errorMessageArchiveAgreements: "",
      extra_details: [],
      emptyService: 0,
      all_client_data: [],
      kyc_details: [],
      kyc_key: "",
      steps_allowed: 0,
      steps_completed: 0,
      completed_percentage: 0,
      showKycApproved: false,
      showApprovedAction: "",
      showRejectAction: "",
      loading_button: false,
      kycErrorMessage: "",
      kycSuccessMessage: "",
      client_register_date: "",
      activation_button: false,
      activation_tick: false,
      activation_cross: false,
      client_services_client_id: "",
      client_accountno: "",
      kyc_email_address: "",
      kyc_approved: "",
      credit_applications: [],
      processing_request: false,
      creditErrorMessage: "",
      creditSuccessMessage: "",
      application_no: "",
      rejection_container: false,
      rejection_reason: "",
      select_agent: "",
      client_email: "",
      client_name: "",
      clientErrorMessage: "",
      clientSuccessMessage: "",
      selected_agent: null,
      selected_agent_accountno: "",
      all_active_agents: [],
      all_sharelinks: [],
      sharelinkErrorMessage: "",
      client_comp_name: "",
      client_update_name: "",
      client_name_initials: "",
      client_title: "",
      client_update_email: "",

      client_phone: "",
      client_address: "",
      client_address2: "",
      client_country: "",
      client_city: "",
      client_state: "",
      client_zip: "",
      client_status: "",
      client_password: "",
      client_confirm_password: "",
      errorClientTitle: "",
      errorClientEmail: "",
      errorClientPhone: "",
      errorClientPass: "",
      errorClientAddress: "",
      errorClientCountry: "",
      errorClientCity: "",
      errorClientState: "",
      errorClientZip: "",
      errorClientMessage: "",
      errorClientMessageEdit: "",
      successClientMessage: "",
      successClientMessageEdit: "",
      isApproveActive: false,
      approve_client_id: "",
      approve_agreement_accountno: "",

      selected_products: [],
      checkAll: false,
      update_service_button: false,
      assignedErrorMessage: "",
      assignedSuccessMessage: "",
      assignedLoader: true,
      activeTab: "agreements",
      isEditorReady: false,
      notifyCheckBox: false,
      assignParentClientRole: false,
      selectedParentClient: "",
      parentEligibleClients: [],
      parentClientLoading: false,
      totalClientAgreements: 0,
      signedClientAgreements: 0,
      unsignedClientAgreements: 0,
      totalSalesOrders: 0,
      paidSalesOrders: 0,
      completedSalesOrders: 0,
      kyc_percentage: 0,
      client_account_status: "",

      errorMessageAgentRole: "",
      successMessageAgentRole: "",
      assignRoleData: [],
      assignSubRoleData: [],
      changedRolesRights: [],
      changedSubRolesRights: [],
      subchangedRolesRights: [],
      subchangedSubRolesRights: [],
      checkedRoleIds: [],
      checkedSubRoleIds: [],
      checkedName: "",
      checkedEmail: "",

      useGooglePlaces: true,
      toggleButtonText: "Allow PO Box Address",

      statusChanged: false,

      selected_client_accountno: "",
      signee_details: [],
      selected_agreement_id: "",

      uploadErrorTitle: "",
      uploadErrorMessage: "",
      uploadSuccessMessage: "",
      upload_agreement_button: false,
      add_picture: "",
      add_picture_name: "",

      archivedAgreements: [],
      archivedAgreementsDetails: [],
      processing_request_archived: false,
      errorMessageArchivedDetails: "",
      delete_archive_id: "",
      successMessageDelete: "",
      errorMessageDelete: "",

      client_isVerified: "",

      removeErrorTitle: "",
      removeErrorMessage: "",
      removeSuccessMessage: "",
      remove_agreement_button: false,

      addErrorTitle: "",
      addErrorMessage: "",
      addSuccessMessage: "",
      add_agreement_button: false,
      add_service_text: "",
      selected_service_id: "",
      show_add_button: true,
      editLink: "",

      isEnableChecked: false,
      status: "",
      isEnableCheckedDirect: false,
      statusDirect: "",
      va_intergation: "No",

      formsAssignedData: [],
      formsErrorMessageTitle: "",
      formsErrorMessage: "",
      formsSuccessMessage: "",
      extra_files: [],
      extra_files_clients: [],
      errorMessageTotals: "",
      errorMessageTotalsTitle: "",
      viewClientSubmissions: [],
      rejectClientErrorMessage: "",
      rejectClientSuccessMessage: "",
      allClientRejectionsListing: [],
      form_title: "",
      form_accountno: "",
      client_submission_id: "",
      client_submission_type: "",
      approveClientErrorMessage: "",
      approveClientSuccessMessage: "",
      approve_client_button: false,
      form_token: "",
      reject_client_reason: "",
      assignModalLoader: true,
      clientsList: [],
      selectedForms: [],
      selectAllClients: false,
      errorMessageAssignModal: "",
      successMessageAssignModal: "",
      disableAssignBtn: false,
      archivedForms: [],
      errorMessageArchiveForms: "",
      rejection_date: "",
      rejection_reason: "",
      isProcessingUnarchive: false,
      errorMessageUnarchive: "",
      successMessageUnarchive: "",

      isProcessingUnrevoke: false,
      errorMessageUnrevoke: "",
      successMessageUnrevoke: "",
      unrevokeFormToken: "",
      unrevokeFormAccountno: "",

      register_type: "",
      sharelink_hash: "",
      sharelink_service_id: "",
      sharelink_title: "",
      sharelink_external_link: "",

      progressPercentage: 0,

      isEnableCheckedMeta: false,
      meta_intergation: "No",

      archive_date: "",
      loginDetails: [],

      selectedAgreements: [],
      errorMessageAssignAgreement: "",
      successMessageAssignAgreement: "",

      reassign_archive_id: "",
      errorMessageReassign: "",
      successMessageReassign: "",

      passwordShown: false,
      confirmPasswordShown: false,

      isEmailChanged: false,
      proceedAfterEmailModal: false,
      showEmailWarning: false,
      original_client_update_email: "",

      submission_link: "",
      deleteLoader: false,
      address_autocomplete: true,
      address_validation: true,
      is_fcc_enabled: "No",
      has_fcc_filer_id: false,
      errorFilerId: "",
      fccLoading: false,
      fccSuccess: false,
      fcc_data: null,
      lastVerifiedFilerId: "",
      filerIdAlreadyExists: false,
      fcc_filing_url: "",

      notification_form_token: "",
      notification_scheduler: false,
      schedule_div: false,
      repeat_count: 7,
      repeat_interval: 24,
      initial_reminder_interval: 2,
      notification_loader: false,
      notificationErrorMsg: "",
      notificationSuccessMsg: "",
      missing_form_settings: "No",

      resetLink: "",
      copied: false,
      copiedSub: false,
      copiedLogin: false,
      copiedResetPassword: false,
      successMessageSub: "",
      showMailForm: false,
      mailName: "",
      mailEmail: "",
      mailComment: "",
      successMessageMail: "",
      errorMessageMail: "",

      notifyLoginLoading: false,
      notifyLoginSuccess: "",
      notifyLoginError: "",
      editClientLoading: false,
      
      loginUrl: "",
      sendingLoginEmail: false,
      sendingResetPasswordEmail: false,
      loginEmailSent: false,
      resetPasswordEmailSent: false,
      loginEmailError: "",
      resetPasswordEmailError: "",

      permissionsState: [],
      permission_edit_client: 0,
      permission_approve_agreement: 0,
      permission_reject_agreement: 0,
      permission_view_agreement: 0,
      permission_approve_form_submission: 0,
      permission_reject_form_submission: 0,
      permission_view_form_submission: 0,
      permission_edit_form_submission: 0,
      permission_view_submission_rejections: 0,
      permission_edit_submission_notifications: 0,
      permission_view_client_sso: 0,
      permission_assigned_products: 0,
      permission_assign_form: 0,
      permission_archived_forms: 0,
      permission_edit_client_menu: 0,
      permission_manage_integrations: 0,
      permission_forogt_password_link: 0,
      permission_view_signee: 0,
      permission_upload_agreement: 0,
      permission_remove_agreement: 0,
      isApproved: 0,
      approveClientButtonLoading: false,
      approveClientModalErrorMessage: "",
      approveClientModalSuccessMessage: "",
      approvalNotes: "",
      approvalNotesError: "",

      rejectClientButtonLoading: false,
      rejectClientModalErrorMessage: "",
      rejectClientModalSuccessMessage: "",
      rejectClientReason: "",
      showRejectReasonField: false,

      showAddFilerIdModal: false,
      addFilerIdValue: "",
      addFilerIdLoading: false,
      addFilerIdSuccess: false,
      addFilerIdError: "",
      addFilerIdFccData: null,
      ocnValues: [],
      ocnFixedValues: [],
      addFilerIdSuccessMsg: "",

      showUpdateOcnModal: false,
      updateOcnValues: [],
      updateOcnLoading: false,
      updateOcnError: "",
      updateOcnSuccess: "",
      updateOcnWarning: "",

      showRevokeFccModal: false,
      revokeClientFccLoading: false,
      revokeClientFccError: "",
      revokeClientFccSuccess: "",

      fccToastMessage: "",
      fccToastType: "success",

      showFccDataModal: false,
      fccDataModalLoading: false,
      fccDataModalData: null,
      fccDataModalError: "",

      clientOcns: [],
      // Onboarding Settings
      onboardingItems: [],
      onboardingErrorMessage: "",
      onboardingErrorMessageTitle: "",
      onboardingSuccessMessage: "",
      onboardingItemsWithErrors: [],
      onboarding_save_loading: false,
      newStepCounter: 0,
      onboardingTitle: "",
      onboardingMessage: "",

      // Edit Onboarding Form
      editOnboardingId: "",
      editOnboardingTitle: "",
      editOnboardingForm: "",
      editOnboardingAnswerType: "",
      editOnboardingAllowSkip: false,
      editOnboardingAllowEnable: false,
      editOnboardingAllowAI: false,
      questionErrorMessage: "",
      questionErrorMessageTitle: "",
      questionSuccessMessage: "",
      add_question_loader: false,
      formsLoading: false,
      formsList: [],
      editOnboardingType: "form",
      addOnboardingType: "form",
      editOnboardingAgreement: "",
      editOnboardingAgreementTitle: "",
      editOnboardingAgreementInstruction: "",
      clientAgreementsList: [],
      clientAgreementsLoading: false,

      // Delete Onboarding Modal
      onboarding_id: "",
      onboardingErrorMessageDelete: "",
      onboardingSuccessMessageDelete: "",
      CustomErrorMessageDomainDel: "",
      CustomSuccessMessageDomainDel: "",
      isProcessing: false,

      onboarding_percentage: 0,
      total_onboarding_steps: 0,
      onboarding_progress: 0,
      registrationFieldSettings: {},

      // Client Credits (ledger-based)
      creditSummary: { total_credit: 0, total_used: 0, balance: 0 },
      creditRecent: [],
      creditSummaryLoading: false,
      creditSummaryError: "",

      addCreditAmount: "",
      addCreditDate: new Date().toISOString().split("T")[0],
      addCreditPaymentMethod: "Bank ACH",
      addCreditReference: "",
      addCreditMemo: "",
      addCreditError: "",
      addCreditSuccess: "",
      addCreditLoading: false,

      ledgerRows: [],
      ledgerPage: 1,
      ledgerLimit: 10,
      ledgerTotal: 0,
      ledgerLoading: false,
      ledgerError: "",

      // SBC Settings tab
      sipnavEnabled: false,
      sipnavLoading: false,
      sipnavAccount: null,
      sipnavRateDecks: [],
      sipnavAccountLoading: false,
      sipnavAccountError: null,
      sipnavRateDeckOpenIndex: null,
    };
    this.countryOptions = countryList()
      .getData()
      .filter(
        (country) => country.label !== "United States Minor Outlying Islands",
      );
  }

  async componentDidMount() {
    let tab_type = this.props.props.match.params.tab_type;
    let client_accountno = this.props.props.match.params.client_accountno;
    this.setState({
      client_accountno: client_accountno,
    });
    // Allow deep-links like /viewClient/<accountno>/<tab> to land on a tab.
    const allowedTabs = [
      "agreements",
      "assigned_products",
      "onboarding_settings",
      "forms",
      "notes",
    ];
    if (tab_type && allowedTabs.indexOf(tab_type) !== -1) {
      this.setState({ activeTab: tab_type });
    }

    // Attach event listener for manual modal close (Bootstrap hidden.bs.modal event)
    window.$("#modalDefaultLogin").on("hidden.bs.modal", () => {
      if (this.state.showLoginModal) {
        this.setState({ showLoginModal: false });
      }
    });
    const getClientInfoResponce = await getClientInfo(
      auth.getAccount(),
      auth.getToken(),
      client_accountno,
    );
    /*console.log(
      "getClientInfoResponce.data.data : ",
      getClientInfoResponce.data
    );*/
    if (
      getClientInfoResponce.data.data.status === 403 ||
      getClientInfoResponce.data.data.errors === "authentication missing" ||
      getClientInfoResponce.data.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      getClientInfoResponce.data.data.status === 404 ||
      getClientInfoResponce.data.data.note === "missing"
    ) {
      // window.location.replace("/error");
      // console.log("settings missing");
      this.setState({
        tableLoader: false,
      });
    } else if (
      getClientInfoResponce.data.data.status === 200 &&
      getClientInfoResponce.data.data.message === "success"
    ) {
      const client_initials = getClientInfoResponce.data.data.name
        ? getClientInfoResponce.data.data.name
            .split(" ")
            .map((word) => {
              const firstChar = word.charAt(0);
              return /^[a-zA-Z]+$/.test(firstChar) ? firstChar : "";
            })
            .join("")
        : "N/A";
      let kyc_percentage =
        (100 / getClientInfoResponce.data.data.steps_allowed) *
        getClientInfoResponce.data.data.steps_completed;

      const enableStatus =
        getClientInfoResponce.data.data.clientIntegrationPermission &&
        getClientInfoResponce.data.data.clientIntegrationPermission.length > 0
          ? getClientInfoResponce.data.data.clientIntegrationPermission[0]
              .enable
          : "No";
      const isEnableChecked = enableStatus === "Yes";

      const enableStatusDirect =
        getClientInfoResponce.data.data.clientIntegrationPermission &&
        getClientInfoResponce.data.data.clientIntegrationPermission.length > 0
          ? getClientInfoResponce.data.data.clientIntegrationPermission[0]
              .direct_sso
          : "No";
      const isEnableCheckedDirect = enableStatusDirect === "Yes";

      const enableStatusMeta =
        getClientInfoResponce.data.data.clientIntegrationPermissionMeta &&
        getClientInfoResponce.data.data.clientIntegrationPermissionMeta.length >
          0
          ? getClientInfoResponce.data.data.clientIntegrationPermissionMeta[0]
              .enable
          : "No";
      const isEnableCheckedMeta = enableStatusMeta === "Yes";

      // Extract OCNs from fcc_data
      let clientOcns = [];
      let fccFilingUrl = "";
      if (
        getClientInfoResponce.data.data.fcc_data &&
        getClientInfoResponce.data.data.fcc_data.length > 0 &&
        getClientInfoResponce.data.data.fcc_data[0].ocn
      ) {
        if (getClientInfoResponce.data.data.fcc_data[0].ocn) {
          const ocnString = getClientInfoResponce.data.data.fcc_data[0].ocn;
          clientOcns = ocnString
            .split(",")
            .map((ocn) => ocn.trim())
            .filter((ocn) => ocn !== "");
        }
        if (getClientInfoResponce.data.data.fcc_data[0].filing_url) {
          fccFilingUrl = getClientInfoResponce.data.data.fcc_data[0].filing_url;
        }
      }

      this.setState({
        client_comp_name: getClientInfoResponce.data.data.comp_name,
        client_update_name: getClientInfoResponce.data.data.name,
        client_title: getClientInfoResponce.data.data.title,
        client_update_email: getClientInfoResponce.data.data.email,
        kyc_email_address: getClientInfoResponce.data.data.email,
        client_phone: getClientInfoResponce.data.data.phone,
        client_address: getClientInfoResponce.data.data.address,
        client_address2: getClientInfoResponce.data.data.address2,
        client_country: getClientInfoResponce.data.data.country,
        client_city: getClientInfoResponce.data.data.city,
        client_state: getClientInfoResponce.data.data.state,
        client_zip: getClientInfoResponce.data.data.zip,
        client_status: getClientInfoResponce.data.data.isVerified,
        client_name_initials: client_initials,
        totalClientAgreements: getClientInfoResponce.data.data.totalAgreements,
        signedClientAgreements:
          getClientInfoResponce.data.data.signedAgreements,
        unsignedClientAgreements:
          getClientInfoResponce.data.data.unsignedAgreements,
        totalSalesOrders: getClientInfoResponce.data.data.totalOrders,
        paidSalesOrders: getClientInfoResponce.data.data.paidOrders,
        completedSalesOrders: getClientInfoResponce.data.data.completedOrders,
        kyc_percentage: kyc_percentage.toFixed(0),
        filer_id: getClientInfoResponce.data.data.filer_id,
        client_isVerified: getClientInfoResponce.data.data.isVerified,
        clientIntegrationPermission:
          getClientInfoResponce.data.data.clientIntegrationPermission,
        isEnableChecked: isEnableChecked,
        status: isEnableChecked ? "enable" : "disable",
        isEnableCheckedDirect: isEnableCheckedDirect,
        statusDirect: isEnableCheckedDirect ? "enable" : "disable",
        isEnableCheckedMeta: isEnableCheckedMeta,
        statusMeta: isEnableCheckedMeta ? "enable" : "disable",
        register_type: getClientInfoResponce.data.data.register_type,
        sharelink_hash: getClientInfoResponce.data.data.sharelink_hash,
        sharelink_service_id:
          getClientInfoResponce.data.data.sharelink_service_id,
        sharelink_title: getClientInfoResponce.data.data.sharelink_title,
        sharelink_external_link:
          getClientInfoResponce.data.data.sharelink_external_link,
        loginDetails: getClientInfoResponce.data.data.clientLoginDetails,
        original_client_update_email: getClientInfoResponce.data.data.email,
        isApproved: getClientInfoResponce.data.data.isApproved,
        clientOcns: clientOcns,
        fcc_filing_url: fccFilingUrl,
        onboarding_total_steps:
          getClientInfoResponce.data.data.onboarding_total_steps || 0,
        onboarding_progress:
          getClientInfoResponce.data.data.onboarding_progress || 0,
      });
      //console.log("this.state.kyc_percentage: ", this.state.kyc_percentage);
    } else {
      // window.location.replace("/error");
    }
    this.clientAgreements();
    this.get_integration_data();
    this.getCustomSettings();
    await this.loadRegistrationSettings();
    this.loadCreditSummary();
    this.checkSipnavStatus();
  }

  // Centralized notification toast. Clearing first lets identical
  // consecutive messages re-trigger the slide-in animation.
  showToast = (message, type = "error", title) => {
    const cleaned = String(message || "")
      .replace(/<br\s*\/?\s*>/gi, " ")
      .replace(/<[^>]*>/g, "")
      .replace(/\s+/g, " ")
      .trim();
    if (cleaned === "") return;
    this.setState({ toastMessage: "" }, () =>
      this.setState({
        toastMessage: cleaned,
        toastType: type,
        toastTitle:
          title ||
          (type === "success"
            ? "Success"
            : type === "warning"
              ? "Warning"
              : type === "error"
                ? "Error"
                : "Info"),
      }),
    );
  };

  // Bridge: any error/success/warning message state field that becomes a
  // newly-set non-empty string is surfaced as a toast (the inline alerts that
  // used to render these were removed). On a success, any open Bootstrap modal
  // is also closed — this is the "modal closes when the API returns 200"
  // behavior, since success copy is only set on a 200 response.
  fireMessageToasts = (prevState) => {
    const keys = Object.keys(this.state);
    for (const k of keys) {
      // Only consider message-bearing fields by name.
      if (!/(message|msg|error|success|warning)/i.test(k)) continue;
      // `toast*` are the toast's own fields (avoid self-retriggering); `*Title`
      // fields are companion titles, not messages.
      if (/^toast/i.test(k) || /title$/i.test(k)) continue;

      const val = this.state[k];
      // React only to non-empty string transitions (skips boolean flags like
      // `fccSuccess` and `null` defaults like `sipnavAccountError`).
      if (typeof val !== "string" || val === "" || val === prevState[k]) continue;
      // Skip field-highlight markers (e.g. `errorClientEmail: "error"`).
      if (val.toLowerCase() === "error") continue;

      let type;
      if (/success/i.test(k)) {
        type = "success";
      } else if (/warning/i.test(k)) {
        type = "warning";
      } else {
        // *Error*/generic: client-side validation copy → warning, else error.
        type =
          /\b(required|invalid|please|must|select|enter|provide|valid|choose|cannot|missing|empty)\b/i.test(
            val,
          )
            ? "warning"
            : "error";
      }

      const title = this.state[k + "Title"] || undefined;
      this.showToast(val, type, title);

      if (type === "success") {
        // Auto-close any open modal on success.
        window.$(".modal.show").modal("hide");
      }
      break; // surface the first newly-set message this cycle
    }
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevState) this.fireMessageToasts(prevState);

    if (prevProps.userRoleItems !== this.props.userRoleItems) {
      const canEdit = UserPermissionHelper.getAllRoles(
        this.props.userRoleItems,
        "clients",
        "view_client",
      );

      this.setState({
        permissionsState: canEdit,
        permission_edit_client: canEdit[0].edit_client,
        permission_approve_agreement: canEdit[0].approve_agreement,
        permission_reject_agreement: canEdit[0].reject_agreement,
        permission_view_agreement: canEdit[0].view_agreement,
        permission_approve_form_submission: canEdit[0].approve_form_submission,
        permission_reject_form_submission: canEdit[0].reject_form_submission,
        permission_view_form_submission: canEdit[0].view_form_submission,
        permission_edit_form_submission: canEdit[0].edit_form_submission,
        permission_view_submission_rejections:
          canEdit[0].view_submission_rejections,
        permission_edit_submission_notifications:
          canEdit[0].edit_submission_notifications,
        permission_view_client_sso: canEdit[0].view_client_sso,
        permission_assigned_products: canEdit[0].assigned_products,
        permission_assign_form: canEdit[0].assign_form,
        permission_archived_forms: canEdit[0].archived_forms,
        permission_edit_client_menu: canEdit[0].edit_client_menu,
        permission_manage_integrations: canEdit[0].manage_integrations,
        permission_forogt_password_link: canEdit[0].forgot_password_link,
        permission_view_signee: canEdit[0].view_signee,
        permission_upload_agreement: canEdit[0].upload_agreement,
        permission_remove_agreement: canEdit[0].remove_agreement,
      });
    }

    // Sync React state with jQuery modal
    if (prevState && prevState.showLoginModal !== this.state.showLoginModal) {
      this.toggleLoginModal(this.state.showLoginModal);
    }
  }

  checkSipnavStatus = async () => {
    try {
      const res = await getOutboundSBCConfig(auth.getAccount(), auth.getToken());
      if (
        res.data &&
        res.data.status === 200 &&
        res.data.data &&
        res.data.data.is_enabled == 1
      ) {
        this.setState({ sipnavEnabled: true, sipnavLoading: true });
        try {
          await this.fetchSipnavAccountDetails(true);
        } finally {
          this.setState({ sipnavLoading: false });
        }
      }
    } catch (e) {
      // Outbound SBC status check failure is non-critical — tab stays hidden
    }
  };

  fetchSipnavAccountDetails = async (silentCheck) => {
    if (!silentCheck) {
      this.setState({ sipnavAccountLoading: true, sipnavAccountError: null });
    }
    try {
      const res = await getSipnavAccountDetails(
        auth.getAccount(),
        this.state.client_accountno,
        auth.getToken()
      );
      if (!res.data.success) {
        this.setState({
          sipnavHasAccount: false,
          sipnavAccountLoading: false,
          sipnavAccountError: silentCheck ? null : (res.data.message || "Failed to load SBC account details"),
        });
        return;
      }
      if (!res.data.sipnav_enabled || !res.data.has_account) {
        this.setState({
          sipnavHasAccount: false,
          sipnavAccountLoading: false,
          sipnavAccount: null,
          sipnavRateDecks: [],
        });
        return;
      }
      this.setState({
        sipnavHasAccount: true,
        sipnavAccountLoading: false,
        sipnavAccount: res.data.account || null,
        sipnavRateDecks: res.data.rateDecks || [],
        sipnavAccountError: null,
      });
    } catch (e) {
      this.setState({
        sipnavHasAccount: false,
        sipnavAccountLoading: false,
        sipnavAccountError: silentCheck ? null : "Unable to reach server. Please try again.",
      });
    }
  };

  toggleLoginModal = (show) => {
    const $modal = window.$("#modalDefaultLogin");
    if (show) {
      // Ensure modal is shown
      if (!$modal.hasClass("show")) {
        $modal.modal("show");
      }
    } else {
      // Ensure modal is hidden
      if ($modal.hasClass("show")) {
        $modal.modal("hide");
      }
    }
  };

  loginDetailView = () => {
    this.setState({ successMessage: "", errorMessage: "" });
    window.$("#modalLoginDetail").modal("show");
  };

  updateClientPremission = async () => {
    const { client_accountno, status } = this.state;
    this.setState({
      successMessage: "",
      errorMessage: "",
      disabled: true,
    });

    const servicesResponce = await updateClientPremission(
      auth.getAccount(),
      auth.getToken(),
      client_accountno,
      status,
    );
    //console.log("updateClientPremission.data: ", servicesResponce.data);
    this.setState({
      disabled: false,
    });
    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
      return;
    } else if (servicesResponce.data.status === 406) {
      this.setState({
        errorMessage:
          "There is an error while updating the permission. Please try again.",
      });
      //window.location.replace("/error");
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        errorMessage:
          "There is an error while updating the permission. Please try again.",
      });
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        successMessage: "Permission updated successfully",
        isApproveActive: false,
      });
    } else {
      this.setState({
        errorMessage:
          "There is an error while updating the permission. Please try again.",
      });
    }
    setTimeout(() => {
      this.setState({ successMessage: "", errorMessage: "" });
    }, 4000);
  };

  updateClientPremissionDirect = async () => {
    const { client_accountno, statusDirect } = this.state;
    this.setState({
      successMessage: "",
      errorMessage: "",
      disabledDirect: true,
    });

    const servicesResponce = await updateClientPremissionDirect(
      auth.getAccount(),
      auth.getToken(),
      client_accountno,
      statusDirect,
    );
    //console.log("updateClientPremissionDirect.data: ", servicesResponce.data);
    this.setState({
      disabledDirect: false,
    });
    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
      return;
    } else if (servicesResponce.data.status === 406) {
      this.setState({
        errorMessage:
          "There is an error while updating the permission. Please try again.",
      });
      //window.location.replace("/error");
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        errorMessage:
          "There is an error while updating the permission. Please try again.",
      });
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        successMessage: "Permission updated successfully",
        isApproveActive: false,
      });
    } else {
      this.setState({
        errorMessage:
          "There is an error while updating the permission. Please try again.",
      });
    }
    setTimeout(() => {
      this.setState({ successMessage: "", errorMessage: "" });
    }, 4000);
  };

  handleEditornNotes = (updatedContent) => {
    //console.log("updatedContent: ", updatedContent);
    this.setState({ client_services_welcome_content: updatedContent });
  };

  updateClientPremissionMeta = async () => {
    const { client_accountno, statusMeta } = this.state;
    this.setState({
      successMessage: "",
      errorMessage: "",
      disabledMeta: true,
    });

    const servicesResponce = await updateClientPremissionMeta(
      auth.getAccount(),
      auth.getToken(),
      client_accountno,
      statusMeta,
    );
    //console.log("updateClientPremissionMeta.data: ", servicesResponce.data);
    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
      return;
    } else if (servicesResponce.data.status === 406) {
      this.setState({
        errorMessage:
          "There is an error while updating the permission. Please try again.",
      });
      //window.location.replace("/error");
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        errorMessage:
          "There is an error while updating the permission. Please try again.",
        disabledMeta: false,
      });
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        successMessage: "Permission updated successfully",
        isApproveActive: false,
        disabledMeta: false,
      });
    } else {
      this.setState({
        errorMessage:
          "There is an error while updating the permission. Please try again.",
        disabledMeta: false,
      });
    }
    setTimeout(() => {
      this.setState({ successMessage: "", errorMessage: "" });
    }, 4000);
  };

  handleEnableChangeMeta = () => {
    this.setState(
      (prevState) => {
        const newStatusMeta = prevState.isEnableCheckedMeta
          ? "disable"
          : "enable";
        return {
          isEnableCheckedMeta: !prevState.isEnableCheckedMeta,
          statusMeta: newStatusMeta,
        };
      },
      () => {
        // console.log(`StatusMeta changed to: ${this.state.statusMeta}`);
      },
    );
  };

  modalOpenIntegration = () => {
    window.$("#modalEditIntegration").modal("show");
  };

  modalOpenForgotPasswordLink = () => {
    this.setState({
      notifyLoginLoading: true,
      notifyLoginSuccess: "",
      notifyLoginError: "",
      resetLink: "",
      loginUrl: `${AGENT_PORTAL_URL}onboardsoft/client/login`,
      copiedLogin: false,
      copiedResetPassword: false,
      loginEmailSent: false,
      resetPasswordEmailSent: false,
      loginEmailError: "",
      resetPasswordEmailError: "",
    });
    this.openNotificationModal();
  };

  copyToClipboard = (type) => {
    const textToCopy = type === "login" ? this.state.loginUrl : this.state.resetLink;
    const stateKey = type === "login" ? "copiedLogin" : "copiedResetPassword";
    
    navigator.clipboard.writeText(textToCopy).then(() => {
      this.setState({
        successMessage: "Link Copied Successfully!",
        [stateKey]: true,
      });
      setTimeout(
        () => this.setState({ successMessage: "", [stateKey]: false }),
        2000,
      );
    });
  };

  openNotificationModal = async () => {
    // Fetch reset password link
    try {
      const servicesResponce = await getForgotPasswordLink(
        auth.getAccount(),
        auth.getToken(),
        this.state.client_update_email,
        this.state.client_accountno,
      );

      if (
        servicesResponce.data.status === 403 ||
        servicesResponce.data.errors === "authentication missing" ||
        servicesResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (
        servicesResponce.data.status === 200 &&
        servicesResponce.data.message === "success"
      ) {
        this.setState(
          {
            resetLink: servicesResponce.data.data.data,
            notifyLoginLoading: false,
          },
          () => {
            window.$("#modalNotificationLinks").modal("show");
          },
        );
      } else {
        this.setState({ 
          notifyLoginError: "Unable to generate reset password link.",
          notifyLoginLoading: false 
        });
      }
    } catch (e) {
      this.setState({ 
        notifyLoginError: "Failed to generate links.",
        notifyLoginLoading: false 
      });
    }
  };

  sendEmailUrl = async (type) => {
    const statePrefix = type === "login" ? "login" : "resetPassword";
    const urlToSend = type === "login" ? this.state.loginUrl : this.state.resetLink;
    const emailType = type === "login" ? "Login URL" : "Reset password";
    
    this.setState({
      [`sending${statePrefix.charAt(0).toUpperCase() + statePrefix.slice(1)}Email`]: true,
      [`${statePrefix}EmailSent`]: false,
      successMessage: "",
      errorMessage: "",
    });

    try {
      const apiCall = type === "login" 
        ? sendClientLoginUrlEmail 
        : sendClientResetPasswordEmail;
        
      const response = await apiCall(
        auth.getAccount(),
        auth.getToken(),
        this.state.client_accountno,
        urlToSend,
      );

      if (
        response.data.status === 403 ||
        response.data.errors === "authentication missing" ||
        response.data.errors === "jwt expired"
      ) {
        this.setState({ 
          errorMessage: "Authentication error"
        });
      } else if (
        response.data.status === 200 &&
        response.data.message === "success"
      ) {
        this.setState({ 
          [`${statePrefix}EmailSent`]: true,
          successMessage: `${emailType} email sent successfully!`
        });
        setTimeout(() => this.setState({ [`${statePrefix}EmailSent`]: false, successMessage: "" }), 5000);
      } else {
        const errMsg = response.data.message || response.data.errors || "Failed to send email.";
        this.setState({ 
          errorMessage: errMsg
        });
      }
    } catch (e) {
      this.setState({ 
        errorMessage: e.message || "Failed to send email."
      });
    }
    
    this.setState({
      [`sending${statePrefix.charAt(0).toUpperCase() + statePrefix.slice(1)}Email`]: false,
    });
  };

  getForgotPasswordLink = async () => {
    this.setState({
      errorMessage: "",
      successMessage: "",
      resetLink: "",
    });

    const servicesResponce = await getForgotPasswordLink(
      auth.getAccount(),
      auth.getToken(),
      this.state.client_update_email,
      this.state.client_accountno,
    );
    // console.log("servicesResponce: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState(
        {
          resetLink: servicesResponce.data.data.data, // save full URL
        },
        () => {
          // show modal only after link is ready
          window.$("#modalForgotPasswordLink").modal("show");
        },
      );
    } else {
      this.setState({ errorMessage: "Unable to generate link." });
    }
  };

  notifyClientLoginByEmail = async () => {
    this.modalOpenForgotPasswordLink();
  };

  get_integration_data = async () => {
    this.setState({
      errorMessage: "",
      successMessage: "",
    });
    const servicesResponce = await getIntegration(
      auth.getAccount(),
      auth.getToken(),
    );
    //console.log("get_integration_data: ", servicesResponce.data);
    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      let va_intergation = "No";
      let meta_intergation = "No";
      if (servicesResponce.data.data && servicesResponce.data.data.length > 0) {
        for (let i = 0; i < servicesResponce.data.data.length; i++) {
          /*console.log(
            'servicesResponce.data.data[i]["integration_type"]' +
              servicesResponce.data.data[i]["active"] +
              " " +
              servicesResponce.data.data[i]["integration_type"] +
              " " +
              servicesResponce.data.data[i]["status"]
          );*/
          if (
            servicesResponce.data.data[i]["integration_type"] ===
              "voicealerts" &&
            servicesResponce.data.data[i]["active"] === 1 &&
            servicesResponce.data.data[i]["status"] === "Yes"
          ) {
            va_intergation = "Yes";
          }
          if (
            servicesResponce.data.data[i]["integration_type"] === "metabase" &&
            servicesResponce.data.data[i]["active"] === 1 &&
            servicesResponce.data.data[i]["status"] === "Yes"
          ) {
            meta_intergation = "Yes";
          }
        }
      }
      //console.log("va_intergation: ", va_intergation);
      this.setState({
        va_intergation: va_intergation,
        meta_intergation: meta_intergation,
      });
    } else {
    }
  };

  redirectToEditResponse = (user, tableMeta) => {
    const url = `${APP_URL}forms/edit_response/${user}/${this.state.client_accountno}/${tableMeta.rowData[7]}/${tableMeta.rowData[10]}`;
    window.location.href = url;
  };

  handleEnableChange = () => {
    this.setState(
      (prevState) => {
        const newStatus = prevState.isEnableChecked ? "disable" : "enable";
        return {
          isEnableChecked: !prevState.isEnableChecked,
          status: newStatus,
        };
      },
      () => {
        // console.log(`Status changed to: ${this.state.status}`);
      },
    );
  };

  handleEnableChangeDirect = () => {
    this.setState(
      (prevState) => {
        const newStatus = prevState.isEnableCheckedDirect
          ? "disable"
          : "enable";
        return {
          isEnableCheckedDirect: !prevState.isEnableCheckedDirect,
          statusDirect: newStatus,
        };
      },
      () => {
        // console.log(`Status changed to: ${this.state.statusDirect}`);
      },
    );
  };

  format_date = (value, tableMeta) => {
    let date = value;
    if (date && date !== "") {
      return dateFormat(date, "mm-dd-yyyy");
    } else {
      return "---";
    }
  };

  handleEditorChange = (event, editor) => {
    const content = editor.getData();
    this.setState({
      client_services_welcome_content: content,
    });
    //console.log("Content was updated:", content);
  };

  defaultText = (value, tableMeta) => {
    //console.log("tableMeta.rowData: ", tableMeta.rowData[9]);
    let is_default = value;

    if (is_default === "inactive") {
      return (
        <span className="badge badge-outline-danger">
          <em className="icon ni ni-signin"></em> Inactive
        </span>
      );
    } else if (is_default === "active") {
      return (
        <span className="badge badge-outline-success">
          <em className="icon ni ni-done"></em> Active
        </span>
      );
    }
  };

  clientServices = async () => {
    const { client_accountno } = this.state;
    const servicesResponce = await getClientSettings(
      auth.getAccount(),
      auth.getToken(),
      client_accountno,
    );

    //console.log("getClientSettings: ", servicesResponce.data);
    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      //window.location.replace("/error");
    } else if (servicesResponce.data.status === 200) {
      this.setState({
        client_services_welcome_content: servicesResponce.data.data,
        errorMessageAgreements: "",
        successMessageAgreements: "",
        assignedLoader: false,
        isEditorReady: true,
      });
    }

    // window.$("#modalFormClientServices").modal("show");
  };

  handleToggle = () => {
    this.setState((prevState) => ({
      useGooglePlaces: !prevState.useGooglePlaces,
      toggleButtonText:
        prevState.toggleButtonText === "Allow PO Box Address"
          ? "Allow Simple Address"
          : "Allow PO Box Address",
    }));
  };

  showAssignedServices = async () => {
    const { client_accountno } = this.state;
    const servicesResponce = await listClientAllowedServices(
      auth.getAccount(),
      auth.getToken(),
      client_accountno,
    );
    //console.log("showAssignedServices: ", servicesResponce.data);
    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        showServiceLoader: false,
        assignedLoader: false,
      });
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        serviceAssignedData: servicesResponce.data.data,
        showServiceLoader: false,
        assignedLoader: false,
      });
    } else {
      this.setState({
        showServiceLoader: false,
        assignedLoader: false,
      });
    }
  };

  handleCheckboxChange = (id) => {
    const serviceAssignedData = this.state.serviceAssignedData.map(
      (checkbox) =>
        checkbox.id === id
          ? { ...checkbox, checked: !checkbox.checked }
          : checkbox,
    );
    this.setState({ serviceAssignedData });
  };

  handleCheckAllChange = () => {
    const { checkAll, serviceAssignedData } = this.state;
    const updatedCheckboxes = serviceAssignedData.map((checkbox) => ({
      ...checkbox,
      checked: !checkAll,
    }));
    this.setState({
      serviceAssignedData: updatedCheckboxes,
      checkAll: !checkAll,
    });
  };

  updateAssignedServices = async () => {
    const { checkAll, serviceAssignedData, client_accountno } = this.state;
    this.setState({
      update_service_button: true,
    });
    /*console.log(
      "updateAssignedServices serviceAssignedData: ",
      serviceAssignedData
    );*/
    const servicesResponce = await updateClientAllowedServices(
      auth.getAccount(),
      auth.getToken(),
      client_accountno,
      JSON.stringify(serviceAssignedData),
    );
    //console.log("updateAssignedServices: ", servicesResponce.data);
    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        update_service_button: false,
        assignedErrorMessage:
          "There is some error while assigning the services to the client.",
        assignedSuccessMessage: "",
      });
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        assignedErrorMessage: "",
        assignedSuccessMessage:
          "Services / Products assigned successfully to the client.",
        update_service_button: false,
      });
      setTimeout(() => {
        this.showAssignedServices();
      }, 2000);
    } else {
      this.setState({
        update_service_button: false,
        assignedErrorMessage:
          "There is some error while assigning the services to the client.",
        assignedSuccessMessage: "",
      });
    }
    setTimeout(() => {
      this.setState({
        update_service_button: false,
        assignedErrorMessage: "",
        assignedSuccessMessage: "",
      });
    }, 4000);
  };

  handleRevokeValueChange = (event) => {
    const { target } = event;
    const value = target.value;

    this.setState({
      revoke_reason: value,
    });
  };

  handleClientAgreementRevokeSubmit = async (
    agreement_accountno,
    client_id,
    revoke_reason,
  ) => {
    let is_validated = true;
    if (revoke_reason === "") {
      is_validated = false;
      this.setState({
        errorCompName: "error",
        errorMessageAgreements: "Revoke Reason is required.",
      });
    }
    if (is_validated === true) {
      this.setState({
        successMessageAgreements: "",
        errorMessageAgreements: "",
        disabled: true,
      });

      const servicesResponce = await revokeClientSignedAgreements(
        auth.getAccount(),
        auth.getToken(),
        client_id,
        agreement_accountno,
        revoke_reason,
      );
      //console.log("handleAgentAgreementRevokeSubmit.data: ", servicesResponce.data);
      this.setState({
        disabled: false,
      });
      if (
        servicesResponce.data.status === 403 ||
        servicesResponce.data.errors === "authentication missing" ||
        servicesResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
        return;
      } else if (servicesResponce.data.status === 406) {
        this.setState({
          errorMessageAgreements:
            "There is an error while revoking an agreement. Please try again.",
        });
        //window.location.replace("/error");
      } else if (servicesResponce.data.status === 404) {
        this.setState({
          errorMessageAgreements:
            "There is an error while revoking an agreement. Please try again.",
        });
        //window.location.replace("/error");
      } else if (
        servicesResponce.data.status === 200 &&
        servicesResponce.data.message === "success"
      ) {
        this.setState({
          successMessageAgreements: "Agreement is revoked successfully.",
          revoke_reason: "",
          isRevokeReasonActive: false,
        });
        setTimeout(() => {
          this.clientAgreements();
        }, 4000);
      } else {
        this.setState({
          errorMessageAgreements:
            "There is an error while revoking an agreement. Please try again.",
        });
      }
    }
    setTimeout(() => {
      this.setState({
        successMessageAgreements: "",
        errorMessageAgreements: "",
      });
    }, 4000);
  };

  handleChange = async (event) => {
    const { target } = event;
    let value = target.type === "radio" ? target.checked : target.value;
    const { name } = target;
    if (name === "client_account_status") {
      this.setState({ statusChanged: true });
      // console.log("Status Changed:", true);
    }
    if (name === "client_update_name") {
      value = value.replace(/[^a-zA-Z\s'.,\-:()|!@]/g, "");
    } else if (name === "client_comp_name") {
      value = value.replace(/[^a-zA-Z0-9\s_\-.,&:()|!@]/g, "");
    } else if (name === "client_title") {
      value = value.replace(/[^a-zA-Z0-9\s_\-.,&:()|!@]/g, "");
    }
    if (name === "client_update_email") {
      const { original_client_update_email } = this.state;

      const isChanged = value.trim() !== original_client_update_email.trim();

      this.setState({ isEmailChanged: isChanged }, () => {
        // console.log("Original Email:", original_client_update_email);
        // console.log("New Email:", value);
        // console.log("isEmailChanged:", this.state.isEmailChanged);
      });
    }
    //console.log(name);
    this.setState({
      [name]: value,
    });
  };

  handleChangeClientServices = async (event) => {
    const { target } = event;
    // console.log('handleChangeClientServicesWelcomeContent',target);
    // return;
    const value = target.value;
    const { name } = target;
    //console.log(name);
    this.setState({
      [name]: value,
    });
  };

  handle_accordion_head = (number) => {
    if (number === 0) {
      return "accordion-head";
    } else {
      return "accordion-head collapsed";
    }
  };

  handle_accordion_body = (number) => {
    if (number === 0) {
      return "accordion-body collapse show";
    } else {
      return "accordion-body collapse";
    }
  };

  downloadPdf = async (d_f_name, agreement_title) => {
    const reportsData = await getAgreementPdf(
      auth.getAccount(),
      auth.getToken(),
      d_f_name,
    );
    //console.log("PDF.data: ", reportsData.data.data + " " + d_f_name);
    if (
      reportsData.data.status === 403 ||
      reportsData.data.errors === "authentication missing" ||
      reportsData.data.errors === "jwt expired"
    ) {
      auth.adminlogout();
    } else if (reportsData.data.status === 404) {
      this.setState({
        errorMessage: "There is some error.",
      });
      //window.location.replace("/error");
    } else if (
      reportsData.data.status === 200 &&
      reportsData.data.message === "success"
    ) {
      var url = reportsData.data.data;
      // Sanitize company name: remove special characters and replace spaces with underscores
      const sanitizeFileName = (name) => {
        return name
          .replace(/[^a-zA-Z0-9\s_-]/g, '') // Remove special characters
          .replace(/\s+/g, '_') // Replace spaces with underscores
          .trim();
      };
      let file_name = `${agreement_title}_${this.state.client_accountno}_${sanitizeFileName(this.state.client_comp_name)}.pdf`;
      fetch(url)
        .then((x) => x.blob())
        .then((b) => {
          // console.log("B INSTANCE", b instanceof Blob);
          const url = window.URL.createObjectURL(b);
          var a = document.createElement("a");
          document.body.appendChild(a);
          a.style = "display: none";
          a.href = url;
          a.download = file_name;
          a.click();
          window.URL.revokeObjectURL(url);
        });
    } else {
      this.setState({
        errorMessage: "There is some error.",
      });
    }
  };

  downloadPdfClient = async (d_f_name) => {
    //var url = d_f_name;
    if (d_f_name && d_f_name !== "") {
      let file_name = d_f_name;
      var url =
        AGENT_PORTAL_URL + "files_data/form_response_uploads/" + d_f_name;
      fetch(url)
        .then((x) => x.blob())
        .then((b) => {
          // console.log("B INSTANCE", b instanceof Blob);
          const url = window.URL.createObjectURL(b);
          var a = document.createElement("a");
          document.body.appendChild(a);
          a.style = "display: none";
          a.href = url;
          a.download = file_name;
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          this.setState({
            errorMessage:
              "There is some error while downloading the attachment.",
          });
          setTimeout(() => {
            this.setState({ errorMessage: "" });
          }, 4000);
          // Handle any errors that occurred during the fetch
          console.error("Fetch error:", error);
        });
    } else {
      this.setState({
        errorMessage: "Attachement not found.",
      });
      setTimeout(() => {
        this.setState({ errorMessage: "" });
      }, 4000);
    }
  };

  print_details = () => {
    //console.log('print');
    let printContents = document.getElementById("printablediv").innerHTML;
    let originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
  };

  showApprovedCont = (kyc_action, accountno) => {
    this.setState({
      showKycApproved: true,
      showApprovedAction: kyc_action,
    });
  };

  showRejectCont = (kyc_action, accountno) => {
    this.setState({
      showKycApproved: true,
      showApprovedAction: kyc_action,
    });
  };

  addMenuHistoryLeft = (link) => {
    this.props.history.push(link);
  };

  openLinkInNewTab = (link) => {
    window.open(link, "_blank");
  };

  // Reorder onboarding steps via react-beautiful-dnd, then auto-save the new
  // order (shouldReload: false keeps the UI in place — local state already
  // reflects the change). Mirrors the Upgrades onboarding behavior.
  handleOnboardingDragEnd = (result) => {
    const { source, destination } = result;
    if (!destination) return;
    if (source.index === destination.index) return;

    const { onboardingItems } = this.state;

    // Never swap onto a locked item.
    if (
      onboardingItems[destination.index] &&
      onboardingItems[destination.index].isLocked
    ) {
      return;
    }

    const swappedItems = this.swapItems(
      onboardingItems,
      source.index,
      destination.index,
    );
    this.setState({ onboardingItems: swappedItems }, () => {
      this.saveOnboardingSettings({
        onboardingItemsOverride: swappedItems,
        shouldReload: false,
      });
    });
  };

  // Swap two items in array - clean implementation
  swapItems = (array, index1, index2) => {
    const newArray = [...array];
    [newArray[index1], newArray[index2]] = [newArray[index2], newArray[index1]];
    return newArray;
  };

  changeActiveTab = (tab) => {
    this.setState({
      activeTab: tab,
      assignedLoader: true,
    });

    if (tab === "onboarding_settings") {
      this.getOnboardingItems();
      this.get_forms_list();
    }
    if (tab === "sbc_settings") {
      this.fetchSipnavAccountDetails();
    }
  };

  // Onboarding Methods
  updateOnboardingItemTitle = (id, newTitle) => {
    const updatedItems = this.state.onboardingItems.map((item) =>
      item.id === id ? { ...item, title: newTitle } : item,
    );

    // Remove error if title is not empty
    let updatedErrors = [...this.state.onboardingItemsWithErrors];
    if (newTitle.trim() !== "") {
      updatedErrors = updatedErrors.filter((errorId) => errorId !== id);
    }

    this.setState({
      onboardingItems: updatedItems,
      onboardingItemsWithErrors: updatedErrors,
    });
  };

  // Helper method to check if agreement step should be filled (green border)
  isAgreementStepFilled = () => {
    const { unsignedData } = this.state;

    // If no unsigned agreements, it's filled
    if (!unsignedData || unsignedData.length === 0) {
      return true;
    }

    // Check if all unsigned agreements have ismandatory: "No"
    return unsignedData.every((agreement) => agreement.ismandatory === "No");
  };

  // Get available forms excluding forms already selected in other steps
  getAvailableFormsForStep = (currentStepId) => {
    const { onboardingItems, formsList } = this.state;

    // Get all form IDs already selected in other steps (excluding the current step)
    const selectedFormIds = onboardingItems
      .filter(
        (item) =>
          item.id !== currentStepId && item.form && item.form.trim() !== "",
      )
      .map((item) => item.form);

    // Filter formsList to exclude already selected forms
    const availableForms = formsList.filter(
      (form) => !selectedFormIds.includes(form.form_accountno),
    );

    return availableForms;
  };

  getAvailableClientAgreementsForStep = (currentStepId) => {
    const { onboardingItems, clientAgreementsList } = this.state;

    const selectedAgreementIds = onboardingItems
      .filter(
        (item) =>
          item.id !== currentStepId &&
          item.agreement_accountno &&
          item.agreement_accountno !== "",
      )
      .map((item) => item.agreement_accountno);

    return (clientAgreementsList || []).filter(
      (agreement) =>
        !selectedAgreementIds.includes(agreement.agreement_accountno),
    );
  };

  editOnboarding = async (onboardingId) => {
    const { onboardingItems } = this.state;
    const itemToEdit = onboardingItems.find((item) => item.id === onboardingId);

    if (itemToEdit) {
      // Prevent editing of items that are already filled
      if (itemToEdit.isFilled) {
        console.warn("Cannot edit filled onboarding item");
        return;
      }

      const itemType = itemToEdit.type === "agreement" ? "agreement" : "form";
      this.setState({
        editOnboardingId: onboardingId,
        editOnboardingTitle: itemToEdit.title,
        editOnboardingType: itemType,
        editOnboardingForm: itemToEdit.form || "",
        editOnboardingAnswerType: itemToEdit.answerType || "",
        editOnboardingAllowSkip: itemToEdit.allowSkip || false,
        editOnboardingAllowEnable: itemToEdit.enable || false,
        editOnboardingIsEnabled:
          itemToEdit.isEnabled !== undefined && itemToEdit.isEnabled !== null
            ? itemToEdit.isEnabled
            : 1,
        editOnboardingAllowMultiple:
          itemToEdit.allow_multiple !== undefined
            ? itemToEdit.allow_multiple
            : 0,
        editOnboardingAllowAI: itemToEdit.allowAI || false,
        editOnboardingAgreement: itemToEdit.agreement_accountno || "",
        editOnboardingAgreementTitle: itemToEdit.agreement_title || "",
        editOnboardingAgreementInstruction: itemToEdit.agreement_instruction || "",
        questionErrorMessage: "",
        questionErrorMessageTitle: "",
        questionSuccessMessage: "",
        add_question_loader: false,
      });
      if (!this.state.formsList || this.state.formsList.length === 0) {
        await this.get_forms_list();
      }
      if (!this.state.clientAgreementsList || this.state.clientAgreementsList.length === 0) {
        await this.get_client_agreements_list();
      }
      window.$("#modalEditOnboarding").modal("show");
    }
  };

  submitEditOnboarding = () => {
    const {
      editOnboardingId,
      editOnboardingTitle,
      editOnboardingType,
      addOnboardingType,
      editOnboardingForm,
      editOnboardingAnswerType,
      editOnboardingAllowSkip,
      editOnboardingAllowEnable,
      editOnboardingIsEnabled,
      editOnboardingAllowMultiple,
      editOnboardingAgreement,
      editOnboardingAgreementTitle,
      editOnboardingAgreementInstruction,
      onboardingItems,
      newStepCounter,
    } = this.state;

    const itemExists = onboardingItems.some((item) => item.id === editOnboardingId);
    const activeType = itemExists ? editOnboardingType : addOnboardingType;

    // Validate title
    if (!editOnboardingTitle || editOnboardingTitle.trim() === "") {
      this.setState({
        questionErrorMessage: "Please enter an onboarding item title.",
        questionErrorMessageTitle: "Title Required",
        questionSuccessMessage: "",
        add_question_loader: false,
      });
      return;
    }

    // Validate form or agreement selection
    if (activeType === "agreement") {
      if (!editOnboardingAgreement || editOnboardingAgreement === "") {
        this.setState({
          questionErrorMessage: "Please select an agreement from the dropdown.",
          questionErrorMessageTitle: "Agreement Required",
          questionSuccessMessage: "",
          add_question_loader: false,
        });
        return;
      }
    } else {
      if (!editOnboardingForm || editOnboardingForm === "") {
        this.setState({
          questionErrorMessage: "Please select a form from the dropdown.",
          questionErrorMessageTitle: "Form Required",
          questionSuccessMessage: "",
          add_question_loader: false,
        });
        return;
      }
    }

    this.setState({ add_question_loader: true });

    let updatedItems;
    let successMessage;
    let updatedCounter = newStepCounter;

    const baseFields = {
      title: editOnboardingTitle,
      enable: editOnboardingAllowEnable,
      isEnabled: editOnboardingIsEnabled,
    };

    if (itemExists) {
      updatedItems = onboardingItems.map((item) => {
        if (item.id !== editOnboardingId) return item;
        if (activeType === "agreement") {
          return {
            ...item,
            ...baseFields,
            type: "agreement",
            sub_type: "clients",
            form: "",
            allowSkip: false,
            allow_multiple: 0,
            agreement_accountno: editOnboardingAgreement,
            agreement_title: editOnboardingAgreementTitle,
            agreement_instruction: editOnboardingAgreementInstruction,
          };
        }
        return {
          ...item,
          ...baseFields,
          type: "form",
          form: editOnboardingForm,
          answerType: editOnboardingAnswerType,
          allowSkip: editOnboardingAllowSkip,
          allow_multiple: editOnboardingAllowMultiple,
          agreement_accountno: "",
          agreement_title: "",
          agreement_instruction: "",
        };
      });
      successMessage = "Onboarding item updated successfully.";
    } else {
      const newItem =
        activeType === "agreement"
          ? {
              id: editOnboardingId,
              ...baseFields,
              type: "agreement",
              sub_type: "clients",
              form: "",
              answerType: "",
              allowSkip: false,
              allow_multiple: 0,
              isLocked: false,
              agreement_accountno: editOnboardingAgreement,
              agreement_title: editOnboardingAgreementTitle,
              agreement_instruction: editOnboardingAgreementInstruction,
            }
          : {
              id: editOnboardingId,
              ...baseFields,
              type: "form",
              form: editOnboardingForm,
              answerType: editOnboardingAnswerType,
              allowSkip: editOnboardingAllowSkip,
              allow_multiple: editOnboardingAllowMultiple,
              isLocked: false,
              agreement_accountno: "",
              agreement_title: "",
              agreement_instruction: "",
            };
      updatedItems = [...onboardingItems, newItem];
      updatedCounter = newStepCounter + 1;
      successMessage = "Onboarding item added successfully.";
    }

    this.setState(
      {
        onboardingItems: updatedItems,
        newStepCounter: updatedCounter,
        questionErrorMessage: "",
        questionErrorMessageTitle: "",
        questionSuccessMessage: successMessage,
      },
      async () => {
        const saved = await this.saveOnboardingSettings({
          onboardingItemsOverride: updatedItems,
          shouldReload: false,
        });

        if (!saved) {
          this.setState({
            questionSuccessMessage: "",
            add_question_loader: false,
          });
          return;
        }

        setTimeout(() => {
          this.setState({
            questionErrorMessage: "",
            questionErrorMessageTitle: "",
            questionSuccessMessage: "",
            editOnboardingId: "",
            editOnboardingTitle: "",
            editOnboardingType: "form",
            addOnboardingType: "form",
            editOnboardingForm: "",
            editOnboardingIsEnabled: 1,
            editOnboardingAllowMultiple: 0,
            editOnboardingAnswerType: "",
            editOnboardingAllowSkip: false,
            editOnboardingAllowEnable: false,
            editOnboardingDescription: "",
            editOnboardingAgreement: "",
            editOnboardingAgreementTitle: "",
            editOnboardingAgreementInstruction: "",
            add_question_loader: false,
          });
          window.$("#modalEditOnboarding").modal("hide");
          window.$("#modalAddOnboarding").modal("hide");
        }, 800);
      },
    );
  };

  closeModal = (modalId) => {
    this.setState({
      editQuestionErrorMessage: "",
      editQuestionSuccessMessage: "",
      editOnboardingId: "",
      editOnboardingTitle: "",
      editOnboardingType: "form",
      addOnboardingType: "form",
      editOnboardingForm: "",
      editOnboardingAnswerType: "",
      editOnboardingAllowSkip: false,
      editOnboardingAllowEnable: false,
      editOnboardingAllowAI: false,
      editOnboardingLoader: false,
      editOnboardingAgreement: "",
      editOnboardingAgreementTitle: "",
      editOnboardingAgreementInstruction: "",
      newQuestion: [],
      questionErrorMessage: "",
      questionErrorMessageTitle: "",
      questionSuccessMessage: "",
      add_question_loader: false,
    });
    window.$("#" + modalId).modal("hide");
  };

  deleteOnboarding = (onboarding_id) => {
    this.onboarding_id_to_delete = onboarding_id;
    this.setState({
      onboarding_id: onboarding_id,
      onboardingErrorMessageDelete: "",
      onboardingSuccessMessageDelete: "",
    });
    window.$("#modalDeleteAlert").modal("show");
  };

  deleteOnboardingItem = async () => {
    this.setState({ isProcessing: true });
    const onboarding_id =
      this.onboarding_id_to_delete || this.state.onboarding_id;
    const { onboardingItems } = this.state;

    try {
      const updatedItems = onboardingItems.filter(
        (item) => item.id !== onboarding_id,
      );
      const updatedErrors = this.state.onboardingItemsWithErrors.filter(
        (errorId) => errorId !== onboarding_id,
      );

      const saved = await this.saveOnboardingSettings({
        onboardingItemsOverride: updatedItems,
        shouldReload: false,
      });

      if (!saved) {
        this.setState({
          isProcessing: false,
          onboardingErrorMessageDelete:
            "Failed to delete onboarding item. Please try again.",
          onboardingSuccessMessageDelete: "",
        });
        return;
      }

      this.setState({
        onboardingItems: updatedItems,
        onboardingItemsWithErrors: updatedErrors,
        onboardingSuccessMessageDelete: "Onboarding item deleted successfully.",
        onboardingErrorMessageDelete: "",
      });

      setTimeout(() => {
        window.$("#modalDeleteAlert").modal("hide");
        this.setState({
          onboardingSuccessMessageDelete: "",
          onboarding_id: "",
          isProcessing: false,
        });
        this.onboarding_id_to_delete = null;
      }, 2000);
    } catch (error) {
      this.setState({
        isProcessing: false,
        onboardingErrorMessageDelete:
          error.message || "Failed to delete onboarding item.",
        onboardingSuccessMessageDelete: "",
      });
    }
  };

  modalHideDel = () => {
    this.setState({
      onboarding_id: "",
      onboardingErrorMessageDelete: "",
      onboardingSuccessMessageDelete: "",
      CustomErrorMessageDomainDel: "",
      CustomSuccessMessageDomainDel: "",
      isProcessing: false,
    });
    this.onboarding_id_to_delete = null;
    window.$("#modalDeleteAlert").modal("hide");
  };

  addNewOnboardingStep = () => {
    const { newStepCounter } = this.state;
    const newId = uuid();

    this.setState(
      {
        editOnboardingId: newId,
        editOnboardingTitle: "",
        editOnboardingForm: "",
        editOnboardingAnswerType: "",
        editOnboardingAllowSkip: false,
        editOnboardingAllowEnable: false,
        editOnboardingIsEnabled: 1,
        editOnboardingAllowMultiple: 0,
        editOnboardingAllowAI: false,
        addOnboardingType: "form",
        editOnboardingAgreement: "",
        editOnboardingAgreementTitle: "",
        editOnboardingAgreementInstruction: "",
        questionErrorMessage: "",
        questionErrorMessageTitle: "",
        questionSuccessMessage: "",
        add_question_loader: false,
        newStepCounter: newStepCounter + 1,
      },
      () => {
        if (!this.state.formsList || this.state.formsList.length === 0) {
          this.get_forms_list();
        }
        if (!this.state.clientAgreementsList || this.state.clientAgreementsList.length === 0) {
          this.get_client_agreements_list();
        }
        window.$("#modalAddOnboarding").modal("show");
      },
    );
  };

  saveOnboardingSettings = async (options = {}) => {
    const { onboardingItemsOverride = null, shouldReload = true } = options;
    const onboardingItemsToSave = onboardingItemsOverride || this.state.onboardingItems;

    // Validate items
    const emptyItems = onboardingItemsToSave.filter(
      (item) => item.title.trim() === "",
    );

    if (emptyItems.length > 0) {
      const emptyItemIds = emptyItems.map((item) => item.id);
      this.setState({
        onboardingItemsWithErrors: emptyItemIds,
        onboardingErrorMessage:
          "Please fill in all onboarding step titles before saving.",
        onboardingErrorMessageTitle: "Validation Error",
        onboardingSuccessMessage: "",
      });
      return false;
    }

    // Validation 2: Check for duplicate step names
    const stepNames = onboardingItemsToSave.map((item) =>
      item.title.trim().toLowerCase(),
    );
    const uniqueStepNames = new Set(stepNames);

    if (stepNames.length !== uniqueStepNames.size) {
      // Find all items that have duplicate names
      const itemsWithDuplicateNames = onboardingItemsToSave.filter((item) => {
        const count = stepNames.filter(
          (name) => name === item.title.trim().toLowerCase(),
        ).length;
        return count > 1;
      });

      this.setState({
        onboardingItemsWithErrors: itemsWithDuplicateNames.map(
          (item) => item.id,
        ),
        onboardingErrorMessage:
          "Duplicate step names found. Each step must have a unique name. Please rename the duplicate steps.",
        onboardingErrorMessageTitle: "Duplicate Steps",
        onboardingSuccessMessage: "",
      });
      return false;
    }

    this.setState({
      onboarding_save_loading: true,
      onboardingErrorMessage: "",
      onboardingErrorMessageTitle: "",
      onboardingSuccessMessage: "",
    });

    try {
      const accountno = auth.getAccount();
      const token = auth.getToken();
      const {
        client_accountno,
        onboardingTitle,
        onboardingMessage,
      } = this.state;

      // Format steps data for API with proper type assignment
      const stepsData = onboardingItemsToSave.map((item, index) => {
        let isEnabled =
          item.isEnabled !== undefined && item.isEnabled !== null
            ? item.isEnabled
            : item.enable ? 1 : 0;
        let stepIsFilled = item.isFilled ? 1 : 0;

        // First step is always "basic" and locked
        if (index === 0) {
          return {
            id: item.id || uuid(),
            title: item.title,
            form: item.form || "",
            allowSkip: 0,
            isEnabled: 1,
            isFilled: 1,
            type: "basic",
            formToken: "",
            isSkipped: 0,
            allow_multiple: 0,
            form_desc: "",
            formFilledDate: "",
          };
        }

        // Agreement-type steps
        if (item.type === "agreement") {
          return {
            id: item.id || uuid(),
            title: item.title,
            type: "agreement",
            sub_type: "clients",
            agreement_title: item.agreement_title || "",
            agreement_instruction: item.agreement_instruction || "",
            agreement_accountno: item.agreement_accountno || "",
            is_signed: item.is_signed || "No",
            allowSkip: 0,
            isEnabled: isEnabled,
            isFilled: stepIsFilled,
            isSkipped: item.isSkipped || 0,
            agreementDetails: item.agreementDetails || item.agreements_details || null,
          };
        }

        // Form-type steps
        return {
          id: item.id || uuid(),
          title: item.title,
          form: item.form || "",
          allowSkip: item.allowSkip ? 1 : 0,
          isEnabled: isEnabled,
          isFilled: stepIsFilled,
          allow_multiple: item.allow_multiple !== undefined ? item.allow_multiple : 0,
          form_desc: "",
          formFilledDate: item.formFilledDate || "",
          isSkipped: item.isSkipped || 0,
          type: "form",
          formToken: "",
        };
      });

      // Call the save API
      const response = await save_onboarding_user(
        accountno,
        token,
        client_accountno,
        stepsData,
        "client",
        onboardingTitle,
        onboardingMessage,
      );

      // console.log("Save Onboarding Items Response:", response);

      if (
        response &&
        response.status === 200 &&
        response.data &&
        response.data.status === "success"
      ) {
        this.setState({ onboardingItems: onboardingItemsToSave });
        this.setState({
          onboarding_save_loading: false,
          onboardingSuccessMessage: "Onboarding settings saved successfully.",
          onboardingItemsWithErrors: [],
        });

        if (shouldReload) {
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        }
        return true;
      } else {
        this.setState({
          onboarding_save_loading: false,
          onboardingErrorMessage:
            response?.data?.message || "Failed to save onboarding settings.",
          onboardingErrorMessageTitle: "Error",
        });
        return false;
      }
    } catch (error) {
      console.error("Error saving onboarding settings:", error);
      this.setState({
        onboarding_save_loading: false,
        onboardingErrorMessage:
          error.message || "Failed to save onboarding settings.",
        onboardingErrorMessageTitle: "Error",
      });
      return false;
    }
  };

  clientAgreements = async (event) => {
    let company_id = this.state.client_accountno;
    this.setState({
      isRevokeReasonActive: false,
      revoke_reason: "",
      errorMessage: "",
      successMessage: "",
      client_accountno: company_id,
    });
    // this.setState({
    //   company_title: company_title
    // });
    // window.$("#modalFormClientAgreements").modal("show");
    // return;

    //console.log("tableMeta: ", tableMeta);
    let clientAgreementsInfo = [];
    const servicesResponce = await listAssignedServicesAgreements(
      auth.getAccount(),
      auth.getToken(),
      company_id,
    );

    //console.log("clientAgreements: ", servicesResponce.data);
    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      if (
        servicesResponce.data.clientAgreementsInfo &&
        servicesResponce.data.clientAgreementsInfo.length > 0
      ) {
        clientAgreementsInfo = servicesResponce.data.clientAgreementsInfo;
      }
      const combinedAgreements = [
        ...clientAgreementsInfo,
        ...servicesResponce.data.unSignedAgreements,
      ];
      this.setState({
        signedData: combinedAgreements,
        unsignedData: servicesResponce.data.unSignedAgreements,
        errorMessage: "",
        successMessage: "",
        assignedLoader: false,
      });
    } else {
      this.setState({
        signedData: [],
        unsignedData: [],
        errorMessage: "",
        successMessage: "",
        assignedLoader: false,
      });
    }

    //let company_title = tableMeta.rowData[1];

    // window.$("#modalFormClientAgreements").modal("show");
  };

  approveAgreement = async (agreement_accountno) => {
    const { client_accountno } = this.state;
    this.setState({
      successMessageAgreements: "",
      errorMessageAgreements: "",
      disabled: true,
    });

    const servicesResponce = await approveClientSignedAgreement(
      auth.getAccount(),
      auth.getToken(),
      client_accountno,
      agreement_accountno,
    );
    //console.log("approveAgreement.data: ", servicesResponce.data);
    this.setState({
      disabled: false,
    });
    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
      return;
    } else if (servicesResponce.data.status === 406) {
      this.setState({
        errorMessageAgreements:
          "There is an error while approving an agreement. Please try again.",
      });
      //window.location.replace("/error");
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        errorMessageAgreements:
          "There is an error while approving an agreement. Please try again.",
      });
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.clientAgreements();
      this.setState({
        successMessageAgreements: "Agreement approved successfully",
        isApproveActive: false,
      });
      setTimeout(() => {
        this.clientAgreements();
      }, 4000);
    } else {
      this.setState({
        errorMessageAgreements:
          "There is an error while approving an agreement. Please try again.",
      });
    }
    setTimeout(() => {
      this.setState({
        successMessageAgreements: "",
        errorMessageAgreements: "",
      });
    }, 4000);
  };

  reloadClientAgreements = async (company_id) => {
    let clientAgreementsInfo = [];
    const servicesResponce = await listAssignedServicesAgreements(
      auth.getAccount(),
      auth.getToken(),
      company_id,
    );

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      if (
        servicesResponce.data.clientAgreementsInfo &&
        servicesResponce.data.clientAgreementsInfo.length > 0
      ) {
        clientAgreementsInfo = servicesResponce.data.clientAgreementsInfo;
      }
      this.setState({
        signedData: clientAgreementsInfo.filter(
          (data) => data.is_signed === "Yes",
        ),
        unsignedData: servicesResponce.data.unSignedAgreements,
        errorMessage: "",
        successMessage: "",
      });
    } else {
    }
  };

  revokeAgreement = async (agreement_accountno) => {
    //console.log('revokeAgreement',agreement_id,agreement_accountno);
    this.setState({
      isRevokeReasonActive: true,
      isApproveActive: false,
      revoke_reason: "",
      errorMessage: "",
      successMessage: "",
      revokeAgreementData: {
        agreement_accountno: agreement_accountno,
      },
    });
    this.scrollToDiv("card-content");
    //console.log("agreement_accountno: ", agreement_accountno);
  };

  showDetails = async () => {
    let extra_details = this.state.client_accountno;
    this.setState({
      kyc_details: [],
      kyc_key: "",
      steps_allowed: 0,
      steps_completed: 0,
      completed_percentage: 0,
      kycErrorMessage: "",
      loading_button: false,
      kycSuccessMessage: "",
      kyc_approved: "",
    });

    const kycResponce = await getClientKycDetail(
      auth.getAccount(),
      auth.getToken(),
      extra_details,
    );
    // console.log("getClientKycDetail: ", kycResponce.data);
    if (
      kycResponce.data.status === 403 ||
      kycResponce.data.errors === "authentication missing" ||
      kycResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
      return;
    } else if (kycResponce.data.status === 406) {
      this.setState({
        errorMessageAgreements:
          "There is an error while getting client details. Please try again later.",
      });
      //window.location.replace("/error");
    } else if (
      kycResponce.data.status === 404 &&
      kycResponce.data.message === "not_exists"
    ) {
      this.setState({
        errorMessageAgreements: "",
      });
      //window.location.replace("/error");
    } else if (
      kycResponce.data.status === 200 &&
      kycResponce.data.message === "success"
    ) {
      let completed_percentage =
        (100 / kycResponce.data.steps_allowed) *
        kycResponce.data.steps_completed;
      this.setState({
        kyc_details: kycResponce.data.data,
        kyc_key: kycResponce.data.kyc_key,
        steps_allowed: kycResponce.data.steps_allowed,
        steps_completed: kycResponce.data.steps_completed,
        completed_percentage: completed_percentage.toFixed(0),
        client_register_date: this.format_date(kycResponce.data.register_date),
        kyc_approved: kycResponce.data.kyc_approved,
        assignedLoader: false,
      });
    } else {
      this.setState({
        errorMessageAgreements: "",
      });
    }

    // window.$("#modalClientDetails").modal("show");
  };

  initiateKyc = async () => {
    const { client_accountno } = this.state;
    this.setState({
      errorMessageAgreements: "",
      loading_button: true,
      successMessageAgreements: "",
    });
    const kycResponce = await initiateClientKyc(
      auth.getAccount(),
      auth.getToken(),
      client_accountno,
    );
    //console.log("initiateKyc: ", kycResponce.data);
    if (
      kycResponce.data.status === 403 ||
      kycResponce.data.errors === "authentication missing" ||
      kycResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
      return;
    } else if (kycResponce.data.status === 406) {
      this.setState({
        errorMessageAgreements:
          "There is an error while getting client details. Please try again later.",
        loading_button: false,
        successMessageAgreements: "",
      });
      //window.location.replace("/error");
    } else if (
      kycResponce.data.status === 404 &&
      kycResponce.data.message === "not_exists"
    ) {
      this.setState({
        errorMessageAgreements:
          "There is an error while getting the data. Please try again.",
        loading_button: false,
        successMessageAgreements: "",
      });
      //window.location.replace("/error");
    } else if (
      kycResponce.data.status === 200 &&
      kycResponce.data.message === "success"
    ) {
      this.setState({
        loading_button: false,
        errorMessageAgreements: "",
        successMessageAgreements:
          "Kyc process initiated successfully. An email has also been sent to the customer with URL.",
      });
      // setTimeout(function () {
      //   window.$("#modalClientDetails").modal("hide");
      // }, 2000);
    } else {
      this.setState({
        errorMessageAgreements:
          "There is an error while getting the data. Please try again.",
        loading_button: false,
        successMessageAgreements: "",
      });
    }
    //window.$("#modalClientDetails").modal("show");
  };

  downloadKycPdf = async (d_f_name) => {
    if (d_f_name !== "") {
      d_f_name = d_f_name + ".pdf";
      var url = APP_URL + "files_data/kyc_signup/" + d_f_name;
      //console.log("url: ", url);
      let file_name = d_f_name;
      fetch(url)
        .then((x) => x.blob())
        .then((b) => {
          // console.log("B INSTANCE", b instanceof Blob);
          const url = window.URL.createObjectURL(b);
          var a = document.createElement("a");
          document.body.appendChild(a);
          a.style = "display: none";
          a.href = url;
          a.download = file_name;
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          this.setState({
            errorMessageAgreements:
              "There is some error while downloading the PDF.",
          });
          setTimeout(() => {
            this.setState({ errorMessageAgreements: "" });
          }, 4000);
          // Handle any errors that occurred during the fetch
          console.error("Fetch error:", error);
        });
    }
  };

  submit_client_kyc_approval = async () => {
    const { client_accountno, kyc_reason, showApprovedAction } = this.state;
    this.setState({
      errorMessageAgreements: "",
      disabled: true,
      successMessageAgreements: "",
    });
    if (kyc_reason === "") {
      this.setState({
        errorMessageAgreements: "Please enter the rejection / approval reason.",
        disabled: false,
        successMessageAgreements: "",
      });
    } else {
      const kycResponce = await submitKycApproval(
        auth.getAccount(),
        auth.getToken(),
        client_accountno,
        kyc_reason,
        showApprovedAction,
      );
      //console.log("email_kyc_Details: ", kycResponce.data);
      if (
        kycResponce.data.status === 403 ||
        kycResponce.data.errors === "authentication missing" ||
        kycResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
        return;
      } else if (kycResponce.data.status === 406) {
        this.setState({
          errorMessageAgreements:
            "There is an error while processing your request. Please try again later.",
          disabled: false,
          successMessageAgreements: "",
        });
        //window.location.replace("/error");
      } else if (
        kycResponce.data.status === 404 &&
        kycResponce.data.message === "not_exists"
      ) {
        this.setState({
          errorMessageAgreements:
            "There is an error while processing your request. Please try again.",
          disabled: false,
          successMessageAgreements: "",
        });
        //window.location.replace("/error");
      } else if (
        kycResponce.data.status === 200 &&
        kycResponce.data.message === "success"
      ) {
        this.setState({
          disabled: false,
          errorMessageAgreements: "",
          successMessageAgreements:
            "Your request has been processed successfully.",
          kyc_reason: "",
          kyc_approved: kycResponce.data.kyc_approved,
        });
        setTimeout(() => {
          this.setState({
            showKycApproved: false,
          });
        }, 4000);
      } else {
        this.setState({
          errorMessageAgreements:
            "There is an error while processing your request. Please try again.",
          disabled: false,
          successMessageAgreements: "",
        });
      }
    }
    setTimeout(() => {
      this.setState({
        errorMessageAgreements: "",
        successMessageAgreements: "",
      });
    }, 5000);
  };

  email_kyc_Details = async () => {
    const { client_accountno, kyc_email_address } = this.state;
    this.setState({
      errorMessageAgreements: "",
      disabled: true,
      successMessageAgreements: "",
    });
    if (kyc_email_address === "") {
      this.setState({
        errorMessageAgreements: "Please enter the email address.",
        disabled: false,
        successMessageAgreements: "",
      });
    } else if (ValidateEmail(kyc_email_address) === false) {
      this.setState({
        errorMessageAgreements: "Please enter the valid email address.",
        disabled: false,
        successMessageAgreements: "",
      });
    } else {
      const kycResponce = await emailKycDetails(
        auth.getAccount(),
        auth.getToken(),
        client_accountno,
        kyc_email_address,
      );
      //console.log("email_kyc_Details: ", kycResponce.data);
      if (
        kycResponce.data.status === 403 ||
        kycResponce.data.errors === "authentication missing" ||
        kycResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
        return;
      } else if (kycResponce.data.status === 406) {
        this.setState({
          errorMessageAgreements:
            "There is an error while sending an email. Please try again later.",
          disabled: false,
          successMessageAgreements: "",
        });
        //window.location.replace("/error");
      } else if (
        kycResponce.data.status === 404 &&
        kycResponce.data.message === "not_exists"
      ) {
        this.setState({
          errorMessageAgreements:
            "There is an error while sending an email. Please try again.",
          disabled: false,
          successMessageAgreements: "",
        });
        //window.location.replace("/error");
      } else if (
        kycResponce.data.status === 200 &&
        kycResponce.data.message === "success"
      ) {
        this.setState({
          disabled: false,
          errorMessageAgreements: "",
          successMessageAgreements:
            "An email has been sent to the customer with URL to complete his profile.",
        });
      } else {
        this.setState({
          errorMessageAgreements:
            "There is an error while sending an email. Please try again.",
          disabled: false,
          successMessageAgreements: "",
        });
      }
    }
    setTimeout(() => {
      this.setState({
        errorMessageAgreements: "",
        successMessageAgreements: "",
      });
    }, 5000);

    //window.$("#modalClientDetails").modal("show");
  };

  handleClientServicesSubmit = async (client_id, welcome_content, email) => {
    //console.log('handleClientAgreementRevokeSubmit',client_id, revoke_reason, agreement_accountno);
    const {
      client_accountno,
      client_services_welcome_content,
      client_services_email,
    } = this.state;

    let is_validated = true;
    if (client_services_welcome_content === "") {
      is_validated = false;
      this.setState({
        errorMessageAgreements: "Welcome content is required.",
      });
    }
    if (is_validated === true) {
      this.setState({
        successMessageAgreements: "",
        errorMessageAgreements: "",
        disabled: true,
      });

      const servicesResponce = await submitClientServicesData(
        auth.getAccount(),
        auth.getToken(),
        client_accountno,
        client_services_welcome_content,
        client_services_email,
      );
      //console.log("handleAgentAgreementRevokeSubmit.data: ", servicesResponce.data);
      this.setState({
        disabled: false,
      });
      if (
        servicesResponce.data.status === 403 ||
        servicesResponce.data.errors === "authentication missing" ||
        servicesResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
        return;
      } else if (servicesResponce.data.status === 406) {
        this.setState({
          errorMessageAgreements:
            "There is an error while submitting a data. Please try again.",
        });
        //window.location.replace("/error");
      } else if (servicesResponce.data.status === 404) {
        this.setState({
          errorMessageAgreements:
            "There is an error while submitting a data. Please try again.",
        });
        //window.location.replace("/error");
      } else if (
        servicesResponce.data.status === 200 &&
        servicesResponce.data.message === "success"
      ) {
        this.setState({
          successMessageAgreements: "Client notes updated successfully.",
        });
        setTimeout(function () {
          window.$("#modalFormClientServices").modal("hide");
        }, 4000);
      } else {
        this.setState({
          errorMessageAgreements:
            "There is an error while submitting a data. Please try again.",
        });
      }
    }
    setTimeout(() => {
      this.setState({
        successMessageAgreements: "",
        errorMessageAgreements: "",
      });
    }, 4000);
  };

  showCreditApplications = async () => {
    const { client_accountno } = this.state;
    const kycResponce = await getCreditApplications(
      auth.getAccount(),
      auth.getToken(),
      client_accountno,
    );
    //console.log("showCreditApplications: ", kycResponce.data);
    if (
      kycResponce.data.status === 403 ||
      kycResponce.data.errors === "authentication missing" ||
      kycResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
      return;
    } else if (kycResponce.data.status === 406) {
      this.setState({
        errorMessageAgreements:
          "There is an error while getting the credit applications. Please try again later.",
        processing_request: false,
        assignedLoader: false,
      });
      //window.location.replace("/error");
    } else if (
      kycResponce.data.status === 404 &&
      kycResponce.data.message === "not_exists"
    ) {
      this.setState({
        errorMessageAgreements: "",
        processing_request: false,
        assignedLoader: false,
      });
      //window.location.replace("/error");
    } else if (
      kycResponce.data.status === 200 &&
      kycResponce.data.message === "success"
    ) {
      this.setState({
        credit_applications: kycResponce.data.data,
        processing_request: false,
        assignedLoader: false,
      });
    } else {
      this.setState({
        errorMessageAgreements: "",
        processing_request: false,
        assignedLoader: false,
      });
    }
    // window.$("#modalCreditApplications").modal("show");
  };

  editClientModal = async () => {
    const { client_accountno } = this.state;
    this.setState({ editClientLoading: true });
    const getClientInfoResponce = await getClientInfo(
      auth.getAccount(),
      auth.getToken(),
      client_accountno,
    );
    this.setState({ editClientLoading: false });
    /*console.log(
      "getClientInfoResponce.data.data : ",
      getClientInfoResponce.data.data
    );*/
    if (
      getClientInfoResponce.data.data.status === 403 ||
      getClientInfoResponce.data.data.errors === "authentication missing" ||
      getClientInfoResponce.data.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      getClientInfoResponce.data.data.status === 404 ||
      getClientInfoResponce.data.data.note === "missing"
    ) {
      // window.location.replace("/error");
      // console.log("settings missing");
      this.setState({
        tableLoader: false,
      });
    } else if (
      getClientInfoResponce.data.data.status === 200 &&
      getClientInfoResponce.data.data.message === "success"
    ) {
      window.$("#modalUpdateClient").modal("show");
      const existingFilerId = getClientInfoResponce.data.data.filer_id || "";
      this.setState({
        update_client_account_no: client_accountno,
        client_comp_name: getClientInfoResponce.data.data.comp_name,
        client_update_name: getClientInfoResponce.data.data.name,
        client_title: getClientInfoResponce.data.data.title,
        client_update_email: getClientInfoResponce.data.data.email,
        client_phone: getClientInfoResponce.data.data.phone,
        client_address: getClientInfoResponce.data.data.address,
        client_address2: getClientInfoResponce.data.data.address2,
        client_country: getClientInfoResponce.data.data.country,
        client_city: getClientInfoResponce.data.data.city,
        client_state: getClientInfoResponce.data.data.state,
        client_zip: getClientInfoResponce.data.data.zip,
        client_account_status: getClientInfoResponce.data.data.account_status,
        client_isVerified: getClientInfoResponce.data.data.isVerified,
        client_password: "",
        filer_id: existingFilerId,
        has_fcc_filer_id: existingFilerId !== "",
        fccSuccess: existingFilerId !== "",
        lastVerifiedFilerId: existingFilerId,
        assignParentClientRole: false,
        selectedParentClient: "",
        parentEligibleClients: [],
      });

      // Fetch parent-eligible clients for dropdown
      this.fetchParentEligibleClients(client_accountno);
    } else {
      // window.location.replace("/error");
    }
  };

  fetchParentEligibleClients = async (currentClientAccountno) => {
    this.setState({ parentClientLoading: true });
    try {
      const response = await listParentEligibleClients(
        auth.getAccount(),
        auth.getToken()
      );
      if (
        response.data.status === 200 &&
        response.data.message === "success"
      ) {
        // Filter out the current client being edited
        const eligibleClients = (response.data.data || []).filter(
          (client) => client[0] !== currentClientAccountno
        );
        this.setState({
          parentEligibleClients: eligibleClients,
          parentClientLoading: false,
        });
      } else {
        this.setState({ parentEligibleClients: [], parentClientLoading: false });
      }
    } catch (e) {
      this.setState({ parentEligibleClients: [], parentClientLoading: false });
    }
  };

  formUpdateClient = async () => {
    let {
      client_accountno,
      client_title,
      client_update_name,
      client_update_email,
      client_password,
      client_confirm_password,
      client_phone,
      client_comp_name,
      client_state,
      client_address,
      client_city,
      client_zip,
      client_country,
      client_account_status,
      statusChanged,
      client_address2,
      client_isVerified,
      isEmailChanged,
      proceedAfterEmailModal,
      original_client_update_email,
    } = this.state;
    const modalBody = document.getElementById("modalUpdateClient");
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
    if (modalBody) {
      setTimeout(() => {
        modalBody.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }, 0);
    }

    this.setState({
      proceedAfterEmailModal: false,
      showEmailWarning: false,
      successClientMessageEdit: "",
      errorClientMessageEdit: "",
      tableLoader: false,
    });
    let is_validated = true;

    if (
      this.state.is_fcc_enabled === "Yes" &&
      this.state.has_fcc_filer_id &&
      this.state.filer_id === ""
    ) {
      this.setState({
        errorFilerId: "error",
        errorClientMessageEdit: "FCC 499 Filer ID is required.",
      });
      is_validated = false;
    } else if (
      this.state.is_fcc_enabled === "Yes" &&
      this.state.has_fcc_filer_id &&
      this.state.filer_id.trim().length < 6
    ) {
      this.setState({
        errorFilerId: "error",
        errorClientMessageEdit: "FCC 499 Filer ID must be at least 6 digits.",
      });
      is_validated = false;
    } else if (
      this.state.is_fcc_enabled === "Yes" &&
      this.state.has_fcc_filer_id &&
      this.state.filerIdAlreadyExists
    ) {
      this.setState({
        errorFilerId: "error",
        errorClientMessageEdit: "This Filer ID is already associated with an existing client. Please use a different Filer ID.",
      });
      is_validated = false;
    } else if (this.isFieldRequired('client_comp_name') && (!client_comp_name || client_comp_name === "")) {
      this.setState({
        errorClientCompName: "error",
        errorClientPhone: "",
        errorClientName: "",
        errorClientTitle: "",
        errorClientEmail: "",
        errorClientPass: "",
        errorFilerId: "",
        errorClientMessageEdit: "Company name is required.",
      });
      is_validated = false;
    } else if (this.isFieldRequired('client_title') && (!client_title || client_title === "")) {
      this.setState({
        errorClientPhone: "",
        errorClientCompName: "",
        errorClientName: "",
        errorClientTitle: "error",
        errorClientEmail: "",
        errorClientPass: "",
        errorFilerId: "",
        errorClientMessageEdit: "Title is required.",
      });
      is_validated = false;
    } else if (this.isFieldRequired('client_update_name') && (!client_update_name || client_update_name === "")) {
      this.setState({
        errorClientPhone: "",
        errorClientCompName: "",
        errorClientTitle: "",
        errorClientEmail: "",
        errorClientPass: "",
        errorFilerId: "",
        errorClientName: "error",
        errorClientMessageEdit: "Name is required.",
      });
      is_validated = false;
    } else if (this.isFieldRequired('client_phone') && (!client_phone || client_phone === "")) {
      this.setState({
        errorClientName: "",
        errorClientCompName: "",
        errorClientEmail: "",
        errorClientPass: "",
        errorFilerId: "",
        errorClientPhone: "error",
        errorClientMessageEdit: "Phone is required.",
      });
      is_validated = false;
    } else if (this.isFieldRequired('client_phone') && client_phone && client_phone !== "" && !this.isPhoneValid(client_phone)) {
      this.setState({
        errorClientName: "",
        errorClientCompName: "",
        errorClientEmail: "",
        errorClientPass: "",
        errorFilerId: "",
        errorClientPhone: "error",
        errorClientMessageEdit: "Invalid phone format.",
      });
      is_validated = false;
    } else if (client_update_email && client_update_email !== "" && ValidateEmail(client_update_email) === false) {
      this.setState({
        errorClientPhone: "",
        errorClientName: "",
        errorClientCompName: "",
        errorClientPass: "",
        errorFilerId: "",
        errorClientEmail: "error",
        errorClientMessageEdit: "Invalid email format.",
      });
      is_validated = false;
    } else if (this.isFieldRequired('client_address') && (!client_address || client_address === "")) {
      this.setState({
        errorClientPhone: "",
        errorClientName: "",
        errorClientCompName: "",
        errorClientEmail: "",
        errorClientPass: "",
        errorFilerId: "",
        errorClientMessageEdit: "Address is required.",
      });
      is_validated = false;
    } else if (this.isFieldRequired('client_city') && (!client_city || client_city === "")) {
      this.setState({
        errorClientPhone: "",
        errorClientName: "",
        errorClientCompName: "",
        errorClientEmail: "",
        errorClientPass: "",
        errorFilerId: "",
        errorClientCity: "error",
        errorClientMessageEdit: "City is required.",
      });
      is_validated = false;
    } else if (this.isFieldRequired('client_state') && (!client_state || client_state === "")) {
      this.setState({
        errorClientPhone: "",
        errorClientName: "",
        errorClientCompName: "",
        errorClientEmail: "",
        errorClientPass: "",
        errorFilerId: "",
        errorClientCity: "",
        errorClientState: "error",
        errorClientMessageEdit: "State is required.",
      });
      is_validated = false;
    } else if (this.isFieldRequired('client_zip') && (!client_zip || client_zip === "")) {
      this.setState({
        errorClientPhone: "",
        errorClientName: "",
        errorClientCompName: "",
        errorClientEmail: "",
        errorClientPass: "",
        errorFilerId: "",
        errorClientCity: "",
        errorClientState: "",
        errorClientZip: "error",
        errorClientMessageEdit: "Zip/postal code is required.",
      });
      is_validated = false;
    } else if (this.isFieldRequired('client_country') && (!client_country || client_country === "")) {
      this.setState({
        errorClientPhone: "",
        errorClientName: "",
        errorClientCompName: "",
        errorClientEmail: "",
        errorClientPass: "",
        errorFilerId: "",
        errorClientZip: "",
        errorClientMessageEdit: "Country is required.",
      });
      is_validated = false;
    } else if (client_password && client_password !== "") {
      if (client_password.length < 8) {
        this.setState({
          errorClientPhone: "",
          errorClientName: "",
          errorClientCompName: "",
          errorClientEmail: "",
          errorClientPass: "error",
          errorFilerId: "",
          errorClientMessageEdit: "Use 8 characters or more for your password",
        });
        is_validated = false;
      } else if (!passwordRegex.test(client_password)) {
        this.setState({
          errorClientPhone: "",
          errorClientName: "",
          errorClientCompName: "",
          errorClientEmail: "",
          errorClientPass: "error",
          errorFilerId: "",
          errorClientMessageEdit:
            "Password must be at least 8 characters, with uppercase, lowercase, number & special character.",
        });
        is_validated = false;
      } else if (client_confirm_password === "") {
        this.setState({
          errorClientPhone: "",
          errorClientName: "",
          errorClientCompName: "",
          errorClientEmail: "",
          errorClientPass: "error",
          errorFilerId: "",
          errorClientMessageEdit: "Confirm password is required.",
        });
        is_validated = false;
      } else if (client_confirm_password.length < 8) {
        this.setState({
          errorClientPhone: "",
          errorClientName: "",
          errorClientCompName: "",
          errorClientEmail: "",
          errorClientPass: "error",
          errorFilerId: "",
          errorClientMessageEdit:
            "Use 8 characters or more for your confirm password",
        });
        is_validated = false;
      } else if (client_password.trim() !== client_confirm_password.trim()) {
        this.setState({
          errorClientPhone: "",
          errorClientName: "",
          errorClientCompName: "",
          errorClientEmail: "",
          errorClientPass: "error",
          errorFilerId: "",
          errorClientMessageEdit: "Password and confirm password do not match.",
        });
        is_validated = false;
      }
    } else if (client_account_status === "") {
      this.setState({
        errorMessageEdit: "Account Status is required.",
        disabled: false,
      });
      is_validated = false;
    }

    if (is_validated && this.state.assignParentClientRole && !this.state.selectedParentClient) {
      this.setState({
        errorClientMessageEdit: "Please select a parent client.",
      });
      is_validated = false;
    }

    if (is_validated) {
      if (isEmailChanged && !proceedAfterEmailModal) {
        this.setState({ showEmailWarning: true });
        return;
      }

      this.setState({
        errorClientPhone: "",
        errorClientName: "",
        errorClientCompName: "",
        errorClientEmail: "",
        errorClientPass: "",
        disabled: true,
      });
      const fcc_payload =
        this.state.is_fcc_enabled === "Yes"
          ? {
              filer_id: this.state.filer_id,
              ...this.state.fcc_data,
              fcc_raw_data: this.state.fcc_data ? JSON.stringify(this.state.fcc_data) : null,
            }
          : null;

      let apiResponce = await editClient(
        auth.getAccount(),
        auth.getToken(),
        client_accountno,
        client_title,
        client_update_name,
        client_update_email,
        client_password,
        client_phone,
        client_comp_name,
        client_address,
        client_city,
        client_state,
        client_zip,
        client_country,
        this.state.notifyCheckBox.toString(),
        client_account_status,
        statusChanged,
        client_address2,
        client_isVerified,
        original_client_update_email,
        fcc_payload,
      );
      if (
        apiResponce.data.status === 403 ||
        apiResponce.data.errors === "authentication missing" ||
        apiResponce.data.errors === "jwt expired"
      ) {
        this.setState({ disabled: false });
        auth.logout();
      } else if (
        apiResponce.data.status === 409 &&
        apiResponce.data.message === "Address validation failed"
      ) {
        const formattedErrorMessage = apiResponce.data.errors
          ? String(apiResponce.data.errors).replace(/,/g, "<br />")
          : "Address validation failed";
        this.setState({
          errorClientMessageEdit: formattedErrorMessage,
          tableLoader: false,
          disabled: false,
        });
      } else if (
        apiResponce.data.status === 409 &&
        apiResponce.data.message === "Email is already registered."
      ) {
        this.setState({
          successClientMessageEdit: "",
          errorClientMessageEdit:
            "Email already in use. Please use a different one.",
          tableLoader: false,
          disabled: false,
        });
      } else if (
        apiResponce.data.status === 200 &&
        apiResponce.data.message === "success"
      ) {
        // If assign parent client role is enabled, convert client to sub-client
        let shouldRedirectToClients = false;
        if (this.state.assignParentClientRole && this.state.selectedParentClient) {
          const convertResponse = await convertClientToSubClient(
            auth.getAccount(),
            auth.getToken(),
            client_accountno,
            this.state.selectedParentClient,
          );
          if (
            convertResponse.data.status === 200 &&
            convertResponse.data.message === "success"
          ) {
            this.setState({
              successClientMessageEdit:
                "Client updated and assigned as sub-client successfully.",
              errorClientMessageEdit: "",
              tableLoader: false,
              disabled: false,
            });
            shouldRedirectToClients = true;
          } else {
            this.setState({
              successClientMessageEdit: "Client updated successfully.",
              errorClientMessageEdit:
                convertResponse.data.message || "Sub-client conversion failed.",
              tableLoader: false,
              disabled: false,
            });
          }
        } else {
          this.setState({
            successClientMessageEdit: "Client updated successfully.",
            errorClientMessageEdit: "",
            tableLoader: false,
            disabled: false,
          });
        }
        if (shouldRedirectToClients) {
          setTimeout(() => {
            window.location.href = "/clients";
          }, 2000);
        } else {
          setTimeout(async function () {
            //window.$("#modalFormDetail").modal("hide");
            window.location.reload();
          }, 2000);
        }
      } else if (
        apiResponce.data.status === 404 &&
        apiResponce.data.message === "fail"
      ) {
        this.setState({
          errorClientMessageEdit: "Something went wrong,try again later.",
          successClientMessageEdit: "",
          disabled: false,
          tableLoader: false,
        });
        return false;
      } else {
        this.setState({
          errorClientMessageEdit: "Something went wrong,try again later.",
          successClientMessageEdit: "",
          disabled: false,
          tableLoader: false,
        });
        //auth.logout();
      }
    }
  };

  resendActivation = async () => {
    let { client_accountno } = this.state;
    this.setState({
      activation_button: true,
      activation_tick: false,
      activation_cross: false,
    });
    window.$("#modalAlertResend").modal("show");
    const kycResponce = await resendActivation(
      auth.getAccount(),
      auth.getToken(),
      client_accountno,
    );
    //console.log("resendActivation: ", kycResponce.data);
    if (
      kycResponce.data.status === 403 ||
      kycResponce.data.errors === "authentication missing" ||
      kycResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
      return;
    } else if (kycResponce.data.status === 406) {
      this.setState({
        activation_button: false,
        activation_tick: false,
        activation_cross: true,
      });
      //window.location.replace("/error");
    } else if (
      kycResponce.data.status === 404 &&
      kycResponce.data.message === "not_exists"
    ) {
      this.setState({
        activation_button: false,
        activation_tick: false,
        activation_cross: true,
      });
      //window.location.replace("/error");
    } else if (
      kycResponce.data.status === 200 &&
      kycResponce.data.message === "success"
    ) {
      this.setState({
        activation_button: false,
        activation_tick: true,
        activation_cross: false,
      });
    } else {
      this.setState({
        activation_button: false,
        activation_tick: false,
        activation_cross: true,
      });
    }
    setTimeout(() => {
      this.setState({
        activation_button: false,
        activation_tick: false,
        activation_cross: false,
      });
      window.$("#modalAlertResend").modal("hide");
    }, 4000);
  };

  handleEmailWarningYes = () => {
    this.setState(
      {
        proceedAfterEmailModal: true,
      },
      () => {
        this.formUpdateClient();
      },
    );
  };

  handleEmailWarningNo = () => {
    this.setState({ showEmailWarning: false });
  };

  togglePassword = () => {
    this.setState({
      passwordShown: !this.state.passwordShown,
    });
  };

  toggleConfirmPassword = () => {
    this.setState({
      confirmPasswordShown: !this.state.confirmPasswordShown,
    });
  };

  handleAddressSelect = async (place) => {
    const { description } = place.value;
    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
          description,
        )}&key=${process.env.REACT_APP_ADDRESS_AUTOCOMPLETE_API_KEY}`,
      );
      const data = await response.json();

      if (data.status === "OK") {
        const addressComponents = data.results[0].address_components;
        const formattedAddress = data.results[0].formatted_address;
        let city = null;
        let state = null;
        let country = null;
        let zipCode = null;
        let streetAddress = "";
        let neighborhood = null;
        let locality = null;
        let address2 = "";
        addressComponents.forEach((component) => {
          if (component.types.includes("neighborhood")) {
            neighborhood = component.long_name;
          } else if (component.types.includes("locality")) {
            locality = component.long_name;
          } else if (component.types.includes("administrative_area_level_1")) {
            state = component.short_name;
          } else if (component.types.includes("country")) {
            country = component.long_name;
          } else if (component.types.includes("postal_code")) {
            zipCode = component.long_name;
          } else if (component.types.includes("subpremise")) {
            address2 = component.long_name;
          } else if (
            ![
              "neighborhood",
              "sublocality",
              "sublocality_level_1",
              "sublocality_level_2",
              "administrative_area_level_2",
              "administrative_area_level_3",
              "postal_code_suffix",
            ].includes(component.types[0])
          ) {
            if (streetAddress !== "") {
              streetAddress += " ";
            }
            streetAddress += component.long_name;
          }
        });
        // Check if neighborhood is part of the formatted address
        if (neighborhood && formattedAddress.includes(neighborhood)) {
          city = neighborhood;
        } else {
          city = locality;
        }
        this.setState({
          client_city: city && city !== "" ? city : "",
          client_state: state && state !== "" ? state : "",
          client_zip: zipCode && zipCode !== "" ? zipCode : "",
          client_country: country && country !== "" ? country : "",
          client_address:
            streetAddress && streetAddress !== "" ? streetAddress : "",
          client_address2: address2 && address2 !== "" ? address2 : "",
        });
      } else {
        console.error("Reverse geocoding request failed:", data.status);
      }
    } catch (error) {
      console.error("Error fetching reverse geocoding data:", error);
    }
  };

  clientLoginSso = async (value, tableMeta) => {
    let { client_accountno } = this.state;
    this.setState({
      showLoginModal: true,
      loginErrorMessage: "",
      login_url: "",
    });
    const servicesResponce = await client_LoginSso(
      auth.getAccount(),
      auth.getToken(),
      client_accountno,
    );
    //console.log("agentLogin.data.data: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      this.setState({ showLoginModal: false });
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        loginErrorMessage:
          "There is some error while authenticating the account.",
      });
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({ showLoginModal: false });
      setTimeout(() => {
        window.open(servicesResponce.data.login_url, "_blank");
      }, 500);
      this.setState({
        login_url: servicesResponce.data.login_url,
      });
    } else {
      this.setState({
        loginErrorMessage:
          "There is some error while authenticating the account.",
      });
    }
  };

  closeLoginModal = () => {
    this.setState({ showLoginModal: false });
  };

  handleChangeCountry = (event) => {
    const country = event?.label || "";
    this.setState({
      client_country: country,
    });
  };

  normalizeFccPhoneTemp = (phone) => {
    if (!phone) return "";

    // Remove non-digit characters
    const digits = phone.replace(/\D/g, "");

    // Only modify if exactly 10 digits
    if (digits.length === 10) {
      return `1${digits}`;
    }

    // Otherwise return original value
    return phone;
  };

  scrollToDiv = (cont_id) => {
    const targetDiv = document.getElementsByClassName(cont_id);

    if (targetDiv) {
      const targetPosition = targetDiv.offsetTop;

      const scroll = () => {
        const currentPosition = window.scrollY;
        const distance = targetPosition;

        const easeOutCubic = (t) => t * (2 - t);

        const duration = 800; // Adjust the duration as needed
        let start = null;

        const step = (timestamp) => {
          if (!start) start = timestamp;

          const progress = timestamp - start;
          const percentage = progress / duration;

          window.scrollTo(
            0,
            currentPosition + distance * easeOutCubic(percentage),
          );

          if (progress < duration) {
            window.requestAnimationFrame(step);
          }
        };

        window.requestAnimationFrame(step);
      };

      scroll();
    }
  };

  client_archived_forms = async () => {
    const { client_accountno } = this.state;
    // console.log("archived_agreements client_accountno: ", client_accountno);
    const kycResponce = await getClientArchivedForms(
      auth.getAccount(),
      auth.getToken(),
      client_accountno,
    );
    //console.log("client_archived_forms: ", kycResponce.data);
    if (
      kycResponce.data.status === 403 ||
      kycResponce.data.errors === "authentication missing" ||
      kycResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
      return;
    } else if (kycResponce.data.status === 406) {
      this.setState({
        errorMessageAgreements:
          "There is an error while getting the archived. Please try again later.",
        processing_request_archived: false,
        assignedLoader: false,
      });
      //window.location.replace("/error");
    } else if (
      kycResponce.data.status === 404 &&
      kycResponce.data.message === "not_exists"
    ) {
      this.setState({
        errorMessageAgreements: "",
        processing_request_archived: false,
        assignedLoader: false,
      });
      //window.location.replace("/error");
    } else if (
      kycResponce.data.status === 200 &&
      kycResponce.data.message === "success"
    ) {
      this.setState({
        archivedForms: kycResponce.data.data,
        processing_request_archived: false,
        assignedLoader: false,
        columnArchivedForms: [
          {
            name: "form_title",
            label: "Form Title",
          },
          {
            name: "submitter_name",
            label: "Sent To",
          },
          {
            name: "is_submitted",
            label: "Submitted",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return <div>{this.format_submitted(value)}</div>;
              },
            },
          },
          {
            name: "submitted_on",
            label: "Submitted On",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return <div>{this.format_date(value)}</div>;
              },
            },
          },
          {
            name: "sent_by_email",
            label: "Sent By",
            options: {
              customBodyRender: (value) => {
                return <div>{value ? value : "---"}</div>;
              },
            },
          },
          {
            name: "pdf_name",
            label: "Download",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return (
                  <div>
                    {this.format_download_form_archived(value, tableMeta)}
                  </div>
                );
              },
            },
          },
          {
            name: "submission_status",
            label: "Status",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return (
                  <div>{this.format_submission_status(value, tableMeta)}</div>
                );
              },
            },
          },
          {
            name: "form_accountno",
            label: "Actions",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return (
                  <div>
                    <div
                      className="nk-tb-col nk-tb-col-tools"
                      style={{ padding: "0px" }}
                    >
                      <ul className="nk-tb-actions gx-1">
                        <li>
                          <div className="drodown">
                            <a
                              style={{ cursor: "pointer" }}
                              title="Other Actions"
                              className="dropdown-toggle btn btn-icon  btn-outline-light"
                              data-toggle="dropdown"
                            >
                              <em className="icon ni ni-more-h"></em>
                            </a>
                            <div className="dropdown-menu dropdown-menu-md dropdown-menu-right customStyle_dropdown-menu-md_forms">
                              <ul className="link-list-opt no-bdr">
                                <li>
                                  <Tooltip title="View Details" placement="top">
                                    <a
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        this.viewClientArchivedSubmission(
                                          value,
                                          tableMeta,
                                        )
                                      }
                                    >
                                      <em className="icon ni ni-card-view"></em>
                                      <span>View Details</span>
                                    </a>
                                  </Tooltip>
                                </li>

                                <li>
                                  <Tooltip
                                    title="Restore this submission from the archive."
                                    placement="top"
                                  >
                                    <a
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        this.unArchiveSubmission(
                                          value,
                                          tableMeta
                                        )
                                      }
                                    >
                                      <em className="icon ni ni-unarchive"></em>
                                      <span>Unarchive</span>
                                    </a>
                                  </Tooltip>
                                </li>

                                {/*<li>
                                  <Tooltip
                                    title="Delete Submission"
                                    placement="top"
                                  >
                                    <a
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        this.delete_archived_details(
                                          value,
                                          tableMeta
                                        )
                                      }
                                      disabled={
                                        this.props.is_msa_signed === "No" ||
                                        this.props.defaultSettings === "missing"
                                          ? true
                                          : false
                                      }
                                    >
                                      <em className="icon ni ni-edit"></em>
                                      <span>Delete</span>
                                    </a>
                                  </Tooltip>
                                </li>*/}
                              </ul>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                );
              },
            },
          },
          {
            name: "link_form",
            label: "Link Only",
            options: {
              display: false,
            },
          },
          {
            name: "external_link",
            label: "Link",
            options: {
              display: false,
            },
          },
          {
            name: "form_token",
            label: "Token",
            options: {
              display: false,
            },
          },
          {
            name: "archive_date",
            label: "Archive Date",
            options: {
              display: false,
            },
          },
        ],
      });
    } else {
      this.setState({
        errorMessageAgreements: "",
        processing_request_archived: false,
        assignedLoader: false,
      });
    }
  };

  reassing_archived_details = async (value, tableMeta) => {
    const { client_accountno } = this.state;
    let archive_id = tableMeta.rowData[5];
    this.setState({
      reassign_archive_id: archive_id,
      successMessageDelete: "",
      errorMessageDelete: "",
      disabled: false,
    });
    window.$("#modalReassignAlert").modal("show");
  };

  modalHideReassign = () => {
    window.$("#modalReassignAlert").modal("hide");
  };

  reassign_archived_agreement = async () => {
    const { reassign_archive_id, client_accountno } = this.state;
    this.setState({
      successMessageReassign: "",
      errorMessageReassign: "",
      disabled: true,
    });
    const agreementResponce = await reassignClientArchivedAgreement(
      auth.getAccount(),
      auth.getToken(),
      client_accountno,
      reassign_archive_id,
    );

    //console.log("reassignAgreement: ", agreementResponce.data);
    //$("#btnloader").show();
    if (
      agreementResponce.data.status === 403 ||
      agreementResponce.data.errors === "authentication missing" ||
      agreementResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      agreementResponce.data.status === 404 &&
      agreementResponce.data.message === "fail" &&
      agreementResponce.data.note !== ""
    ) {
      // window.location.replace("/error");
      this.setState({
        errorMessageReassign:
          "There is some error while processing the request.",
        successMessageReassign: "",
        disabled: false,
      });
      //$("#btnloader").hide();
    } else if (
      agreementResponce.data.status === 200 &&
      agreementResponce.data.message === "Agreement successfully reassigned."
    ) {
      //await this.reLoadClients();
      this.setState({
        errorMessageReassign: "",
        successMessageReassign: "Agreement successfully reassigned.",
        disabled: false,
      });

      setTimeout(() => {
        window.$("#modalReassignAlert").modal("hide");
        this.archived_agreements(client_accountno);
      }, 2000);
      //$("#btnloader").hide();
    } else {
      this.setState({
        errorMessageReassign:
          "There is some error while processing the request.",
        successMessageReassign: "",
        disabled: false,
      });
      //$("#btnloader").hide();
      //window.location.replace("/error");
    }
  };

  getAllAgreements = async () => {
    const { client_accountno } = this.state;
    this.setState({ disableAssignBtn: false });
    const listClientsResponse = await listAllClientAgreements(
      auth.getAccount(),
      auth.getToken(),
      client_accountno,
    );

    //console.log("getAllForms: ", listClientsResponse.data);

    if (
      listClientsResponse.data.status === 403 ||
      listClientsResponse.data.errors === "authentication missing" ||
      listClientsResponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (listClientsResponse.data.status === 404) {
      // Handle 404 error if needed
      this.setState({
        assignModalLoader: false,
      });
    } else if (
      listClientsResponse.data.status === 200 &&
      listClientsResponse.data.message === "success"
    ) {
      let clients = listClientsResponse.data.data.map((client) => ({
        value: client.agreement_accountno,
        label: client.agreement_title,
      }));

      const selectedAgreements =
        listClientsResponse.data.selected_agreements.map(
          (client) => client.agreement_accountno,
        );

      const selectAllClients =
        clients.length > 0 &&
        clients.every((client) => selectedAgreements.includes(client.value));

      this.setState({
        clientsList: clients,
        selectedAgreements: selectedAgreements,
        selectAllClients: selectAllClients,
        assignModalLoader: false,
      });
    } else {
      this.setState({
        assignModalLoader: false,
      });
      // Handle other responses or errors
    }
    window.$("#modalAssignAgreementClient").modal("show");
  };

  handleSubmitAssignAgreementClient = async () => {
    const { selectedAgreements, client_accountno } = this.state;

    this.setState({ disableAssignBtn: true });

    const assignFormResponse = await assignAgreementsToClients(
      auth.getAccount(),
      auth.getToken(),
      JSON.stringify(selectedAgreements),
      client_accountno,
    );

    //console.log("assignAgreementResponse: ", assignFormResponse.data);

    if (
      assignFormResponse.data.status === 403 ||
      assignFormResponse.data.errors === "authentication missing" ||
      assignFormResponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      assignFormResponse.data.status === 404 &&
      assignFormResponse.data.message === "assigning_error"
    ) {
      this.setState({
        errorMessageAssignAgreement:
          "There was some error while assigning the agreements to the clients.",
        disableAssignBtn: false,
      });
    } else if (
      assignFormResponse.data.status === 200 &&
      assignFormResponse.data.message === "success"
    ) {
      this.setState({
        successMessageAssignAgreement:
          "Agreements assigned to selected client.",
      });
      this.clientAgreements();
      setTimeout(() => {
        this.setState({
          successMessageAssignAgreement: "",
          errorMessageAssignAgreement: "",
        });
        window.$("#modalAssignAgreementClient").modal("hide");
      }, 2000);
    } else {
      this.setState({
        errorMessageAssignAgreement:
          "There was some error while assigning the agreements to the clients.",
        disableAssignBtn: false,
      });
    }
    setTimeout(() => {
      this.setState({
        successMessageAssignAgreement: "",
        errorMessageAssignAgreement: "",
      });
    }, 3500);
  };

  handleClientChangeAgreement = (event, newSelectedOptions) => {
    const newselectedAgreements = newSelectedOptions.map(
      (option) => option.value,
    );

    const selectAllClients =
      this.state.clientsList.length > 0 &&
      this.state.clientsList.length === newselectedAgreements.length;

    this.setState({
      selectedAgreements: newselectedAgreements,
      selectAllClients: selectAllClients,
    });
  };

  /*viewClientArchivedSubmission = async (value, tableMeta) => {
    const rejection_date = tableMeta.rowData[11];
    const rejection_reason = tableMeta.rowData[12];
    this.setState({
      form_title: tableMeta.rowData[0],
      rejection_date: rejection_date,
      rejection_reason: rejection_reason,
    });

    window.$("#modalClientArchivedSubmission").modal("show");
  };*/

  viewClientArchivedSubmission = async (value, tableMeta) => {
    const archive_date = tableMeta.rowData[11];
    this.setState({
      form_title: tableMeta.rowData[0],
      archive_date: archive_date,
    });

    window.$("#modalClientArchivedSubmission").modal("show");
  };

  unArchiveSubmission = async (value, tableMeta) => {
    const { client_accountno } = this.state;
    const form_token = tableMeta.rowData[10];
    // console.log("unArchiveSubmission value: ", value);

    this.setState({
      isProcessingUnarchive: false,
      errorMessageUnarchive: "",
      successMessageUnarchive: "",
      form_token: form_token,
      form_accountno: value,
    });

    window.$("#modalUnarchiveClientAlert").modal("show");
  };

  unarchiveClientSubmission = async () => {
    const { client_accountno, form_token, form_accountno } = this.state;
    this.setState({
      isProcessingUnarchive: true,
      disabled: true,
      errorMessageUnarchive: "",
      successMessageUnarchive: "",
    });

    const servicesResponse = await unarchiveClientSubmission(
      auth.getAccount(),
      auth.getToken(),
      form_accountno,
      form_token,
      client_accountno,
    );

    //console.log("unarchiveClientSubmission: ", servicesResponse.data);

    if (
      servicesResponse.data.status === 403 ||
      servicesResponse.data.errors === "authentication missing" ||
      servicesResponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      servicesResponse.data.status === 404 &&
      servicesResponse.data.message === "form_not_found"
    ) {
      this.setState({
        errorMessageUnarchive:
          "Form not found. It may have been deleted.",
        successMessageUnarchive: "",
        isProcessingUnarchive: false,
        disabled: false,
      });
    } else if (
      servicesResponse.data.status === 200 &&
      servicesResponse.data.message === "success"
    ) {
      this.setState(
        {
          errorMessageUnarchive: "",
          successMessageUnarchive: "Submission restored successfully.",
          isProcessingUnarchive: false,
          reject_general_reason: "",
        },
        () => {
          setTimeout(() => {
            this.client_archived_forms();

            window.$("#modalUnarchiveClientAlert").modal("hide");
            this.setState({
              errorMessageUnarchive: "",
              isProcessingUnarchive: "",
            });
          }, 2000);
        },
      );
    } else {
      this.setState({
        errorMessageUnarchive:
          "There is some error while unarchiving the submission.",
        successMessageUnarchive: "",
        isProcessingUnarchive: false,
        disabled: false,
      });
    }
  };

  openUnrevokeSubmissionAlert = (value, tableMeta) => {
    const form_token = tableMeta.rowData[10];
    this.setState({
      isProcessingUnrevoke: false,
      errorMessageUnrevoke: "",
      successMessageUnrevoke: "",
      unrevokeFormToken: form_token,
      unrevokeFormAccountno: value,
    });
    window.$("#modalUnrevokeSubmissionAlert").modal("show");
  };

  unrevokeClientSubmissionAction = async () => {
    const { client_accountno, unrevokeFormToken, unrevokeFormAccountno } =
      this.state;
    this.setState({
      isProcessingUnrevoke: true,
      disabled: true,
      errorMessageUnrevoke: "",
      successMessageUnrevoke: "",
    });

    const servicesResponse = await unrevokeClientSubmission(
      auth.getAccount(),
      auth.getToken(),
      unrevokeFormAccountno,
      unrevokeFormToken,
      client_accountno,
    );

    if (
      servicesResponse.data.status === 403 ||
      servicesResponse.data.errors === "authentication missing" ||
      servicesResponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      servicesResponse.data.status === 404 &&
      servicesResponse.data.message === "form_archived"
    ) {
      this.setState({
        errorMessageUnrevoke:
          "Form is deleted. Unarchive the form first to restore this submission.",
        successMessageUnrevoke: "",
        isProcessingUnrevoke: false,
        disabled: false,
      });
    } else if (
      servicesResponse.data.status === 200 &&
      servicesResponse.data.message === "success"
    ) {
      this.setState(
        {
          errorMessageUnrevoke: "",
          successMessageUnrevoke: "Submission restored successfully.",
        },
        () => {
          setTimeout(() => {
            this.client_assigned_forms();
            window.$("#modalUnrevokeSubmissionAlert").modal("hide");
            this.setState({
              errorMessageUnrevoke: "",
              successMessageUnrevoke: "",
              isProcessingUnrevoke: false,
            });
          }, 2000);
        },
      );
    } else {
      this.setState({
        errorMessageUnrevoke:
          "There is some error while restoring the submission.",
        successMessageUnrevoke: "",
        isProcessingUnrevoke: false,
        disabled: false,
      });
    }
  };

  client_assigned_forms = async () => {
    const { client_accountno } = this.state;
    // console.log("archived_agreements client_accountno: ", client_accountno);
    const kycResponce = await getClientAssignedForms(
      auth.getAccount(),
      auth.getToken(),
      client_accountno,
    );
    // console.log("client_assigned_forms: ", kycResponce.data);
    if (
      kycResponce.data.status === 403 ||
      kycResponce.data.errors === "authentication missing" ||
      kycResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
      return;
    } else if (kycResponce.data.status === 406) {
      this.setState({
        errorMessageAgreements:
          "There is an error while getting the assigned forms. Please try again later.",
        processing_request_archived: false,
        assignedLoader: false,
      });
      //window.location.replace("/error");
    } else if (
      kycResponce.data.status === 404 &&
      kycResponce.data.message === "not_exists"
    ) {
      this.setState({
        errorMessageAgreements: "",
        processing_request_archived: false,
        assignedLoader: false,
      });
      //window.location.replace("/error");
    } else if (
      kycResponce.data.status === 200 &&
      kycResponce.data.message === "success"
    ) {
      this.setState({
        formsAssignedData: kycResponce.data.data,
        processing_request_archived: false,
        assignedLoader: false,
        columnForms: [
          {
            name: "form_title",
            label: "Title / Progress",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return (
                  <div>
                    {this.format_client_title_for_clients(value, tableMeta)}
                  </div>
                );
              },
            },
          },
          {
            name: "submitter_name",
            label: "Sent To",
          },
          {
            name: "is_submitted",
            label: "Submitted",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return <div>{this.format_submitted(value)}</div>;
              },
            },
          },
          {
            name: "submitted_on",
            label: "Submitted On",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return <div>{this.format_date(value)}</div>;
              },
            },
          },
          {
            name: "sent_by_email",
            label: "Sent By",
          },
          {
            name: "pdf_name",
            label: "Download",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return <div>{this.format_download_form(value, tableMeta)}</div>;
              },
            },
          },
          {
            name: "submission_status",
            label: "Status",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return (
                  <div>{this.format_submission_status(value, tableMeta)}</div>
                );
              },
            },
          },
          {
            name: "form_accountno",
            label: "Actions",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return (
                  <div>
                    <div
                      className="nk-tb-col nk-tb-col-tools"
                      style={{ padding: "0px" }}
                    >
                      <ul className="nk-tb-actions gx-1">
                        <li>
                          <div className="drodown">
                            <a
                              style={{ cursor: "pointer" }}
                              title="Other Actions"
                              className="dropdown-toggle btn btn-icon  btn-outline-light"
                              data-toggle="dropdown"
                            >
                              <em className="icon ni ni-more-h"></em>
                            </a>
                            <div className="dropdown-menu dropdown-menu-md dropdown-menu-right customStyle_dropdown-menu-md_forms">
                              <ul className="link-list-opt no-bdr">
                                {this.state.permissionsState &&
                                this.state.permissionsState.length > 0 &&
                                this.state.permission_view_form_submission ===
                                  1 ? (
                                  <li>
                                    <Tooltip
                                      title="View Details"
                                      placement="top"
                                    >
                                      <a
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          this.viewClientSubmission(
                                            value,
                                            tableMeta,
                                          )
                                        }
                                      >
                                        <em className="icon ni ni-card-view"></em>
                                        <span>View Details</span>
                                      </a>
                                    </Tooltip>
                                  </li>
                                ) : null}

                                {tableMeta.rowData[2] !== 1 &&
                                (!tableMeta.rowData[8] ||
                                  tableMeta.rowData[8] !== 1) ? (
                                  <>
                                    {this.state.permissionsState &&
                                    this.state.permissionsState.length > 0 &&
                                    this.state
                                      .permission_edit_form_submission === 1 ? (
                                      <li>
                                        <Tooltip
                                          title="View Details"
                                          placement="top"
                                        >
                                          <a
                                            style={{ cursor: "pointer" }}
                                            href={`${AGENT_PORTAL_URL}client/client_forms/${tableMeta.rowData[10]}`}
                                            target="_blank"
                                          >
                                            <em className="icon ni ni-edit"></em>
                                            <span>Edit</span>
                                          </a>
                                        </Tooltip>
                                      </li>
                                    ) : null}
                                  </>
                                ) : null}

                                {/*<li>
                                    <Tooltip
                                      title="Edit Submission"
                                      placement="top"
                                    >
                                      <a
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          this.redirectToEditResponse(
                                            "client",
                                            tableMeta
                                          )
                                        }
                                      >
                                        <em className="icon ni ni-card-view"></em>
                                        <span>Edit Submission</span>
                                      </a>
                                    </Tooltip>
                                  </li>*/}

                                {tableMeta.rowData[2] === 1 &&
                                tableMeta.rowData[6] === 0 ? (
                                  <>
                                    {this.state.permissionsState &&
                                    this.state.permissionsState.length > 0 &&
                                    this.state
                                      .permission_approve_form_submission ===
                                      1 ? (
                                      <li>
                                        <Tooltip
                                          title="Approve Submission"
                                          placement="top"
                                        >
                                          <a
                                            style={{ cursor: "pointer" }}
                                            onClick={() =>
                                              this.openApproveClientAlert(
                                                value,
                                                "clients",
                                                tableMeta,
                                              )
                                            }
                                          >
                                            <em className="icon ni ni-done text-success"></em>
                                            <span className="text-success">
                                              Approve
                                            </span>
                                          </a>
                                        </Tooltip>
                                      </li>
                                    ) : null}
                                    {this.state.permissionsState &&
                                    this.state.permissionsState.length > 0 &&
                                    this.state
                                      .permission_reject_form_submission ===
                                      1 ? (
                                      <li>
                                        <Tooltip
                                          title="Reject Submission"
                                          placement="top"
                                        >
                                          <a
                                            style={{ cursor: "pointer" }}
                                            onClick={() =>
                                              this.openRejectionClientAlert(
                                                value,
                                                "clients",
                                                tableMeta,
                                              )
                                            }
                                            className="text-danger"
                                          >
                                            <em className="icon ni ni-cross-circle text-danger"></em>
                                            <span className="text-danger">
                                              Reject
                                            </span>
                                          </a>
                                        </Tooltip>
                                      </li>
                                    ) : null}
                                  </>
                                ) : tableMeta.rowData[2] === 1 &&
                                  tableMeta.rowData[6] === 2 ? (
                                  <>
                                    {this.state.permissionsState &&
                                    this.state.permissionsState.length > 0 &&
                                    this.state
                                      .permission_approve_form_submission ===
                                      1 ? (
                                      <li>
                                        <Tooltip
                                          title="Approve Submission"
                                          placement="top"
                                        >
                                          <a
                                            style={{ cursor: "pointer" }}
                                            onClick={() =>
                                              this.openApproveClientAlert(
                                                value,
                                                "clients",
                                                tableMeta,
                                              )
                                            }
                                          >
                                            <em className="icon ni ni-done text-success"></em>
                                            <span className="text-success">
                                              Approve
                                            </span>
                                          </a>
                                        </Tooltip>
                                      </li>
                                    ) : null}
                                  </>
                                ) : tableMeta.rowData[2] === 1 &&
                                  tableMeta.rowData[6] === 1 ? (
                                  <>
                                    {this.state.permissionsState &&
                                    this.state.permissionsState.length > 0 &&
                                    this.state
                                      .permission_reject_form_submission ===
                                      1 ? (
                                      <li>
                                        <Tooltip
                                          title="Reject Submission"
                                          placement="top"
                                        >
                                          <a
                                            style={{ cursor: "pointer" }}
                                            onClick={() =>
                                              this.openRejectionClientAlert(
                                                value,
                                                "clients",
                                                tableMeta,
                                              )
                                            }
                                            className="text-danger"
                                          >
                                            <em className="icon ni ni-cross-circle text-danger"></em>
                                            <span className="text-danger">
                                              Reject
                                            </span>
                                          </a>
                                        </Tooltip>
                                      </li>
                                    ) : null}
                                  </>
                                ) : null}

                                {this.state.permissionsState &&
                                this.state.permissionsState.length > 0 &&
                                this.state
                                  .permission_view_submission_rejections ===
                                  1 ? (
                                  <li>
                                    <Tooltip
                                      title="View all rejections"
                                      placement="top"
                                    >
                                      <a
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          this.modalAllRejectionsClient(
                                            value,
                                            "clients",
                                            tableMeta,
                                          )
                                        }
                                        className="text-danger"
                                      >
                                        <em className="icon ni ni-cross-circle"></em>
                                        <span>View Rejections</span>
                                      </a>
                                    </Tooltip>
                                  </li>
                                ) : null}

                                {tableMeta.rowData[8] === 0 &&
                                tableMeta.rowData[2] !== 1 ? (
                                  <>
                                    {this.state.permissionsState &&
                                    this.state.permissionsState.length > 0 &&
                                    this.state
                                      .permission_edit_form_submission === 1 ? (
                                      <li>
                                        <Tooltip
                                          title="Send Form"
                                          placement="top"
                                        >
                                          <a
                                            style={{ cursor: "pointer" }}
                                            onClick={() =>
                                              this.get_general_submission_link(
                                                value,
                                                tableMeta,
                                              )
                                            }
                                            className="text-danger"
                                          >
                                            <em className="icon ni ni-send text-warning"></em>
                                            <span className="text-warning">
                                              Send Form
                                            </span>
                                          </a>
                                        </Tooltip>
                                      </li>
                                    ) : null}
                                  </>
                                ) : null}
                                {tableMeta.rowData[8] &&
                                tableMeta.rowData[8] === 1 ? (
                                  <li>
                                    <Tooltip title="Link Only" placement="top">
                                      <a
                                        style={{ cursor: "pointer" }}
                                        href={tableMeta.rowData[9]}
                                        target="_blank"
                                        className="text-danger"
                                      >
                                        <em className="icon ni ni-link-alt text-warning"></em>
                                        <span className="text-warning">
                                          Link Only
                                        </span>
                                      </a>
                                    </Tooltip>
                                  </li>
                                ) : null}
                                {/*<li>
                                  <Tooltip
                                    title="Delete Submission"
                                    placement="top"
                                  >
                                    <a
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        this.delete_archived_details(
                                          value,
                                          tableMeta
                                        )
                                      }
                                      disabled={
                                        this.props.is_msa_signed === "No" ||
                                        this.props.defaultSettings === "missing"
                                          ? true
                                          : false
                                      }
                                    >
                                      <em className="icon ni ni-edit"></em>
                                      <span>Delete</span>
                                    </a>
                                  </Tooltip>
                                </li>*/}
                                {(!tableMeta.rowData[8] ||
                                  tableMeta.rowData[8] === 0) &&
                                tableMeta.rowData[2] !== 1 ? (
                                  <>
                                    {this.state.permissionsState &&
                                    this.state.permissionsState.length > 0 &&
                                    this.state
                                      .permission_edit_submission_notifications ===
                                      1 ? (
                                      <li>
                                        <Tooltip
                                          title="Notification settings"
                                          placement="top"
                                        >
                                          <a
                                            style={{ cursor: "pointer" }}
                                            onClick={() =>
                                              this.open_notifications(
                                                value,
                                                tableMeta,
                                              )
                                            }
                                            disabled={
                                              this.props.is_msa_signed ===
                                                "No" ||
                                              this.props.defaultSettings ===
                                                "missing"
                                                ? true
                                                : false
                                            }
                                          >
                                            <em className="icon ni ni-bell"></em>
                                            <span>Notification settings</span>
                                          </a>
                                        </Tooltip>
                                      </li>
                                    ) : null}
                                  </>
                                ) : null}
                              </ul>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                );
              },
            },
          },
          {
            name: "link_form",
            label: "Link Only",
            options: {
              display: false,
            },
          },
          {
            name: "external_link",
            label: "Link",
            options: {
              display: false,
            },
          },
          {
            name: "form_token",
            label: "Token",
            options: {
              display: false,
            },
          },
          {
            name: "progress",
            label: "Token",
            options: {
              display: false,
            },
          },
        ],
      });
    } else {
      this.setState({
        errorMessageAgreements: "",
        processing_request_archived: false,
        assignedLoader: false,
      });
    }
  };

  get_general_submission_link = async (value, tableMeta, type) => {
    this.setState({
      showMailForm: false,
      form_title: tableMeta.rowData[10],
    });
    window.$("#modalSubmissionLink").modal("show");
    this.setState({
      deleteLoader: true,
      submission_link: "",
    });
    setTimeout(() => {
      this.setState({
        deleteLoader: false,
        submission_link: `${AGENT_PORTAL_URL}client/client_forms/${tableMeta.rowData[10]}`,
      });
    }, 2000);
  };

  format_client_title_for_clients = (value, tableMeta) => {
    // console.log(
    //   "form client title: " +
    //     tableMeta.rowData[0] +
    //     " - " +
    //     tableMeta.rowData[11]
    // );

    let progressPercentage = 0;

    if (
      tableMeta.rowData[11] &&
      tableMeta.rowData[11] !== "undefined/undefined"
    ) {
      let progress = tableMeta.rowData[11];
      let [completed, total] = progress.split("/").map(Number);
      // console.log("completed - total: " + completed + " - " + total);
      progressPercentage = (completed / total) * 100;
    }
    // console.log("progressPercentage: ", progressPercentage);
    return (
      <div className="progress-list gy-3">
        <div className="progress-wrap">
          <div className="progress-text">
            <div
              className="progress-label text-dark fs-10"
              style={{ fontSize: "12px" }}
            >
              {tableMeta.rowData[0]}
            </div>
            <div className="progress-amount text-dark">
              {progressPercentage.toFixed(2)}%
            </div>
          </div>
          <div className="progress progress-md">
            <div
              className="progress-bar bg-teal"
              data-progress={progressPercentage}
              style={{
                width: `${progressPercentage}%`,
              }}
            ></div>
          </div>
        </div>
      </div>
    );
    //return this.state.form_title;
  };

  format_submission_status = (value, tableMeta) => {
    const is_submitted = tableMeta.rowData[2];
    if (is_submitted === 1) {
      if (value === 0) {
        return (
          <span className="badge badge-outline-primary">
            <em className="icon ni ni-done"></em> Pending Approval
          </span>
        );
      } else if (value === 1) {
        return (
          <span className="badge badge-outline-success">
            <em className="icon ni ni-caution"></em> Approved
          </span>
        );
      } else if (value === 2) {
        return (
          <span className="badge badge-outline-danger">
            <em className="icon ni ni-caution"></em> Rejected
          </span>
        );
      } else if (value === 3) {
        return (
          <span className="badge badge-outline-danger">
            <em className="icon ni ni-file"></em> Archived
          </span>
        );
      } else {
        return (
          <span className="badge badge-outline-primary">
            <em className="icon ni ni-caution"></em> Pending Approval
          </span>
        );
      }
    } else {
      if (value === 2) {
        return (
          <span className="badge badge-outline-danger">
            <em className="icon ni ni-caution"></em> Rejected
          </span>
        );
      } else if (value === 3) {
        return (
          <span className="badge badge-outline-warning">
            <em className="icon ni ni-file"></em> Drafted
          </span>
        );
      } else {
        return "---";
      }
    }
  };

  format_submitted = (value) => {
    if (value === 1) {
      return (
        <span className="badge badge-outline-success">
          <em className="icon ni ni-done"></em> Yes
        </span>
      );
    } else {
      return (
        <span className="badge badge-outline-light">
          <em className="icon ni ni-caution"></em> No
        </span>
      );
    }
  };

  openApproveClientAlert = (id, type, tableMeta) => {
    const form_token = tableMeta.rowData[10];
    this.setState({
      client_submission_id: form_token,
      form_accountno: id,
      client_submission_type: type,
      approveClientErrorMessage: "",
      approveClientSuccessMessage: "",
      approve_client_button: false,
      form_token: form_token,
      form_title: tableMeta.rowData[0],
    });
    window.$("#modalApproveClientAlert").modal("show");
  };

  openApproveClientMainAlert = () => {
    this.setState({
      approveClientModalErrorMessage: "",
      approveClientModalSuccessMessage: "",
      approveClientButtonLoading: false,
      rejectClientModalErrorMessage: "",
      rejectClientModalSuccessMessage: "",
      rejectClientButtonLoading: false,
      rejectClientReason: "",
      showRejectReasonField: false,
    });
    window.$("#modalApproveClientMainAlert").modal("show");
  };

  openAddFilerIdModal = () => {
    this.setState({
      showAddFilerIdModal: true,
      addFilerIdValue: "",
      addFilerIdLoading: false,
      addFilerIdSuccess: false,
      addFilerIdError: "",
      addFilerIdFccData: null,
      ocnValues: [],
      ocnFixedValues: [],
    });
    window.$("#modalAddFilerId").modal("show");
  };

  closeAddFilerIdModal = () => {
    window.$("#modalAddFilerId").modal("hide");
    this.setState({
      showAddFilerIdModal: false,
    });
  };

  handleAddFilerIdChange = (value) => {
    this.setState({
      addFilerIdValue: value,
      addFilerIdError: "",
      addFilerIdSuccess: false,
    });
  };

  handleAddFilerIdSelect = async (filerId) => {
    // User selected an item from autocomplete dropdown
    this.setState({
      addFilerIdValue: filerId,
      addFilerIdError: "",
      addFilerIdSuccess: false,
    });
    // Verify the selected Filer ID
    await this.verifyAddFilerId(filerId);
  };

  handleAddFilerIdDataLoading = () => {
    // Optional: handle loading state
  };

  handleAddFilerIdDataLoaded = () => {
    // Optional: handle loaded state
  };

  handleAddFilerIdDataError = (error) => {
    // Optional: handle error state
  };

  verifyAddFilerId = async (filerId) => {
    if (!filerId || filerId.trim() === "") {
      return;
    }

    this.setState({
      addFilerIdLoading: true,
      addFilerIdError: "",
      addFilerIdSuccess: false,
    });

    try {
      const response = await getFccFiler(
        auth.getAccount(),
        auth.getToken(),
        filerId,
      );

      if (
        response.data.status === 403 ||
        response.data.errors === "authentication missing" ||
        response.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (response.data.status === 200) {
        // FCC API returns data in response.data.frn_details.data.robocall_data or response.data.data
        const fccData = response.data.frn_details?.data || response.data.data;
        let fixedOcns = [];
        let ocnMsg = "";
        let ocnRaw =
          fccData.robocall_data && typeof fccData.robocall_data === "object"
            ? fccData.robocall_data.ocn
            : null;
        if (ocnRaw && typeof ocnRaw === "string" && ocnRaw.trim() !== "") {
          fixedOcns = ocnRaw
            .toString()
            .split(",")
            .map((ocn) => ocn.trim())
            .filter((ocn) => ocn !== "");
          ocnMsg = "Filer ID verified and OCN(s) loaded.";
        } else {
          ocnMsg =
            "Filer ID verified, but no OCN was found for this filer. Please add OCN(s) manually if applicable.";
        }

        // Check if Filer ID already exists - MUST run before setting success
        try {
          const checkResponse = await checkFilerIdExists(
            auth.getAccount(),
            auth.getToken(),
            filerId
          );
          
          if (checkResponse.data && checkResponse.data.exists) {
            this.setState({
              addFilerIdLoading: false,
              filerIdAlreadyExists: true,
              addFilerIdError: "This Filer ID is already associated with an existing client.",
              addFilerIdSuccess: false,
              addFilerIdFccData: null,
              ocnFixedValues: [],
              ocnValues: [],
              addFilerIdSuccessMsg: "",
            });
            return; // Stop execution if duplicate found
          }
        } catch (error) {
          console.error("Error checking filer ID:", error);
          // Continue even if check fails
        }

        // Only set success if no duplicate was found
        this.setState({
          addFilerIdLoading: false,
          addFilerIdSuccess: true,
          addFilerIdFccData: fccData,
          ocnFixedValues: fixedOcns,
          ocnValues: [...fixedOcns],
          addFilerIdError: "",
          addFilerIdSuccessMsg: ocnMsg,
          filerIdAlreadyExists: false,
        });

        setTimeout(() => {
          this.setState({
            addFilerIdSuccessMsg: "",
          });
        }, 3000);
      } else {
        this.setState({
          addFilerIdLoading: false,
          addFilerIdError: response.data.errors || "Failed to verify Filer ID",
          addFilerIdSuccess: false,
          addFilerIdSuccessMsg: "",
        });
        setTimeout(() => {
          this.setState({ addFilerIdError: "" });
        }, 2000);
      }
    } catch (error) {
      this.setState({
        addFilerIdLoading: false,
        addFilerIdError: "An error occurred while verifying Filer ID",
        addFilerIdSuccess: false,
        addFilerIdSuccessMsg: "",
      });
      setTimeout(() => {
        this.setState({ addFilerIdError: "" });
      }, 2000);
    }
  };

  handleAddFilerIdBlur = async () => {
    const { addFilerIdValue } = this.state;
    await this.verifyAddFilerId(addFilerIdValue);
  };

  handleAddFilerIdKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      this.handleAddFilerIdBlur();
    }
  };

  handleOcnChange = (event, newValue) => {
    const { ocnFixedValues } = this.state;
    // Accept alphanumeric OCNs
    const updatedValues = [
      ...ocnFixedValues,
      ...newValue.filter((option) => !ocnFixedValues.includes(option)),
    ];
    this.setState({
      ocnValues: updatedValues,
    });
  };

  openUpdateOcnModal = async () => {
    this.setState({
      showUpdateOcnModal: true,
      updateOcnValues: [],
      updateOcnLoading: true,
      updateOcnError: "",
      updateOcnSuccess: "",
      updateOcnWarning: "",
    });
    window.$("#modalUpdateOcn").modal("show");

    // Fetch existing OCNs
    try {
      const response = await getClientOcns(
        auth.getAccount(),
        auth.getToken(),
        this.state.client_accountno,
      );

      if (
        response.data.status === 403 ||
        response.data.errors === "authentication missing" ||
        response.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (
        response.data.status === 200 &&
        response.data.data &&
        response.data.data.length > 0
      ) {
        // Parse OCNs from response - data is an array
        const ocns = response.data.data[0].ocn
          ? response.data.data[0].ocn
              .split(",")
              .map((ocn) => ocn.trim())
              .filter((ocn) => ocn !== "")
          : [];
        this.setState({
          updateOcnValues: ocns,
          updateOcnLoading: false,
        });
      } else {
        this.setState({
          updateOcnValues: [],
          updateOcnLoading: false,
        });
      }
    } catch (error) {
      console.error("Error fetching OCNs:", error);
      this.setState({
        updateOcnLoading: false,
        updateOcnError: "Failed to load OCNs",
      });
    }
  };

  closeUpdateOcnModal = () => {
    window.$("#modalUpdateOcn").modal("hide");
    this.setState({
      showUpdateOcnModal: false,
      updateOcnValues: [],
      updateOcnError: "",
      updateOcnSuccess: "",
      updateOcnWarning: "",
    });
  };

  handleUpdateOcnChange = (event, newValue) => {
    // Accept alphanumeric OCNs
    this.setState({
      updateOcnValues: newValue,
    });
  };

  openRevokeFccModal = () => {
    this.setState({
      showRevokeFccModal: true,
      revokeClientFccLoading: false,
      revokeClientFccError: "",
      revokeClientFccSuccess: "",
    });
    window.$("#modalRevokeFcc").modal("show");
  };

  closeRevokeFccModal = () => {
    window.$("#modalRevokeFcc").modal("hide");
    this.setState({
      showRevokeFccModal: false,
      revokeClientFccError: "",
      revokeClientFccSuccess: "",
    });
  };

  openFccDataModal = async () => {
    this.setState({
      showFccDataModal: true,
      fccDataModalLoading: true,
      fccDataModalData: null,
      fccDataModalError: "",
    });
    window.$("#modalFccDataViewer").modal("show");

    try {
      const response = await getClientOcns(
        auth.getAccount(),
        auth.getToken(),
        this.state.client_accountno,
      );

      if (
        response.data.status === 403 ||
        response.data.errors === "authentication missing" ||
        response.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (
        response.data.status === 200 &&
        response.data.data &&
        response.data.data.length > 0
      ) {
        this.setState({
          fccDataModalData: response.data.data[0],
          fccDataModalLoading: false,
        });
      } else {
        this.setState({
          fccDataModalLoading: false,
          fccDataModalError: "No FCC data found for this client",
        });
      }
    } catch (error) {
      console.error("Error fetching FCC data:", error);
      this.setState({
        fccDataModalLoading: false,
        fccDataModalError: "Failed to load FCC data",
      });
    }
  };

  closeFccDataModal = () => {
    window.$("#modalFccDataViewer").modal("hide");
    this.setState({
      showFccDataModal: false,
      fccDataModalData: null,
      fccDataModalError: "",
    });
  };

  // Format a snake_case or underscore key into a human-readable label
  formatFccKey = (key) => {
    if (!key) return "";
    // Strip leading digits/underscores (e.g. "499_filer_data" → "Filer Data")
    let cleaned = key.replace(/^\d+_/, "");
    return cleaned
      .replace(/_/g, " ")
      .replace(/\b\w/g, (c) => c.toUpperCase());
  };

  // Format a value for display
  formatFccValue = (value) => {
    if (value === null || value === undefined || value === "") return "-";
    if (value === true || value === "true") return "Yes";
    if (value === false || value === "false") return "No";
    return String(value);
  };

  // Render a section of key-value pairs from a flat or nested object
  renderFccSection = (obj, sectionTitle = null, depth = 0) => {
    if (!obj || typeof obj !== "object") return null;
    const entries = Object.entries(obj);
    if (entries.length === 0) return null;

    // Separate flat values from nested objects/arrays
    const flatEntries = entries.filter(
      ([, v]) => v === null || typeof v !== "object",
    );
    const nestedEntries = entries.filter(
      ([, v]) => v !== null && typeof v === "object",
    );

    return (
      <div key={sectionTitle || "root"} style={{ marginBottom: depth > 0 ? "10px" : "20px" }}>
        {sectionTitle ? (
          <h6
            style={{
              marginTop: depth === 0 ? "20px" : "10px",
              marginBottom: "10px",
              padding: "8px 12px",
              backgroundColor: depth === 0 ? "#364a63" : "#e5e9f2",
              color: depth === 0 ? "#fff" : "#364a63",
              borderRadius: "4px",
              fontSize: depth === 0 ? "14px" : "13px",
              fontWeight: 600,
            }}
          >
            {this.formatFccKey(sectionTitle)}
          </h6>
        ) : null}
        {flatEntries.length > 0 ? (
          <table className="table table-bordered" style={{ marginBottom: "5px" }}>
            <tbody>
              {flatEntries.map(([key, value]) => (
                <tr key={key}>
                  <th
                    style={{
                      width: "35%",
                      backgroundColor: "#f5f6fa",
                      fontSize: "13px",
                      fontWeight: 500,
                    }}
                  >
                    {this.formatFccKey(key)}
                  </th>
                  <td style={{ fontSize: "13px" }}>
                    {this.formatFccValue(value)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : null}
        {nestedEntries.map(([key, value]) => {
          if (Array.isArray(value)) {
            // Render arrays: if array of objects, render each as a sub-section
            if (value.length === 0) return null;
            if (typeof value[0] === "object" && value[0] !== null) {
              return (
                <div key={key}>
                  <h6
                    style={{
                      marginTop: "10px",
                      marginBottom: "8px",
                      padding: "6px 12px",
                      backgroundColor: "#e5e9f2",
                      borderRadius: "4px",
                      fontSize: "13px",
                      fontWeight: 600,
                      color: "#364a63",
                    }}
                  >
                    {this.formatFccKey(key)} ({value.length})
                  </h6>
                  {value.map((item, idx) =>
                    this.renderFccSection(item, `${key} #${idx + 1}`, depth + 1),
                  )}
                </div>
              );
            }
            // Array of primitives
            return (
              <table className="table table-bordered" key={key} style={{ marginBottom: "5px" }}>
                <tbody>
                  <tr>
                    <th style={{ width: "35%", backgroundColor: "#f5f6fa", fontSize: "13px", fontWeight: 500 }}>
                      {this.formatFccKey(key)}
                    </th>
                    <td style={{ fontSize: "13px" }}>
                      {value.map((v, i) => (
                        <span
                          key={i}
                          className="badge badge-outline-primary"
                          style={{ marginRight: "5px", marginBottom: "3px", display: "inline-block" }}
                        >
                          {this.formatFccValue(v)}
                        </span>
                      ))}
                    </td>
                  </tr>
                </tbody>
              </table>
            );
          }
          // Nested object
          return this.renderFccSection(value, key, depth + 1);
        })}
      </div>
    );
  };

  submitRevokeFcc = async () => {
    const { client_accountno } = this.state;

    this.setState({
      revokeClientFccLoading: true,
      revokeClientFccError: "",
      revokeClientFccSuccess: "",
    });

    try {
      const response = await revokeClientFcc(
        auth.getAccount(),
        auth.getToken(),
        client_accountno,
      );

      if (
        response.data.status === 403 ||
        response.data.errors === "authentication missing" ||
        response.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (response.data.status === 200) {
        this.closeRevokeFccModal();
        this.setState({
          revokeClientFccLoading: false,
          revokeClientFccError: "",
          revokeClientFccSuccess: "",
          isApproved: 0,
          fccToastMessage: "FCC 499 approval revoked successfully.",
          fccToastType: "success",
        });
      } else {
        let errorMsg =
          response.data.message ||
          response.data.errors ||
          "Failed to revoke FCC 499 approval";
        if (typeof errorMsg === "object") {
          errorMsg = JSON.stringify(errorMsg);
        }
        this.closeRevokeFccModal();
        this.setState({
          revokeClientFccLoading: false,
          revokeClientFccError: "",
          fccToastMessage: errorMsg,
          fccToastType: "error",
        });
      }
    } catch (error) {
      this.closeRevokeFccModal();
      this.setState({
        revokeClientFccLoading: false,
        revokeClientFccError: "",
        fccToastMessage: "An error occurred while revoking FCC 499 approval.",
        fccToastType: "error",
      });
    }
  };

  submitUpdateOcn = async () => {
    const { updateOcnValues, client_accountno } = this.state;

    this.setState({
      updateOcnLoading: true,
      updateOcnError: "",
      updateOcnSuccess: "",
      updateOcnWarning: "",
    });

    try {
      // Join OCN values with comma
      const ocnString = updateOcnValues.join(",");

      // Call API to save updated OCNs
      const updateResponse = await saveClientOcns(
        auth.getAccount(),
        auth.getToken(),
        client_accountno,
        ocnString,
      );

      if (
        updateResponse.data.status === 403 ||
        updateResponse.data.errors === "authentication missing" ||
        updateResponse.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (updateResponse.data.status === 200) {
        const messageDetails = updateResponse.data.message_details;
        let timeoutDuration = 2000;

        if (messageDetails === "success_with_rejected_ocns") {
          const rejectedOcns = updateResponse.data.rejected_ocns || [];
          const rmdbRejected = rejectedOcns
            .filter((r) => r.reason === "not_validated_rmdb")
            .map((r) => r.ocn);
          const duplicateRejected = rejectedOcns
            .filter((r) => r.reason === "duplicate_other_account")
            .map((r) => r.ocn);

          let warningParts = [];
          if (rmdbRejected.length > 0) {
            warningParts.push(
              "These OCNs were rejected as they are not validated from RMDB: " +
                rmdbRejected.join(", "),
            );
          }
          if (duplicateRejected.length > 0) {
            warningParts.push(
              "These OCNs are already assigned to other clients: " +
                duplicateRejected.join(", "),
            );
          }

          const warningMessage =
            "OCNs partially updated. " +
            warningParts.join(". ") + ".";
          timeoutDuration = 6000;

          this.setState({
            updateOcnLoading: false,
            updateOcnWarning: warningMessage,
          });
        } else {
          this.setState({
            updateOcnLoading: false,
            updateOcnSuccess: "OCNs updated successfully",
          });
        }

        setTimeout(function () {
          window.location.reload();
        }, timeoutDuration);
      } else {
        let errorMsg = "";
        const respData = updateResponse.data;

        if (respData.message === "not_exists") {
          errorMsg =
            "No FCC record was found for this client. Please add a Filer ID first before updating OCNs.";
        } else if (Array.isArray(respData.errors)) {
          errorMsg = respData.errors
            .map((e) => (e.msg ? e.param + ": " + e.msg : String(e)))
            .join(", ");
        } else if (
          respData.errors &&
          typeof respData.errors === "object"
        ) {
          errorMsg =
            respData.errors.message ||
            JSON.stringify(respData.errors);
        } else if (respData.message) {
          errorMsg = respData.message;
        } else {
          errorMsg =
            "Unable to update OCNs. Please try again or contact support.";
        }

        this.setState({
          updateOcnLoading: false,
          updateOcnError: errorMsg,
        });
        setTimeout(() => {
          this.setState({ updateOcnError: "" });
        }, 4000);
      }
    } catch (error) {
      this.setState({
        updateOcnLoading: false,
        updateOcnError:
          "A network error occurred while updating OCNs. Please check your connection and try again.",
      });
      setTimeout(() => {
        this.setState({ updateOcnError: "" });
      }, 4000);
    }
  };

  submitAddFilerId = async () => {
    const { addFilerIdValue, ocnValues, client_accountno, addFilerIdFccData } =
      this.state;
    // console.log("addFilerIdFccData: ", addFilerIdFccData);
    if (!addFilerIdValue || addFilerIdValue.trim() === "") {
      this.setState({
        addFilerIdError: "Please enter a valid Filer ID",
      });
      return;
    }

    if (!this.state.addFilerIdSuccess) {
      this.setState({
        addFilerIdError: "Please verify the Filer ID first",
      });
      return;
    }

    if (this.state.filerIdAlreadyExists) {
      this.setState({
        addFilerIdError: "This Filer ID is already associated with an existing client",
      });
      return;
    }

    this.setState({
      addFilerIdLoading: true,
      addFilerIdError: "",
    });

    try {
      // Join OCN values with comma
      const ocnString = ocnValues.join(",");

      // Extract frn, number, coresid from addFilerIdFccData (from getFccFiler response)
      let frn = null;
      let number = null;
      let coresid = null;
      if (addFilerIdFccData && addFilerIdFccData.robocall_data) {
        frn = addFilerIdFccData.robocall_data.frn || null;
        number = addFilerIdFccData.robocall_data.number || null;
        coresid = addFilerIdFccData.coresid || null;
      }

      // Call API to update client with filer_id, ocns, and new fields
      const updateResponse = await updateClientFilerIdAndOcn(
        auth.getAccount(),
        auth.getToken(),
        client_accountno,
        addFilerIdValue,
        ocnString,
        coresid,
        number,
        frn,
        addFilerIdFccData ? JSON.stringify(addFilerIdFccData) : null,
      );

      if (
        updateResponse.data.status === 403 ||
        updateResponse.data.errors === "authentication missing" ||
        updateResponse.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (updateResponse.data.status === 200) {
        const messageDetails = updateResponse.data.message_details;
        let addFilerWarning = "";

        if (messageDetails === "success_with_rejected_ocns") {
          const rejectedOcns = updateResponse.data.rejected_ocns || [];
          const rmdbRejected = rejectedOcns
            .filter((r) => r.reason === "not_validated_rmdb")
            .map((r) => r.ocn);
          const duplicateRejected = rejectedOcns
            .filter((r) => r.reason === "duplicate_other_account")
            .map((r) => r.ocn);

          let warningParts = [];
          if (rmdbRejected.length > 0) {
            warningParts.push(
              "These OCNs were rejected as they are not validated from RMDB: " +
                rmdbRejected.join(", "),
            );
          }
          if (duplicateRejected.length > 0) {
            warningParts.push(
              "These OCNs are already assigned to other clients: " +
                duplicateRejected.join(", "),
            );
          }

          if (warningParts.length > 0) {
            addFilerWarning = " Note: " + warningParts.join(". ") + ".";
          }
        }

        this.setState({
          addFilerIdLoading: false,
          filer_id: addFilerIdValue,
          addFilerIdSuccess: true,
          addFilerIdSuccessMsg: addFilerWarning
            ? "Filer ID saved successfully." + addFilerWarning
            : "Filer ID saved successfully",
        });
        setTimeout(function () {
          window.location.reload();
        }, addFilerWarning ? 6000 : 2000);
      } else {
        let errorMsg = "";
        const respData = updateResponse.data;

        if (
          respData.message === "filer_id_already_exists" ||
          (respData.error &&
            respData.error.message === "filer_id_already_exists")
        ) {
          errorMsg =
            "This Filer ID is already assigned to another client. Please use a different Filer ID.";
        } else if (respData.message === "not_exists") {
          errorMsg =
            "No FCC record was found for this client. Please contact support if this issue persists.";
        } else if (Array.isArray(respData.errors)) {
          errorMsg = respData.errors
            .map((e) => (e.msg ? e.param + ": " + e.msg : String(e)))
            .join(", ");
        } else if (
          respData.errors &&
          typeof respData.errors === "object"
        ) {
          errorMsg =
            respData.errors.message ||
            JSON.stringify(respData.errors);
        } else if (respData.message) {
          errorMsg = respData.message;
        } else {
          errorMsg =
            "Unable to save Filer ID. Please try again or contact support.";
        }

        this.setState({
          addFilerIdLoading: false,
          addFilerIdError: errorMsg,
        });
        setTimeout(() => {
          this.setState({ addFilerIdError: "" });
        }, 4000);
      }
    } catch (error) {
      this.setState({
        addFilerIdLoading: false,
        addFilerIdError:
          "A network error occurred while saving the Filer ID. Please check your connection and try again.",
      });
      setTimeout(() => {
        this.setState({ addFilerIdError: "" });
      }, 4000);
    }
  };

  approve_client_main = async () => {
    // console.log("approving client");
    const { client_accountno } = this.state;
    this.setState({
      approveClientModalErrorMessage: "",
      approveClientModalSuccessMessage: "",
      approveClientButtonLoading: true,
    });

    const approveResponse = await approveClient(
      auth.getAccount(),
      auth.getToken(),
      client_accountno,
    );

    if (
      approveResponse.data.status === 403 ||
      approveResponse.data.errors === "authentication missing" ||
      approveResponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      approveResponse.data.status === 200 &&
      approveResponse.data.message === "success"
    ) {
      // console.log("approve_client_main: ", approveResponse.data);
      this.setState(
        {
          approveClientModalErrorMessage: "",
          approveClientModalSuccessMessage: "Client approved successfully.",
          approveClientButtonLoading: false,
          isApproved: 1,
        },
        () => {
          setTimeout(function () {
            window.location.reload();
          }, 2000);
        },
      );
    } else {
      // console.log("approve_client_main error");
      this.setState({
        approveClientButtonLoading: false,
        approveClientModalErrorMessage:
          "There is some error while approving the client.",
        approveClientModalSuccessMessage: "",
      });
      setTimeout(() => {
        this.setState({ approveClientModalErrorMessage: "" });
      }, 2000);
    }
  };

  handleRejectReasonChange = (event) => {
    this.setState({
      rejectClientReason: event.target.value,
    });
  };

  showRejectReasonField = () => {
    this.setState({
      showRejectReasonField: true,
      rejectClientModalErrorMessage: "",
      rejectClientModalSuccessMessage: "",
    });
  };

  reject_client_main = async () => {
    const { client_accountno, rejectClientReason, filer_id } = this.state;

    // Validate rejection reason
    if (!rejectClientReason || rejectClientReason.trim() === "") {
      this.setState({
        rejectClientModalErrorMessage: "Rejection reason is required.",
        rejectClientModalSuccessMessage: "",
      });
      setTimeout(() => {
        this.setState({ rejectClientModalErrorMessage: "" });
      }, 2000);
      return;
    }

    this.setState({
      rejectClientModalErrorMessage: "",
      rejectClientModalSuccessMessage: "",
      rejectClientButtonLoading: true,
    });

    try {
      const rejectResponse = await rejectClientFccFiler(
        auth.getAccount(),
        auth.getToken(),
        client_accountno,
        filer_id,
        rejectClientReason.trim(),
      );

      if (
        rejectResponse.data.status === 403 ||
        rejectResponse.data.errors === "authentication missing" ||
        rejectResponse.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (
        rejectResponse.data.status === 200 &&
        rejectResponse.data.message === "success"
      ) {
        const emailStatus = rejectResponse.data.email_status;
        const emailError = rejectResponse.data.email_error;
        let toastMsg = "Client FCC Filer ID rejected successfully.";
        let toastType = "success";
        if (emailStatus === "skipped" || emailStatus === "failed") {
          toastMsg = "Client FCC Filer ID rejected successfully. Email issue: " + emailError;
          toastType = "error";
        }
        window.$("#modalApproveClientMainAlert").modal("hide");
        this.setState({
          rejectClientModalErrorMessage: "",
          rejectClientModalSuccessMessage: "",
          rejectClientButtonLoading: false,
          rejectClientReason: "",
          showRejectReasonField: false,
          isApproved: 2,
          filer_id: "",
          clientOcns: [],
          fcc_filing_url: "",
          fccToastMessage: toastMsg,
          fccToastType: toastType,
        });
      } else {
        window.$("#modalApproveClientMainAlert").modal("hide");
        this.setState({
          rejectClientButtonLoading: false,
          rejectClientModalErrorMessage: "",
          rejectClientModalSuccessMessage: "",
          fccToastMessage:
            rejectResponse.data.errors ||
            "There is some error while rejecting the client.",
          fccToastType: "error",
        });
      }
    } catch (error) {
      console.error("reject_client_main error: ", error);
      window.$("#modalApproveClientMainAlert").modal("hide");
      this.setState({
        rejectClientButtonLoading: false,
        rejectClientModalErrorMessage: "",
        rejectClientModalSuccessMessage: "",
        fccToastMessage: "There is some error while rejecting the client.",
        fccToastType: "error",
      });
    }
  };

  handleApprovalNotesChange = (event) => {
    const value = event.target.value;
    this.setState({
      approvalNotes: value,
      approvalNotesError: "", // Clear error when user types
    });
  };

  approve_client_form = async () => {
    const {
      client_submission_id,
      client_submission_type,
      form_accountno,
      form_title,
      client_accountno,
      form_token,
      approvalNotes,
    } = this.state;
    this.setState({
      approveClientErrorMessage: "",
      approveClientSuccessMessage: "",
      approve_client_button: true,
    });

    const servicesResponse = await approveClientSubmission(
      auth.getAccount(),
      auth.getToken(),
      form_accountno,
      client_submission_id,
      form_title,
      client_submission_type,
      client_accountno,
      approvalNotes || "",
    );

    //console.log("approveClientSubmission: ", servicesResponse.data);

    if (
      servicesResponse.data.status === 403 ||
      servicesResponse.data.errors === "authentication missing" ||
      servicesResponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      servicesResponse.data.status === 400 &&
      servicesResponse.data.message === "form_not_found"
    ) {
      this.setState({
        approveClientErrorMessage:
          "There is some error while approving the submission.",
        approveClientSuccessMessage: "",
        approve_client_button: false,
      });
    } else if (
      servicesResponse.data.status === 200 &&
      servicesResponse.data.message === "success"
    ) {
      this.setState(
        {
          approveClientErrorMessage: "",
          approveClientSuccessMessage: "Submission approved successfully.",

          reject_general_reason: "",
          approvalNotes: "",
          approvalNotesError: "",
        },
        () => {
          setTimeout(() => {
            if (client_submission_type === "clients") {
              this.client_assigned_forms();
            }

            window.$("#modalApproveClientAlert").modal("hide");
            this.setState({
              approveClientErrorMessage: "",
              approveClientSuccessMessage: "",
              approvalNotes: "",
              approvalNotesError: "",
            });
            //window.location.reload();
          }, 2000);
        },
      );
    } else {
      this.setState({
        approve_client_button: false,
        approveClientErrorMessage:
          "There is some error while approving the submission.",
        approveClientSuccessMessage: "",
        approvalNotesError: "",
      });
    }
  };

  openRejectionClientAlert = (id, type, tableMeta) => {
    let rejection_client_title = "Reject Submission";
    if (type === "clients") {
      rejection_client_title = "Reject Client Submission";
    }
    if (type === "agents") {
      rejection_client_title = "Reject Channel Partner Submission";
    }
    const form_token = tableMeta.rowData[10];

    this.setState({
      client_submission_id: form_token,
      form_accountno: id,
      rejectClientErrorMessage: "",
      rejectClientSuccessMessage: "",
      reject_client_reason: "",
      reject_client_button: false,
      rejection_client_title: rejection_client_title,
      client_submission_type: type,
      form_token: form_token,
      form_title: tableMeta.rowData[0],
    });
    //console.log("resendForm: ", id);
    window.$("#modalRejectionClientAlert").modal("show");
  };

  reject_client_form = async () => {
    const {
      client_submission_id,
      reject_client_reason,
      form_accountno,
      form_title,
      client_submission_type,
      client_accountno,
      form_token,
    } = this.state;
    this.setState({
      reject_client_button: true,
      rejectClientErrorMessage: "",
      rejectClientSuccessMessage: "",
    });
    let is_validated = true;
    if (reject_client_reason === "") {
      is_validated = false;
    }
    if (is_validated === true) {
      const servicesResponse = await rejectClientSubmission(
        auth.getAccount(),
        auth.getToken(),
        form_accountno,
        client_submission_id,
        reject_client_reason,
        form_title,
        client_submission_type,
        client_accountno,
      );

      //console.log("reject_client_form: ", servicesResponse.data);

      if (
        servicesResponse.data.status === 403 ||
        servicesResponse.data.errors === "authentication missing" ||
        servicesResponse.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (
        servicesResponse.data.status === 400 &&
        servicesResponse.data.message === "form_not_found"
      ) {
        this.setState({
          rejectClientErrorMessage:
            "There is some error while rejecting the submission.",
          rejectClientSuccessMessage: "",
          reject_client_button: false,
        });
      } else if (
        servicesResponse.data.status === 200 &&
        servicesResponse.data.message === "success"
      ) {
        this.setState(
          {
            rejectClientErrorMessage: "",
            rejectClientSuccessMessage: "Submission rejected successfully.",
            reject_client_button: false,
            reject_general_reason: "",
          },
          () => {
            setTimeout(() => {
              if (client_submission_type === "clients") {
                this.client_assigned_forms();
              }
              if (client_submission_type === "agents") {
                //this.getAgentSubmissions();
              }
              window.$("#modalRejectionClientAlert").modal("hide");
              this.setState({
                rejectClientErrorMessage: "",
                rejectClientSuccessMessage: "Submission rejected successfully.",
              });
              //window.location.reload();
            }, 2000);
          },
        );
      } else {
        this.setState({
          reject_client_button: false,
          rejectClientErrorMessage:
            "There is some error while rejecting the submission.",
          rejectClientSuccessMessage: "",
        });
      }
    } else {
      this.setState({
        reject_client_button: false,
        rejectClientErrorMessage: "Please enter the reason.",
        rejectClientSuccessMessage: "",
      });
    }
  };

  viewClientSubmission = async (id, tableMeta) => {
    const { client_accountno } = this.state;
    const form_token = tableMeta.rowData[10];
    this.setState({ viewLoader: true, viewClientSubmissions: [] });
    const servicesResponse = await viewClientFormSubmission(
      auth.getAccount(),
      auth.getToken(),
      id,
      form_token,
      client_accountno,
    );

    window.$("#modalClientSubmission").modal("show");
    //console.log("viewClientSubmission: ", servicesResponse.data);

    if (
      servicesResponse.data.status === 403 ||
      servicesResponse.data.errors === "authentication missing" ||
      servicesResponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      servicesResponse.data.status === 404 &&
      servicesResponse.data.message === "form_not_found"
    ) {
      this.setState({
        errorMessageTotalsTitle: "No Submission",
        errorMessageTotals: "There are no submissions right now.",
        viewLoader: false,
      });
    } else if (
      servicesResponse.data.status === 200 &&
      servicesResponse.data.message === "success"
    ) {
      let extra_files = [];
      let progressPercentage = 0;
      if (servicesResponse.data.data && servicesResponse.data.data.length > 0) {
        if (servicesResponse.data.data[0].extra_files) {
          extra_files = JSON.parse(servicesResponse.data.data[0].extra_files);
        }
        if (servicesResponse.data.data[0].progress) {
          let progress = servicesResponse.data.data[0].progress;
          let [completed, total] = progress.split("/").map(Number);
          progressPercentage = (completed / total) * 100;
        }
      }
      this.setState({
        viewClientSubmissions: servicesResponse.data.data,
        extra_files_clients: extra_files,
        viewLoader: false,
        progressPercentage: progressPercentage.toFixed(2),
      });

      //
    } else {
      {
        this.setState({
          errorMessageTotalsTitle: "No Submission",
          errorMessageTotals: "There are no submissions right now.",
          viewLoader: false,
        });
      }
    }
  };

  modalAllRejectionsClient = async (id, type, tableMeta) => {
    const { client_accountno, form_title } = this.state;
    const form_token = tableMeta.rowData[10];
    let rejection_client_title = "All Rejections";
    if (type === "clients") {
      rejection_client_title = "Client Rejections";
    }
    if (type === "agents") {
      rejection_client_title = "Channel Partner Rejections";
    }
    this.setState({
      client_submission_id: id,
      rejectClientErrorMessage: "",
      rejectClientSuccessMessage: "",
      reject_client_reason: "",
      reject_client_button: false,
      rejection_client_title: rejection_client_title,
      client_submission_type: type,
    });
    this.setState({
      rejectGeneralErrorMessage: "",
      rejectGeneralSuccessMessage: "",
      allClientRejectionsListing: [],
      rejectionLoader: true,
    });
    window.$("#modalRejectionClients").modal("show");
    const servicesResponse = await allClientRejections(
      auth.getAccount(),
      auth.getToken(),
      id,
      form_token,
      client_accountno,
      type,
    );

    //console.log("allClientRejections: ", servicesResponse.data);

    if (
      servicesResponse.data.status === 403 ||
      servicesResponse.data.errors === "authentication missing" ||
      servicesResponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      servicesResponse.data.status === 404 &&
      servicesResponse.data.message === "form_not_found"
    ) {
      this.setState({
        approveGeneralErrorMessage: "Submission not found.",
        approveGeneralSuccessMessage: "",
        rejectionLoader: false,
      });
    } else if (
      servicesResponse.data.status === 404 &&
      servicesResponse.data.message === "rejection_not_found"
    ) {
      this.setState({
        approveGeneralErrorMessage:
          "There are no rejections against this submission.",
        approveGeneralSuccessMessage: "",
        rejectionLoader: false,
      });
    } else if (
      servicesResponse.data.status === 200 &&
      servicesResponse.data.message === "success"
    ) {
      this.setState({
        approveGeneralErrorMessage: "",
        approveGeneralSuccessMessage: "",
        allClientRejectionsListing: servicesResponse.data.data,
        rejectionLoader: false,
      });
    } else {
      this.setState({
        rejectionLoader: false,
        approveGeneralErrorMessage:
          "There is some error while getting the rejections.",
        approveGeneralSuccessMessage: "",
      });
    }
  };

  getAllForms = async () => {
    const { client_accountno } = this.state;
    this.setState({ disableAssignBtn: false });
    const listClientsResponse = await listAllForms(
      auth.getAccount(),
      auth.getToken(),
      client_accountno,
    );

    //console.log("getAllForms: ", listClientsResponse.data);

    if (
      listClientsResponse.data.status === 403 ||
      listClientsResponse.data.errors === "authentication missing" ||
      listClientsResponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (listClientsResponse.data.status === 404) {
      // Handle 404 error if needed
      this.setState({
        assignModalLoader: false,
      });
    } else if (
      listClientsResponse.data.status === 200 &&
      listClientsResponse.data.message === "success"
    ) {
      let clients = listClientsResponse.data.data.map((client) => ({
        value: client.form_accountno,
        label: client.form_title,
      }));

      const selectedForms = listClientsResponse.data.selected_forms.map(
        (client) => client.form_accountno,
      );

      const selectAllClients =
        clients.length > 0 &&
        clients.every((client) => selectedForms.includes(client.value));

      this.setState({
        clientsList: clients,
        selectedForms: selectedForms,
        selectAllClients: selectAllClients,
        assignModalLoader: false,
      });
    } else {
      this.setState({
        assignModalLoader: false,
      });
      // Handle other responses or errors
    }
    window.$("#modalAssignFormClient").modal("show");
  };

  // Fetch Forms from API
  get_forms_list = async () => {
    this.setState({ formsLoading: true });
    try {
      const response = await listForms(auth.getAccount(), auth.getToken());
      if (response && response.data && response.data.status === 200) {
        // Handle different possible response structures
        let formsData = response.data.data || response.data.forms || [];

        // Ensure it's an array
        if (!Array.isArray(formsData)) {
          formsData = [];
        }
        this.setState({
          formsList: formsData,
          formsLoading: false,
        });
      } else {
        this.setState({
          formsList: [],
          formsLoading: false,
        });
      }
    } catch (error) {
      console.error("Error fetching forms:", error);
      this.setState({
        formsList: [],
        formsLoading: false,
      });
    }
  };
  get_client_agreements_list = async () => {
    this.setState({ clientAgreementsLoading: true });
    try {
      const response = await getMandatoryClientAgreements(auth.getAccount(), auth.getToken());
      if (
        response && response.data &&
        response.data.status === 200 &&
        response.data.message === "success"
      ) {
        const list = (response.data.data || []).map((agr) => ({
          agreement_accountno: agr.agreement_accountno,
          agreement_title: agr.agreement_title,
          agreement_instruction: agr.agreement_instruction || "",
        }));
        this.setState({ clientAgreementsList: list, clientAgreementsLoading: false });
      } else {
        this.setState({ clientAgreementsList: [], clientAgreementsLoading: false });
      }
    } catch {
      this.setState({ clientAgreementsList: [], clientAgreementsLoading: false });
    }
  };

  get_unsigned_client_agreements = async () => {
    this.setState({ clientAgreementsLoading: true, clientAgreementsList: [] });
    try {
      const response = await getUnsignedClientAgreements(
        auth.getAccount(),
        auth.getToken(),
        this.state.client_accountno
      );
      if (
        response &&
        response.data &&
        response.data.status === 200 &&
        response.data.message === "success"
      ) {
        const list = (response.data.data || []).map((agr) => ({
          agreement_accountno: agr.agreement_accountno,
          agreement_title: agr.agreement_title,
          agreement_instruction: agr.agreement_instruction || "",
        }));
        this.setState({ clientAgreementsList: list, clientAgreementsLoading: false });
      } else {
        this.setState({ clientAgreementsList: [], clientAgreementsLoading: false });
      }
    } catch {
      this.setState({ clientAgreementsList: [], clientAgreementsLoading: false });
    }
  };

  // Calculate onboarding percentage based on progress and total steps
  getOnboardingPercentage = () => {
    const { onboarding_progress, onboarding_total_steps } = this.state;
    if (onboarding_total_steps > 0) {
      return Math.round((onboarding_progress / onboarding_total_steps) * 100);
    }
    return 0;
  };

  // Fetch Onboarding Items from API
  getOnboardingItems = async () => {
    try {
      const accountno = auth.getAccount();
      const token = auth.getToken();
      const { client_accountno } = this.state;

      const response = await get_onboarding_user(
        accountno,
        token,
        client_accountno,
        "client",
      );

      // console.log("Get Onboarding Items Full Response:", response);
      // console.log("Response Status:", response?.status);
      // console.log("Response Data:", response?.data);

      // Handle 404 with adminTemplateMissing FIRST
      if (response?.status === 404 && response?.data?.adminTemplateMissing) {
        this.setState({
          adminTemplateMissing: true,
          onboardingErrorMessage:
            response.data.message ||
            "Admin onboarding template does not exist. Please update it.",
          onboardingErrorMessageTitle: "Admin Template Missing",
          onboardingItems: [],
          newStepCounter: 0,
          assignedLoader: false,
        });
        return;
      }

      if (response && response.status === 200) {
        const responseData = response.data;
        // console.log("Response Data Object:", responseData);

        let formattedItems = [];

        // Check if response status is success
        if (responseData.status === "success") {
          // The API returns: { status: "success", data: { steps: { steps: [...], total_steps, progress }, ... } }
          let stepsData = null;

          // Handle case where data is an object (single item)
          if (
            responseData.data &&
            typeof responseData.data === "object" &&
            !Array.isArray(responseData.data)
          ) {
            // Check for steps.steps structure
            if (responseData.data.steps && responseData.data.steps.steps) {
              stepsData = responseData.data.steps.steps;
            }
            // Check for onboarding_template.steps structure
            else if (
              responseData.data.onboarding_template &&
              responseData.data.onboarding_template.steps
            ) {
              stepsData = responseData.data.onboarding_template.steps;
            }
            // Fallback to direct steps property
            else if (
              responseData.data.steps &&
              Array.isArray(responseData.data.steps)
            ) {
              stepsData = responseData.data.steps;
            }
          }
          // Handle case where data is an array with items
          else if (
            responseData.data &&
            Array.isArray(responseData.data) &&
            responseData.data.length > 0
          ) {
            // Look for onboarding_template property first (new structure)
            const templateContainer = responseData.data[0]?.onboarding_template;

            if (templateContainer && templateContainer.steps) {
              stepsData = templateContainer.steps;
            } else {
              // Fallback to old structure for backward compatibility
              const stepsContainer = responseData.data[0]?.steps;
              if (
                stepsContainer &&
                stepsContainer.steps &&
                stepsContainer.steps.steps
              ) {
                stepsData = stepsContainer.steps.steps;
              } else if (stepsContainer && stepsContainer.steps) {
                stepsData = stepsContainer.steps;
              } else {
                stepsData = stepsContainer;
              }
            }
          }

          // console.log("Steps Data:", stepsData);

          // Handle array format (new - preserves exact order)
          if (stepsData && Array.isArray(stepsData)) {
            formattedItems = stepsData.map((stepData, index) => ({
              id: stepData.id || `step_${index + 1}`,
              title: stepData.title || "",
              form: stepData.form || "",
              allowSkip:
                stepData.allowSkip === 1 || stepData.allowSkip === true
                  ? true
                  : false,
              enable:
                stepData.enable === 1 ||
                stepData.enable === true ||
                stepData.isEnabled === 1 ||
                stepData.isEnabled === true
                  ? true
                  : false,
              type: stepData.type || "",
              isFilled:
                stepData.isFilled === 1 || stepData.isFilled === true
                  ? true
                  : false,
              isSkipped:
                stepData.isSkipped === 1 || stepData.isSkipped === true ? 1 : 0,
              isLocked: index < 1,
              agreementDetails:
                stepData.agreementDetails ||
                stepData.agreements_details ||
                null,
              answerType: stepData.answerType || "",
              allow_multiple: stepData.allow_multiple || 0,
              formFilledDate: stepData.formFilledDate || "",
              form_desc: stepData.form_desc || "",
              agreement_accountno: stepData.agreement_accountno || "",
              agreement_title: stepData.agreement_title || "",
              agreement_instruction: stepData.agreement_instruction || "",
              sub_type: stepData.sub_type || (stepData.type === "agreement" ? "clients" : ""),
            }));
          }
          // Handle object format with step titles as keys (legacy)
          else if (
            stepsData &&
            typeof stepsData === "object" &&
            !Array.isArray(stepsData)
          ) {
            formattedItems = Object.entries(stepsData).map(
              ([title, stepData], index) => ({
                id: stepData.id || `step_${index + 1}`,
                title: title.trim(),
                form: stepData.form || "",
                allowSkip:
                  stepData.allowSkip === 1 || stepData.allowSkip === true
                    ? true
                    : false,
                enable:
                  stepData.enable === 1 ||
                  stepData.enable === true ||
                  stepData.isEnabled === 1 ||
                  stepData.isEnabled === true
                    ? true
                    : false,
                type: stepData.type || "",
                isFilled:
                  stepData.isFilled === 1 || stepData.isFilled === true
                    ? true
                    : false,
                isSkipped:
                  stepData.isSkipped === 1 || stepData.isSkipped === true
                    ? 1
                    : 0,
                isLocked: index < 1, // Only the first item is locked
                agreementDetails:
                  stepData.agreementDetails ||
                  stepData.agreements_details ||
                  null,
                answerType: stepData.answerType || "",
                allow_multiple: stepData.allow_multiple || 0,
                formFilledDate: stepData.formFilledDate || "",
                form_desc: stepData.form_desc || "",
              }),
            );
          }
        }

        // console.log("Formatted Items:", formattedItems);

        if (formattedItems.length > 0) {
          this.setState({
            onboardingItems: formattedItems,
            newStepCounter: formattedItems.length,
            assignedLoader: false,
            onboardingTitle: responseData.data.onboardingTitle || "",
            onboardingMessage: responseData.data.message || "",
          });
          // console.log("State Updated with items:", formattedItems);
        } else {
          // Check if adminTemplateMissing in response (HTTP 200 but status: "error")

          console.warn("No items found in response");
          this.setState({
            onboardingItems: [],
            newStepCounter: 0,
            assignedLoader: false,
          });
        }
      } else {
        // Handle non-200 responses
        if (response?.data?.adminTemplateMissing) {
          this.setState({
            adminTemplateMissing: true,
            onboardingErrorMessage:
              response.data.message ||
              "Admin onboarding template does not exist. Please update it.",
            onboardingErrorMessageTitle: "Admin Template Missing",
            onboardingItems: [],
            newStepCounter: 0,
            assignedLoader: false,
          });
          return;
        }

        console.warn(
          "Failed to fetch onboarding items - Invalid status:",
          response?.status,
        );
        this.setState({ assignedLoader: false });
      }
    } catch (error) {
      // Handle errors (404 with adminTemplateMissing, network errors, etc.)
      if (
        error?.response?.status === 404 &&
        error.response.data?.adminTemplateMissing
      ) {
        this.setState({
          adminTemplateMissing: true,
          onboardingErrorMessage:
            error.response.data.message ||
            "Admin onboarding template does not exist. Please update it.",
          onboardingErrorMessageTitle: "Admin Template Missing",
          onboardingItems: [],
          newStepCounter: 0,
          assignedLoader: false,
        });
        return;
      }

      console.error("Error fetching onboarding items:", error);
      console.error("Error Stack:", error.stack);
      this.setState({ assignedLoader: false });
    }
  };

  handleSubmitAssignFormClient = async () => {
    const { selectedForms, client_accountno } = this.state;

    this.setState({ disableAssignBtn: true });
    //console.log("selectedForms: ", selectedForms);
    const assignFormResponse = await assignFormToClients(
      auth.getAccount(),
      auth.getToken(),
      JSON.stringify(selectedForms),
      client_accountno,
    );

    //console.log("assignFormResponse: ", assignFormResponse.data);

    if (
      assignFormResponse.data.status === 403 ||
      assignFormResponse.data.errors === "authentication missing" ||
      assignFormResponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      assignFormResponse.data.status === 404 &&
      assignFormResponse.data.message === "assigning_error"
    ) {
      this.setState({
        errorMessageAssignModal:
          "There was some error while assigning the forms to the clients.",
        disableAssignBtn: false,
      });
    } else if (
      assignFormResponse.data.status === 200 &&
      assignFormResponse.data.message === "success"
    ) {
      const note = assignFormResponse.data.note;
      this.setState({
        successMessageAssignModal:
          note === "no_change"
            ? "No changes to save — client assignments are already up to date."
            : "Forms assignments updated for selected client.",
      });
      this.client_assigned_forms();
      setTimeout(() => {
        this.setState({
          successMessageAssignModal: "",
          errorMessageAssignModal: "",
        });
        window.$("#modalAssignFormClient").modal("hide");
      }, 2000);
    } else {
      this.setState({
        errorMessageAssignModal:
          "There was some error while assigning the forms to the clients.",
        disableAssignBtn: false,
      });
    }
    setTimeout(() => {
      this.setState({
        successMessageAssignModal: "",
        errorMessageAssignModal: "",
      });
    }, 3500);
  };

  archived_agreements = async (client_accountno) => {
    // console.log("archived_agreements client_accountno: ", client_accountno);

    const kycResponce = await getClientArchivedAgreements(
      auth.getAccount(),
      auth.getToken(),
      client_accountno,
    );
    //console.log("archived_agreements: ", kycResponce.data);
    if (
      kycResponce.data.status === 403 ||
      kycResponce.data.errors === "authentication missing" ||
      kycResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
      return;
    } else if (kycResponce.data.status === 406) {
      this.setState({
        errorMessageAgreements:
          "There is an error while getting the credit applications. Please try again later.",
        processing_request_archived: false,
        assignedLoader: false,
      });
      //window.location.replace("/error");
    } else if (
      kycResponce.data.status === 404 &&
      kycResponce.data.message === "not_exists"
    ) {
      this.setState({
        errorMessageAgreements: "",
        processing_request_archived: false,
        assignedLoader: false,
      });
      //window.location.replace("/error");
    } else if (
      kycResponce.data.status === 200 &&
      kycResponce.data.message === "success"
    ) {
      this.setState({
        archivedAgreements: kycResponce.data.data,
        processing_request_archived: false,
        assignedLoader: false,
        columnServices: [
          { name: "agreement_title", label: "Agreement Name" },
          {
            name: "archived_date",
            label: "Archived date",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return <div>{this.format_date(value)}</div>;
              },
            },
          },
          {
            name: "signed_date",
            label: "Signed Date",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return <div>{this.format_date(value)}</div>;
              },
            },
          },
          {
            name: "approved",
            label: "Approved",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return <div>{this.format_approved(value)}</div>;
              },
            },
          },
          {
            name: "pdf_path",
            label: "Download",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return <div>{this.format_download(value, tableMeta)}</div>;
              },
            },
          },

          {
            name: "id",
            label: "Actions",
            options: {
              customBodyRender: (value, tableMeta, updateValue) => {
                return (
                  <div>
                    <div
                      className="nk-tb-col nk-tb-col-tools"
                      style={{ padding: "0px" }}
                    >
                      <ul className="nk-tb-actions gx-1">
                        <li>
                          <div className="drodown">
                            <a
                              style={{ cursor: "pointer" }}
                              title="Other Actions"
                              className="dropdown-toggle btn btn-icon  btn-outline-light"
                              data-toggle="dropdown"
                            >
                              <em className="icon ni ni-more-h"></em>
                            </a>
                            <div className="dropdown-menu dropdown-menu-md dropdown-menu-right customStyle_dropdown-menu-md_forms">
                              <ul className="link-list-opt no-bdr">
                                <li>
                                  <Tooltip title="View Details" placement="top">
                                    <a
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        this.get_archived_details(
                                          value,
                                          tableMeta,
                                        )
                                      }
                                    >
                                      <em className="icon ni ni-card-view"></em>
                                      <span>View Details</span>
                                    </a>
                                  </Tooltip>
                                </li>
                                <li>
                                  <Tooltip
                                    title="Reassign Agreement"
                                    placement="top"
                                  >
                                    <a
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        this.reassing_archived_details(
                                          value,
                                          tableMeta,
                                        )
                                      }
                                      disabled={
                                        this.props.is_msa_signed === "No" ||
                                        this.props.defaultSettings === "missing"
                                          ? true
                                          : false
                                      }
                                    >
                                      <em className="icon ni ni-repeat"></em>
                                      <span>Reassign</span>
                                    </a>
                                  </Tooltip>
                                </li>
                                <li>
                                  <Tooltip
                                    title="Delete Agreement"
                                    placement="top"
                                  >
                                    <a
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        this.delete_archived_details(
                                          value,
                                          tableMeta,
                                        )
                                      }
                                      disabled={
                                        this.props.is_msa_signed === "No" ||
                                        this.props.defaultSettings === "missing"
                                          ? true
                                          : false
                                      }
                                    >
                                      <em className="icon ni ni-edit"></em>
                                      <span>Delete</span>
                                    </a>
                                  </Tooltip>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                );
              },
            },
          },
        ],
      });
    } else {
      this.setState({
        errorMessageAgreements: "",
        processing_request_archived: false,
        assignedLoader: false,
      });
    }
  };

  format_approved = (value) => {
    if (value === "Yes") {
      return (
        <Tooltip title="This agreement is approved." placement="top">
          <span className="badge badge-outline-success">
            <em className="icon ni ni-done"></em> Yes
          </span>
        </Tooltip>
      );
    } else {
      return (
        <span className="badge badge-outline-light">
          <em className="icon ni ni-caution"></em> No
        </span>
      );
    }
  };

  handleClientChange = (event, newSelectedOptions) => {
    const newselectedForms = newSelectedOptions.map((option) => option.value);

    const selectAllClients =
      this.state.clientsList.length > 0 &&
      this.state.clientsList.length === newselectedForms.length;

    this.setState({
      selectedForms: newselectedForms,
      selectAllClients: selectAllClients,
    });
  };

  format_download_form_archived = (value, tableMeta) => {
    //console.log("format_download value: ", value);
    let form_token = tableMeta.rowData[10];
    if (value && value !== "") {
      return (
        <>
          <a
            onClick={() => this.downloadPdfClient(value, this.state.form_title)}
            title="Download PDF"
            style={{
              cursor: "pointer",
            }}
          >
            <span className="badge badge-outline-primary">
              <em className="icon ni ni-download"></em>
            </span>
          </a>
          <a
            href={`${APP_URL}forms/view_client_archived_submission/${form_token}`}
            title="Submission View"
            style={{
              cursor: "pointer",
              marginLeft: "5px",
            }}
            target="_blank"
          >
            <span className="badge badge-outline-primary">
              <em className="icon ni ni-table-view"></em>
            </span>
          </a>
        </>
      );
    } else {
      return <span className="badge badge-outline-light">---</span>;
    }
  };

  // format_download_form = (value, tableMeta) => {
  //   //
  //   let form_token = tableMeta.rowData[10];
  //   let form_status = tableMeta.rowData[6];
  //   // console.log("form_status: ", form_status);
  //   if (form_status !== 3) {
  //     if (value && value !== "") {
  //       return (
  //         <>
  //           <a
  //             onClick={() =>
  //               this.downloadPdfClient(value, this.state.form_title)
  //             }
  //             title="Download PDF"
  //             style={{
  //               cursor: "pointer",
  //             }}
  //           >
  //             <span className="badge badge-outline-primary">
  //               <em className="icon ni ni-download"></em>
  //             </span>
  //           </a>
  //           <a
  //             href={`${APP_URL}forms/view_client_submission/${form_token}`}
  //             title="Submission View"
  //             style={{
  //               cursor: "pointer",
  //               marginLeft: "5px",
  //             }}
  //             target="_blank"
  //           >
  //             <span className="badge badge-outline-primary">
  //               <em className="icon ni ni-table-view"></em>
  //             </span>
  //           </a>
  //         </>
  //       );
  //     } else {
  //       return <span className="badge badge-outline-light">---</span>;
  //     }
  //   } else {
  //     return (
  //       <a
  //         href={`${APP_URL}forms/view_client_submission/${form_token}`}
  //         title="Submission View"
  //         style={{
  //           cursor: "pointer",
  //           marginLeft: "5px",
  //         }}
  //         target="_blank"
  //       >
  //         <span className="badge badge-outline-primary">
  //           <em className="icon ni ni-table-view"></em>
  //         </span>
  //       </a>
  //     );
  //   }
  // };

  format_download_form = (value, tableMeta) => {
    //
    let form_token = tableMeta.rowData[10];
    let form_status = tableMeta.rowData[6];
    // console.log("form_status: ", form_status);
    if (form_status !== 3) {
      if (value && value !== "") {
        return (
          <>
            {this.state.permissionsState &&
            this.state.permissionsState.length > 0 &&
            this.state.permission_view_form_submission === 1 ? (
              <>
                <a
                  onClick={() =>
                    this.downloadPdfClient(value, this.state.form_title)
                  }
                  title="Download PDF"
                  style={{
                    cursor: "pointer",
                  }}
                >
                  <span className="badge badge-outline-primary">
                    <em className="icon ni ni-download"></em>
                  </span>
                </a>
                <a
                  href={`${APP_URL}forms/view_client_submission/${form_token}`}
                  title="Submission View"
                  style={{
                    cursor: "pointer",
                    marginLeft: "5px",
                  }}
                  target="_blank"
                >
                  <span className="badge badge-outline-primary">
                    <em className="icon ni ni-table-view"></em>
                  </span>
                </a>
              </>
            ) : (
              <span className="badge badge-outline-light">---</span>
            )}
          </>
        );
      } else {
        return <span className="badge badge-outline-light">---</span>;
      }
    } else {
      return (
        <>
          {this.state.permissionsState &&
          this.state.permissionsState.length > 0 &&
          this.state.permission_view_form_submission === 1 ? (
            <a
              href={`${APP_URL}forms/view_client_submission/${form_token}`}
              title="Submission View"
              style={{
                cursor: "pointer",
                marginLeft: "5px",
              }}
              target="_blank"
            >
              <span className="badge badge-outline-primary">
                <em className="icon ni ni-table-view"></em>
              </span>
            </a>
          ) : (
            <span className="badge badge-outline-light">---</span>
          )}
        </>
      );
    }
  };

  format_download = (value, tableMeta) => {
    if (value !== "") {
      return (
        <a
          onClick={() => this.downloadPdf(value, tableMeta.rowData[0])}
          title="Download Agreement"
          style={{
            cursor: "pointer",
          }}
        >
          <span className="badge badge-outline-primary">
            <em className="icon ni ni-download"></em>
          </span>
        </a>
      );
    } else {
      return (
        <span className="badge badge-outline-light">
          <em className="icon ni ni-caution"></em> --
        </span>
      );
    }
  };

  get_archived_details = async (value, tableMeta) => {
    const { client_accountno } = this.state;
    let archive_id = tableMeta.rowData[5];
    // console.log("get_archived_details archive_id: ", archive_id);

    const kycResponce = await getClientArchivedAgreementsSingle(
      auth.getAccount(),
      auth.getToken(),
      client_accountno,
      archive_id,
    );
    //console.log("get_archived_details: ", kycResponce.data);
    window.$("#modalArchivedDetails").modal("show");
    if (
      kycResponce.data.status === 403 ||
      kycResponce.data.errors === "authentication missing" ||
      kycResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
      return;
    } else if (kycResponce.data.status === 406) {
      this.setState({
        errorMessageArchivedDetails:
          "There is an error while getting the credit applications. Please try again later.",
      });
      //window.location.replace("/error");
    } else if (
      kycResponce.data.status === 404 &&
      kycResponce.data.message === "not_exists"
    ) {
      this.setState({
        errorMessageArchivedDetails: "",
      });
      //window.location.replace("/error");
    } else if (
      kycResponce.data.status === 200 &&
      kycResponce.data.message === "success"
    ) {
      this.setState({
        archivedAgreementsDetails: kycResponce.data.data,
      });
    } else {
      this.setState({
        errorMessageArchivedDetails: "",
      });
    }
  };

  delete_archived_details = async (value, tableMeta) => {
    const { client_accountno } = this.state;
    let archive_id = tableMeta.rowData[5];
    this.setState({
      delete_archive_id: archive_id,
      successMessageDelete: "",
      errorMessageDelete: "",
      disabled: false,
    });
    window.$("#modalDeleteAlert").modal("show");
  };

  modalHideDel = () => {
    window.$("#modalDeleteAlert").modal("hide");
  };

  modalHideRemove = () => {
    window.$("#modalRemoveContract").modal("hide");
  };

  modalHideRemoveService = () => {
    window.$("#modalRemoveServiceContract").modal("hide");
  };

  modalHideAddService = () => {
    window.$("#modalAddServiceContract").modal("hide");
  };

  delete_archived_agreement = async () => {
    const { delete_archive_id, client_accountno } = this.state;
    this.setState({
      successMessageDelete: "",
      errorMessageDelete: "",
      disabled: true,
    });
    const agreementResponce = await deleteClientArchivedAgreement(
      auth.getAccount(),
      auth.getToken(),
      client_accountno,
      delete_archive_id,
    );

    //console.log("deleteAgreement: ", agreementResponce.data);
    //$("#btnloader").show();
    if (
      agreementResponce.data.status === 403 ||
      agreementResponce.data.errors === "authentication missing" ||
      agreementResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      agreementResponce.data.status === 404 &&
      agreementResponce.data.message === "fail" &&
      agreementResponce.data.note !== ""
    ) {
      // window.location.replace("/error");
      this.setState({
        errorMessageDelete: "There is some error while processing the request.",
        successMessageDelete: "",
        disabled: false,
      });
      //$("#btnloader").hide();
    } else if (
      agreementResponce.data.status === 200 &&
      agreementResponce.data.message === "success"
    ) {
      //await this.reLoadClients();
      this.setState({
        errorMessageDelete: "",
        successMessageDelete: "Archived agreement deleted successfully.",
        //disabled: false,
      });

      setTimeout(() => {
        window.$("#modalDeleteAlert").modal("hide");
        this.archived_agreements(client_accountno);
      }, 2000);
      //$("#btnloader").hide();
    } else {
      this.setState({
        errorMessageDelete: "There is some error while processing the request.",
        successMessageDelete: "",
        disabled: false,
      });
      //$("#btnloader").hide();
      //window.location.replace("/error");
    }
  };

  agentAssignRole = async (agentId, agentEmail, company, name) => {
    this.setState({
      errorMessageAgentRole: "",
      successMessageAgentRole: "",
      assignRoleData: [],
      assignSubRoleData: [],
      changedRolesRights: [],
      changedSubRolesRights: [],
      agentRoleLoader: true,
      disableRoleBtn: false,
      disableSubRoleBtn: false,
      rolesAgentName: company + " (" + name + ")",
      checkedName: name,
      checkedEmail: agentEmail,
    });
    window.$("#modalAgentAssignRole").modal("show");
    this.getAgentRoleData(agentId, agentEmail);
  };

  getAgentRoleData = async (agentId, agentEmail) => {
    const listAgentAssignRoles = await ListClientAssignRoles(
      auth.getAccount(),
      auth.getToken(),
      agentId,
      agentEmail,
    );

    //console.log("ListAgentRoles Res: ", listAgentAssignRoles.data.data);
    if (
      listAgentAssignRoles.data.status === 403 ||
      listAgentAssignRoles.data.errors === "authentication missing" ||
      listAgentAssignRoles.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (listAgentAssignRoles.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      listAgentAssignRoles.data.status === 200 &&
      listAgentAssignRoles.data.message === "success"
    ) {
      const assignRoleData = listAgentAssignRoles.data.data.roles;
      const assignSubRoleData = listAgentAssignRoles.data.data.subroles;
      const allRoleData = listAgentAssignRoles.data.data.Allroles.map(
        (role) => {
          const isActiveRole = assignRoleData.some(
            (assignedRole) =>
              assignedRole.alt === role.alt && assignedRole.isactive === 1,
          );
          return {
            ...role,
            isChecked: isActiveRole,
          };
        },
      );

      const allSubRoleData = listAgentAssignRoles.data.data.Allsubroles.map(
        (subRole) => {
          const isActiveSubRole = assignSubRoleData.some(
            (assignedSubRole) =>
              assignedSubRole.alt === subRole.alt &&
              assignedSubRole.isactive === 1,
          );
          return {
            ...subRole,
            isChecked: isActiveSubRole,
          };
        },
      );

      this.setState({
        assignRoleData,
        assignSubRoleData,
        allRoleData,
        allSubRoleData,
        agentRoleLoader: false,
      });

      const initialActiveRoles = assignRoleData
        .filter((role) => role.isactive === 1)
        .map((role) => ({
          alt: role.alt,
          isChecked: true,
        }));

      const initialActiveSubRoles = assignSubRoleData
        .filter((subRole) => subRole.isactive === 1)
        .map((subRole) => ({
          id: subRole.id,
          isChecked: true,
        }));

      this.setState({
        changedRolesRights: initialActiveRoles,
        changedSubRolesRights: initialActiveSubRoles,
      });
    } else {
      //window.location.replace("/error");
    }
  };

  handleSubmitRoleCheckbox = async (name, email) => {
    this.setState({
      errorMessageAgentRole: "",
      successMessageAgentRole: "",
      disableRoleBtn: true,
    });

    const { allRoleData, allSubRoleData } = this.state;

    // Prepare the CheckRoleFields array with IDs and isactive status
    const CheckRoleFields = allRoleData.map((role) => ({
      id: role.id,
      isactive: role.isChecked ? 1 : 0,
    }));

    const CheckSubRoleFields = allSubRoleData.map((role) => ({
      id: role.tabdetailid,
      isactive: role.isChecked ? 1 : 0,
    }));

    try {
      // Call the backend API to save the roles
      const saveResponce = await editClientAssignRole(
        auth.getAccount(),
        auth.getToken(),
        CheckRoleFields,
        CheckSubRoleFields,
        name,
        email,
      );

      // Handle response status
      if (
        saveResponce.data.status === 403 ||
        saveResponce.data.errors === "authentication missing" ||
        saveResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (saveResponce.data.status === 404) {
        this.setState({
          errorMessageAgentRole:
            "There is some error while updating the client menu.",
          successMessageAgentRole: "",
          disableRoleBtn: false,
        });
      } else if (
        saveResponce.data.status === 200 &&
        saveResponce.data.message === "success"
      ) {
        this.setState({
          errorMessageAgentRole: "",
          successMessageAgentRole: "Client menu updated successfully.",
          disableRoleBtn: false,
        });
        setTimeout(() => {
          window.$("#modalAgentAssignRole").modal("hide");
        }, 2000);
      } else {
        this.setState({
          errorMessageAgentRole: saveResponce.data.message,
          successMessageAgentRole: "",
          disableRoleBtn: false,
        });
      }
    } catch (error) {
      console.error("Error while saving roles:", error);
      this.setState({
        errorMessageAgentRole: "An error occurred while saving menu.",
        successMessageAgentRole: "",
        disableRoleBtn: false,
      });
    }
  };

  changedSubRolesRights = (event) => {
    const { name, checked, Id } = event.target;
    const { changedSubRolesRights } = this.state;

    const index = changedSubRolesRights.findIndex(
      (item) => item.id === parseInt(name),
    );

    if (index !== -1) {
      const updatedchangedSubRolesRights = [...changedSubRolesRights];
      updatedchangedSubRolesRights[index] = {
        id: parseInt(name),
        isChecked: checked,
      };
      this.setState({ changedSubRolesRights: updatedchangedSubRolesRights });
    } else {
      this.setState((prevState) => ({
        changedSubRolesRights: [
          ...prevState.changedSubRolesRights,
          {
            id: parseInt(name),
            isChecked: checked,
          },
        ],
      }));
    }
  };

  changedRolesRights = (event) => {
    const { name, checked } = event.target;
    const { assignRoleData, assignSubRoleData } = this.state;

    // Find the main role in assignRoleData
    const mainRole = assignRoleData.find((item) => item.id === parseInt(name));

    if (!mainRole) {
      return;
    }

    // Update the checked state of the main role
    const updatedChangedRolesRights = this.state.changedRolesRights.map(
      (item) =>
        item.id === mainRole.id ? { ...item, isChecked: checked } : item,
    );

    // If the main role is not found in changedRolesRights, add it
    if (!updatedChangedRolesRights.some((item) => item.id === mainRole.id)) {
      updatedChangedRolesRights.push({ ...mainRole, isChecked: checked });
    }

    // Find the associated sub roles
    const associatedSubRoles = assignSubRoleData.filter(
      (subRole) => subRole.parent_role_id === mainRole.parent_role_id,
    );

    // Update the checked state of associated sub roles
    const updatedSubRolesRights = this.state.changedSubRolesRights.map(
      (subRole) => {
        // Check if the sub role is associated with the main role
        const isAssociated = associatedSubRoles.some(
          (assocSubRole) => assocSubRole.id === subRole.id,
        );

        // If associated, update isChecked based on the checked state of the main role
        if (isAssociated) {
          return { ...subRole, isChecked: checked };
        } else {
          return subRole;
        }
      },
    );

    // If associated sub roles are not found in changedSubRolesRights, add them
    associatedSubRoles.forEach((assocSubRole) => {
      if (
        !updatedSubRolesRights.some((subRole) => subRole.id === assocSubRole.id)
      ) {
        updatedSubRolesRights.push({ ...assocSubRole, isChecked: checked });
      }
    });

    // Update the state with the modified arrays
    this.setState({
      changedRolesRights: updatedChangedRolesRights,
      changedSubRolesRights: updatedSubRolesRights,
    });
  };

  changedAllRolesRights = (event) => {
    const { name, checked } = event.target;

    // Update checkedRoleIds in the state
    const { checkedRoleIds } = this.state;
    const updatedCheckedRoleIds = checked
      ? [...checkedRoleIds, name] // add ID if checked
      : checkedRoleIds.filter((id) => id !== name); // remove ID if unchecked

    this.setState({ checkedRoleIds: updatedCheckedRoleIds });

    // Update allRoleData with isChecked property
    const { allRoleData, allSubRoleData } = this.state;
    const updatedAllRoleData = allRoleData.map((role) => {
      if (role.id.toString() === name) {
        return {
          ...role,
          isChecked: checked,
        };
      }
      return role;
    });

    // Update associated sub roles
    const updatedAllSubRoleData = allSubRoleData.map((subRole) => {
      if (subRole.role_id.toString() === name) {
        return {
          ...subRole,
          isChecked: checked,
        };
      }
      return subRole;
    });

    this.setState({
      allRoleData: updatedAllRoleData,
      allSubRoleData: updatedAllSubRoleData,
    });
  };

  changedAllSubRolesRights = (event) => {
    const { name, checked } = event.target;

    // Update checkedSubRoleIds in the state
    const { checkedSubRoleIds } = this.state;
    const updatedCheckedSubRoleIds = checked
      ? [...checkedSubRoleIds, name] // add ID if checked
      : checkedSubRoleIds.filter((id) => id !== name); // remove ID if unchecked

    this.setState({ checkedSubRoleIds: updatedCheckedSubRoleIds });

    // Update allSubRoleData with isChecked property
    const { allSubRoleData } = this.state;
    const updatedAllSubRoleData = allSubRoleData.map((subRole) => {
      if (subRole.tabdetailid.toString() === name) {
        return {
          ...subRole,
          isChecked: checked,
        };
      }
      return subRole;
    });

    this.setState({ allSubRoleData: updatedAllSubRoleData });
  };

  openSigneeDetails = async (agreement_accountno) => {
    const { client_accountno } = this.state;
    let selected_client_accountno = client_accountno;
    let selected_agreement_id = agreement_accountno;
    this.setState({
      selected_client_accountno: selected_client_accountno,
      selected_agreement_id: selected_agreement_id,
      signee_details: [],
    });
    const servicesResponce = await getClientAgreementSigneeDetails(
      auth.getAccount(),
      auth.getToken(),
      selected_client_accountno,
      selected_agreement_id,
    );
    //console.log("openSigneeDetails.data: ", servicesResponce.data);
    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
      return;
    } else if (servicesResponce.data.status === 406) {
      this.setState({
        approveErrorMessage:
          "There is an error while displaying the signee details. Please try again.",
      });
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 404 &&
      servicesResponce.data.message === "signee_not_found"
    ) {
      this.setState({
        approveErrorMessage: "Signee details not found.",
      });
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 404 &&
      servicesResponce.data.message === "agent_not_found"
    ) {
      this.setState({
        approveErrorMessage: `${localization.specificPortals.agentLabel} not found.`,
      });
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        signee_details: servicesResponce.data.data,
      });
    } else {
      this.setState({
        approveErrorMessage:
          "There is an error while displaying the signee details. Please try again.",
        disabled: false,
      });
    }
    //
    window.$("#modalOpenSignee").modal("show");
  };

  removeContract = (agreement_accountno) => {
    const { client_accountno } = this.state;
    let selected_client_accountno = client_accountno;
    let selected_agreement_id = agreement_accountno;
    this.setState({
      selected_client_accountno: selected_client_accountno,
      selected_agreement_id: selected_agreement_id,
      removeErrorTitle: "",
      removeErrorMessage: "",
      removeSuccessMessage: "",
      remove_agreement_button: false,
    });
    window.$("#modalRemoveContract").modal("show");
  };

  remove_agreement = async () => {
    const { selected_agreement_id, selected_client_accountno } = this.state;
    this.setState({
      removeSuccessMessage: "",
      removeErrorMessage: "",
      disabled: true,
      remove_agreement_button: true,
    });
    const agreementResponce = await deleteClientAssignedAgreement(
      auth.getAccount(),
      auth.getToken(),
      selected_client_accountno,
      selected_agreement_id,
    );

    //console.log("deleteAgreement: ", agreementResponce.data);
    //$("#btnloader").show();
    if (
      agreementResponce.data.status === 403 ||
      agreementResponce.data.errors === "authentication missing" ||
      agreementResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      agreementResponce.data.status === 404 &&
      agreementResponce.data.message === "fail" &&
      agreementResponce.data.note !== ""
    ) {
      // window.location.replace("/error");
      this.setState({
        removeErrorMessage: "There is some error while removing the agreement.",
        removeSuccessMessage: "",
        disabled: false,
        remove_agreement_button: false,
      });
      //$("#btnloader").hide();
    } else if (
      agreementResponce.data.status === 200 &&
      agreementResponce.data.message === "success"
    ) {
      //await this.reLoadClients();
      this.setState({
        removeErrorMessage: "",
        removeSuccessMessage: "Agreement removed successfully.",
        //remove_agreement_button: false,
        //disabled: false,
      });

      setTimeout(() => {
        window.$("#modalRemoveContract").modal("hide");
        this.clientAgreements();
      }, 2000);
      //$("#btnloader").hide();
    } else {
      this.setState({
        removeErrorMessage: "There is some error while processing the request.",
        removeSuccessMessage: "",
        disabled: false,
        remove_agreement_button: false,
      });
      //$("#btnloader").hide();
      //window.location.replace("/error");
    }
  };

  openUploadContract = async (agreement_accountno) => {
    const { client_accountno } = this.state;
    let selected_client_accountno = client_accountno;
    let selected_agreement_id = agreement_accountno;
    this.setState({
      selected_client_accountno: selected_client_accountno,
      selected_agreement_id: selected_agreement_id,
      uploadErrorTitle: "",
      uploadErrorMessage: "",
      uploadSuccessMessage: "",
      upload_agreement_button: false,
      add_picture: "",
      add_picture_name: "",
    });
    window.$("#modalOpenUploadContract").modal("show");
  };

  submitClientContract = async () => {
    let {
      selected_client_accountno,
      selected_agreement_id,
      add_picture,
      add_picture_name,
    } = this.state;
    this.setState({
      upload_agreement_button: true,
    });
    if (add_picture_name === "") {
      this.setState({
        uploadErrorMessage: "Agreement file is required.",
        uploadErrorTitle: "Missing Fields",
        upload_agreement_button: false,
      });
      setTimeout(() => {
        this.setState({
          uploadErrorTitle: "",
          uploadErrorMessage: "",
        });
      }, 4000);
      return false;
    } else {
      const formData = new FormData();
      formData.append("token", process.env.REACT_APP_API_TOKEN);
      formData.append("api_accountno", process.env.REACT_APP_API_ACCOUNTNO);
      formData.append("accountno", auth.getAccount());
      formData.append("file", add_picture);
      formData.append("fileName", add_picture_name);
      formData.append("client_accountno", Number(selected_client_accountno));
      formData.append("agreement_id", Number(selected_agreement_id));

      try {
        axios
          .post(
            AGENT_SERVER_URL +
              "signed_agreements_external_api_calls/upload_client_agreement",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                "Access-Control-Allow-Origin": "http://localhost:2000",
                "Access-Control-Allow-Credentials": true,
              },
            },
            {},
          )
          .then((response) => {
            //console.log("submitSignatory response.data : ", response.data);
            if (
              response.data.status === 404 &&
              response.data.message === "no_record"
            ) {
              this.setState({
                uploadErrorMessage: "Record not found.",
                uploadErrorTitle: "System Error",
                upload_agreement_button: false,
                uploadSuccessMessage: "",
              });
            } else if (response.data.status === 403) {
              this.setState({
                uploadErrorTitle: "System Error",
                uploadErrorMessage: response.data.message,
                upload_agreement_button: false,
                uploadSuccessMessage: "",
              });
            } else if (
              response.data.status === 200 &&
              response.data.message === "success"
            ) {
              this.setState({
                uploadSuccessMessage: "Agreement added successfully.",
                uploadErrorMessage: "",
                uploadErrorTitle: "",
                upload_agreement_button: true,
              });
              //this.reloadClients();
              setTimeout(() => {
                this.clientAgreements();
                window.$("#modalOpenUploadContract").modal("hide");
              }, 4000);
            } else {
              this.setState({
                uploadErrorTitle: "System Error",
                uploadErrorMessage:
                  "There is some error while adding the agreement.",
                uploadSuccessMessage: "",
                upload_agreement_button: false,
              });
            }
          });
      } catch (error) {
        this.setState({
          uploadErrorTitle: "System Error",
          uploadErrorMessage: "There is some error while adding the agreement.",
          disabled: false,
          uploadSuccessMessage: "",
          upload_agreement_button: false,
        });

        // console.log("catch : ", error);
      }
      setTimeout(() => {
        this.setState({
          uploadErrorMessage: "",
          uploadErrorTitle: "",
        });
      }, 4000);
    }
  };

  phoneUtil = PhoneNumberUtil.getInstance();

  isPhoneValid = (phone) => {
    try {
      return this.phoneUtil.isValidNumber(
        this.phoneUtil.parseAndKeepRawInput(phone),
      );
    } catch (error) {
      return false;
    }
  };

  handleFilerIdChange = async (event) => {
    const filerId = event.target.value;

    if (
      filerId.trim() === this.state.lastVerifiedFilerId &&
      this.state.lastVerifiedFilerId !== ""
    ) {
      this.setState({ filer_id: filerId, errorFilerId: "", fccSuccess: true });
      return;
    }

    this.setState({ filer_id: filerId, errorFilerId: "", fccSuccess: false });

    // Only trigger API when exactly 6 digits are entered
    if (filerId.trim().length === 6 && !this.state.fccLoading) {
      this.setState({ fccLoading: true });
      try {
        const response = await getFccFiler(
          auth.getAccount(),
          auth.getToken(),
          filerId.trim(),
        );

        console.log("FCC API Response:", response);

        if (response.data.status === 200 && response.data.frn_details?.data) {
          const fccData = response.data.frn_details.data;
          const robocallData = fccData.robocall_data || {};

          console.log("FCC Success - Now checking for duplicate Filer ID...");

          // Check if Filer ID already exists - MUST run before setting success
          try {
            const checkResponse = await checkFilerIdExists(
              auth.getAccount(),
              auth.getToken(),
              filerId.trim()
            );

            console.log("Duplicate check response:", checkResponse.data);
            
            if (checkResponse.data && checkResponse.data.exists) {
              this.setState({
                filerIdAlreadyExists: true,
                errorFilerId: "This Filer ID is already associated with an existing client.",
                fccSuccess: false,
                fccLoading: false,
              });
              return; // Stop execution if duplicate found
            }
          } catch (error) {
            console.error("Error checking filer ID:", error);
            // Continue even if check fails
          }

          // Only set success if no duplicate was found
          this.setState({
            fccSuccess: true,
            fccLoading: false,
            fcc_data: fccData,
            lastVerifiedFilerId: filerId.trim(),
            client_company: robocallData.business_name || "",
            name: robocallData.robocall_mitigation_contact_name || "",
            title: robocallData.contact_title || "",
            client_phone: this.normalizeFccPhoneTemp(robocallData.contact_telephone_number),
            client_country: robocallData.contact_country || null,
            fcc_contact_email: robocallData.contact_email || "",
            fcc_ocn: robocallData.ocn || "",
            fcc_frn: robocallData.frn || "",
            fcc_number: fccData.coresid || "",
            fcc_coresid: fccData.coresid || "",
            filerIdAlreadyExists: false,
          });

          // Use Google to parse the address properly
          if (robocallData.contact_business_address) {
            await this.parseAddressWithGoogle(
              robocallData.contact_business_address,
            );
          }
        } else {
          console.log("FCC API condition not met. Status:", response.data.status, "Has frn_details.data:", !!response.data.frn_details?.data);
          this.setState({
            errorFilerId: "Invalid Filer ID",
            fccLoading: false,
            fccSuccess: false,
          });
        }
      } catch (error) {
        console.error("FCC API Error:", error);
        this.setState({
          errorFilerId: "Error verifying Filer ID",
          fccLoading: false,
          fccSuccess: false,
        });
      }
    }
  };

  handleFilerIdBlur = async () => {
    const filerId = this.state.filer_id.trim();

    if (filerId === "") {
      this.setState({ errorFilerId: "", fccLoading: false });
      return;
    }

    // Check if this Filer ID has already been verified or if API is currently loading
    if (filerId === this.state.lastVerifiedFilerId || this.state.fccLoading) {
      return;
    }

    this.setState({ fccLoading: true });
    try {
      const response = await getFccFiler(
        auth.getAccount(),
        auth.getToken(),
        filerId,
      );

      if (response.data.status === 200 && response.data.frn_details) {
        const frnData = response.data.frn_details.data;

        if (frnData && frnData.robocall_data) {
          const robocallData = frnData.robocall_data;

          // Check if Filer ID already exists - MUST run before setting success
          try {
            const checkResponse = await checkFilerIdExists(
              auth.getAccount(),
              auth.getToken(),
              filerId
            );
            
            if (checkResponse.data && checkResponse.data.exists) {
              this.setState({
                filerIdAlreadyExists: true,
                errorFilerId: "This Filer ID is already associated with an existing client.",
                fccSuccess: false,
                fccLoading: false,
              });
              return; // Stop execution if duplicate found
            }
          } catch (error) {
            console.error("Error checking filer ID:", error);
            // Continue even if check fails
          }

          // Only set success if no duplicate was found
          this.setState({
            fcc_data: frnData,
            fccLoading: false,
            fccSuccess: true,
            errorFilerId: "",
            lastVerifiedFilerId: filerId,
            client_comp_name:
              robocallData.business_name || this.state.client_comp_name,
            client_phone: robocallData.contact_telephone_number
              ? this.normalizeFccPhoneTemp(robocallData.contact_telephone_number)
              : this.state.client_phone,
            client_update_name:
              robocallData.robocall_mitigation_contact_name ||
              this.state.client_update_name,
            client_title: robocallData.contact_title || this.state.client_title,
            filerIdAlreadyExists: false,
          });

          if (robocallData.business_address) {
            await this.parseAddressWithGoogle(robocallData.business_address);
          }

          setTimeout(() => {
            this.setState({ fccSuccess: false });
          }, 2000);
        } else {
          this.setState({
            errorFilerId: "Invalid Filer ID",
            fccLoading: false,
            fccSuccess: false,
          });
        }
      } else {
        this.setState({
          errorFilerId: response.data?.message || "Invalid Filer ID",
          fccLoading: false,
          fccSuccess: false,
        });
      }
    } catch (error) {
      this.setState({
        errorFilerId: "Error fetching FCC data",
        fccLoading: false,
        fccSuccess: false,
      });
    }
  };

  handleFilerIdKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      this.handleFilerIdBlur();
    }
  };

  parseAddressWithGoogle = async (address) => {
    try {
      const response = await axios.get(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
          address,
        )}&key=${process.env.REACT_APP_ADDRESS_AUTOCOMPLETE_API_KEY}`,
      );

      if (response.data.results && response.data.results.length > 0) {
        const addressComponents = response.data.results[0].address_components;
        let street = "";
        let city = "";
        let state = "";
        let zip = "";
        let country = "";

        addressComponents.forEach((component) => {
          if (component.types.includes("street_number")) {
            street = component.long_name + " ";
          }
          if (component.types.includes("route")) {
            street += component.long_name;
          }
          if (component.types.includes("locality")) {
            city = component.long_name;
          }
          if (component.types.includes("administrative_area_level_1")) {
            state = component.short_name;
          }
          if (component.types.includes("postal_code")) {
            zip = component.long_name;
          }
          if (component.types.includes("country")) {
            country = component.long_name;
          }
        });

        this.setState({
          address: street || address.split("\n")[0],
          city: city || this.state.city,
          state: state || this.state.state,
          zip: zip || this.state.zip,
          country: country || this.state.country,
        });
      }
    } catch (error) {
      console.error("Error parsing address:", error);
    }
  };

  handleFileChange = (e) => {
    const selectedFile = e.target.files[0];

    if (!selectedFile) {
      return; // No file selected
    }

    // File type validation selectedFiles PDF, DOC, DOCX, ZIP, TXT, PNG, JPEG, JPG
    const allowedFileTypes = [
      ".png",
      ".jpg",
      ".jpeg",
      ".doc",
      ".docx",
      ".pdf",
      ".zip",
      ".txt",
      ".rtf",
    ];
    const fileExtension = selectedFile.name.split(".").pop().toLowerCase();

    if (!allowedFileTypes.includes(`.${fileExtension}`)) {
      this.setState({
        uploadErrorMessage:
          "Invalid file type. Please select a valid file format.",
        uploadErrorTitle: "Invalid File",
        add_picture: "",
        add_picture_name: "",
      });
      e.target.value = null;
      return;
    }

    // File size validation (e.g., limit to 10MB)
    const maxSizeBytes = 10 * 1024 * 1024; // 10MB
    if (selectedFile.size > maxSizeBytes) {
      this.setState({
        uploadErrorMessage:
          "File size exceeds the limit (10MB). Please choose a smaller file.",
        uploadErrorTitle: "Invalid File",
        add_picture: "",
        add_picture_name: "",
      });
      e.target.value = null;
      return;
    }

    // Clear any previous errors
    this.setState({
      add_picture: selectedFile,
      uploadErrorMessage: "",
      uploadErrorTitle: "",
      add_picture_name: selectedFile.name,
    });
    e.target.value = null;
    //return true;
  };

  openAgreementAdd = async (service_id) => {
    const { client_accountno } = this.state;
    let selected_client_accountno = client_accountno;
    this.setState({
      selected_client_accountno: selected_client_accountno,
      selected_service_id: service_id,
      add_service_text: "",
      addErrorTitle: "",
      addErrorMessage: "",
      addSuccessMessage: "",
      show_add_button: true,
      editLink: "",
    });

    const agreementResponce = await getServiceAgreement(
      auth.getAccount(),
      auth.getToken(),
      selected_client_accountno,
      service_id,
    );

    //console.log("openAgreementAdd: ", agreementResponce.data);

    if (
      agreementResponce.data.status === 403 ||
      agreementResponce.data.errors === "authentication missing" ||
      agreementResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      agreementResponce.data.status === 404 &&
      agreementResponce.data.message === "service_not_found"
    ) {
      this.setState({
        addErrorMessage: "Service not found.",
        addSuccessMessage: "",
        disabled: false,
      });
    } else if (
      agreementResponce.data.status === 404 &&
      agreementResponce.data.message === "agreement_not_found"
    ) {
      let editLink = APP_URL + "services/Editservice/" + service_id;
      this.setState({
        addErrorMessage: "",
        editLink: "Yes",

        addSuccessMessage: "",
        disabled: false,
        show_add_button: false,
      });
    } else if (
      agreementResponce.data.status === 200 &&
      agreementResponce.data.message === "success"
    ) {
      this.setState({
        addErrorMessage: "",
        addSuccessMessage: "",
        selected_agreement_id: agreementResponce.data.agreement_accountno,
        add_service_text: `Are you sure you want to add ${agreementResponce.data.agreement_title} to ${this.state.client_update_name} (${this.state.client_comp_name})?`,
      });
    } else {
      this.setState({
        addErrorMessage: "There is some error while processing the request.",
        addSuccessMessage: "",
        disabled: false,
      });
    }

    window.$("#modalAddServiceContract").modal("show");
  };

  add_service_agreement = async () => {
    const {
      selected_agreement_id,
      selected_client_accountno,
      selected_service_id,
    } = this.state;
    this.setState({
      addSuccessMessage: "",
      addErrorMessage: "",
      disabled: true,
      add_agreement_button: true,
    });
    const agreementResponce = await addNewClientServiceAgreement(
      auth.getAccount(),
      auth.getToken(),
      selected_client_accountno,
      selected_agreement_id,
    );

    //console.log("deleteAgreement: ", agreementResponce.data);

    if (
      agreementResponce.data.status === 403 ||
      agreementResponce.data.errors === "authentication missing" ||
      agreementResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      agreementResponce.data.status === 404 &&
      agreementResponce.data.message === "fail" &&
      agreementResponce.data.note !== ""
    ) {
      this.setState({
        addErrorMessage: "There is some error while adding the agreement.",
        addSuccessMessage: "",
        disabled: false,
        add_agreement_button: false,
      });
    } else if (
      agreementResponce.data.status === 200 &&
      agreementResponce.data.message === "success"
    ) {
      this.setState({
        addErrorMessage: "",
        addSuccessMessage: "Agreement added successfully.",
      });

      setTimeout(() => {
        window.$("#modalAddServiceContract").modal("hide");
        this.showAssignedServices();
      }, 2000);
    } else {
      this.setState({
        addErrorMessage: "There is some error while processing the request.",
        addSuccessMessage: "",
        disabled: false,
        add_agreement_button: false,
      });
    }
  };

  openAgreementDelete = (service_id, agreement_accountno) => {
    const { client_accountno } = this.state;
    let selected_client_accountno = client_accountno;
    let selected_agreement_id = agreement_accountno;
    this.setState({
      selected_client_accountno: selected_client_accountno,
      selected_agreement_id: selected_agreement_id,
      removeErrorTitle: "",
      removeErrorMessage: "",
      removeSuccessMessage: "",
      remove_agreement_button: false,
    });
    window.$("#modalRemoveServiceContract").modal("show");
  };

  remove_service_agreement = async () => {
    const { selected_agreement_id, selected_client_accountno } = this.state;
    this.setState({
      removeSuccessMessage: "",
      removeErrorMessage: "",
      disabled: true,
      remove_agreement_button: true,
    });
    const agreementResponce = await deleteClientAssignedAgreement(
      auth.getAccount(),
      auth.getToken(),
      selected_client_accountno,
      selected_agreement_id,
    );

    //console.log("deleteAgreement: ", agreementResponce.data);
    //$("#btnloader").show();
    if (
      agreementResponce.data.status === 403 ||
      agreementResponce.data.errors === "authentication missing" ||
      agreementResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      agreementResponce.data.status === 404 &&
      agreementResponce.data.message === "fail" &&
      agreementResponce.data.note !== ""
    ) {
      // window.location.replace("/error");
      this.setState({
        removeErrorMessage: "There is some error while removing the agreement.",
        removeSuccessMessage: "",
        disabled: false,
        remove_agreement_button: false,
      });
      //$("#btnloader").hide();
    } else if (
      agreementResponce.data.status === 200 &&
      agreementResponce.data.message === "success"
    ) {
      //await this.reLoadClients();
      this.setState({
        removeErrorMessage: "",
        removeSuccessMessage: "Agreement removed successfully.",
        //remove_agreement_button: false,
        //disabled: false,
      });

      setTimeout(() => {
        window.$("#modalRemoveServiceContract").modal("hide");
        this.showAssignedServices();
      }, 2000);
      //$("#btnloader").hide();
    } else {
      this.setState({
        removeErrorMessage: "There is some error while processing the request.",
        removeSuccessMessage: "",
        disabled: false,
        remove_agreement_button: false,
      });
      //$("#btnloader").hide();
      //window.location.replace("/error");
    }
  };

  modalHideAlll = async (id) => {
    window.$("#" + id).modal("hide");
    // Clear approval notes when modal closes
    if (id === "modalApproveClientAlert") {
      this.setState({
        approvalNotes: "",
        approvalNotesError: "",
      });
    }
  };

  preViewDefault = async () => {
    const getEmailResponse = await getEditClientEmailPreview(
      auth.getAccount(),
      auth.getToken(),
    );
    // console.log("getEmailResponse: ", getEmailResponse.data);
    if (
      getEmailResponse.data.status === 403 ||
      getEmailResponse.data.errors === "authentication missing" ||
      getEmailResponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (getEmailResponse.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      getEmailResponse.data.status === 200 &&
      getEmailResponse.data.message === "success"
    ) {
      let emailTemplate = getEmailResponse.data.data[0][3];
      let logoUrl = getEmailResponse.data.data[0]["reseller_logo"];

      if (emailTemplate && emailTemplate !== "") {
        // Replace company logo
        emailTemplate = emailTemplate.replace(/{{comp_logo}}/g, logoUrl);

        // Replace placeholders with user input values
        emailTemplate = emailTemplate.replace(
          /{{client_name}}/g,
          this.state.client_update_name || "{{client_name}}",
        );
        emailTemplate = emailTemplate.replace(
          /{{comp_name}}/g,
          auth.getCompName() || "{{comp_name}}",
        );
        emailTemplate = emailTemplate.replace(
          /{{client_company}}/g,
          this.state.client_comp_name || "{{client_company}}",
        );
        emailTemplate = emailTemplate.replace(
          /{{client_email}}/g,
          this.state.client_update_email || "{{client_email}}",
        );

        // Clean up any empty paragraphs
        emailTemplate = emailTemplate.replace(/<p>&nbsp;<\/p>/g, "");
      }

      this.setState({
        email_id: getEmailResponse.data.data[0][0],
        email_title: getEmailResponse.data.data[0][1],
        email_subject: getEmailResponse.data.data[0][2],
        email_template: emailTemplate,
        tableLoader: false,
        isEditorReady: true,
      });
      window.$("#modalPreviewDefaultModal").modal("show");
    } else {
      //window.location.replace("/error");
    }
  };

  closePreviewModal = () => {
    // Close the preview modal
    window.$("#modalPreviewDefaultModal").modal("hide");
  };

  loadRegistrationSettings = async () => {
    try {
      const response = await getClientRegistrationSettings(
        auth.getAccount(),
        auth.getToken(),
      );

      if (
        response.data.status === 403 ||
        response.data.errors === "authentication missing" ||
        response.data.errors === "jwt expired"
      ) {
        this.props.props.history.push("/logout");
        return;
      }

      if (response.data.status === 200 && response.data.fields) {
        this.setState({
          registrationFieldSettings: response.data.fields,
        });
      } else {
        // Default all configurable fields to 'required' if no settings found
        this.setState({
          registrationFieldSettings: {
            name: "required",
            title: "required",
            client_company: "required",
            client_phone: "required",
            client_address: "required",
            client_address2: "required",
            client_city: "required",
            client_state: "required",
            client_zip: "required",
            client_country: "required",
          },
        });
      }
    } catch (error) {
      console.error("Error loading registration settings:", error);
      // Default to all required on error
      this.setState({
        registrationFieldSettings: {
          name: "required",
          title: "required",
          client_company: "required",
          client_phone: "required",
          client_address: "required",
          client_address2: "required",
          client_city: "required",
          client_state: "required",
          client_zip: "required",
          client_country: "required",
        },
      });
    }
  };

  isFieldRequired = (fieldName) => {
    const { registrationFieldSettings } = this.state;

    // Always required fields (locked - not configurable)
    const alwaysRequired = [
      "client_update_email",
    ];

    // If field is in the always required list, return true
    if (alwaysRequired.includes(fieldName)) {
      return true;
    }

    // Map edit-profile field names to registration settings keys
    const fieldMapping = {
      client_update_name: "name",
      client_title: "title",
      client_comp_name: "client_company",
      client_phone: "client_phone",
      client_address: "client_address",
      client_address2: "client_address2",
      client_city: "client_city",
      client_state: "client_state",
      client_zip: "client_zip",
      client_country: "client_country",
    };

    const mappedFieldName = fieldMapping[fieldName] || fieldName;

    // For configurable fields, check settings
    // If settings are not loaded or field not in settings, default to required
    if (
      !registrationFieldSettings ||
      Object.keys(registrationFieldSettings).length === 0
    ) {
      return true;
    }

    // Return true if field is marked as "required", false if "optional"
    return registrationFieldSettings[mappedFieldName] === "required";
  };

  getCustomSettings = async () => {
    try {
      const getCustomSetting_res = await getCustomSettings(
        auth.getAccount(),
        auth.getToken(),
      );
      //console.log("getCustomSetting_res: ", getCustomSetting_res.data);
      if (
        getCustomSetting_res.data.status === 200 &&
        getCustomSetting_res.data.data &&
        getCustomSetting_res.data.data.length > 0
      ) {
        this.setState({
          address_autocomplete:
            getCustomSetting_res.data.data[0].address_autocomplete || "Yes",
          address_validation:
            getCustomSetting_res.data.data[0].address_validation || "Yes",
        });
      }
    } catch (error) {
      console.error("Error fetching settings:", error);
    }

    try {
      const fccStatusResponse = await isFccIntegrationEnabled(
        auth.getAccount(),
        auth.getToken(),
      );
      if (fccStatusResponse.data.status === 200) {
        this.setState({
          is_fcc_enabled: fccStatusResponse.data.is_fcc_enabled,
        });
      }
    } catch (error) {
      console.error("Error fetching FCC status:", error);
    }
  };

  handleNotificationSchedule = (event) => {
    // console.log("handleNotificationSchedule: ", event.target.checked);
    let schedule = event.target.checked;
    let schedule_div = false;
    if (schedule) {
      schedule_div = true;
    }
    this.setState({
      notification_scheduler: event.target.checked,
      schedule_div: schedule_div,
    });
  };

  handleChangeInitialReminder = (e) => {
    const value = e.target.value;

    // Allow empty string to let user clear input
    if (value === "") {
      this.setState({ initial_reminder_interval: "" });
      return;
    }

    const numericValue = Number(value);

    // Only allow numbers between 1 and 24
    if (!isNaN(numericValue) && numericValue >= 1 && numericValue <= 24) {
      this.setState({ initial_reminder_interval: numericValue });
    }
  };

  handleChangeRepeatReminder = (e) => {
    const value = e.target.value;

    // Allow empty string to let user clear input
    if (value === "") {
      this.setState({ repeat_interval: "" });
      return;
    }

    const numericValue = Number(value);

    // Only allow numbers between 1 and 24
    if (!isNaN(numericValue) && numericValue >= 1 && numericValue <= 48) {
      this.setState({ repeat_interval: numericValue });
    }
  };

  handleChangeRepeatDays = (e) => {
    const value = e.target.value;

    // Allow empty string to let user clear input
    if (value === "") {
      this.setState({ repeat_count: "" });
      return;
    }

    const numericValue = Number(value);

    // Only allow numbers between 1 and 24
    if (!isNaN(numericValue) && numericValue >= 1 && numericValue <= 12) {
      this.setState({ repeat_count: numericValue });
    }
  };

  open_notifications = async (value, tableMeta) => {
    const { client_accountno } = this.state;
    let form_token = tableMeta.rowData[10];
    let form_accountno = tableMeta.rowData[7];
    this.setState({
      notification_form_token: form_token,
      form_accountno: form_accountno,
      notificationErrorMsg: "",
      notificationSuccessMsg: "",
      notification_loader: true,
      disabled: false,
      missing_form_settings: "No",
    });
    const servicesResponse = await getClientNotificationSettings(
      auth.getAccount(),
      auth.getToken(),
      form_accountno,
      form_token,
      client_accountno,
    );
    // console.log("getClientNotificationSettings: ", servicesResponse.data);
    if (
      servicesResponse.data.status === 403 ||
      servicesResponse.data.errors === "authentication missing" ||
      servicesResponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      servicesResponse.data.status === 404 &&
      servicesResponse.data.message === "not_found"
    ) {
      this.setState({
        notificationErrorMsg: "Form submission not found.",
        notificationSuccessMsg: "",
        missing_form_settings: "No",
        notification_loader: false,
      });
    } else if (
      servicesResponse.data.status === 404 &&
      servicesResponse.data.message === "form_settings_missing"
    ) {
      this.setState({
        notificationErrorMsg: "",
        missing_form_settings: "Yes",
        notificationSuccessMsg: "",
        notification_loader: false,
      });
    } else if (
      servicesResponse.data.status === 200 &&
      servicesResponse.data.message === "success"
    ) {
      let notification_scheduler = false;
      let schedule_div = false;
      let initial_reminder_interval = 2;
      let repeat_interval = 12;
      let repeat_count = 7;
      if (servicesResponse.data.data && servicesResponse.data.data.length > 0) {
        if (
          servicesResponse.data.data[0]["is_active"] &&
          servicesResponse.data.data[0]["is_active"] === 1
        ) {
          notification_scheduler = true;
          schedule_div = true;
          initial_reminder_interval =
            servicesResponse.data.data[0]["initial_reminder_interval"];
          repeat_interval = servicesResponse.data.data[0]["repeat_interval"];
          repeat_count = servicesResponse.data.data[0]["repeat_count"];
        }
      }
      this.setState({
        notificationErrorMsg: "",
        notification_scheduler: notification_scheduler,
        schedule_div: schedule_div,
        repeat_count: repeat_count,
        repeat_interval: repeat_interval,
        initial_reminder_interval: initial_reminder_interval,
        notification_loader: false,
        missing_form_settings: "No",
      });
    } else {
      this.setState({
        notificationErrorMsg:
          "There is some error while displaying the notification settings.",
        notificationSuccessMsg: "",
        notification_loader: false,
        missing_form_settings: "No",
      });
    }
    window.$("#modalNotificationSchedule").modal("show");
  };

  submitNotifications = async () => {
    const {
      repeat_count,
      repeat_interval,
      initial_reminder_interval,
      notification_scheduler,
      form_submission_id,
      submission_type,
      form_accountno,
      client_accountno,
      notification_form_token,
    } = this.state;

    this.setState({
      notification_loader: true,
      notificationErrorMsg: "",
      notificationSuccessMsg: "",
    });

    if (repeat_interval === "") {
      this.setState({
        notification_loader: false,
        notificationErrorMsg: "Please enter the repeat reminder.",
      });
      setTimeout(() => {
        this.setState({ notificationErrorMsg: "" });
      }, 4000);
    } else if (repeat_count === "") {
      this.setState({
        notification_loader: false,
        notificationErrorMsg:
          "Please enter the days for which this notification reminders will be sent.",
      });
      setTimeout(() => {
        this.setState({ notificationErrorMsg: "", notificationSuccessMsg: "" });
      }, 4000);
    } else {
      let notificationScheduler = notification_scheduler ? "1" : "0";
      const servicesResponse = await submitClientNotificationSettings(
        auth.getAccount(),
        auth.getToken(),
        form_accountno,
        notification_form_token,
        client_accountno,
        notificationScheduler,
        repeat_count,
        repeat_interval,
        initial_reminder_interval,
      );
      // console.log("submitClientNotificationSettings: ", servicesResponse.data);
      if (
        servicesResponse.data.status === 403 ||
        servicesResponse.data.errors === "authentication missing" ||
        servicesResponse.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (
        servicesResponse.data.status === 404 &&
        servicesResponse.data.message === "not_found"
      ) {
        this.setState({
          notificationErrorMsg: "Form submission not found.",
          notificationSuccessMsg: "",
          notification_loader: false,
        });
        setTimeout(() => {
          this.setState({
            notificationErrorMsg: "",
            notificationSuccessMsg: "",
          });
        }, 4000);
      } else if (
        servicesResponse.data.status === 200 &&
        servicesResponse.data.message === "success"
      ) {
        this.setState({
          notificationErrorMsg: "",
          notificationSuccessMsg: "Notification settings updated successfully.",
          notification_loader: false,
        });
        setTimeout(() => {
          this.setState({
            notificationErrorMsg: "",
            notificationSuccessMsg: "",
          });
        }, 4000);
      } else {
        this.setState({
          notificationErrorMsg:
            "There is some error while updated the notification settings.",
          notificationSuccessMsg: "",
          notification_loader: false,
        });
        setTimeout(() => {
          this.setState({
            notificationErrorMsg: "",
            notificationSuccessMsg: "",
          });
        }, 4000);
      }
    }
  };

  copySubmissionLink = () => {
    navigator.clipboard.writeText(this.state.submission_link).then(() => {
      this.setState({
        successMessageSub: "Link Copied Successfully!",
        copiedSub: true,
      });
      setTimeout(
        () => this.setState({ successMessageSub: "", copiedSub: false }),
        2000,
      );
    });
  };

  sendSubmissionLinkByEmail = async () => {
    const { mailName, mailEmail, mailComment, submission_link, form_title } =
      this.state;

    // reset messages and disable button
    this.setState({
      successMessageMail: "",
      errorMessageMail: "",
      disabled: true,
    });

    // validations
    if (!mailName.trim()) {
      this.setState({
        errorMessageMail: "Please enter the name.",
        disabled: false,
      });
      return setTimeout(() => this.setState({ errorMessageMail: "" }), 2000);
    }
    if (!mailEmail.trim()) {
      this.setState({
        errorMessageMail: "Please enter the email address.",
        disabled: false,
      });
      return setTimeout(() => this.setState({ errorMessageMail: "" }), 2000);
    }
    if (ValidateEmail(mailEmail) === false) {
      this.setState({
        errorMessageMail: "Please enter a valid email address.",
        disabled: false,
      });
      return setTimeout(() => this.setState({ errorMessageMail: "" }), 2000);
    }
    if (!mailComment.trim()) {
      this.setState({
        errorMessageMail: "Please enter the comment.",
        disabled: false,
      });
      return setTimeout(() => this.setState({ errorMessageMail: "" }), 2000);
    }

    try {
      const response = await sendSubmissionLinkByEmail(
        auth.getAccount(),
        auth.getToken(),
        mailName.trim(),
        mailEmail.trim(),
        mailComment.trim(),
        submission_link,
        auth.getUserType(),
        form_title,
      );

      const { status, message, errors } = response.data;

      if (
        status === 403 ||
        errors === "authentication missing" ||
        errors === "jwt expired"
      ) {
        return auth.logout();
      }

      if (status === 409) {
        this.setState({
          errorMessageMail: "Client already registered with this email.",
          disabled: false,
        });
        setTimeout(() => this.setState({ errorMessageMail: "" }), 2000);
      } else if (status === 404) {
        this.setState({
          errorMessageMail:
            "There was an error while sending the submission link.",
          disabled: false,
        });
        setTimeout(() => this.setState({ errorMessageMail: "" }), 2000);
      } else if (status === 200 && message === "success") {
        this.setState({
          successMessageMail:
            "Submission link successfully sent to the client.",
          errorMessageMail: "",
          disabled: false,
          mailName: "",
          mailEmail: "",
          mailComment: "",
        });
        setTimeout(() => this.setState({ successMessageMail: "" }), 2000);
      } else {
        this.setState({
          errorMessageMail: "Unexpected error while sending submission link.",
          disabled: false,
        });
        setTimeout(() => this.setState({ errorMessageMail: "" }), 2000);
      }
    } catch (error) {
      console.error("Error sending submission link:", error);
      this.setState({
        errorMessageMail: "An error occurred. Please try again later.",
        disabled: false,
      });
      setTimeout(() => this.setState({ errorMessageMail: "" }), 2000);
    }
  };

  /* ============================================================
   * Client Credits (ledger-based)
   * ============================================================ */

  formatCreditAmount = (value) => {
    const decimals = Number(auth.getBillingDecimalPoint() || 2);
    const n = Number(value);
    if (!Number.isFinite(n)) return Number(0).toFixed(decimals);
    return n.toFixed(decimals);
  };

  formatLedgerType = (type) => {
    if (type === "credit_added") return "Credit Added";
    if (type === "invoice_payment") return "Invoice Payment";
    if (type === "manual_adjustment") return "Manual Adjustment";
    return type || "";
  };

  formatLedgerDate = (value) => {
    if (!value) return "";
    try {
      const d = new Date(value);
      if (Number.isNaN(d.getTime())) return String(value);
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const dd = String(d.getDate()).padStart(2, "0");
      const yyyy = d.getFullYear();
      return `${mm}-${dd}-${yyyy}`;
    } catch (e) {
      return String(value);
    }
  };

  loadCreditSummary = async () => {
    const { client_accountno } = this.state;
    if (!client_accountno) return;
    this.setState({ creditSummaryLoading: true, creditSummaryError: "" });
    try {
      const response = await getClientCreditSummary(
        auth.getAccount(),
        auth.getToken(),
        client_accountno,
      );
      const payload = response && response.data;
      if (
        payload &&
        (payload.status === 403 ||
          payload.errors === "authentication missing" ||
          payload.errors === "jwt expired")
      ) {
        auth.logout();
      } else if (payload && payload.status === 200 && payload.data) {
        this.setState({
          creditSummary: payload.data.summary || {
            total_credit: 0,
            total_used: 0,
            balance: 0,
          },
          creditRecent: payload.data.recent || [],
          creditSummaryLoading: false,
        });
      } else {
        this.setState({
          creditSummaryLoading: false,
          creditSummaryError:
            (payload && payload.message) || "Failed to load credit summary.",
        });
      }
    } catch (e) {
      this.setState({
        creditSummaryLoading: false,
        creditSummaryError: "Failed to load credit summary.",
      });
    }
  };

  handleCreditFieldChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value, addCreditError: "", addCreditSuccess: "" });
  };

  openAddCreditModal = () => {
    this.setState({
      showAddCreditModal: true,
      addCreditAmount: "",
      addCreditDate: new Date().toISOString().split("T")[0],
      addCreditPaymentMethod: "Bank ACH",
      addCreditReference: "",
      addCreditMemo: "",
      addCreditError: "",
      addCreditSuccess: "",
      addCreditLoading: false,
    });
  };

  closeAddCreditModal = () => {
    if (this.state.addCreditLoading) return;
    this.setState({ showAddCreditModal: false, addCreditError: "", addCreditSuccess: "" });
  };

  submitAddCredit = async () => {
    const {
      client_accountno,
      addCreditAmount,
      addCreditDate,
      addCreditPaymentMethod,
      addCreditReference,
      addCreditMemo,
    } = this.state;
    const amountNum = Number(addCreditAmount);
    if (
      !addCreditAmount ||
      !Number.isFinite(amountNum) ||
      amountNum <= 0
    ) {
      this.setState({
        addCreditError: "Please enter a valid positive amount.",
      });
      return;
    }
    if (amountNum > 1000000) {
      this.setState({
        addCreditError: "Amount must be 1,000,000 or less.",
      });
      return;
    }

    // Compose description from the new fields
    const parts = [];
    if (addCreditReference) parts.push(addCreditReference);
    if (addCreditPaymentMethod) parts.push(`via ${addCreditPaymentMethod}`);
    if (addCreditDate) parts.push(`Date: ${addCreditDate}`);
    if (addCreditMemo) parts.push(`[Memo: ${addCreditMemo}]`);
    const composedDescription = parts.length
      ? parts.join(" | ")
      : "Preloaded credit by admin";

    this.setState({
      addCreditLoading: true,
      addCreditError: "",
      addCreditSuccess: "",
    });

    try {
      const response = await addClientCredit(
        auth.getAccount(),
        auth.getToken(),
        client_accountno,
        amountNum,
        composedDescription,
      );
      const payload = response && response.data;
      if (
        payload &&
        (payload.status === 403 ||
          payload.errors === "authentication missing" ||
          payload.errors === "jwt expired")
      ) {
        auth.logout();
        return;
      }
      if (payload && payload.status === 200) {
        this.setState({
          addCreditLoading: false,
          addCreditSuccess: "Credit added successfully.",
          addCreditAmount: "",
          addCreditReference: "",
          addCreditMemo: "",
        });
        this.loadCreditSummary();
        // If ledger modal is open, refresh first page.
        if (this.state.showLedgerModal) {
          this.setState({ ledgerPage: 1 }, () => this.loadLedger());
        }
        setTimeout(() => {
          this.setState({ addCreditSuccess: "" });
          this.closeAddCreditModal();
        }, 1500);
      } else {
        this.setState({
          addCreditLoading: false,
          addCreditError:
            (payload && payload.message) || "Failed to add credit.",
        });
      }
    } catch (e) {
      this.setState({
        addCreditLoading: false,
        addCreditError: "Failed to add credit.",
      });
    }
  };

  openLedgerModal = () => {
    this.setState(
      {
        showLedgerModal: true,
        ledgerPage: 1,
        ledgerLimit: 1000,
        ledgerRows: [],
        ledgerError: "",
      },
      this.loadLedger,
    );
  };

  closeLedgerModal = () => {
    this.setState({ showLedgerModal: false });
  };

  loadLedger = async () => {
    const { client_accountno, ledgerPage, ledgerLimit } = this.state;
    if (!client_accountno) return;
    this.setState({ ledgerLoading: true, ledgerError: "" });
    try {
      const response = await getClientCreditLedger(
        auth.getAccount(),
        auth.getToken(),
        client_accountno,
        ledgerPage,
        ledgerLimit,
      );
      const payload = response && response.data;
      if (
        payload &&
        (payload.status === 403 ||
          payload.errors === "authentication missing" ||
          payload.errors === "jwt expired")
      ) {
        auth.logout();
        return;
      }
      if (payload && payload.status === 200 && payload.data) {
        this.setState({
          ledgerRows: payload.data.rows || [],
          ledgerTotal: Number(payload.data.total) || 0,
          ledgerLoading: false,
        });
      } else {
        this.setState({
          ledgerLoading: false,
          ledgerError:
            (payload && payload.message) || "Failed to load ledger.",
        });
      }
    } catch (e) {
      this.setState({
        ledgerLoading: false,
        ledgerError: "Failed to load ledger.",
      });
    }
  };

  onLedgerPageChange = (page) => {
    this.setState({ ledgerPage: page }, () => this.loadLedger());
  };

  onLedgerLimitChange = (limit) => {
    this.setState({ ledgerLimit: limit, ledgerPage: 1 }, () =>
      this.loadLedger(),
    );
  };

  render() {
    const { useGooglePlaces, toggleButtonText } = this.state;
    const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
    const checkedIcon = <CheckBoxIcon fontSize="small" />;
    const fetchToken = async () => {
      try {
        const response = await fetch(
          AGENT_SERVER_URL + "agents/editor_token_url",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              request_type: "ckeditor-tokenUrl",
              user: auth.getAccount(),
            }),
          },
        );
        const data = await response.json();
        return data.token;
      } catch (error) {
        console.error("Failed to fetch token:", error);
        return null;
      }
    };
    return (
      <div className="nk-content " id="Clients_Block">
        <style>{`
          /* Green border for filled onboarding items */
          .onboarding-filled-field .MuiOutlinedInput-notchedOutline {
            border-color: #0fca7a !important;
            border-width: 2px !important;
          }
          .onboarding-filled-field.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
            border-color: #0fca7a !important;
          }
          .onboarding-filled-field.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
            border-color: #0fca7a !important;
          }
        `}</style>
        <NotificationToast
          message={this.state.toastMessage}
          type={this.state.toastType}
          title={this.state.toastTitle}
          onDismiss={() => this.setState({ toastMessage: "" })}
        />
        <div className="container-fluid">
          {/* MSA WARNING  START*/}
          {this.props.defaultSettings === "missing" &&
          this.props.from !== "dashboard" ? (
            <SettingsError />
          ) : null}
          {this.props.is_msa_signed === "No" &&
          this.props.from !== "dashboard" ? (
            <MsaWarning />
          ) : null}
          {/* MSA WARNING END */}

          <div className="nk-content-inner">
            <div className="nk-content-body">
              <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between g-3">
                  <div className="nk-block-head-content">
                    <h3 className="nk-block-title page-title">
                      Client /{" "}
                      <strong className="text-primary small">
                        {this.state.client_update_name} (
                        {this.state.client_comp_name})
                      </strong>
                    </h3>
                    <div className="nk-block-des text-soft">
                      <ul className="list-inline">
                        <li>
                          Client ID:{" "}
                          <span className="text-base">
                            {this.state.client_accountno}
                          </span>
                        </li>
                        {/*<li>
                          Last Login:{" "}
                          <span className="text-base">15 Feb, 2019 01:02 PM</span>
                        </li>*/}
                      </ul>
                    </div>
                  </div>
                  <div className="nk-block-head-content">
                    <a
                      onClick={() => this.addMenuHistoryLeft("/clients")}
                      style={{ cursor: "pointer" }}
                      className="btn btn-outline-light bg-white d-none d-sm-inline-flex"
                    >
                      <em className="icon ni ni-arrow-left"></em>
                      <span>Back</span>
                    </a>
                    <a
                      onClick={() => this.addMenuHistoryLeft("/clients")}
                      style={{ cursor: "pointer" }}
                      className="btn btn-icon btn-outline-light bg-white d-inline-flex d-sm-none"
                    >
                      <em className="icon ni ni-arrow-left"></em>
                    </a>
                  </div>
                </div>
              </div>
              <div className="nk-block">
                <div className="card card-bordered">
                  <div className="card-aside-wrap clientsView">
                    <div className="card-content">
                      <ul className="nav nav-tabs nav-tabs-mb-icon nav-tabs-card viewClient_nav-tabs_customStyle">
                        <li
                          className="nav-item viewClients_nav-item_customStyle"
                          style={{ cursor: "pointer" }}
                        >
                          <a
                            className={`nav-link ${
                              this.state.activeTab === "agreements"
                                ? "active"
                                : ""
                            }`}
                            onClick={(e) => {
                              this.changeActiveTab("agreements");
                              this.clientAgreements();
                            }}
                          >
                            <em className="icon ni ni-reports-alt"></em>
                            <span>Agreements</span>
                          </a>
                        </li>
                        <li
                          className="nav-item viewClients_nav-item_customStyle"
                          style={{ cursor: "pointer" }}
                        >
                          <a
                            className={`nav-link ${
                              this.state.activeTab === "assigned_products"
                                ? "active"
                                : ""
                            }`}
                            onClick={(e) => {
                              this.changeActiveTab("assigned_products");
                              this.showAssignedServices();
                            }}
                          >
                            <em className="icon ni ni-package"></em>
                            <span>Assigned Products</span>
                          </a>
                        </li>
                        {/*<li
                          className="nav-item viewClients_nav-item_customStyle"
                          style={{ cursor: "pointer" }}
                        >
                          <a
                            className={`nav-link ${
                              this.state.activeTab === "kyc_form"
                                ? "active"
                                : ""
                            }`}
                            onClick={(e) => {
                              this.changeActiveTab("kyc_form");
                              this.showDetails();
                            }}
                          >
                            <em className="icon ni ni-user-list"></em>
                            <span>KYC Form</span>
                          </a>
                        </li>*/}
                        <li
                          className="nav-item viewClients_nav-item_customStyle"
                          style={{ cursor: "pointer" }}
                        >
                          <a
                            className={`nav-link ${
                              this.state.activeTab === "onboarding_settings"
                                ? "active"
                                : ""
                            }`}
                            onClick={(e) => {
                              this.changeActiveTab("onboarding_settings");
                            }}
                          >
                            <em className="icon ni ni-setting"></em>
                            <span>Onboarding Settings</span>
                          </a>
                        </li>
                        <li
                          className="nav-item viewClients_nav-item_customStyle"
                          style={{ cursor: "pointer" }}
                        >
                          <a
                            className={`nav-link ${
                              this.state.activeTab === "forms" ? "active" : ""
                            }`}
                            onClick={(e) => {
                              this.changeActiveTab("forms");
                              this.client_assigned_forms();
                            }}
                          >
                            <em className="icon ni ni-list-check"></em>
                            <span>Forms</span>
                          </a>
                        </li>
                        <li
                          className="nav-item viewClients_nav-item_customStyle"
                          style={{ cursor: "pointer" }}
                        >
                          <a
                            className={`nav-link ${
                              this.state.activeTab === "notes" ? "active" : ""
                            }`}
                            onClick={(e) => {
                              this.changeActiveTab("notes");
                              this.clientServices();
                            }}
                          >
                            <em className="icon ni ni-notes"></em>
                            <span>Client Notes</span>
                          </a>
                        </li>
                        <li
                          className="nav-item viewClients_nav-item_customStyle"
                          style={{ cursor: "pointer" }}
                        >
                          <a
                            className={`nav-link ${
                              this.state.activeTab === "credit_app"
                                ? "active"
                                : ""
                            }`}
                            onClick={() =>
                              this.openLinkInNewTab(
                                "/clients/subclients/" +
                                  this.state.client_accountno,
                              )
                            }
                          >
                            <em className="icon ni ni-user-list"></em>
                            <span>Sub Users</span>
                          </a>
                        </li>
                        {this.state.sipnavLoading ? (
                          <li className="nav-item viewClients_nav-item_customStyle">
                            <a className="nav-link disabled pe-none d-flex align-items-center">
                              <span
                                className="skeleton-text"
                                style={{ width: 16, height: 16 }}
                              ></span>
                              <span
                                className="skeleton-text ml-1"
                                style={{ width: 80, height: 14 }}
                              ></span>
                            </a>
                          </li>
                        ) : (
                          this.state.sipnavEnabled && this.state.sipnavHasAccount && (
                            <li
                              className="nav-item viewClients_nav-item_customStyle"
                              style={{ cursor: "pointer" }}
                            >
                              <a
                                className={`nav-link ${
                                  this.state.activeTab === "sbc_settings"
                                    ? "active"
                                    : ""
                                }`}
                                onClick={() =>
                                  this.changeActiveTab("sbc_settings")
                                }
                              >
                                <em className="icon ni ni-signal"></em>
                                <span>SBC Settings</span>
                              </a>
                            </li>
                          )
                        )}
                        <li>
                          <div className="dropdown mt-3">
                            <a
                              className="btn btn-xs btn-outline-light btn-icon dropdown-toggle"
                              data-toggle="dropdown"
                              data-offset="0,5"
                            >
                              <em className="icon ni ni-more-h"></em>
                            </a>
                            <div className="dropdown-menu dropdown-menu-right dropdown-menu-md  dropdown-menu-s">
                              <ul className="link-list-plain">
                                <li>
                                  <a
                                    data-toggle="tooltip"
                                    data-placement="left"
                                    onClick={() =>
                                      this.openLinkInNewTab(
                                        "/Quotations/" +
                                          this.state.client_accountno,
                                      )
                                    }
                                    title="Quotations"
                                    style={{ cursor: "pointer" }}
                                  >
                                    <em
                                      className="icon ni ni-note-add"
                                      style={{ marginRight: "7px" }}
                                    ></em>
                                    <span>Quotations</span>
                                  </a>
                                </li>
                                <li>
                                  <a
                                    data-toggle="tooltip"
                                    data-placement="left"
                                    onClick={() =>
                                      this.openLinkInNewTab(
                                        "/Rfqs/" + this.state.client_accountno,
                                      )
                                    }
                                    title="RFQs"
                                    style={{ cursor: "pointer" }}
                                  >
                                    <em
                                      className="icon ni ni-files"
                                      style={{ marginRight: "7px" }}
                                    ></em>
                                    <span>RFQs</span>
                                  </a>
                                </li>
                                <li>
                                  <a
                                    data-toggle="tooltip"
                                    data-placement="left"
                                    onClick={() =>
                                      this.openLinkInNewTab(
                                        "/SalesOrders/" +
                                          this.state.client_accountno,
                                      )
                                    }
                                    title="Sale Orders"
                                    style={{ cursor: "pointer" }}
                                  >
                                    <em
                                      className="icon ni ni-growth"
                                      style={{ marginRight: "7px" }}
                                    ></em>
                                    <span>Sale Orders</span>
                                  </a>
                                </li>
                                <li>
                                  <a
                                    data-toggle="tooltip"
                                    data-placement="left"
                                    onClick={() =>
                                      this.agentAssignRole(
                                        this.state.client_accountno,
                                        this.state.client_update_email,
                                        this.state.client_comp_name,
                                        this.state.client_update_name,
                                      )
                                    }
                                    style={{ cursor: "pointer" }}
                                  >
                                    <em
                                      className="icon ni ni-grid-alt"
                                      style={{ marginRight: "7px" }}
                                    ></em>
                                    <span>Client Menu</span>
                                  </a>
                                </li>
                                <li>
                                  <a
                                    style={{ cursor: "pointer" }}
                                    onClick={(e) => {
                                      this.changeActiveTab(
                                        "archived_agreements",
                                      );
                                      this.archived_agreements(
                                        this.state.client_accountno,
                                      );
                                    }}
                                  >
                                    <em
                                      className="icon ni ni-archived"
                                      style={{ marginRight: "7px" }}
                                    ></em>
                                    <span>Archived Agreements</span>
                                  </a>
                                </li>
                                {/* <li>
                                  <a
                                    data-toggle="tooltip"
                                    data-placement="left"
                                    onClick={() =>
                                      this.openLinkInNewTab(
                                        "/clients/subclients/" +
                                          this.state.client_accountno
                                      )
                                    }
                                    style={{ cursor: "pointer" }}
                                  >
                                    <em
                                      className="icon ni ni-users"
                                      style={{ marginRight: "7px" }}
                                    ></em>
                                    <span>Sub Users</span>
                                  </a>
                                </li> */}
                                <li>
                                  <a
                                    data-toggle="tooltip"
                                    data-placement="left"
                                    onClick={() => this.loginDetailView()}
                                    style={{ cursor: "pointer" }}
                                  >
                                    <em
                                      className="icon ni ni-signin"
                                      style={{ marginRight: "7px" }}
                                    ></em>
                                    <span>Login Details</span>
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </li>
                      </ul>

                      <div className="tab-content">
                        <div
                          className={
                            this.state.activeTab === "assigned_products"
                              ? "tab-pane active"
                              : "tab-pane"
                          }
                          id="tabItemProducts"
                        >
                          <div className="card-inner">
                            <div className="nk-block">
                              <div className="nk-block-head">
                                <h5 className="title">
                                  Assigned Products & Services
                                </h5>
                                <p>
                                  This list comprises the products or services
                                  allocated or permitted for this client.
                                </p>
                              </div>
                              {this.state.assignedLoader === true ? (
                                FormLoader()
                              ) : (
                                <div className="table-responsive">
                                  {this.state.serviceAssignedData &&
                                  this.state.serviceAssignedData.length > 0 ? (
                                    <>
                                      <table className="table table-striped">
                                        <thead>
                                          <tr>
                                            <th>
                                              <div className="custom-control custom-checkbox">
                                                <input
                                                  type="checkbox"
                                                  checked={this.state.checkAll}
                                                  className="custom-control-input"
                                                  name="selected_products_1"
                                                  onChange={
                                                    this.handleCheckAllChange
                                                  }
                                                  id="product_ids"
                                                autoComplete="new-password" />
                                                <label
                                                  className="custom-control-label"
                                                  htmlFor="product_ids"
                                                ></label>
                                              </div>
                                            </th>
                                            <th>Item</th>
                                            <th>SKU</th>
                                            <th>Title</th>
                                            <th>Agreement</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {this.state.serviceAssignedData.map(
                                            (row, index) => (
                                              <tr key={`prokey${index}`}>
                                                <td>
                                                  <div className="custom-control custom-checkbox">
                                                    <input
                                                      type="checkbox"
                                                      checked={row.checked}
                                                      className="custom-control-input"
                                                      name="selected_products"
                                                      onChange={() =>
                                                        this.handleCheckboxChange(
                                                          row.id,
                                                        )
                                                      }
                                                      value={row.id}
                                                      id={`product_id_${index}`}
                                                    />
                                                    <label
                                                      className="custom-control-label"
                                                      htmlFor={`product_id_${index}`}
                                                    ></label>
                                                  </div>
                                                </td>
                                                <td>{row.id}</td>
                                                <td>
                                                  {row.sku && row.sku !== ""
                                                    ? row.sku
                                                    : "---"}
                                                </td>
                                                <td>{row.service_title}</td>
                                                <td>
                                                  {row.agreement_title &&
                                                  row.agreement_title !== "" ? (
                                                    <>
                                                      <ul className="preview-list">
                                                        <li className="preview-item">
                                                          <a
                                                            onClick={() =>
                                                              this.openAgreementDelete(
                                                                row.id,
                                                                row.agreement_accountno,
                                                              )
                                                            }
                                                            style={{
                                                              cursor: "pointer",
                                                            }}
                                                          >
                                                            <span className="badge badge-outline-danger">
                                                              <em className="icon ni ni-cross"></em>{" "}
                                                              Remove
                                                            </span>
                                                          </a>
                                                        </li>
                                                        {row.is_signed &&
                                                        row.is_signed !== "" ? (
                                                          <li className="preview-item">
                                                            {row.is_signed ===
                                                            "Yes" ? (
                                                              <span className="badge badge-outline-success">
                                                                Signed
                                                              </span>
                                                            ) : row.is_signed ===
                                                              "No" ? (
                                                              <span className="badge badge-outline-warning">
                                                                Not Signed
                                                              </span>
                                                            ) : null}
                                                          </li>
                                                        ) : null}
                                                      </ul>
                                                    </>
                                                  ) : (
                                                    <ul className="preview-list">
                                                      <li className="preview-item">
                                                        <a
                                                          onClick={() =>
                                                            this.openAgreementAdd(
                                                              row.id,
                                                            )
                                                          }
                                                          style={{
                                                            cursor: "pointer",
                                                          }}
                                                        >
                                                          <span className="badge badge-outline-secondary">
                                                            <em className="icon ni ni-plus"></em>{" "}
                                                            Add
                                                          </span>
                                                        </a>
                                                      </li>
                                                      <li className="preview-item">
                                                        <span className="badge badge-outline-dark">
                                                          No Agreement
                                                        </span>
                                                      </li>
                                                    </ul>
                                                  )}
                                                </td>
                                              </tr>
                                            ),
                                          )}
                                        </tbody>
                                      </table>
                                      <div className="col-sm-12 mt-4 d-flex justify-content-end">
                                        <div className="nk-block-head-content">
                                          <ul className="nk-block-tools gx-3">
                                            {this.state
                                              .update_service_button ===
                                            true ? (
                                              <button
                                                className="btn btn-primary"
                                                type="button"
                                                disabled
                                              >
                                                <span
                                                  className="spinner-grow spinner-grow-sm"
                                                  role="status"
                                                  aria-hidden="true"
                                                ></span>
                                                <span> Processing... </span>
                                              </button>
                                            ) : (
                                              <>
                                                {this.state.permissionsState &&
                                                this.state.permissionsState
                                                  .length > 0 &&
                                                this.state
                                                  .permission_assigned_products ===
                                                  1 ? (
                                                  <li>
                                                    <a
                                                      onClick={() =>
                                                        this.updateAssignedServices()
                                                      }
                                                      style={{
                                                        cursor: "pointer",
                                                        color: "#fff",
                                                      }}
                                                      className="btn btn-primary"
                                                    >
                                                      <em className="icon ni ni-check-round-cut"></em>{" "}
                                                      <span>Update</span>{" "}
                                                    </a>
                                                  </li>
                                                ) : null}
                                              </>
                                            )}
                                          </ul>
                                        </div>
                                      </div>
                                    </>
                                  ) : (
                                    <div className="alert alert-pro alert-primary">
                                      <div className="alert-text">
                                        <h6>No Service Assigned</h6>
                                        <p>
                                          No service has been assigned to this
                                          client.
                                        </p>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div
                          className={
                            this.state.activeTab === "forms"
                              ? "tab-pane active"
                              : "tab-pane"
                          }
                          id="tabItemForms"
                        >
                          <div className="card-inner">
                            <div className="nk-block">
                              <div className="nk-block-head">
                                <div className="nk-block-between-md g-4">
                                  <div className="nk-block-head-content">
                                    <h5 className="nk-block-title">
                                      Assigned Forms
                                    </h5>
                                  </div>
                                  <div className="nk-block-head-content">
                                    <ul className="nk-block-tools g-4 flex-wrap">
                                      {this.state.permissionsState &&
                                      this.state.permissionsState.length > 0 &&
                                      this.state.permission_assign_form ===
                                        1 ? (
                                        <li className="order-md-last">
                                          <a
                                            onClick={() => this.getAllForms()}
                                            href="#"
                                            className="btn btn-white btn-dim btn-outline-primary"
                                          >
                                            <em className="icon ni ni-note-add-c"></em>
                                            <span>Assign Forms</span>
                                          </a>
                                        </li>
                                      ) : null}
                                      {this.state.permissionsState &&
                                      this.state.permissionsState.length > 0 &&
                                      this.state.permission_archived_forms ===
                                        1 ? (
                                        <li className="order-md-last">
                                          <a
                                            onClick={(e) => {
                                              this.changeActiveTab(
                                                "archived_forms",
                                              );
                                              this.client_archived_forms(
                                                this.state.client_accountno,
                                              );
                                            }}
                                            href="#"
                                            className="btn btn-white btn-dim btn-outline-primary"
                                          >
                                            <em className="icon ni ni-archived"></em>
                                            <span>Archived Submissions</span>
                                          </a>
                                        </li>
                                      ) : null}
                                    </ul>
                                  </div>
                                </div>
                              </div>
                              {this.state.assignedLoader === true ? (
                                FormLoader()
                              ) : (
                                <>
                                  <div className="caption-text">
                                    <div
                                      className="tab-pane active"
                                      id="tabItemSigned"
                                    >
                                      <div className="card card-bordered card-preview">
                                        <DataTableExtended
                                          columns={this.state.columnForms}
                                          tableData={
                                            this.state.formsAssignedData
                                          }
                                          title=""
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                        <div
                          className={
                            this.state.activeTab === "agreements"
                              ? "tab-pane active"
                              : "tab-pane"
                          }
                          id="tabItemAgreements"
                        >
                          <div className="card-inner">
                            <div className="nk-block">
                              <div className="nk-block-head">
                                <div className="nk-block-between mb-4">
                                  <div className="nk-block-head-content">
                                    <h5 className="nk-block-title page-title">
                                      Agreements
                                    </h5>
                                  </div>
                                  <div
                                    className="nk-block-head-content"
                                    id="HeadContent"
                                  >
                                    <div className="toggle-wrap nk-block-tools-toggle">
                                      <a
                                        href="#"
                                        className="btn btn-icon btn-trigger toggle-expand mr-n1"
                                        data-target="pageMenu"
                                      >
                                        <em className="icon ni ni-more-v"></em>
                                      </a>
                                      <div
                                        className="toggle-expand-content"
                                        data-content="pageMenu"
                                      >
                                        <ul className="nk-block-tools g-3">
                                          {/*<li className="nk-block-tools-opt">
                                          <a
                                            style={{
                                              cursor: "pointer",
                                            }}
                                            onClick={(e) => {
                                              this.getAllAgreements();
                                            }}
                                            className="btn btn-white btn-dim btn-outline-primary"
                                          >
                                            <em className="icon ni ni-note-add"></em>
                                            &nbsp; Assign Agreements
                                          </a>
                                        </li>*/}
                                          <li className="nk-block-tools-opt">
                                            <a
                                              style={{
                                                cursor: "pointer",
                                              }}
                                              onClick={(e) => {
                                                this.changeActiveTab(
                                                  "archived_agreements",
                                                );
                                                this.archived_agreements(
                                                  this.state.client_accountno,
                                                );
                                              }}
                                              className="btn btn-white btn-dim btn-outline-primary"
                                            >
                                              <em className="icon ni ni-archived"></em>
                                              &nbsp; Archived Agreements
                                            </a>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {this.state.assignedLoader === true ? (
                                  FormLoader()
                                ) : (
                                  <>
                                    <div className="caption-text">
                                      <div
                                        className="tab-pane active"
                                        id="tabItemSigned"
                                      >
                                        {this.state.isRevokeReasonActive ? (
                                          <div id="revokeReasonItems">
                                            <div className="tb-odr-id">
                                              Reason to revoke
                                            </div>
                                            <div className="card card-bordered card-preview mt-1">
                                              <TextareaAutosize
                                                maxrows={4}
                                                name="revoke_reason"
                                                id="revoke_reason"
                                                aria-label=""
                                                placeholder=""
                                                value={this.state.revoke_reason}
                                                helperText="Reason to revoke this agreement"
                                                onChange={
                                                  this.handleRevokeValueChange
                                                }
                                                style={{
                                                  width: "100%",
                                                  height: "100px",
                                                  borderColor:
                                                    "rgba(0, 0, 0, 0.125)",
                                                  borderRadius: "4px",
                                                }}
                                                variant="outlined"
                                              />
                                            </div>
                                            <div
                                              className="form-group text-right"
                                              style={{
                                                marginTop: "15px",
                                                marginBottom: "15px",
                                              }}
                                            >
                                              <button
                                                type="button"
                                                style={{ marginRight: 5 }}
                                                className="btn btn-light"
                                                onClick={() => {
                                                  this.setState({
                                                    isRevokeReasonActive: false,
                                                    revoke_reason: "",
                                                    errorMessage: "",
                                                    successMessage: "",
                                                  });
                                                }}
                                              >
                                                Cancel
                                              </button>
                                              <button
                                                type="button"
                                                className="btn btn-primary"
                                                onClick={() => {
                                                  this.handleClientAgreementRevokeSubmit(
                                                    this.state
                                                      .revokeAgreementData
                                                      .agreement_accountno,
                                                    this.state.client_accountno,
                                                    this.state.revoke_reason,
                                                  );
                                                }}
                                                disabled={this.state.disabled}
                                              >
                                                Submit
                                              </button>
                                            </div>
                                          </div>
                                        ) : null}

                                        {this.state.isApproveActive ? (
                                          <div className="row g-gs">
                                            <div className="col-md-12 mb-3">
                                              <div className="card card-bordered">
                                                <div className="card-inner">
                                                  <h5 className="card-title">
                                                    Approve Agreement
                                                  </h5>

                                                  <p className="card-text">
                                                    Are you sure you want to
                                                    approve this agreement?
                                                  </p>

                                                  <div className="col-md-12">
                                                    <div className="form-group text-right">
                                                      <button
                                                        type="button"
                                                        onClick={() =>
                                                          this.setState({
                                                            isApproveActive: false,
                                                            approve_agreement_accountno:
                                                              "",
                                                            approve_agreement_id:
                                                              "",
                                                          })
                                                        }
                                                        className="btn btn-light"
                                                        disabled={
                                                          this.state.disabled
                                                        }
                                                        style={{
                                                          marginRight: "15px",
                                                        }}
                                                      >
                                                        No
                                                      </button>
                                                      <button
                                                        type="button"
                                                        onClick={() =>
                                                          this.approveAgreement(
                                                            this.state
                                                              .approve_agreement_accountno,
                                                          )
                                                        }
                                                        className="btn btn-success"
                                                        disabled={
                                                          this.state.disabled
                                                        }
                                                        title=""
                                                      >
                                                        Yes
                                                      </button>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        ) : null}

                                        <div className="card card-bordered card-preview">
                                          <table className="table table-orders viewClient_table-orders_customStyle">
                                            <thead className="tb-odr-head">
                                              <tr className="tb-odr-item">
                                                <th>
                                                  <span className="tb-odr-id">
                                                    Agreement Name
                                                  </span>
                                                </th>
                                                <th>
                                                  <span className="tb-odr-date d-none d-md-inline-block">
                                                    Signed Date
                                                  </span>
                                                </th>
                                                <th>
                                                  <span className="tb-odr-total">
                                                    Approved
                                                  </span>
                                                </th>
                                                <th>
                                                  <span className="tb-odr-total">
                                                    Status
                                                  </span>
                                                </th>
                                                <th>
                                                  <span className="tb-odr-status d-none d-md-inline-block">
                                                    Download
                                                  </span>
                                                </th>
                                                <th className="tb-odr-action">
                                                  Action
                                                </th>
                                              </tr>
                                            </thead>
                                            <tbody className="tb-odr-body">
                                              {this.state.signedData &&
                                              this.state.signedData.length >
                                                0 ? (
                                                <>
                                                  {this.state.signedData.map(
                                                    (signed, index) => (
                                                      <tr
                                                        className="tb-odr-item"
                                                        key={`sign${index}`}
                                                      >
                                                        <td>
                                                          <span className="tb-odr-id">
                                                            {
                                                              signed.agreement_title
                                                            }
                                                          </span>
                                                        </td>
                                                        <td>
                                                          <span className="tb-odr-date">
                                                            {signed.signed_date &&
                                                            signed.signed_date !==
                                                              ""
                                                              ? this.format_date(
                                                                  signed.signed_date,
                                                                )
                                                              : "---"}
                                                          </span>
                                                        </td>
                                                        <td>
                                                          <span className="tb-odr-status">
                                                            {signed.approved ===
                                                            "Yes" ? (
                                                              <span className="badge badge-outline-success">
                                                                Yes
                                                              </span>
                                                            ) : (
                                                              <span className="badge badge-outline-danger">
                                                                No
                                                              </span>
                                                            )}
                                                          </span>
                                                        </td>
                                                        <td>
                                                          <span className="tb-odr-status">
                                                            {signed.is_signed ===
                                                            "Yes" ? (
                                                              <span className="badge badge-outline-success">
                                                                Signed
                                                              </span>
                                                            ) : (
                                                              <span className="badge badge-outline-danger">
                                                                Unsigned
                                                              </span>
                                                            )}
                                                          </span>
                                                        </td>

                                                        <td>
                                                          {signed.pdf_path &&
                                                          signed.pdf_path !==
                                                            "" ? (
                                                            <>
                                                              {this.state
                                                                .permissionsState &&
                                                              this.state
                                                                .permissionsState
                                                                .length > 0 &&
                                                              this.state
                                                                .permission_view_agreement ===
                                                                1 ? (
                                                                <a
                                                                  onClick={() =>
                                                                    this.downloadPdf(
                                                                      signed.pdf_path,
                                                                      signed.agreement_title,
                                                                    )
                                                                  }
                                                                  title="Download Agreement"
                                                                  style={{
                                                                    cursor:
                                                                      "pointer",
                                                                  }}
                                                                >
                                                                  <span className="badge badge-outline-primary">
                                                                    <em className="icon ni ni-download"></em>
                                                                  </span>
                                                                </a>
                                                              ) : (
                                                                <span className="badge badge-outline-light">
                                                                  ---
                                                                </span>
                                                              )}
                                                            </>
                                                          ) : (
                                                            <span className="badge badge-outline-light">
                                                              ---
                                                            </span>
                                                          )}
                                                        </td>
                                                        <td className="tb-odr-action">
                                                          <div className="dropdown">
                                                            <a
                                                              className="text-soft dropdown-toggle btn btn-icon btn-trigger"
                                                              data-toggle="dropdown"
                                                              data-offset="-8,0"
                                                            >
                                                              <em className="icon ni ni-more-h"></em>
                                                            </a>
                                                            <div
                                                              className="dropdown-menu dropdown-menu-right dropdown-menu-xs"
                                                              style={{
                                                                padding: "0px",
                                                              }}
                                                            >
                                                              <ul className="link-list-plain">
                                                                {signed.is_signed ===
                                                                  "Yes" &&
                                                                signed.approved ===
                                                                  "No" ? (
                                                                  <>
                                                                    {this.state
                                                                      .permissionsState &&
                                                                    this.state
                                                                      .permissionsState
                                                                      .length >
                                                                      0 &&
                                                                    this.state
                                                                      .permission_approve_agreement ===
                                                                      1 ? (
                                                                      <li>
                                                                        <a
                                                                          style={{
                                                                            cursor:
                                                                              "pointer",
                                                                          }}
                                                                          className="text-success"
                                                                          onClick={() =>
                                                                            this.setState(
                                                                              {
                                                                                isApproveActive: true,
                                                                                isRevokeReasonActive: false,
                                                                                approve_agreement_id:
                                                                                  signed.agreement_id,
                                                                                approve_agreement_accountno:
                                                                                  signed.agreement_accountno,
                                                                              },
                                                                              () =>
                                                                                this.scrollToDiv(
                                                                                  "card-content",
                                                                                ),
                                                                            )
                                                                          }
                                                                        >
                                                                          <em className="icon ni ni-done icon_space"></em>
                                                                          <span>
                                                                            Approve
                                                                          </span>
                                                                        </a>
                                                                      </li>
                                                                    ) : null}
                                                                  </>
                                                                ) : null}
                                                                {signed.is_signed ===
                                                                "Yes" ? (
                                                                  <>
                                                                    {this.state
                                                                      .permissionsState &&
                                                                    this.state
                                                                      .permissionsState
                                                                      .length >
                                                                      0 &&
                                                                    this.state
                                                                      .permission_reject_agreement ===
                                                                      1 ? (
                                                                      <li>
                                                                        <a
                                                                          style={{
                                                                            cursor:
                                                                              "pointer",
                                                                          }}
                                                                          onClick={() =>
                                                                            this.revokeAgreement(
                                                                              signed.agreement_accountno,
                                                                            )
                                                                          }
                                                                        >
                                                                          <em className="icon ni ni-na icon_space"></em>
                                                                          <span>
                                                                            Revoke
                                                                          </span>
                                                                        </a>
                                                                      </li>
                                                                    ) : null}
                                                                  </>
                                                                ) : null}
                                                                {signed.is_signed ===
                                                                "Yes" ? (
                                                                  <>
                                                                    {this.state
                                                                      .permissionsState &&
                                                                    this.state
                                                                      .permissionsState
                                                                      .length >
                                                                      0 &&
                                                                    this.state
                                                                      .permission_view_signee ===
                                                                      1 ? (
                                                                      <li>
                                                                        <a
                                                                          style={{
                                                                            cursor:
                                                                              "pointer",
                                                                          }}
                                                                          onClick={() =>
                                                                            this.openSigneeDetails(
                                                                              signed.agreement_accountno,
                                                                            )
                                                                          }
                                                                          data-toggle="tooltip"
                                                                          data-placement="top"
                                                                          title="Show signee details"
                                                                        >
                                                                          <em className="icon ni ni-table-view icon_space"></em>
                                                                          <span>
                                                                            Signee
                                                                            Details
                                                                          </span>
                                                                        </a>
                                                                      </li>
                                                                    ) : null}
                                                                  </>
                                                                ) : null}
                                                                {this.state
                                                                  .permissionsState &&
                                                                this.state
                                                                  .permissionsState
                                                                  .length > 0 &&
                                                                this.state
                                                                  .permission_upload_agreement ===
                                                                  1 ? (
                                                                  <li>
                                                                    <a
                                                                      style={{
                                                                        cursor:
                                                                          "pointer",
                                                                      }}
                                                                      onClick={() =>
                                                                        this.openUploadContract(
                                                                          signed.agreement_accountno,
                                                                        )
                                                                      }
                                                                      data-toggle="tooltip"
                                                                      data-placement="top"
                                                                      title="Upload new contract"
                                                                    >
                                                                      <em className="icon ni ni-upload icon_space"></em>
                                                                      <span>
                                                                        Upload
                                                                        Agreement
                                                                      </span>
                                                                    </a>
                                                                  </li>
                                                                ) : null}
                                                                {this.state
                                                                  .permissionsState &&
                                                                this.state
                                                                  .permissionsState
                                                                  .length > 0 &&
                                                                this.state
                                                                  .permission_remove_agreement ===
                                                                  1 ? (
                                                                  <li>
                                                                    <a
                                                                      style={{
                                                                        cursor:
                                                                          "pointer",
                                                                      }}
                                                                      onClick={() =>
                                                                        this.removeContract(
                                                                          signed.agreement_accountno,
                                                                        )
                                                                      }
                                                                      data-toggle="tooltip"
                                                                      data-placement="top"
                                                                      title="Remove Agreement"
                                                                    >
                                                                      <em className="icon ni ni-minus-circle icon_space"></em>{" "}
                                                                      <span>
                                                                        Remove
                                                                        Agreement
                                                                      </span>
                                                                    </a>
                                                                  </li>
                                                                ) : null}
                                                              </ul>
                                                            </div>
                                                          </div>
                                                        </td>
                                                      </tr>
                                                    ),
                                                  )}
                                                </>
                                              ) : (
                                                <tr className="tb-odr-item">
                                                  <td
                                                    colSpan={6}
                                                    className="text-center text-muted py-4"
                                                  >
                                                    Sorry, no record found.
                                                  </td>
                                                </tr>
                                              )}
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className={
                            this.state.activeTab === "kyc_form"
                              ? "tab-pane active"
                              : "tab-pane"
                          }
                          id="tabItemKyc"
                        >
                          <div className="card-inner">
                            <div className="nk-block">
                              <div className="nk-block-head">
                                <div
                                  className="modal-title"
                                  style={{ marginBottom: "2rem" }}
                                >
                                  <h5>
                                    <em className="icon ni ni-card-view"></em>{" "}
                                    KYC Details
                                  </h5>
                                </div>
                                {this.state.assignedLoader === true ? (
                                  FormLoader()
                                ) : (
                                  <>
                                    <div className="caption-text">
                                      <div
                                        className="tab-pane active"
                                        id="tabItemSigned"
                                      >
                                        <div className="card card-preview">
                                          {this.state.kyc_key === "" ? (
                                            <div className="nk-block">
                                              <div className="card card-bordered">
                                                <div className="card-inner card-inner-lg">
                                                  <div className="nk-help">
                                                    <div className="nk-help-img">
                                                      <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        viewBox="0 0 90 90"
                                                      >
                                                        <rect
                                                          x="5"
                                                          y="7"
                                                          width="60"
                                                          height="56"
                                                          rx="7"
                                                          ry="7"
                                                          fill="#e3e7fe"
                                                          stroke="#6576ff"
                                                          strokeLinecap="round"
                                                          strokeLinejoin="round"
                                                          strokeWidth="2"
                                                        ></rect>
                                                        <rect
                                                          x="25"
                                                          y="27"
                                                          width="60"
                                                          height="56"
                                                          rx="7"
                                                          ry="7"
                                                          fill="#e3e7fe"
                                                          stroke="#6576ff"
                                                          strokeLinecap="round"
                                                          strokeLinejoin="round"
                                                          strokeWidth="2"
                                                        ></rect>
                                                        <rect
                                                          x="15"
                                                          y="17"
                                                          width="60"
                                                          height="56"
                                                          rx="7"
                                                          ry="7"
                                                          fill="#fff"
                                                          stroke="#6576ff"
                                                          strokeLinecap="round"
                                                          strokeLinejoin="round"
                                                          strokeWidth="2"
                                                        ></rect>
                                                        <line
                                                          x1="15"
                                                          y1="29"
                                                          x2="75"
                                                          y2="29"
                                                          fill="none"
                                                          stroke="#6576ff"
                                                          strokeMiterlimit="10"
                                                          strokeWidth="2"
                                                        ></line>
                                                        <circle
                                                          cx="53"
                                                          cy="23"
                                                          r="2"
                                                          fill="#c4cefe"
                                                        ></circle>
                                                        <circle
                                                          cx="60"
                                                          cy="23"
                                                          r="2"
                                                          fill="#c4cefe"
                                                        ></circle>
                                                        <circle
                                                          cx="67"
                                                          cy="23"
                                                          r="2"
                                                          fill="#c4cefe"
                                                        ></circle>
                                                        <rect
                                                          x="22"
                                                          y="39"
                                                          width="20"
                                                          height="20"
                                                          rx="2"
                                                          ry="2"
                                                          fill="none"
                                                          stroke="#6576ff"
                                                          strokeLinecap="round"
                                                          strokeLinejoin="round"
                                                          strokeWidth="2"
                                                        ></rect>
                                                        <circle
                                                          cx="32"
                                                          cy="45.81"
                                                          r="2"
                                                          fill="none"
                                                          stroke="#6576ff"
                                                          strokeLinecap="round"
                                                          strokeLinejoin="round"
                                                          strokeWidth="2"
                                                        ></circle>
                                                        <path
                                                          d="M29,54.31a3,3,0,0,1,6,0"
                                                          fill="none"
                                                          stroke="#6576ff"
                                                          strokeLinecap="round"
                                                          strokeLinejoin="round"
                                                          strokeWidth="2"
                                                        ></path>
                                                        <line
                                                          x1="49"
                                                          y1="40"
                                                          x2="69"
                                                          y2="40"
                                                          fill="none"
                                                          stroke="#6576ff"
                                                          strokeLinecap="round"
                                                          strokeLinejoin="round"
                                                          strokeWidth="2"
                                                        ></line>
                                                        <line
                                                          x1="49"
                                                          y1="51"
                                                          x2="69"
                                                          y2="51"
                                                          fill="none"
                                                          stroke="#c4cefe"
                                                          strokeLinecap="round"
                                                          strokeLinejoin="round"
                                                          strokeWidth="2"
                                                        ></line>
                                                        <line
                                                          x1="49"
                                                          y1="57"
                                                          x2="59"
                                                          y2="57"
                                                          fill="none"
                                                          stroke="#c4cefe"
                                                          strokeLinecap="round"
                                                          strokeLinejoin="round"
                                                          strokeWidth="2"
                                                        ></line>
                                                        <line
                                                          x1="64"
                                                          y1="57"
                                                          x2="66"
                                                          y2="57"
                                                          fill="none"
                                                          stroke="#c4cefe"
                                                          strokeLinecap="round"
                                                          strokeLinejoin="round"
                                                          strokeWidth="2"
                                                        ></line>
                                                        <line
                                                          x1="49"
                                                          y1="46"
                                                          x2="59"
                                                          y2="46"
                                                          fill="none"
                                                          stroke="#c4cefe"
                                                          strokeLinecap="round"
                                                          strokeLinejoin="round"
                                                          strokeWidth="2"
                                                        ></line>
                                                        <line
                                                          x1="64"
                                                          y1="46"
                                                          x2="66"
                                                          y2="46"
                                                          fill="none"
                                                          stroke="#c4cefe"
                                                          strokeLinecap="round"
                                                          strokeLinejoin="round"
                                                          strokeWidth="2"
                                                        ></line>
                                                      </svg>
                                                    </div>
                                                    <div className="nk-help-text">
                                                      <h5>
                                                        Initiate KYC Process
                                                      </h5>
                                                      <p className="text-soft">
                                                        Register your customer
                                                        with KYC to complete
                                                        their profile. Click on
                                                        "Initiate KYC" button.
                                                        An email with KYC
                                                        registration link will
                                                        be sent to the customer.
                                                      </p>
                                                    </div>
                                                    <div className="nk-help-action">
                                                      {this.state
                                                        .loading_button ===
                                                      false ? (
                                                        <a
                                                          style={{
                                                            cursor: "pointer",
                                                          }}
                                                          onClick={() => {
                                                            this.initiateKyc();
                                                          }}
                                                          disabled={
                                                            this.state.disabled
                                                          }
                                                          href="#"
                                                          className="btn btn-lg btn-outline-primary"
                                                        >
                                                          <em className="icon ni ni-file-docs"></em>{" "}
                                                          Initiate KYC
                                                        </a>
                                                      ) : null}
                                                      {this.state
                                                        .loading_button ===
                                                      true ? (
                                                        <button
                                                          className="btn btn-primary btn-lg"
                                                          type="button"
                                                          disabled
                                                        >
                                                          <span
                                                            className="spinner-border spinner-border-sm"
                                                            role="status"
                                                            aria-hidden="true"
                                                          ></span>
                                                          <span>
                                                            {" "}
                                                            Initiating...{" "}
                                                          </span>
                                                        </button>
                                                      ) : null}
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          ) : null}

                                          {this.state.kyc_key !== "" ? (
                                            <div id="printablediv">
                                              <div className="nk-content-body">
                                                <div className="nk-block-head nk-block-head-sm">
                                                  <div className="nk-block-between g-3">
                                                    <div className="nk-block-head-content">
                                                      <h5 className="nk-block-title">
                                                        KYCs /{" "}
                                                        <strong className="text-primary small">
                                                          {
                                                            this.state
                                                              .client_update_name
                                                          }
                                                        </strong>
                                                      </h5>
                                                      <div className="nk-block-des text-soft">
                                                        <ul className="list-inline">
                                                          <li>
                                                            Submited At:{" "}
                                                            <span className="text-base">
                                                              {
                                                                this.state
                                                                  .client_register_date
                                                              }
                                                            </span>
                                                          </li>
                                                        </ul>
                                                      </div>
                                                    </div>

                                                    <div className="nk-block-head-content">
                                                      <div className="btn-group">
                                                        {this.state
                                                          .kyc_approved ===
                                                          "No" ||
                                                        this.state
                                                          .kyc_approved ===
                                                          "" ? (
                                                          <>
                                                            {this.state
                                                              .completed_percentage ===
                                                            "100" ? (
                                                              <>
                                                                <button
                                                                  onClick={() =>
                                                                    this.showApprovedCont(
                                                                      "approve",
                                                                    )
                                                                  }
                                                                  type="button"
                                                                  className="btn btn-outline-primary"
                                                                  disabled={
                                                                    this.state
                                                                      .disabled
                                                                  }
                                                                >
                                                                  <em className="icon ni ni-check-round"></em>
                                                                  <span>
                                                                    Approve{" "}
                                                                  </span>
                                                                </button>

                                                                <button
                                                                  onClick={() =>
                                                                    this.showApprovedCont(
                                                                      "reject",
                                                                    )
                                                                  }
                                                                  type="button"
                                                                  className="btn btn-outline-danger"
                                                                  disabled={
                                                                    this.state
                                                                      .disabled
                                                                  }
                                                                >
                                                                  <em className="icon ni ni-cross-round"></em>
                                                                  <span>
                                                                    Reject{" "}
                                                                  </span>
                                                                </button>
                                                              </>
                                                            ) : (
                                                              <button
                                                                onClick={() => {
                                                                  this.setState(
                                                                    {
                                                                      showSendEmail: true,
                                                                    },
                                                                  );
                                                                }}
                                                                type="button"
                                                                className="btn btn-outline-primary"
                                                                disabled={
                                                                  this.state
                                                                    .disabled
                                                                }
                                                              >
                                                                <em className="icon ni ni-emails"></em>
                                                                <span>
                                                                  Send
                                                                  Email{" "}
                                                                </span>
                                                              </button>
                                                            )}
                                                          </>
                                                        ) : this.state
                                                            .kyc_approved ===
                                                          "Yes" ? (
                                                          <>
                                                            <button
                                                              type="button"
                                                              className="btn btn-success"
                                                              disabled={
                                                                this.state
                                                                  .disabled
                                                              }
                                                            >
                                                              <em className="icon ni ni-done"></em>
                                                              <span>
                                                                Approved{" "}
                                                              </span>
                                                            </button>
                                                            <button
                                                              onClick={() =>
                                                                this.showApprovedCont(
                                                                  "reject",
                                                                )
                                                              }
                                                              type="button"
                                                              className="btn btn-outline-danger"
                                                              disabled={
                                                                this.state
                                                                  .disabled
                                                              }
                                                            >
                                                              <em className="icon ni ni-cross-round"></em>
                                                              <span>
                                                                Reject
                                                                Approval{" "}
                                                              </span>
                                                            </button>
                                                          </>
                                                        ) : null}

                                                        {this.state
                                                          .completed_percentage ===
                                                        "100" ? (
                                                          <button
                                                            type="button"
                                                            onClick={() => {
                                                              this.downloadKycPdf(
                                                                this.state
                                                                  .kyc_key,
                                                              );
                                                            }}
                                                            className="btn btn-outline-primary"
                                                          >
                                                            <em className="icon ni ni-download"></em>
                                                            <span>
                                                              Download PDF
                                                            </span>
                                                          </button>
                                                        ) : null}
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                                {this.state.showSendEmail ? (
                                                  <div id="showSendEmailItems">
                                                    <div className="form-group mt-1">
                                                      <MutextField
                                                        required
                                                        id="kyc_email_address"
                                                        name="kyc_email_address"
                                                        type="text"
                                                        label="Email Address"
                                                        value={
                                                          this.state
                                                            .kyc_email_address
                                                        }
                                                        onChange={
                                                          this.handleChange
                                                        }
                                                        variant="outlined"
                                                        fullWidth
                                                      autoComplete="new-password"
                                                      />
                                                    </div>
                                                    <div
                                                      className="form-group text-right"
                                                      style={{
                                                        marginTop: "15px",
                                                        marginBottom: "15px",
                                                      }}
                                                    >
                                                      <button
                                                        type="button"
                                                        style={{
                                                          marginRight: 5,
                                                        }}
                                                        className="btn btn-light"
                                                        onClick={() => {
                                                          this.setState({
                                                            showSendEmail: false,
                                                          });
                                                        }}
                                                      >
                                                        Cancel
                                                      </button>
                                                      <button
                                                        type="button"
                                                        className="btn btn-primary"
                                                        onClick={() => {
                                                          this.email_kyc_Details();
                                                        }}
                                                        disabled={
                                                          this.state.disabled
                                                        }
                                                      >
                                                        Submit
                                                      </button>
                                                    </div>
                                                  </div>
                                                ) : null}
                                                {this.state.showKycApproved ? (
                                                  <div id="showSendEmailItemss">
                                                    <h5>
                                                      {this.state
                                                        .showApprovedAction ===
                                                      "approve"
                                                        ? "Approve KYC"
                                                        : this.state
                                                              .showApprovedAction ===
                                                            "reject"
                                                          ? "Reject KYC"
                                                          : null}
                                                    </h5>
                                                    <div className="form-group mt-1">
                                                      <MutextField
                                                        required
                                                        id="kyc_reason"
                                                        name="kyc_reason"
                                                        type="text"
                                                        label="Reason"
                                                        defaultValue={
                                                          this.state.kyc_reason
                                                        }
                                                        onChange={
                                                          this.handleChange
                                                        }
                                                        variant="outlined"
                                                        fullWidth
                                                      autoComplete="new-password"
                                                      />
                                                    </div>
                                                    <div
                                                      className="form-group text-right"
                                                      style={{
                                                        marginTop: "15px",
                                                        marginBottom: "15px",
                                                      }}
                                                    >
                                                      <button
                                                        type="button"
                                                        style={{
                                                          marginRight: 5,
                                                        }}
                                                        className="btn btn-light"
                                                        onClick={() => {
                                                          this.setState({
                                                            showKycApproved: false,
                                                          });
                                                        }}
                                                      >
                                                        Cancel
                                                      </button>
                                                      <button
                                                        type="button"
                                                        className="btn btn-primary"
                                                        onClick={() => {
                                                          this.submit_client_kyc_approval();
                                                        }}
                                                        disabled={
                                                          this.state.disabled
                                                        }
                                                      >
                                                        Submit
                                                      </button>
                                                    </div>
                                                    {/*<div className="example-alert mb-4">
                                                      <div className="alert alert-light">
                                                        {this.state
                                                          .showApprovedAction ===
                                                        "approve" ? (
                                                          <>
                                                            <h5>
                                                              Approval
                                                              Classifications
                                                            </h5>
                                                            <ol className="list">
                                                              <li>
                                                                <strong>
                                                                  Approval A:
                                                                </strong>{" "}
                                                                This indicates a
                                                                direct,
                                                                authenticated
                                                                relationship
                                                                between the
                                                                Approver and the
                                                                customer or the
                                                                Agent's
                                                                customer. It
                                                                signifies that
                                                                the Approver
                                                                vouches for the
                                                                required
                                                                information
                                                                being either
                                                                already
                                                                available or
                                                                known to them.
                                                              </li>
                                                              <li>
                                                                <strong>
                                                                  Approval B:
                                                                </strong>{" "}
                                                                This signifies
                                                                that the
                                                                Approver has
                                                                obtained
                                                                information
                                                                about the
                                                                customer via the
                                                                Agent or
                                                                Sub-Agent. The
                                                                approval is
                                                                based on the
                                                                authenticity of
                                                                this information
                                                                or upon the
                                                                Agent's/Sub-Agent's
                                                                request.
                                                                However, it
                                                                implies the need
                                                                for further
                                                                information
                                                                verification or
                                                                that
                                                                verification is
                                                                in progress.
                                                              </li>
                                                              <li>
                                                                <strong>
                                                                  Approval C:
                                                                </strong>{" "}
                                                                This approval is
                                                                solely based on
                                                                an internal
                                                                request within
                                                                the office. It
                                                                doesn't indicate
                                                                any direct or
                                                                indirect
                                                                relationship
                                                                with the
                                                                customer or any
                                                                substantial
                                                                information
                                                                about the
                                                                customer's
                                                                identity.
                                                              </li>
                                                            </ol>
                                                          </>
                                                        ) : this.state
                                                            .showApprovedAction ===
                                                          "reject" ? (
                                                          <>
                                                            <h5>
                                                              Rejection
                                                              Classifications
                                                            </h5>
                                                            <ol className="list">
                                                              <li>
                                                                <strong>
                                                                  Approval A:
                                                                </strong>{" "}
                                                                This indicates a
                                                                direct,
                                                                authenticated
                                                                relationship
                                                                between the
                                                                Approver and the
                                                                customer or the
                                                                Agent's
                                                                customer. It
                                                                signifies that
                                                                the Approver
                                                                vouches for the
                                                                required
                                                                information
                                                                being either
                                                                already
                                                                available or
                                                                known to them.
                                                              </li>
                                                              <li>
                                                                <strong>
                                                                  Approval B:
                                                                </strong>{" "}
                                                                This signifies
                                                                that the
                                                                Approver has
                                                                obtained
                                                                information
                                                                about the
                                                                customer via the
                                                                Agent or
                                                                Sub-Agent. The
                                                                approval is
                                                                based on the
                                                                authenticity of
                                                                this information
                                                                or upon the
                                                                Agent's/Sub-Agent's
                                                                request.
                                                                However, it
                                                                implies the need
                                                                for further
                                                                information
                                                                verification or
                                                                that
                                                                verification is
                                                                in progress.
                                                              </li>
                                                              <li>
                                                                <strong>
                                                                  Approval C:
                                                                </strong>{" "}
                                                                This approval is
                                                                solely based on
                                                                an internal
                                                                request within
                                                                the office. It
                                                                doesn't indicate
                                                                any direct or
                                                                indirect
                                                                relationship
                                                                with the
                                                                customer or any
                                                                substantial
                                                                information
                                                                about the
                                                                customer's
                                                                identity.
                                                              </li>
                                                            </ol>
                                                          </>
                                                        ) : null}
                                                      </div>
                                                    </div>*/}
                                                  </div>
                                                ) : null}
                                                <div className="nk-block-head">
                                                  <div className="nk-block-head-content">
                                                    <h5 className="nk-block-title title">
                                                      Profile Completed{" "}
                                                      <span className="text-primary">
                                                        (
                                                        {
                                                          this.state
                                                            .completed_percentage
                                                        }
                                                        %)
                                                      </span>
                                                    </h5>
                                                    <div className="card card-bordered card-preview">
                                                      <div className="card-inner">
                                                        <div className="progress progress-lg">
                                                          <div
                                                            className="progress-bar"
                                                            data-progress={
                                                              this.state
                                                                .completed_percentage
                                                            }
                                                            style={{
                                                              width: `${this.state.completed_percentage}%`,
                                                            }}
                                                          >
                                                            {
                                                              this.state
                                                                .completed_percentage
                                                            }
                                                            %
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              {this.state.kyc_details &&
                                              this.state.kyc_details.length >
                                                0 ? (
                                                <div
                                                  id="accordion"
                                                  className="accordion"
                                                >
                                                  {this.state.kyc_details.map(
                                                    (kyc, i) => (
                                                      <div
                                                        className="accordion-item"
                                                        key={`kycid${i}`}
                                                      >
                                                        <a
                                                          href="#"
                                                          className={this.handle_accordion_head(
                                                            i,
                                                          )}
                                                          data-toggle="collapse"
                                                          data-target={`#accordion-item-${i}`}
                                                          style={{
                                                            background:
                                                              "rgb(245, 246, 250)",
                                                          }}
                                                        >
                                                          <h6 className="title">
                                                            {
                                                              kyc
                                                                .steps_information
                                                                .step_title
                                                            }
                                                            <br />
                                                            <small>
                                                              {
                                                                kyc
                                                                  .steps_information
                                                                  .step_description
                                                              }
                                                            </small>
                                                          </h6>
                                                          <span className="accordion-icon"></span>
                                                        </a>
                                                        <div
                                                          className={this.handle_accordion_body(
                                                            i,
                                                          )}
                                                          id={`accordion-item-${i}`}
                                                          data-parent="#accordion"
                                                        >
                                                          <div className="accordion-inner">
                                                            {kyc.steps_data &&
                                                            kyc.steps_data
                                                              .length > 0 ? (
                                                              <div className="card">
                                                                <ul className="data-list is-compact">
                                                                  {kyc.steps_data.map(
                                                                    (
                                                                      kyc_steps,
                                                                      i,
                                                                    ) => (
                                                                      <li
                                                                        className="data-item"
                                                                        key={`step${i}`}
                                                                      >
                                                                        <div className="data-col">
                                                                          <div className="data-label">
                                                                            {
                                                                              kyc_steps.field_title
                                                                            }
                                                                          </div>
                                                                          <div className="data-value">
                                                                            {kyc_steps.field_type ===
                                                                            "image" ? (
                                                                              <img
                                                                                src={
                                                                                  kyc_steps.field_value
                                                                                }
                                                                                style={{
                                                                                  width:
                                                                                    "60%",
                                                                                }}
                                                                              />
                                                                            ) : (
                                                                              kyc_steps.field_value
                                                                            )}
                                                                          </div>
                                                                        </div>
                                                                      </li>
                                                                    ),
                                                                  )}
                                                                </ul>
                                                              </div>
                                                            ) : null}
                                                          </div>
                                                        </div>
                                                      </div>
                                                    ),
                                                  )}
                                                </div>
                                              ) : null}
                                            </div>
                                          ) : null}
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className={
                            this.state.activeTab === "notes"
                              ? "tab-pane active"
                              : "tab-pane"
                          }
                          id="tabItemNotes"
                        >
                          <div className="card-inner">
                            <div className="nk-block">
                              <div className="nk-block-head">
                                <div
                                  className="modal-title"
                                  style={{ marginBottom: "2rem" }}
                                >
                                  <h5>
                                    <em className="icon ni ni-file-docs"></em>{" "}
                                    Notes
                                  </h5>
                                </div>
                                {this.state.assignedLoader === true ? (
                                  FormLoader()
                                ) : (
                                  <>
                                    <div className="caption-text">
                                      <div
                                        className="tab-pane active"
                                        id="tabItemSigned"
                                      >
                                        <div className="card card-preview">
                                          <div className="caption-text">
                                            <div className="col-lg-12 mt-4">
                                              <div className="form-group">
                                                <h6>Welcome Content</h6>
                                              </div>
                                              <div className="form-group">
                                                <RichTextEditorComponent
                                                  agreementContent={
                                                    this.state
                                                      .client_services_welcome_content
                                                  }
                                                  onContentChange={
                                                    this.handleEditornNotes
                                                  }
                                                />
                                              </div>
                                            </div>

                                            {this.state.isEditorReady ? (
                                              <>
                                                <div
                                                  className="col-lg-12"
                                                  style={{
                                                    marginTop: "20px",
                                                  }}
                                                >
                                                  <table className="table table-striped">
                                                    <tbody>
                                                      <tr>
                                                        <th scope="row">
                                                          Client Place Holders
                                                        </th>
                                                        <td>
                                                          <ul className="preview-list">
                                                            <li className="preview-item">
                                                              <span className="badge badge-outline-gray">
                                                                [[Company_Name]]
                                                              </span>
                                                            </li>
                                                            <li className="preview-item">
                                                              <span className="badge badge-outline-gray">
                                                                [[Company_Email]]
                                                              </span>
                                                            </li>
                                                          </ul>
                                                        </td>
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                                </div>
                                                <div
                                                  className="form-group text-right col-lg-12"
                                                  style={{
                                                    marginTop: "20px",
                                                  }}
                                                >
                                                  {" "}
                                                  <button
                                                    type="button"
                                                    className="btn btn-primary"
                                                    onClick={() => {
                                                      this.handleClientServicesSubmit();
                                                    }}
                                                    disabled={
                                                      this.state.disabled
                                                    }
                                                  >
                                                    {" "}
                                                    Submit{" "}
                                                  </button>{" "}
                                                </div>
                                              </>
                                            ) : null}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className={
                            this.state.activeTab === "credit_app"
                              ? "tab-pane active"
                              : "tab-pane"
                          }
                          id="tabItemCreditApp"
                        >
                          <div className="card-inner">
                            <div className="nk-block">
                              <div className="nk-block-head">
                                <div className="modal-title mb-4" style={{}}>
                                  <h5>
                                    <em className="icon ni ni-card-view"></em>{" "}
                                    Credit Applications
                                  </h5>
                                </div>
                                {this.state.assignedLoader === true ? (
                                  FormLoader()
                                ) : (
                                  <>
                                    <div className="caption-text">
                                      <div
                                        className="tab-pane active"
                                        id="tabItemSigned"
                                      >
                                        <div className="card card-preview">
                                          {this.state.processing_request ===
                                          true ? (
                                            <div className="example-alert mb-3">
                                              <div className="alert alert-light">
                                                <div
                                                  className="spinner-grow spinner-grow-sm"
                                                  role="status"
                                                >
                                                  <span className="sr-only">
                                                    Loading...
                                                  </span>
                                                </div>{" "}
                                                Please wait while we are
                                                processing your request.
                                              </div>
                                            </div>
                                          ) : null}

                                          {this.state.rejection_container ===
                                          true ? (
                                            <div className="col-md-12 mb-3">
                                              <h5>Rejection Reason</h5>
                                              <div className="">
                                                <div className="form-group mt-1">
                                                  <MutextField
                                                    required
                                                    id="rejection_reason"
                                                    name="rejection_reason"
                                                    type="text"
                                                    label="Reason"
                                                    defaultValue={
                                                      this.state
                                                        .rejection_reason
                                                    }
                                                    onChange={this.handleChange}
                                                    variant="outlined"
                                                    fullWidth
                                                  autoComplete="new-password"
                                                  />
                                                </div>
                                                <div
                                                  className="form-group text-right"
                                                  style={{
                                                    marginTop: "15px",
                                                    marginBottom: "15px",
                                                  }}
                                                >
                                                  <button
                                                    type="button"
                                                    style={{ marginRight: 5 }}
                                                    className="btn btn-light"
                                                    onClick={() => {
                                                      this.setState({
                                                        rejection_container: false,
                                                      });
                                                    }}
                                                  >
                                                    Cancel
                                                  </button>
                                                  <button
                                                    type="button"
                                                    className="btn btn-primary"
                                                    onClick={() => {
                                                      this.rejectCreditApplication();
                                                    }}
                                                    disabled={
                                                      this.state.disabled
                                                    }
                                                  >
                                                    Submit
                                                  </button>
                                                </div>
                                              </div>
                                            </div>
                                          ) : null}

                                          <div
                                            className="card card-bordered"
                                            id="creditApplicationTable"
                                          >
                                            {this.state.credit_applications &&
                                            this.state.credit_applications
                                              .length > 0 ? (
                                              <table className="table table-striped table-bordered">
                                                <thead>
                                                  <tr>
                                                    <th scope="col">ID</th>
                                                    <th scope="col">
                                                      Created Date
                                                    </th>
                                                    <th scope="col">
                                                      Approved date
                                                    </th>
                                                    <th scope="col">
                                                      Rejected Date
                                                    </th>
                                                    <th scope="col">Status</th>
                                                    <th scope="col">Actions</th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  {this.state.credit_applications.map(
                                                    (applications, index) => (
                                                      <tr key={`cr${index}`}>
                                                        <th scope="row">
                                                          {applications[0]}
                                                        </th>
                                                        <td>
                                                          {this.format_date(
                                                            applications[1],
                                                          )}
                                                        </td>
                                                        <td>
                                                          {applications[2] &&
                                                          applications[2] !== ""
                                                            ? this.format_date(
                                                                applications[2],
                                                              )
                                                            : "---"}
                                                        </td>
                                                        <td>
                                                          {applications[3] &&
                                                          applications[3] !== ""
                                                            ? this.format_date(
                                                                applications[3],
                                                              )
                                                            : "---"}
                                                        </td>
                                                        <td>
                                                          {applications[4] ===
                                                          "pending" ? (
                                                            <span className="badge badge-dot badge-warning">
                                                              Pending
                                                            </span>
                                                          ) : applications[4] ===
                                                            "approved" ? (
                                                            <span className="badge badge-dot badge-success">
                                                              Approved
                                                            </span>
                                                          ) : applications[4] ===
                                                            "rejected" ? (
                                                            <span className="badge badge-dot badge-danger">
                                                              Rejected
                                                            </span>
                                                          ) : null}
                                                        </td>
                                                        <td>
                                                          <div className="dropdown">
                                                            <a
                                                              className="text-soft dropdown-toggle btn btn-icon btn-trigger"
                                                              data-toggle="dropdown"
                                                            >
                                                              <em className="icon ni ni-more-h"></em>
                                                            </a>
                                                            <div className="dropdown-menu dropdown-menu-right dropdown-menu-xs">
                                                              <ul className="link-list-plain">
                                                                <li>
                                                                  <a
                                                                    style={{
                                                                      cursor:
                                                                        "pointer",
                                                                    }}
                                                                    onClick={() =>
                                                                      this.downloadCreditAppPdf(
                                                                        applications[6],
                                                                      )
                                                                    }
                                                                  >
                                                                    View PDF
                                                                  </a>
                                                                </li>
                                                                {applications[4] ===
                                                                "pending" ? (
                                                                  <li>
                                                                    <a
                                                                      style={{
                                                                        cursor:
                                                                          "pointer",
                                                                      }}
                                                                      onClick={() => {
                                                                        this.setState(
                                                                          {
                                                                            application_no:
                                                                              applications[0],
                                                                            rejection_container: true,
                                                                          },
                                                                        );
                                                                      }}
                                                                    >
                                                                      Reject
                                                                    </a>
                                                                  </li>
                                                                ) : null}
                                                                {applications[4] ===
                                                                "pending" ? (
                                                                  <li>
                                                                    <a
                                                                      style={{
                                                                        cursor:
                                                                          "pointer",
                                                                      }}
                                                                      onClick={() =>
                                                                        this.approveCreditApplication(
                                                                          applications[0],
                                                                        )
                                                                      }
                                                                    >
                                                                      Approve
                                                                    </a>
                                                                  </li>
                                                                ) : null}
                                                              </ul>
                                                            </div>
                                                          </div>
                                                        </td>
                                                      </tr>
                                                    ),
                                                  )}
                                                </tbody>
                                              </table>
                                            ) : (
                                              <div className="alert alert-pro alert-danger">
                                                <div className="alert-text">
                                                  <h6>No Credit Application</h6>
                                                  <p>
                                                    Credit applications are not
                                                    available for this client at
                                                    the moment.{" "}
                                                  </p>
                                                </div>
                                              </div>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        {/***** Archived Agreements *****/}
                        <div
                          className={
                            this.state.activeTab === "archived_agreements"
                              ? "tab-pane active"
                              : "tab-pane"
                          }
                          id="tabItemArchivedAgreements"
                        >
                          <div className="card-inner">
                            <div className="nk-block">
                              <div className="nk-block-head">
                                <div className="modal-title mb-4" style={{}}>
                                  <h5>
                                    <em className="icon ni ni-archived"></em>{" "}
                                    Archived Agreements
                                  </h5>
                                </div>
                                {this.state.assignedLoader === true ? (
                                  FormLoader()
                                ) : (
                                  <>
                                    <div className="caption-text">
                                      <div
                                        className="tab-pane active"
                                        id="tabItemSigned"
                                      >
                                        <div className="card card-bordered card-preview">
                                          <DataTableExtended
                                            columns={this.state.columnServices}
                                            tableData={
                                              this.state.archivedAgreements
                                            }
                                            title=""
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        {/***** Archived AGreements *****/}
                        {/***** Archived Forms *****/}
                        <div
                          className={
                            this.state.activeTab === "archived_forms"
                              ? "tab-pane active"
                              : "tab-pane"
                          }
                          id="tabItemArchivedForms"
                        >
                          <div className="card-inner">
                            <div className="nk-block">
                              <div className="nk-block-head">
                                <div className="modal-title mb-4" style={{}}>
                                  <h5>
                                    <em className="icon ni ni-card-view"></em>{" "}
                                    Archived Form Submissions
                                  </h5>
                                </div>
                                {this.state.assignedLoader === true ? (
                                  FormLoader()
                                ) : (
                                  <>
                                    <div className="caption-text">
                                      <div
                                        className="tab-pane active"
                                        id="tabItemSigned"
                                      >
                                        <div className="card card-bordered card-preview">
                                          <DataTableExtended
                                            columns={
                                              this.state.columnArchivedForms
                                            }
                                            tableData={this.state.archivedForms}
                                            title=""
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        {/***** Archived Forms *****/}
                        {/***** Onboarding Settings *****/}
                        {/* SBC SETTINGS TAB PANE */}
                        {this.state.sipnavEnabled && this.state.sipnavHasAccount && (
                          <div
                            className={
                              this.state.activeTab === "sbc_settings"
                                ? "tab-pane active"
                                : "tab-pane"
                            }
                            id="tabItemSBCSettings"
                          >
                            <div className="card-inner">
                              <div className="nk-block">

                                {this.state.sipnavAccountLoading ? (
                                  FormLoader()
                                ) : (
                                <>

                                {/* Error state */}

                                {/* Account content */}
                                {this.state.sipnavAccount && (
                                  <>
                                    {/* MY ACCOUNT INFORMATION */}
                                    <div className="card card-bordered mb-3">
                                      <div className="card-inner">
                                        <p className="overline-title text-base pb-2 border-bottom" style={{ fontSize: "11px", fontWeight: 700, letterSpacing: "0.1em", color: "#8094ae", marginBottom: "12px" }}>
                                          MY ACCOUNT INFORMATION
                                        </p>
                                        <div className="row g-3">
                                          <div className="col-6 col-md-4">
                                            <span className="sub-text">Customer ID</span>
                                            <span className="lead-text">{this.state.sipnavAccount.account_id || "—"}</span>
                                          </div>
                                          <div className="col-6 col-md-4">
                                            <span className="sub-text">Account Name</span>
                                            <span className="lead-text">{this.state.sipnavAccount.account_name || "—"}</span>
                                          </div>
                                          <div className="col-6 col-md-4">
                                            <span className="sub-text">Group</span>
                                            <span className="lead-text">{this.state.sipnavAccount.group_name || "—"}</span>
                                          </div>
                                          <div className="col-6 col-md-4">
                                            <span className="sub-text">Contact</span>
                                            <span className="lead-text">{this.state.sipnavAccount.contact || "—"}</span>
                                          </div>
                                          <div className="col-6 col-md-4">
                                            <span className="sub-text">Email</span>
                                            <span className="lead-text">{this.state.sipnavAccount.email || "—"}</span>
                                          </div>
                                          <div className="col-6 col-md-4">
                                            <span className="sub-text">Date Added</span>
                                            <span className="lead-text">
                                              {this.state.sipnavAccount.date_added ? dateFormat(this.state.sipnavAccount.date_added, "mmm dd, yyyy") : "—"}
                                            </span>
                                          </div>
                                          {this.state.sipnavAccount.address && (
                                            <div className="col-12 col-md-8">
                                              <span className="sub-text">Address</span>
                                              <span className="lead-text">
                                                {[
                                                  this.state.sipnavAccount.address.address,
                                                  this.state.sipnavAccount.address.city,
                                                  this.state.sipnavAccount.address.state,
                                                  this.state.sipnavAccount.address.zip,
                                                  this.state.sipnavAccount.address.country,
                                                ].filter(Boolean).join(", ") || "—"}
                                              </span>
                                            </div>
                                          )}
                                          {this.state.sipnavAccount.phone_book && this.state.sipnavAccount.phone_book.business && (
                                            <div className="col-6 col-md-4">
                                              <span className="sub-text">Phone (Business)</span>
                                              <span className="lead-text">{this.state.sipnavAccount.phone_book.business || "—"}</span>
                                            </div>
                                          )}
                                          {this.state.sipnavAccount.phone_book && this.state.sipnavAccount.phone_book.mobile && (
                                            <div className="col-6 col-md-4">
                                              <span className="sub-text">Phone (Mobile)</span>
                                              <span className="lead-text">{this.state.sipnavAccount.phone_book.mobile || "—"}</span>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>

                                    {/* ACCOUNT STATUS */}
                                    <div className="card card-bordered mb-3">
                                      <div className="card-inner">
                                        <p className="overline-title text-base pb-2 border-bottom" style={{ fontSize: "11px", fontWeight: 700, letterSpacing: "0.1em", color: "#8094ae", marginBottom: "12px" }}>
                                          ACCOUNT STATUS
                                        </p>
                                        <span style={{ color: this.state.sipnavAccount.status === "Enabled" ? "#1ee0ac" : "#e85347", fontWeight: 600, fontSize: "14px" }}>
                                          {this.state.sipnavAccount.status || "—"}
                                        </span>
                                      </div>
                                    </div>

                                    {/* SETTINGS */}
                                    <div className="card card-bordered mb-3">
                                      <div className="card-inner">
                                        <p className="overline-title text-base pb-2 border-bottom" style={{ fontSize: "11px", fontWeight: 700, letterSpacing: "0.1em", color: "#8094ae", marginBottom: "12px" }}>
                                          SETTINGS
                                        </p>
                                        <div className="row g-3">
                                          <div className="col-6 col-md-4">
                                            <span className="sub-text">CPS Limit</span>
                                            <span className="lead-text">{this.state.sipnavAccount.limit_cps != null ? this.state.sipnavAccount.limit_cps : "—"}</span>
                                          </div>
                                          <div className="col-6 col-md-4">
                                            <span className="sub-text">Ports (Sessions)</span>
                                            <span className="lead-text">{this.state.sipnavAccount.limit_sessions != null ? this.state.sipnavAccount.limit_sessions : "—"}</span>
                                          </div>
                                          <div className="col-6 col-md-4">
                                            <span className="sub-text">Initial Billing Increment</span>
                                            <span className="lead-text">{this.state.sipnavAccount.duration_min != null ? this.state.sipnavAccount.duration_min : "—"}</span>
                                          </div>
                                          <div className="col-6 col-md-4">
                                            <span className="sub-text">Subsequent Billing Increment</span>
                                            <span className="lead-text">{this.state.sipnavAccount.duration_inc != null ? this.state.sipnavAccount.duration_inc : "—"}</span>
                                          </div>
                                          <div className="col-6 col-md-4">
                                            <span className="sub-text">Billing Type</span>
                                            <span className="lead-text">{this.state.sipnavAccount.lrn_billing === 1 ? "LRN" : "Standard"}</span>
                                          </div>
                                          <div className="col-6 col-md-4">
                                            <span className="sub-text">Rounding Digits</span>
                                            <span className="lead-text">{this.state.sipnavAccount.round_precision != null ? this.state.sipnavAccount.round_precision : "—"}</span>
                                          </div>
                                          <div className="col-6 col-md-4">
                                            <span className="sub-text">Rounding Method</span>
                                            <span className="lead-text">
                                              {this.state.sipnavAccount.round_type === 1 ? "Up"
                                                : this.state.sipnavAccount.round_type === 2 ? "Down"
                                                : this.state.sipnavAccount.round_type === 3 ? "Half Up"
                                                : this.state.sipnavAccount.round_type != null ? this.state.sipnavAccount.round_type : "—"}
                                            </span>
                                          </div>
                                          <div className="col-6 col-md-4">
                                            <span className="sub-text">Price Cap (Max Rate)</span>
                                            <span className="lead-text">{this.state.sipnavAccount.max_rate != null ? this.state.sipnavAccount.max_rate : "—"}</span>
                                          </div>
                                          <div className="col-6 col-md-4">
                                            <span className="sub-text">PP Type</span>
                                            <span className="lead-text">{this.state.sipnavAccount.pp_type != null ? this.state.sipnavAccount.pp_type : "—"}</span>
                                          </div>
                                          <div className="col-6 col-md-4">
                                            <span className="sub-text">PP Value</span>
                                            <span className="lead-text">{this.state.sipnavAccount.pp_value != null ? this.state.sipnavAccount.pp_value : "—"}</span>
                                          </div>
                                          <div className="col-6 col-md-4">
                                            <span className="sub-text">Routing Mode</span>
                                            <span className="lead-text">{this.state.sipnavAccount.routing_mode != null ? this.state.sipnavAccount.routing_mode : "—"}</span>
                                          </div>
                                          <div className="col-6 col-md-4">
                                            <span className="sub-text">Always Failover</span>
                                            <span className="lead-text">{this.state.sipnavAccount.always_failover === 1 ? "Yes" : "No"}</span>
                                          </div>
                                          <div className="col-6 col-md-4">
                                            <span className="sub-text">Failure Codes</span>
                                            <span className="lead-text">{this.state.sipnavAccount.failure_codes || "—"}</span>
                                          </div>
                                          <div className="col-6 col-md-4">
                                            <span className="sub-text">Call Timeout (s)</span>
                                            <span className="lead-text">{this.state.sipnavAccount.call_timeout != null ? this.state.sipnavAccount.call_timeout : "—"}</span>
                                          </div>
                                          <div className="col-6 col-md-4">
                                            <span className="sub-text">Progress Timeout (s)</span>
                                            <span className="lead-text">{this.state.sipnavAccount.progress_timeout != null ? this.state.sipnavAccount.progress_timeout : "—"}</span>
                                          </div>
                                          <div className="col-6 col-md-4">
                                            <span className="sub-text">Max Route Depth</span>
                                            <span className="lead-text">{this.state.sipnavAccount.max_route_depth != null ? this.state.sipnavAccount.max_route_depth : "—"}</span>
                                          </div>
                                          <div className="col-6 col-md-4">
                                            <span className="sub-text">International</span>
                                            <span className="lead-text">{this.state.sipnavAccount.international ? "Yes" : "No"}</span>
                                          </div>
                                          <div className="col-6 col-md-4">
                                            <span className="sub-text">RTP Blocking</span>
                                            <span className="lead-text">{this.state.sipnavAccount.rtp_blocking === 1 ? "Yes" : "No"}</span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    {/* STIR/SHAKEN */}
                                    <div className="card card-bordered mb-3">
                                      <div className="card-inner">
                                        <p className="overline-title text-base pb-2 border-bottom" style={{ fontSize: "11px", fontWeight: 700, letterSpacing: "0.1em", color: "#8094ae", marginBottom: "12px" }}>
                                          STIR/SHAKEN
                                        </p>
                                        <div className="row g-3">
                                          <div className="col-6 col-md-4">
                                            <span className="sub-text">Default Attestation</span>
                                            <span className="lead-text">
                                              {this.state.sipnavAccount.stir_shaken_def_attest === 1 ? "A"
                                                : this.state.sipnavAccount.stir_shaken_def_attest === 2 ? "B"
                                                : this.state.sipnavAccount.stir_shaken_def_attest === 3 ? "C"
                                                : this.state.sipnavAccount.stir_shaken_def_attest != null ? this.state.sipnavAccount.stir_shaken_def_attest : "—"}
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    {/* RATE DECKS */}
                                    <div className="card card-bordered mb-3">
                                      <div className="card-inner">
                                        <p className="overline-title text-base pb-2 border-bottom" style={{ fontSize: "11px", fontWeight: 700, letterSpacing: "0.1em", color: "#8094ae", marginBottom: "12px" }}>
                                          RATE DECKS
                                        </p>
                                        {this.state.sipnavRateDecks.length === 0 ? (
                                          <p className="text-muted">No rate decks found for this account.</p>
                                        ) : (
                                          <div className="accordion" id="sbcRateDecksAccordion">
                                            {this.state.sipnavRateDecks.map((rd, idx) => (
                                              <div className="card" key={rd.rd_id || idx}>
                                                <div
                                                  style={{ cursor: "pointer", background: "#f5f6fa", padding: "10px 16px", display: "flex", justifyContent: "space-between", alignItems: "center" }}
                                                  onClick={() => this.setState({ sipnavRateDeckOpenIndex: this.state.sipnavRateDeckOpenIndex === idx ? null : idx })}
                                                >
                                                  <span style={{ fontWeight: 600, fontSize: "13px", color: "#364a63", wordBreak: "break-all" }}>
                                                    <em className="icon ni ni-file-text" style={{ marginRight: "8px" }}></em>
                                                    {rd.filename || ("Rate Deck #" + rd.rd_id)}
                                                  </span>
                                                  <em className={"icon ni " + (this.state.sipnavRateDeckOpenIndex === idx ? "ni-chevron-up" : "ni-chevron-down")} style={{ flexShrink: 0 }}></em>
                                                </div>
                                                {this.state.sipnavRateDeckOpenIndex === idx && (
                                                  <div className="card-inner" style={{ paddingTop: "12px" }}>
                                                    <div className="row g-3">
                                                      <div className="col-6 col-md-4">
                                                        <span className="sub-text">RD ID</span>
                                                        <span className="lead-text">{rd.rd_id != null ? rd.rd_id : "—"}</span>
                                                      </div>
                                                      <div className="col-6 col-md-4">
                                                        <span className="sub-text">Enabled</span>
                                                        <span className="">
                                                          {rd.enabled === 1 ? <span className="badge badge-outline-success">Yes</span> : <span className="badge badge-outline-danger">No</span>}
                                                        </span>
                                                      </div>
                                                      <div className="col-6 col-md-4">
                                                        <span className="sub-text">International</span>
                                                        <span className="lead-text">{rd.international === 1 ? "Yes" : "No"}</span>
                                                      </div>
                                                      <div className="col-6 col-md-4">
                                                        <span className="sub-text">Date Created</span>
                                                        <span className="lead-text">{rd.date_created ? dateFormat(rd.date_created, "mmm dd, yyyy") : "—"}</span>
                                                      </div>
                                                      <div className="col-6 col-md-4">
                                                        <span className="sub-text">Carrier Effective Day</span>
                                                        <span className="lead-text">{rd.carrier_effective_day ? dateFormat(rd.carrier_effective_day, "mmm dd, yyyy") : "—"}</span>
                                                      </div>
                                                      <div className="col-6 col-md-4">
                                                        <span className="sub-text">Toll Free</span>
                                                        <span className="lead-text">{(rd.in_toll_free === "1" || rd.in_toll_free === 1) ? ("Yes (" + rd.toll_free_price + ")") : "No"}</span>
                                                      </div>
                                                      <div className="col-6 col-md-4">
                                                        <span className="sub-text">Areas</span>
                                                        <span className="lead-text">{rd.areas || "—"}</span>
                                                      </div>
                                                      <div className="col-6 col-md-4">
                                                        <span className="sub-text">RD Type</span>
                                                        <span className="lead-text">{rd.rd_type != null ? rd.rd_type : "—"}</span>
                                                      </div>
                                                      <div className="col-6 col-md-4">
                                                        <span className="sub-text">Price Priority</span>
                                                        <span className="lead-text">{rd.price_priority != null ? rd.price_priority : "—"}</span>
                                                      </div>
                                                      <div className="col-6 col-md-4">
                                                        <span className="sub-text">Min Margin</span>
                                                        <span className="lead-text">{rd.min_margin != null ? rd.min_margin : "—"}</span>
                                                      </div>
                                                      <div className="col-6 col-md-4">
                                                        <span className="sub-text">Max Margin</span>
                                                        <span className="lead-text">{rd.max_margin != null ? rd.max_margin : "—"}</span>
                                                      </div>
                                                      <div className="col-6 col-md-4">
                                                        <span className="sub-text">Rounding Precision</span>
                                                        <span className="lead-text">{rd.rounding_persicion != null ? rd.rounding_persicion : "—"}</span>
                                                      </div>
                                                      <div className="col-6 col-md-4">
                                                        <span className="sub-text">Rounding Type</span>
                                                        <span className="lead-text">{rd.rounding_type != null ? rd.rounding_type : "—"}</span>
                                                      </div>
                                                      <div className="col-6 col-md-4">
                                                        <span className="sub-text">Use Carrier Restrictions</span>
                                                        <span className="lead-text">{rd.use_carrier_restrictions === 1 ? "Yes" : "No"}</span>
                                                      </div>
                                                      {rd.rd_type === 3 && (
                                                        <>
                                                          <div className="col-6 col-md-4">
                                                            <span className="sub-text">Flat Rate Price</span>
                                                            <span className="lead-text">{rd.flatrate_price != null ? rd.flatrate_price : "—"}</span>
                                                          </div>
                                                          <div className="col-6 col-md-4">
                                                            <span className="sub-text">Flat Rate Column</span>
                                                            <span className="lead-text">{rd.flatrate_columm || "—"}</span>
                                                          </div>
                                                          <div className="col-6 col-md-4">
                                                            <span className="sub-text">Flat Rate Digit</span>
                                                            <span className="lead-text">{rd.flatrate_digit || "—"}</span>
                                                          </div>
                                                        </>
                                                      )}
                                                    </div>
                                                  </div>
                                                )}
                                              </div>
                                            ))}
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </>
                                )}
                                </>
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                        <div
                          className={
                            this.state.activeTab === "onboarding_settings"
                              ? "tab-pane active"
                              : "tab-pane"
                          }
                          id="tabItemOnboarding"
                        >
                          {this.state.adminTemplateMissing ? (
                            <div className="example-alert m-4">
                              <div className="alert alert-pro alert-warning">
                                <div className="alert-text">
                                  <h6>Admin Template Missing</h6>
                                  <p>
                                    Admin onboarding template does not exist.
                                    Please update it.
                                  </p>
                                  <button
                                    type="button"
                                    className="btn btn-warning mt-2"
                                    onClick={() =>
                                      this.props.history.push(
                                        "/upgrades/onboarding_settings",
                                      )
                                    }
                                  >
                                    Go to Onboarding Settings
                                  </button>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <>
                              <div className="col-md-12 mb-4">
                                <div className="form-group">
                                  <div className="form-control-group">
                                    <MutextField
                                      id="onboarding_title"
                                      name="onboarding_title"
                                      type="text"
                                      label="Onboarding Title"
                                      value={this.state.onboardingTitle}
                                      onChange={(e) =>
                                        this.setState({
                                          onboardingTitle: e.target.value,
                                        })
                                      }
                                      variant="outlined"
                                      fullWidth
                                    autoComplete="new-password"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-12">
                                <div className="form-group">
                                  <div className="form-control-group">
                                    <MutextField
                                      id="onboarding_message"
                                      name="onboarding_message"
                                      type="text"
                                      label="Onboarding Message"
                                      value={this.state.onboardingMessage}
                                      onChange={(e) =>
                                        this.setState({
                                          onboardingMessage: e.target.value,
                                        })
                                      }
                                      variant="outlined"
                                      fullWidth
                                      multiline
                                      rows={3}
                                    autoComplete="new-password"
                                    />
                                  </div>
                                </div>
                              </div>
                              {this.state.assignedLoader === true ? (
                                FormLoader()
                              ) : (
                                <div
                                  id="dragHandleLeft"
                                  className="dragula-container card card-bordered p-4 h-100 mt-3"
                                >
                                  <h5 className="nk-block-title mb-4">
                                    {" "}
                                    <em className="icon ni ni-setting"></em>{" "}
                                    Onboarding Steps
                                  </h5>

                                  <DragDropContext onDragEnd={this.handleOnboardingDragEnd}>
                                    <Droppable droppableId="onboarding-steps-droppable">
                                      {(droppableProvided) => (
                                        <div
                                          ref={droppableProvided.innerRef}
                                          {...droppableProvided.droppableProps}
                                        >
                                          {this.state.onboardingItems.map((item, index) => (
                                            <Draggable
                                              key={item.id}
                                              draggableId={String(item.id)}
                                              index={index}
                                              isDragDisabled={item.isLocked}
                                            >
                                              {(dragProvided, dragSnapshot) => (
                                                <div
                                                  ref={dragProvided.innerRef}
                                                  {...dragProvided.draggableProps}
                                                  className="p-3 bg-white border border-light round-lg"
                                                  style={{
                                                    opacity: item.isLocked ? 0.8 : 1,
                                                    marginBottom: "10px",
                                                    cursor: item.isLocked ? "not-allowed" : "default",
                                                    borderColor: this.state.onboardingItemsWithErrors.includes(
                                                      item.id,
                                                    )
                                                      ? "#dc3545"
                                                      : dragSnapshot.isDragging
                                                        ? "#007bff"
                                                        : "#e3e6f0",
                                                    borderWidth:
                                                      this.state.onboardingItemsWithErrors.includes(item.id) ||
                                                      dragSnapshot.isDragging
                                                        ? "2px"
                                                        : "1px",
                                                    transition: "all 0.2s ease",
                                                    backgroundColor: dragSnapshot.isDragging
                                                      ? "#e3f2fd"
                                                      : "#fff",
                                                    boxShadow: dragSnapshot.isDragging
                                                      ? "0 4px 12px rgba(0, 123, 255, 0.2)"
                                                      : "0 1px 3px rgba(0, 0, 0, 0.05)",
                                                    ...dragProvided.draggableProps.style,
                                                  }}
                                                >
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      alignItems: "center",
                                                      gap: 12,
                                                      width: "100%",
                                                    }}
                                                  >
                                                    {item.isLocked ? (
                                                      <span
                                                        style={{
                                                          display: "inline-flex",
                                                          alignItems: "center",
                                                          justifyContent: "center",
                                                          padding: "6px 10px",
                                                          flexShrink: 0,
                                                        }}
                                                      >
                                                        <em className="far fa-heart"></em>
                                                      </span>
                                                    ) : (
                                                      <span
                                                        className="dragHandle"
                                                        {...dragProvided.dragHandleProps}
                                                        style={{
                                                          cursor: "grab",
                                                          display: "inline-flex",
                                                          alignItems: "center",
                                                          justifyContent: "center",
                                                          padding: "6px 10px",
                                                          borderRadius: "4px",
                                                          userSelect: "none",
                                                          fontSize: "16px",
                                                          flexShrink: 0,
                                                        }}
                                                      >
                                                        <em
                                                          className="icon ni ni-move"
                                                          style={{ color: "#666" }}
                                                        ></em>
                                                      </span>
                                                    )}

                                                    <div
                                                      style={{
                                                        flex: 1,
                                                        minWidth: 0,
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        gap: 8,
                                                      }}
                                                    >
                                                      <div
                                                        style={{
                                                          border: this.state.onboardingItemsWithErrors.includes(
                                                            item.id,
                                                          )
                                                            ? "2px solid #dc3545"
                                                            : item.isLocked
                                                              ? (index === 0 && item.isFilled) ||
                                                                (index === 1 && this.isAgreementStepFilled())
                                                                ? "2px solid #0fca7a"
                                                                : "1px solid #d0d0d0"
                                                              : item.isFilled
                                                                ? "2px solid #0fca7a"
                                                                : "1px solid #d0d0d0",
                                                          borderRadius: "4px",
                                                          padding: "14px 12px",
                                                          minHeight: "56px",
                                                          display: "flex",
                                                          alignItems: "center",
                                                          color: "#526484",
                                                          backgroundColor: "#fff",
                                                          fontSize: "14px",
                                                        }}
                                                      >
                                                        {item.title}
                                                      </div>
                                                    </div>

                                                    {!item.isLocked && (
                                                      <div
                                                        style={{
                                                          display: "flex",
                                                          alignItems: "center",
                                                          gap: 8,
                                                          flexShrink: 0,
                                                        }}
                                                      >
                                                        <Tooltip
                                                          title={
                                                            item.isFilled
                                                              ? "This step is completed and cannot be edited"
                                                              : "Edit Onboarding Item"
                                                          }
                                                          placement="top"
                                                        >
                                                          <a
                                                            onClick={() => {
                                                              if (!item.isFilled) {
                                                                this.editOnboarding(item.id);
                                                              }
                                                            }}
                                                            style={{
                                                              cursor: item.isFilled ? "not-allowed" : "pointer",
                                                              display: "inline-flex",
                                                              alignItems: "center",
                                                              justifyContent: "center",
                                                              opacity: item.isFilled ? 0.5 : 1,
                                                            }}
                                                          >
                                                            <em
                                                              className="icon ni ni-edit text-primary"
                                                              style={{ fontSize: 20 }}
                                                            />
                                                          </a>
                                                        </Tooltip>
                                                        <Tooltip
                                                          title="Delete Onboarding Item"
                                                          placement="top"
                                                        >
                                                          <a
                                                            onClick={() => this.deleteOnboarding(item.id)}
                                                            style={{
                                                              cursor: "pointer",
                                                              display: "inline-flex",
                                                              alignItems: "center",
                                                              justifyContent: "center",
                                                              borderLeft: "1px solid rgb(0 0 0 / 87%)",
                                                              paddingLeft: 8,
                                                            }}
                                                          >
                                                            <em
                                                              className="icon ni ni-trash text-danger"
                                                              style={{ fontSize: 20 }}
                                                            />
                                                          </a>
                                                        </Tooltip>
                                                      </div>
                                                    )}
                                                  </div>
                                                  {!item.isLocked && (
                                                    <label
                                                      style={{
                                                        fontSize: 14,
                                                        paddingTop: 8,
                                                        paddingLeft: "45px",
                                                      }}
                                                    >
                                                      {item.type === "agreement" ? (
                                                        <>
                                                          Attached Agreement: {item.agreement_title || "—"}{" "}
                                                          <span
                                                            className="badge badge-dim badge-outline-info"
                                                            style={{
                                                              fontSize: 11,
                                                              fontWeight: 500,
                                                              verticalAlign: "middle",
                                                            }}
                                                          >
                                                            Client Agreement
                                                          </span>
                                                        </>
                                                      ) : (
                                                        <>
                                                          Attached Form:{" "}
                                                          {this.state.formsList.find(
                                                            (f) => f.form_accountno === item.form,
                                                          )?.form_title || "—"}
                                                        </>
                                                      )}
                                                    </label>
                                                  )}
                                                </div>
                                              )}
                                            </Draggable>
                                          ))}
                                          {droppableProvided.placeholder}
                                        </div>
                                      )}
                                    </Droppable>
                                  </DragDropContext>

                                  <button
                                    type="button"
                                    style={{
                                      cursor: "pointer",
                                      color: "#fff",
                                      marginTop: "15px",
                                      paddingTop: "10px",
                                      width: "170px",
                                    }}
                                    onClick={this.addNewOnboardingStep}
                                    className="btn btn-primary"
                                  >
                                    <em className="icon ni ni-plus-round"></em>
                                    &nbsp; Add New Step
                                  </button>
                                </div>
                              )}
                              {/*
                              {this.state.onboarding_save_loading === false ? (
                                <button
                                  type="button"
                                  className="btn btn-lg btn-primary mt-3 float-right"
                                  style={{ marginRight: "15px" }}
                                  onClick={this.saveOnboardingSettings}
                                >
                                  <em className="icon ni ni-save"></em> Save
                                  Settings
                                </button>
                              ) : (
                                <button
                                  className="btn btn-lg btn-primary mt-3 float-right"
                                  style={{ marginRight: "15px" }}
                                  disabled
                                >
                                  <em className="icon ni ni-save"></em> Save
                                  Settings
                                  <div
                                    className="spinner-grow spinner-grow-sm"
                                    role="status"
                                  >
                                    <span className="sr-only">Loading...</span>
                                  </div>
                                </button>
                              )}
                              */}
                            </>
                          )}
                        </div>
                        {/***** Onboarding Settings *****/}
                      </div>
                    </div>

                    {/* Edit Onboarding Modal */}
                    <div
                      className="modal fade"
                      tabIndex="-1"
                      id="modalEditOnboarding"
                    >
                      <div
                        className="modal-dialog modal-xl modal-dialog-top"
                        role="document"
                      >
                        <div className="modal-content">
                          <a
                            href="#"
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <em className="icon ni ni-cross"></em>
                          </a>
                          <div className="modal-header">
                            <h5 className="modal-title">
                              <em className="icon ni ni-edit text-primary" />{" "}
                              <span>Update Onboarding Item</span>
                            </h5>
                          </div>
                          <div className="modal-body">
                            <div id="OnboardingEditDiv">
                              <div
                                className="col-12"
                                style={{
                                  paddingLeft: "0px",
                                  paddingRight: "0px",
                                }}
                              >

                                <div className="form-group" style={{ marginBottom: "18px" }}>
                                  <MutextField
                                    id="edit-onboarding-title"
                                    name="edit-onboarding-title"
                                    label="Onboarding Item Title"
                                    value={this.state.editOnboardingTitle}
                                    onChange={(e) =>
                                      this.setState({
                                        editOnboardingTitle: e.target.value,
                                      })
                                    }
                                    variant="outlined"
                                    fullWidth
                                    placeholder="Enter onboarding item title"
                                  autoComplete="new-password"
                                  />
                                </div>

                                <div className="row g-4">
                                  {/* Type Tabs: Form / Agreement */}
                                  <div className="col-lg-12">
                                    <div style={{ display: "flex", gap: 8, marginBottom: 8, background: "#f5f5f0", borderRadius: 8, padding: "6px 8px" }}>
                                      {["form", "agreement"].map((tab) => (
                                        <button
                                          key={tab}
                                          type="button"
                                          onClick={() => this.setState({ editOnboardingType: tab, editOnboardingForm: "", editOnboardingAgreement: "", editOnboardingAgreementTitle: "", editOnboardingAgreementInstruction: "" })}
                                          style={{ flex: 1, padding: "7px 0", border: "none", borderRadius: 5, fontSize: 13, fontWeight: 500, cursor: "pointer", background: this.state.editOnboardingType === tab ? "#1d4f8a" : "transparent", color: this.state.editOnboardingType === tab ? "#fff" : "#7a7a6e", transition: "all 0.2s" }}
                                        >
                                          {tab === "form" ? "Form" : "Agreement"}
                                        </button>
                                      ))}
                                    </div>
                                  </div>

                                  {/* Form dropdown */}
                                  {this.state.editOnboardingType === "form" && (
                                    <div className="col-lg-12">
                                      <div className="form-group">
                                        <Autocomplete
                                          options={this.getAvailableFormsForStep(this.state.editOnboardingId).map((form) => ({ id: form.form_accountno, label: form.form_title, form: form }))}
                                          getOptionLabel={(option) => option.label}
                                          value={
                                            this.state.editOnboardingForm
                                              ? this.state.formsList.find((f) => f.form_accountno === this.state.editOnboardingForm)
                                                ? { id: this.state.editOnboardingForm, label: this.state.formsList.find((f) => f.form_accountno === this.state.editOnboardingForm)?.form_title, form: this.state.formsList.find((f) => f.form_accountno === this.state.editOnboardingForm) }
                                                : null
                                              : null
                                          }
                                          onChange={(e, newValue) => {
                                            if (newValue && newValue.id) {
                                              const selectedForm = this.state.formsList.find((form) => form.form_accountno === newValue.id);
                                              this.setState({ editOnboardingForm: newValue.id, editOnboardingAllowMultiple: selectedForm?.allow_multiple !== undefined ? selectedForm.allow_multiple : 0 });
                                            } else {
                                              this.setState({ editOnboardingForm: "", editOnboardingAllowMultiple: 0 });
                                            }
                                          }}
                                          disabled={this.state.formsLoading}
                                          clearOnBlur={false}
                                          clearOnEscape={false}
                                          noOptionsText="No Forms"
                                          renderInput={(params) => (
                                            <MutextField {...params} label="Form" variant="outlined" fullWidth autoComplete="new-password" />
                                          )}
                                        />
                                      </div>
                                    </div>
                                  )}

                                  {/* Agreement dropdown */}
                                  {this.state.editOnboardingType === "agreement" && (
                                    <div className="col-lg-12">
                                      <div className="form-group">
                                        <MutextField
                                          select
                                          label="Select Client Agreement"
                                          value={this.state.editOnboardingAgreement}
                                          onChange={(e) => {
                                            const selected = this.state.clientAgreementsList.find((a) => a.agreement_accountno === e.target.value);
                                            this.setState({ editOnboardingAgreement: e.target.value, editOnboardingAgreementTitle: selected?.agreement_title || "", editOnboardingAgreementInstruction: selected?.agreement_instruction || "" });
                                          }}
                                          variant="outlined"
                                          fullWidth
                                          disabled={this.state.clientAgreementsLoading}
                                          SelectProps={{ MenuProps: { disablePortal: true } }}
                                        >
                                          <MenuItem value="" disabled>
                                            {this.state.clientAgreementsLoading ? "Loading..." : "Select Client Agreement"}
                                          </MenuItem>
                                          {this.getAvailableClientAgreementsForStep(this.state.editOnboardingId).map((agr) => (
                                            <MenuItem key={agr.agreement_accountno} value={agr.agreement_accountno}>
                                              {agr.agreement_title}
                                            </MenuItem>
                                          ))}
                                        </MutextField>
                                      </div>
                                    </div>
                                  )}

                                  {/* Allow Skip — hidden for agreement */}
                                  <div className="col-lg-12 d-flex align-items-center justify-content-between" style={{ marginTop: 4 }}>
                                    <div style={{ display: "flex", gap: 24, alignItems: "center" }}>
                                      {this.state.editOnboardingType !== "agreement" && (
                                        <div className="custom-control custom-checkbox" style={{ display: "flex", alignItems: "center" }}>
                                          <input type="checkbox" className="custom-control-input" id="edit-allow-skip" checked={this.state.editOnboardingAllowSkip} onChange={(e) => this.setState({ editOnboardingAllowSkip: e.target.checked })} />
                                          <label className="custom-control-label" htmlFor="edit-allow-skip" style={{ fontWeight: "500", marginLeft: "8px", marginBottom: "0" }}>Allow Skip</label>
                                        </div>
                                      )}
                                      <div className="custom-control custom-checkbox" style={{ display: "flex", alignItems: "center" }}>
                                        <input type="checkbox" className="custom-control-input" id="edit-allow-Enable" checked={this.state.editOnboardingIsEnabled === 1} onChange={(e) => this.setState({ editOnboardingIsEnabled: e.target.checked ? 1 : 0 })} />
                                        <label className="custom-control-label" htmlFor="edit-allow-Enable" style={{ fontWeight: "500", marginLeft: "8px", marginBottom: "0" }}>Enable</label>
                                      </div>
                                    </div>
                                    <div style={{ display: "flex", gap: 10 }}>
                                      {this.state.add_question_loader === true ? (
                                        <button className="btn btn-lg btn-primary" disabled>
                                          <em className="icon ni ni-swap"></em> Saving
                                          <div className="spinner-grow spinner-grow-sm" role="status"><span className="sr-only">Loading...</span></div>
                                        </button>
                                      ) : (
                                        <>
                                          <a style={{ cursor: "pointer", color: "#fff" }} onClick={() => this.closeModal("modalEditOnboarding")} className="btn btn-primary btn-lg">
                                            <em className="icon ni ni-cross-round"></em><span>Cancel</span>
                                          </a>
                                          <a style={{ cursor: "pointer", color: "#fff" }} onClick={() => this.submitEditOnboarding()} className="btn btn-primary btn-lg">
                                            <em className="icon ni ni-edit" /> <span>Update Item</span>
                                          </a>
                                        </>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* End Edit Onboarding Modal */}

                    {/* Delete Onboarding Modal */}
                    <div
                      className="modal fade"
                      tabIndex="-1"
                      id="modalDeleteAlert"
                    >
                      <div className="modal-dialog" role="document">
                        <div className="modal-content">
                          <a
                            style={{ cursor: "pointer" }}
                            className="close"
                            onClick={() => {
                              this.modalHideDel();
                            }}
                          >
                            <em className="icon ni ni-cross"></em>
                          </a>
                          <div className="modal-body modal-body-lg text-center">
                            <div className="nk-modal">
                              <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-trash bg-danger"></em>

                              <h4 className="nk-modal-title">
                                {this.state.onboarding_id
                                  ? "Delete Onboarding Item?"
                                  : "Delete Domain?"}
                              </h4>

                              <div className="nk-modal-text">
                                <div className="caption-text">
                                  Are you sure you want to delete this
                                  {this.state.onboarding_id
                                    ? " onboarding item"
                                    : " domain"}
                                  ?
                                </div>
                              </div>
                              <div className="nk-modal-action">
                                <a
                                  style={{ cursor: "pointer" }}
                                  className="btn btn-lg btn-mw btn-primary"
                                  onClick={() => {
                                    this.modalHideDel();
                                  }}
                                  disabled={this.state.isProcessing}
                                >
                                  CANCEL
                                </a>
                                {"  "}
                                {this.state.isProcessing ? (
                                  <button
                                    className="btn btn-lg btn-mw btn-danger"
                                    disabled
                                  >
                                    <em className="icon ni ni-trash"></em>
                                    <span>DELETING</span>
                                    <div
                                      className="spinner-grow spinner-grow-sm"
                                      role="status"
                                      style={{ marginLeft: "8px" }}
                                    >
                                      <span className="sr-only">
                                        Loading...
                                      </span>
                                    </div>
                                  </button>
                                ) : (
                                  <button
                                    style={{ cursor: "pointer" }}
                                    className="btn btn-lg btn-mw btn-danger"
                                    onClick={() => {
                                      if (this.state.onboarding_id) {
                                        this.deleteOnboardingItem();
                                      } else {
                                        this.deleteDomain();
                                      }
                                    }}
                                    disabled={
                                      this.state.disabled ||
                                      this.state.isProcessing
                                    }
                                  >
                                    <span>DELETE</span>
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* End Delete Onboarding Modal */}

                    {/* Add Onboarding Modal */}
                    <div
                      className="modal fade"
                      tabIndex="-1"
                      id="modalAddOnboarding"
                    >
                      <div
                        className="modal-dialog modal-xl modal-dialog-top"
                        role="document"
                      >
                        <div className="modal-content">
                          <a
                            href="#"
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <em className="icon ni ni-cross"></em>
                          </a>
                          <div className="modal-header">
                            <h5 className="modal-title">
                              <em className="icon ni ni-plus text-primary" />{" "}
                              <span>Add Onboarding Item</span>
                            </h5>
                          </div>
                          <div className="modal-body">
                            <div id="OnboardingEditDiv">
                              <div
                                className="col-12"
                                style={{
                                  paddingLeft: "0px",
                                  paddingRight: "0px",
                                }}
                              >

                                <div className="row g-4">
                                  <div className="col-lg-12">
                                    <div className="form-group">
                                      <MutextField
                                        id="add-onboarding-title"
                                        name="add-onboarding-title"
                                        label="Onboarding Item Title"
                                        value={this.state.editOnboardingTitle}
                                        onChange={(e) =>
                                          this.setState({
                                            editOnboardingTitle: e.target.value,
                                          })
                                        }
                                        variant="outlined"
                                        fullWidth
                                        placeholder="Enter onboarding item title"
                                      autoComplete="new-password"
                                      />
                                    </div>
                                  </div>

                                  {/* Type Tabs: Form / Agreement */}
                                  <div className="col-lg-12">
                                    <div style={{ display: "flex", gap: 8, marginBottom: 8, background: "#f5f5f0", borderRadius: 8, padding: "6px 8px" }}>
                                      {["form", "agreement"].map((tab) => (
                                        <button
                                          key={tab}
                                          type="button"
                                          onClick={() => {
                                            this.setState({ addOnboardingType: tab, editOnboardingForm: "", editOnboardingAgreement: "", editOnboardingAgreementTitle: "", editOnboardingAgreementInstruction: "" });
                                            if (tab === "agreement") {
                                              this.get_unsigned_client_agreements();
                                            }
                                          }}
                                          style={{ flex: 1, padding: "7px 0", border: "none", borderRadius: 5, fontSize: 13, fontWeight: 500, cursor: "pointer", background: this.state.addOnboardingType === tab ? "#1d4f8a" : "transparent", color: this.state.addOnboardingType === tab ? "#fff" : "#7a7a6e", transition: "all 0.2s" }}
                                        >
                                          {tab === "form" ? "Form" : "Agreement"}
                                        </button>
                                      ))}
                                    </div>
                                  </div>

                                  {/* Form dropdown */}
                                  {this.state.addOnboardingType === "form" && (
                                    <div className="col-lg-12">
                                      <div className="form-group">
                                        <Autocomplete
                                          options={this.getAvailableFormsForStep(this.state.editOnboardingId).map((form) => ({ id: form.form_accountno, label: form.form_title, form: form }))}
                                          getOptionLabel={(option) => option.label}
                                          value={
                                            this.state.editOnboardingForm
                                              ? this.state.formsList.find((f) => f.form_accountno === this.state.editOnboardingForm)
                                                ? { id: this.state.editOnboardingForm, label: this.state.formsList.find((f) => f.form_accountno === this.state.editOnboardingForm)?.form_title, form: this.state.formsList.find((f) => f.form_accountno === this.state.editOnboardingForm) }
                                                : null
                                              : null
                                          }
                                          onChange={(e, newValue) => {
                                            if (newValue && newValue.id) {
                                              const selectedForm = this.state.formsList.find((form) => form.form_accountno === newValue.id);
                                              this.setState({ editOnboardingForm: newValue.id, editOnboardingAllowMultiple: selectedForm?.allow_multiple !== undefined ? selectedForm.allow_multiple : 0 });
                                            } else {
                                              this.setState({ editOnboardingForm: "", editOnboardingAllowMultiple: 0 });
                                            }
                                          }}
                                          disabled={this.state.formsLoading}
                                          clearOnBlur={false}
                                          clearOnEscape={false}
                                          noOptionsText="No Forms"
                                          renderInput={(params) => (
                                            <MutextField {...params} label="Form" variant="outlined" fullWidth autoComplete="new-password" />
                                          )}
                                        />
                                      </div>
                                    </div>
                                  )}

                                  {/* Agreement dropdown */}
                                  {this.state.addOnboardingType === "agreement" && (
                                    <div className="col-lg-12">
                                      <div className="form-group">
                                        <MutextField
                                          select
                                          label="Select Client Agreement"
                                          value={this.state.editOnboardingAgreement}
                                          onChange={(e) => {
                                            const selected = this.state.clientAgreementsList.find((a) => a.agreement_accountno === e.target.value);
                                            this.setState({ editOnboardingAgreement: e.target.value, editOnboardingAgreementTitle: selected?.agreement_title || "", editOnboardingAgreementInstruction: selected?.agreement_instruction || "" });
                                          }}
                                          variant="outlined"
                                          fullWidth
                                          disabled={this.state.clientAgreementsLoading}
                                          SelectProps={{ MenuProps: { disablePortal: true } }}
                                        >
                                          <MenuItem value="" disabled>
                                            {this.state.clientAgreementsLoading ? "Loading..." : "Select Client Agreement"}
                                          </MenuItem>
                                          {this.getAvailableClientAgreementsForStep(this.state.editOnboardingId).map((agr) => (
                                            <MenuItem key={agr.agreement_accountno} value={agr.agreement_accountno}>
                                              {agr.agreement_title}
                                            </MenuItem>
                                          ))}
                                        </MutextField>
                                      </div>
                                    </div>
                                  )}

                                  {/* Allow Skip — hidden for agreement */}
                                  <div className="col-lg-12 d-flex align-items-center justify-content-between" style={{ marginTop: 4 }}>
                                    <div style={{ display: "flex", gap: 24, alignItems: "center" }}>
                                      {this.state.addOnboardingType !== "agreement" && (
                                        <div className="custom-control custom-checkbox" style={{ display: "flex", alignItems: "center" }}>
                                          <input type="checkbox" className="custom-control-input" id="add-allow-skip" checked={this.state.editOnboardingAllowSkip} onChange={(e) => this.setState({ editOnboardingAllowSkip: e.target.checked })} />
                                          <label className="custom-control-label" htmlFor="add-allow-skip" style={{ fontWeight: "500", marginLeft: "8px", marginBottom: "0" }}>Allow Skip</label>
                                        </div>
                                      )}
                                      <div className="custom-control custom-checkbox" style={{ display: "flex", alignItems: "center" }}>
                                        <input type="checkbox" className="custom-control-input" id="add-allow-Enable" checked={this.state.editOnboardingIsEnabled === 1} onChange={(e) => this.setState({ editOnboardingIsEnabled: e.target.checked ? 1 : 0 })} />
                                        <label className="custom-control-label" htmlFor="add-allow-Enable" style={{ fontWeight: "500", marginLeft: "8px", marginBottom: "0" }}>Enable</label>
                                      </div>
                                    </div>
                                    <div style={{ display: "flex", gap: 10 }}>
                                      {this.state.add_question_loader === true ? (
                                        <button className="btn btn-lg btn-primary" disabled>
                                          <em className="icon ni ni-swap"></em> Saving
                                          <div className="spinner-grow spinner-grow-sm" role="status"><span className="sr-only">Loading...</span></div>
                                        </button>
                                      ) : (
                                        <>
                                          <a style={{ cursor: "pointer", color: "#fff" }} onClick={() => this.closeModal("modalAddOnboarding")} className="btn btn-primary btn-lg">
                                            <em className="icon ni ni-cross-round"></em><span>Cancel</span>
                                          </a>
                                          <a style={{ cursor: "pointer", color: "#fff" }} onClick={() => this.submitEditOnboarding()} className="btn btn-primary btn-lg">
                                            <em className="icon ni ni-plus" /> <span>Add Item</span>
                                          </a>
                                        </>
                                      )}
                                    </div>
                                  </div>
                                </div>

                                {/* END BUTTONS */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* End Add Onboarding Modal */}

                    <div
                      className="card-aside card-aside-right user-aside"
                      data-content="userAside"
                      data-toggle-screen="xxl"
                      data-toggle-overlay="true"
                      data-toggle-body="true"
                    >
                      <div className="card-inner-group" data-simplebar>
                        <div className="card-inner">
                          <div className="user-card user-card-s2">
                            <div className="user-avatar lg bg-primary">
                              <span>{this.state.client_name_initials}</span>
                            </div>
                            <div className="user-info">
                              {this.state.client_status &&
                              this.state.client_status === "Yes" ? (
                                <div className="badge badge-outline-success badge-pill ucap">
                                  Verified
                                </div>
                              ) : (
                                <div className="badge badge-outline-danger badge-pill ucap">
                                  Not Verified
                                </div>
                              )}
                              <h5>{this.state.client_update_name}</h5>
                              <span className="sub-text">
                                {this.state.client_update_email}
                              </span>
                              {this.state.is_fcc_enabled === "Yes" &&
                              this.state.isApproved &&
                              this.state.clientOcns &&
                              this.state.clientOcns.length > 0 ? (
                                <div
                                  className="d-flex flex-wrap justify-content-center mt-2"
                                  style={{ gap: "5px" }}
                                >
                                  {this.state.clientOcns.map((ocn, index) => (
                                    <div
                                      key={index}
                                      className="badge bg-light"
                                      style={{ border: "transparent" }}
                                    >
                                      {ocn}
                                    </div>
                                  ))}
                                </div>
                              ) : null}
                              
                            </div>
                          </div>
                        </div>
                        <div
                          style={{
                            borderBottom: "1px solid #dbdfea",
                            textAlign: "center",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "stretch",
                            gap: "10px",
                            fontSize: "20px",
                          }}
                        >
                          <div
                            style={{
                              margin: "7px 0px",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <a
                              style={{
                                cursor:
                                  this.state.notifyLoginLoading ||
                                  this.state.notifyLoginSuccess ||
                                  this.state.notifyLoginError
                                    ? "not-allowed"
                                    : "pointer",
                                opacity: this.state.notifyLoginLoading ? 0.5 : 1,
                                pointerEvents: this.state.notifyLoginLoading
                                  ? "none"
                                  : "auto",
                                fontSize: "12px",
                                fontWeight: "bold",
                              }}
                              className={
                                this.state.notifyLoginSuccess
                                  ? "text-success"
                                  : this.state.notifyLoginError
                                  ? "text-danger"
                                  : "text-primary"
                              }
                              onClick={!this.state.notifyLoginLoading && !this.state.notifyLoginSuccess && !this.state.notifyLoginError ? this.notifyClientLoginByEmail : undefined}
                            >
                              <em className="icon ni ni-mail" /> Notify Client
                            </a>
                          </div> 
                        </div>
                        <div
                          style={{
                            borderBottom: "1px solid #dbdfea",
                            textAlign: "center",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "stretch",
                            gap: "10px",
                            fontSize: "20px",
                          }}
                        >
                          {/* Edit Client */}
                          {this.state.permissionsState &&
                          this.state.permissionsState.length > 0 &&
                          this.state.permission_edit_client === 1 ? (
                            <div
                              style={{
                                margin: "5px 0px",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <a
                                className="text-primary"
                                onClick={
                                  this.state.editClientLoading
                                    ? undefined
                                    : () => this.editClientModal()
                                }
                                style={{
                                  cursor: this.state.editClientLoading
                                    ? "not-allowed"
                                    : "pointer",
                                  opacity: this.state.editClientLoading
                                    ? 0.5
                                    : 1,
                                  pointerEvents: this.state.editClientLoading
                                    ? "none"
                                    : "auto",
                                  display: "flex",
                                  alignItems: "center",
                                  fontWeight: "bold",
                                }}
                              >
                                <em
                                  className="icon ni ni-edit"
                                  style={{ fontSize: "14px" }}
                                />
                                <span
                                  style={{
                                    fontSize: "12px",
                                    marginLeft: "5px",
                                  }}
                                >
                                  Edit Client
                                </span>
                              </a>
                            </div>
                          ) : null}

                          {/* Show divider only if both sections exist */}
                          {this.state.permission_edit_client === 1 &&
                          (this.state.client_status === "No" ||
                            (this.state.permissionsState &&
                              this.state.permissionsState.length > 0 &&
                              this.state.permission_view_client_sso === 1)) ? (
                            <div
                              style={{
                                borderLeft: "1px solid #dbdfea",
                                height: "36px",
                                margin: "0 3px",
                              }}
                            />
                          ) : null}

                          {/* Right side: Resend or Dashboard */}
                          {this.state.client_status === "No" ? (
                            <div
                              style={{
                                margin: "5px 0px",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <a
                                className="text-primary"
                                onClick={() => this.resendActivation()}
                                style={{
                                  cursor: "pointer",
                                  display: "flex",
                                  alignItems: "center",
                                  fontWeight: "bold",
                                }}
                              >
                                <em
                                  className="icon ni ni-send"
                                  style={{ fontSize: "14px" }}
                                />
                                <span
                                  style={{
                                    fontSize: "12px",
                                    marginLeft: "5px",
                                  }}
                                >
                                  Resend Activation
                                </span>
                              </a>
                            </div>
                          ) : (
                            <>
                              {this.state.permissionsState &&
                              this.state.permissionsState.length > 0 &&
                              this.state.permission_view_client_sso === 1 ? (
                                <div
                                  style={{
                                    margin: "5px 0px",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <a
                                    className="text-primary"
                                    onClick={() => this.clientLoginSso()}
                                    title="Dashboard"
                                    style={{
                                      cursor: "pointer",
                                      display: "flex",
                                      alignItems: "center",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    <em
                                      className="icon ni ni-signin"
                                      style={{ fontSize: "14px" }}
                                    />
                                    <span
                                      style={{
                                        fontSize: "12px",
                                        marginLeft: "5px",
                                      }}
                                    >
                                      Dashboard
                                    </span>
                                  </a>
                                </div>
                              ) : null}
                            </>
                          )}
                        </div>
                        <div>
                          {this.state.is_fcc_enabled === "Yes" ? (
                            <div
                              className="card-inner"
                              style={{ borderBottom: "1px solid #dbdfea" }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  marginBottom: "8px",
                                }}
                              >
                                <h6 className="overline-title-alt text-body mb-0">
                                  499 Filer
                                </h6>
                                {this.state.isApproved === 1 ? (
                                  <a
                                    href="#"
                                    className="text-danger"
                                    style={{
                                      fontSize: "12px",
                                      fontWeight: 600,
                                      cursor: "pointer",
                                    }}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      this.openRevokeFccModal();
                                    }}
                                  >
                                    Revoke
                                  </a>
                                ) : null}
                              </div>
                              {this.state.fcc_filing_url &&
                              this.state.fcc_filing_url !== "" ? (
                                <div className="mb-2">
                                  <a
                                    className="overline-title-alt text-primary"
                                    href={this.state.fcc_filing_url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ cursor: "pointer", clear: "both" }}
                                  >
                                    <em className="icon ni ni-link"></em>{" "}
                                    Robocall Mitigation Database
                                  </a>
                                </div>
                              ) : null}
                              <div
                                style={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  gap: "8px",
                                  alignItems: "center",
                                }}
                              >
                                {this.state.isApproved === 1 ? (
                                  <>
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-success"
                                      disabled
                                      style={{ cursor: "default" }}
                                    >
                                      <em className="icon ni ni-check-circle"></em>{" "}
                                      <span>Approved</span>
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-primary"
                                      onClick={() => this.openUpdateOcnModal()}
                                    >
                                      <em className="icon ni ni-edit"></em>{" "}
                                      <span>OCN</span>
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-outline-info"
                                      onClick={() => this.openFccDataModal()}
                                    >
                                      <em className="icon ni ni-eye"></em>{" "}
                                      <span>FCC Data</span>
                                    </button>
                                  </>
                                ) : this.state.isApproved === 2 ? (
                                  <>
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-danger"
                                      disabled
                                      style={{ cursor: "not-allowed" }}
                                    >
                                      <em className="icon ni ni-cross-circle"></em>{" "}
                                      <span>Rejected</span>
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-primary"
                                      onClick={() => this.openAddFilerIdModal()}
                                    >
                                      <em className="icon ni ni-plus"></em>{" "}
                                      <span>Add Filer ID</span>
                                    </button>
                                  </>
                                ) : !this.state.filer_id ||
                                  this.state.filer_id.trim() === "" ? (
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-primary"
                                    onClick={() => this.openAddFilerIdModal()}
                                  >
                                    <em className="icon ni ni-plus"></em>{" "}
                                    <span>Add Filer ID</span>
                                  </button>
                                ) : (
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-primary"
                                    onClick={() =>
                                      this.openApproveClientMainAlert()
                                    }
                                  >
                                    <em className="icon ni ni-alert-circle"></em>{" "}
                                    <span>Approve / Reject</span>
                                  </button>
                                )}
                              </div>
                            </div>
                          ) : null}
                        </div>

                        {/*<div className="card-inner card-inner-sm">\n                          <ul className="btn-toolbar justify-center gx-1">\n                            <li>
                              <a href="#" className="btn btn-trigger btn-icon">
                                <em className="icon ni ni-shield-off"></em>
                              </a>
                            </li>
                            <li>
                              <a href="#" className="btn btn-trigger btn-icon">
                                <em className="icon ni ni-mail"></em>
                              </a>
                            </li>
                            <li>
                              <a href="#" className="btn btn-trigger btn-icon">
                                <em className="icon ni ni-download-cloud"></em>
                              </a>
                            </li>
                            <li>
                              <a href="#" className="btn btn-trigger btn-icon">
                                <em className="icon ni ni-bookmark"></em>
                              </a>
                            </li>
                            <li>
                              <a
                                href="#"
                                className="btn btn-trigger btn-icon text-danger"
                              >
                                <em className="icon ni ni-na"></em>
                              </a>
                            </li>
                          </ul>
                                              </div>*/}
                        {/* <div className="card-inner">
                          <div className="overline-title-alt mb-2">Payments</div>
                          <div className="profile-balance">
                            <div className="profile-balance-group gx-4">
                              <div className="profile-balance-sub">
                                <div className="profile-balance-amount">
                                  <div className="number">
                                    0.00{" "}
                                    <small className="currency currency-usd">
                                      USD
                                    </small>
                                  </div>
                                </div>
                                <div className="profile-balance-subtitle">
                                  Paid Amount
                                </div>
                              </div>
                              <div className="profile-balance-sub">
                                <span className="profile-balance-plus text-soft">
                                  <em className="icon ni ni-plus"></em>
                                </span>
                                <div className="profile-balance-amount">
                                  <div className="number">0.00</div>
                                </div>
                                <div className="profile-balance-subtitle">
                                  Remaining Amount
                                </div>
                              </div>
                            </div>
                          </div>
                        </div> */}
                        {/*<div className="card-inner">
                          <a
                            className="overline-title-alt"
                            style={{ cursor: "pointer" }}
                            onClick={(e) => {
                              this.changeActiveTab("kyc_form");
                              this.showDetails();
                            }}
                          >
                            KYC{" "}
                            <span className="text-primary">
                              ({this.state.kyc_percentage}
                              %)
                            </span>
                          </a>
                          <div className="row text-center mt-2">
                            <div className="col-12">
                              <div className="card card-bordered card-preview">
                                <div className="card-inner viewClient_card-inner_customStyle">
                                  <div className="progress progress-lg">
                                    <div
                                      className="progress-bar"
                                      data-progress={this.state.kyc_percentage}
                                      style={{
                                        width: `${this.state.kyc_percentage}%`,
                                      }}
                                    >
                                      {this.state.kyc_percentage}%
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>*/}
                        <div className="card-inner">
                          <a
                            className="overline-title-alt"
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              this.openLinkInNewTab(
                                "/SalesOrders/" + this.state.client_accountno,
                              )
                            }
                          >
                            Sale Orders
                          </a>
                          <div className="row text-center">
                            <div className="col-4">
                              <div
                                className="profile-stats"
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  this.openLinkInNewTab(
                                    "/SalesOrders/" +
                                      this.state.client_accountno,
                                  )
                                }
                              >
                                <span className="amount">
                                  {this.state.totalSalesOrders}
                                </span>
                                <span className="sub-text">Total</span>
                              </div>
                            </div>
                            <div className="col-4">
                              <div
                                className="profile-stats"
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  this.openLinkInNewTab(
                                    "/SalesOrders/" +
                                      this.state.client_accountno,
                                  )
                                }
                              >
                                <span className="amount">
                                  {this.state.completedSalesOrders}
                                </span>
                                <span className="sub-text">Completed</span>
                              </div>
                            </div>
                            <div className="col-4">
                              <div
                                className="profile-stats"
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  this.openLinkInNewTab(
                                    "/SalesOrders/" +
                                      this.state.client_accountno,
                                  )
                                }
                              >
                                <span className="amount">
                                  {this.state.paidSalesOrders}
                                </span>
                                <span className="sub-text">Paid</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="card-inner">
                          <a
                            className="overline-title-alt"
                            style={{ cursor: "pointer" }}
                            onClick={(e) => {
                              this.changeActiveTab("agreements");
                              this.clientAgreements();
                            }}
                          >
                            Agreements
                          </a>
                          <div className="row text-center">
                            <div className="col-4">
                              <div
                                className="profile-stats"
                                style={{ cursor: "pointer" }}
                                onClick={(e) => {
                                  this.changeActiveTab("agreements");
                                  this.clientAgreements();
                                }}
                              >
                                <span className="amount">
                                  {this.state.totalClientAgreements}
                                </span>
                                <span className="sub-text">Total</span>
                              </div>
                            </div>
                            <div className="col-4">
                              <div
                                className="profile-stats"
                                style={{ cursor: "pointer" }}
                                onClick={(e) => {
                                  this.changeActiveTab("agreements");
                                  this.clientAgreements();
                                }}
                              >
                                <span className="amount">
                                  {this.state.signedClientAgreements}
                                </span>
                                <span className="sub-text">Signed</span>
                              </div>
                            </div>
                            <div className="col-4">
                              <div
                                className="profile-stats"
                                style={{ cursor: "pointer" }}
                                onClick={(e) => {
                                  this.changeActiveTab("agreements");
                                  this.clientAgreements();
                                }}
                              >
                                <span className="amount">
                                  {this.state.unsignedClientAgreements}
                                </span>
                                <span className="sub-text">Unsigned</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="card-inner">
                          <a
                            className="overline-title-alt"
                            style={{ cursor: "pointer" }}
                            onClick={(e) => {
                              this.changeActiveTab("onboarding_settings");
                              this.getOnboardingItems();
                            }}
                          >
                            Onboarding Progress
                          </a>
                          <div
                            className="progress progress-lg"
                            style={{ marginTop: "10px" }}
                          >
                            <div
                              className="progress-bar"
                              data-progress={this.getOnboardingPercentage()}
                              style={{
                                width: `${this.getOnboardingPercentage()}%`,
                                backgroundColor:
                                  this.getOnboardingPercentage() === 100
                                    ? "#00b894"
                                    : "",
                              }}
                            >
                              {this.getOnboardingPercentage()}%
                            </div>
                          </div>
                        </div>
                        {/***** Client Credits (right aside) *****/}
                        {(() => {
                          const cs = this.state.creditSummary || {};
                          const balance = Number(cs.balance) || 0;
                          const recent = this.state.creditRecent || [];
                          return (
                            <div className="card-inner" style={{ borderTop: "1px solid #f0f0f0" }}>

                              {/* CREDIT BALANCE — single row label + value */}
                              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "10px" }}>
                                <span style={{ fontSize: "11px", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.05em", color: "#9a9690" }}>
                                  Credit Balance
                                </span>
                                <span style={{ fontSize: "20px", fontWeight: 800, color: balance > 0 ? "#1c5bde" : "#b8b4ad", letterSpacing: "-0.02em", lineHeight: 1 }}>
                                  ${this.formatCreditAmount(balance)}
                                </span>
                              </div>

                              {/* Recent history rows */}
                              <div style={{ borderTop: "1px solid #f0f0f0", paddingTop: "8px", marginBottom: "10px" }}>
                                {this.state.creditSummaryLoading ? (
                                  <div style={{ fontSize: "12px", color: "#9a9690", fontStyle: "italic" }}>Loading…</div>
                                ) : recent.length === 0 ? (
                                  <div style={{ fontSize: "12px", color: "#9a9690", fontStyle: "italic" }}>No history yet.</div>
                                ) : (
                                  recent.map((h, i) => {
                                    const amt = Number(h.amount) || 0;
                                    const isCredit = amt >= 0;
                                    return (
                                      <div key={h.id || i} style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", fontSize: "11.5px", padding: "4px 0", borderBottom: "1px solid #f5f5f5" }}>
                                        <span style={{ color: "#8094ae", flex: 1, marginRight: "8px", lineHeight: 1.5, wordBreak: "break-word" }}>
                                          {this.formatLedgerDate(h.created_at)}{h.description ? ` · ${h.description.split(" | ").filter(p => !p.startsWith("Date:") && !p.startsWith("[Memo:")).join(" ")}` : ""}
                                        </span>
                                        <span style={{ fontWeight: 700, whiteSpace: "nowrap", color: isCredit ? "#1a7a4a" : "#e85347", flexShrink: 0 }}>
                                          {isCredit ? "+" : "−"}${this.formatCreditAmount(Math.abs(amt))}
                                        </span>
                                      </div>
                                    );
                                  })
                                )}
                              </div>

                              {/* Action buttons — 1 per row */}
                              <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                <button
                                  type="button"
                                  className="btn btn-primary"
                                  style={{ width: "100%", justifyContent: "center" }}
                                  onClick={this.openAddCreditModal}
                                >
                                  <em className="icon ni ni-plus"></em>
                                  <span>Add Credit</span>
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-dim btn-secondary"
                                  style={{ width: "100%", justifyContent: "center" }}
                                  onClick={this.openLedgerModal}
                                >
                                  <span>📒 View Ledger</span>
                                </button>
                              </div>
                            </div>
                          );
                        })()}
                        {/***** Client Credits End *****/}
                        {/*<div className="card-inner">
                          <h6 className="overline-title-alt mb-2">Additional</h6>
                          <div className="row g-3">
                            <div className="col-6">
                              <span className="sub-text">User ID:</span>
                              <span>UD003054</span>
                            </div>
                            <div className="col-6">
                              <span className="sub-text">Last Login:</span>
                              <span>15 Feb, 2019 01:02 PM</span>
                            </div>
                            <div className="col-6">
                              <span className="sub-text">KYC Status:</span>
                              <span className="lead-text text-success">
                                Approved
                              </span>
                            </div>
                            <div className="col-6">
                              <span className="sub-text">Register At:</span>
                              <span>Nov 24, 2019</span>
                            </div>
                          </div>
                        </div>
                        <div className="card-inner">
                          <h6 className="overline-title-alt mb-3">Groups</h6>
                          <ul className="g-1">
                            <li className="btn-group">
                              <a className="btn btn-xs btn-light btn-dim" href="#">
                                investor
                              </a>
                              <a
                                className="btn btn-xs btn-icon btn-light btn-dim"
                                href="#"
                              >
                                <em className="icon ni ni-cross"></em>
                              </a>
                            </li>
                            <li className="btn-group">
                              <a className="btn btn-xs btn-light btn-dim" href="#">
                                support
                              </a>
                              <a
                                className="btn btn-xs btn-icon btn-light btn-dim"
                                href="#"
                              >
                                <em className="icon ni ni-cross"></em>
                              </a>
                            </li>
                            <li className="btn-group">
                              <a className="btn btn-xs btn-light btn-dim" href="#">
                                another tag
                              </a>
                              <a
                                className="btn btn-xs btn-icon btn-light btn-dim"
                                href="#"
                              >
                                <em className="icon ni ni-cross"></em>
                              </a>
                            </li>
                          </ul>
                        </div>*/}

                        <div className="card-inner">
                          {(this.state.va_intergation === "Yes" ||
                            this.state.meta_intergation === "Yes") && (
                            <>
                              {this.state.permissionsState &&
                              this.state.permissionsState.length > 0 &&
                              this.state.permission_manage_integrations ===
                                1 ? (
                                <a
                                  className="overline-title-alt text-primary"
                                  onClick={() => this.modalOpenIntegration()}
                                  style={{ cursor: "pointer", clear: "both" }}
                                >
                                  <em className="icon ni ni-exchange"></em>{" "}
                                  Manage Integrations
                                </a>
                              ) : (
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                  }}
                                >
                                  <span className="text-muted">---</span>
                                </div>
                              )}
                            </>
                          )}
                        </div>

                        <div className="card-inner">
                          <h6 className="overline-title-alt text-body mb-3">
                            Registration Reference
                          </h6>
                          {this.state.register_type &&
                          this.state.register_type === "Admin" ? (
                            <p>Added by Admin</p>
                          ) : this.state.register_type &&
                            this.state.register_type === "sharelink" ? (
                            <p>
                              Added via{" "}
                              {localization.specificPortals.sharelinkLabel} -
                              <a
                                className="text-primary"
                                href={this.state.sharelink_external_link}
                                target="_blank"
                              >
                                {" "}
                                {this.state.sharelink_title}
                              </a>
                            </p>
                          ) : this.state.register_type &&
                            this.state.register_type === "service" ? (
                            <p>
                              Added via{" "}
                              {localization.specificPortals.sharelinkLabel} -
                              <a
                                className="text-primary"
                                href={this.state.sharelink_external_link}
                                target="_blank"
                              >
                                {" "}
                                {this.state.sharelink_title}
                              </a>
                            </p>
                          ) : (
                            <p>Direct Registration</p>
                          )}
                        </div>
                        <div className="card-inner">
                          <>
                            {this.state.permissionsState &&
                            this.state.permissionsState.length > 0 &&
                            this.state.permission_forogt_password_link === 1 ? (
                              <a
                                className="overline-title-alt text-primary"
                                onClick={() =>
                                  this.modalOpenForgotPasswordLink()
                                }
                                style={{ cursor: "pointer", clear: "both" }}
                              >
                                <em className="icon ni ni-link"></em> Forgot
                                Password Link
                              </a>
                            ) : (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <span className="text-muted">---</span>
                              </div>
                            )}
                          </>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal fade" tabIndex="-1" id="modalUpdateClient">
            <div
              className="modal-dialog modal-xl modal-dialog-top"
              role="document"
            >
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Edit Client Profile</h5>
                  <a
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    style={{
                      cursor: "pointer",
                    }}
                  >
                    <em className="icon ni ni-cross"></em>
                  </a>
                </div>

                <div className="modal-body">
                  {/* Error Start */}
                  {this.state.showEmailWarning === true ? (
                    <div className="alert alert-pro alert-warning">
                      <div className="alert-text">
                        <h6>Confirm Email Update</h6>
                        <p>Are you sure you want to update the email?</p>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: "10px",
                          }}
                        >
                          <button
                            type="button"
                            className="btn btn-danger"
                            onClick={this.handleEmailWarningNo}
                          >
                            Cancel
                          </button>
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={this.handleEmailWarningYes}
                          >
                            Yes, Proceed
                          </button>
                        </div>
                      </div>
                    </div>
                  ) : null}
                  <br />

                  <div className="row g-4">
                    {this.state.is_fcc_enabled === "Yes" && (
                      <>
                        <div className="col-lg-12">
                          <div className="form-group">
                            <div className="custom-control custom-checkbox">
                              <input
                                type="checkbox"
                                className="custom-control-input"
                                id="has_fcc_filer_id_edit"
                                name="has_fcc_filer_id"
                                checked={this.state.has_fcc_filer_id}
                                onChange={(e) => {
                                  this.setState({
                                    has_fcc_filer_id: e.target.checked,
                                    errorFilerId: "",
                                  });
                                }}
                              />
                              <label
                                className="custom-control-label"
                                htmlFor="has_fcc_filer_id_edit"
                              >
                                I have{" "}
                                <a
                                  href="https://apps.fcc.gov/cgb/form499/499a.cfm"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{
                                    color: "rgb(101, 118, 255)",
                                    textDecoration: "underline",
                                  }}
                                >
                                  FCC 499 Filer ID
                                </a>
                              </label>
                            </div>
                          </div>
                        </div>

                        {this.state.has_fcc_filer_id && (
                          <div className="col-lg-4">
                            <div className="form-group">
                              <label
                                className="form-label"
                                htmlFor="filer_id"
                                style={{ color: "black", fontWeight: "500" }}
                              >
                                FCC 499 Filer ID *
                              </label>
                              <FccFilerAutocomplete
                                variant="default"
                                value={this.state.filer_id}
                                error={this.state.errorFilerId === "error"}
                                disabled={false}
                                fccLoading={this.state.fccLoading}
                                fccSuccess={this.state.fccSuccess}
                                errorFilerId={this.state.errorFilerId}
                                onInputChange={(value) => {
                                  this.setState({
                                    filer_id: value,
                                    errorFilerId: "",
                                    fccSuccess: false,
                                    lastVerifiedFilerId:
                                      value === this.state.lastVerifiedFilerId
                                        ? this.state.lastVerifiedFilerId
                                        : "",
                                  });
                                }}
                                onSelect={(filerId) => {
                                  this.setState({
                                    filer_id: filerId,
                                    errorFilerId: "",
                                    fccSuccess: false,
                                  });
                                }}
                                onFccDataLoading={(loading) => {
                                  this.setState({ fccLoading: loading });
                                }}
                                onFccDataLoaded={async (fccResponse, filerId) => {
                                  if (
                                    fccResponse.data.status === 200 &&
                                    fccResponse.data.frn_details?.data
                                  ) {
                                    const fccData = fccResponse.data.frn_details.data;
                                    const robocallData = fccData.robocall_data || {};

                                    // Check if Filer ID already exists - MUST run before setting success
                                    try {
                                      const checkResponse = await checkFilerIdExists(
                                        auth.getAccount(),
                                        auth.getToken(),
                                        filerId
                                      );
                                      
                                      if (checkResponse.data && checkResponse.data.exists) {
                                        this.setState({
                                          filerIdAlreadyExists: true,
                                          errorFilerId: "This Filer ID is already associated with an existing client",
                                          fccSuccess: false,
                                          fccLoading: false,
                                        });
                                        return; // Stop execution if duplicate found
                                      }
                                    } catch (error) {
                                      console.error("Error checking filer ID:", error);
                                      // Continue even if check fails
                                    }

                                    // Only set success if no duplicate was found
                                    this.setState({
                                      fccSuccess: true,
                                      fccLoading: false,
                                      fcc_data: fccData,
                                      lastVerifiedFilerId: filerId,
                                      client_comp_name:
                                        robocallData.business_name || this.state.client_comp_name,
                                      client_phone: robocallData.contact_telephone_number
                                        ? this.normalizeFccPhoneTemp(robocallData.contact_telephone_number)
                                        : this.state.client_phone,
                                      client_update_name:
                                        robocallData.robocall_mitigation_contact_name ||
                                        this.state.client_update_name,
                                      client_title:
                                        robocallData.contact_title || this.state.client_title,
                                      fcc_contact_email: robocallData.contact_email || "",
                                      fcc_ocn: robocallData.ocn || "",
                                      fcc_frn: robocallData.frn || "",
                                      fcc_number: fccData.coresid || "",
                                      fcc_coresid: fccData.coresid || "",
                                      filerIdAlreadyExists: false,
                                    });
                                    if (robocallData.contact_business_address) {
                                      this.parseAddressWithGoogle(
                                        robocallData.contact_business_address,
                                      );
                                    }
                                  } else {
                                    this.setState({
                                      errorFilerId: "Invalid Filer ID",
                                      fccLoading: false,
                                      fccSuccess: false,
                                    });
                                  }
                                }}
                                onFccDataError={() => {
                                  this.setState({
                                    errorFilerId: "Error verifying Filer ID",
                                    fccLoading: false,
                                    fccSuccess: false,
                                  });
                                }}
                              />
                            </div>
                          </div>
                        )}
                      </>
                    )}
                    <div className="col-lg-4">
                      <div className="form-group">
                        <MutextField
                          label='Company Name'
                          required={this.isFieldRequired('client_comp_name')}
                          error={this.state.errorClientCompName === "error"}
                          id="client_comp_name"
                          name="client_comp_name"
                          value={this.state.client_comp_name}
                          placeholder="Company Name"
                          onChange={this.handleChange}
                          type="text"
                          inputProps={{ maxLength: 100 }}
                          disabled={this.state.fccLoading}
                          variant="outlined"
                          fullWidth
                          helperText="Allowed characters: (&nbsp; ' &nbsp; - &nbsp; . &nbsp; , &nbsp; : &nbsp; ( ) &nbsp; | &nbsp; ! &nbsp; @ )"
                        autoComplete="new-password"
                        />
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="form-group">
                        <MutextField
                          label='Full Name'
                          required={this.isFieldRequired('client_update_name')}
                          error={this.state.errorClientName === "error"}
                          id="client_update_name"
                          name="client_update_name"
                          value={this.state.client_update_name}
                          placeholder="Full Name"
                          onChange={this.handleChange}
                          inputProps={{ maxLength: 30 }}
                          disabled={this.state.fccLoading}
                          variant="outlined"
                          fullWidth
                          helperText="Allowed characters: (&nbsp; ' &nbsp; - &nbsp; . &nbsp; , &nbsp; : &nbsp; ( ) &nbsp; | &nbsp; ! &nbsp; @ )"
                        autoComplete="new-password"
                        />
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="form-group">
                        <MutextField
                          label='Title'
                          required={this.isFieldRequired('client_title')}
                          error={this.state.errorClientTitle === "error"}
                          id="client_title"
                          name="client_title"
                          value={this.state.client_title}
                          placeholder="Title"
                          onChange={this.handleChange}
                          inputProps={{ maxLength: 30 }}
                          disabled={this.state.fccLoading}
                          variant="outlined"
                          fullWidth
                          helperText="Allowed characters: (&nbsp; ' &nbsp; - &nbsp; . &nbsp; , &nbsp; : &nbsp; ( ) &nbsp; | &nbsp; ! &nbsp; @ )"
                        autoComplete="new-password"
                        />
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="form-group" style={{marginTop: "18px"}}>
                        <MutextField
                          required
                          label="Email"
                          type="text"
                          error={this.state.errorClientEmail === "error"}
                          id="client_update_email"
                          name="client_update_email"
                          value={this.state.client_update_email}
                          placeholder="Enter email address"
                          onChange={this.handleChange}
                          variant="outlined"
                          fullWidth
                        autoComplete="new-password"
                        />
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="form-group" style={{marginTop: "18px"}}>
                        <ReactPhoneInput
                          country="us"
                          value={(this.state.client_phone || "").replace(/^\+/, "")}
                          onChange={(value) =>
                            this.handleChange({
                              target: {
                                name: "client_phone",
                                value: value ? `+${value}` : "",
                              },
                            })
                          }
                          inputProps={{
                            name: "client_phone",
                            id: "client_phone",
                            required: this.isFieldRequired('client_phone'),
                            maxLength: 20,
                            disabled: this.state.fccLoading,
                          }}
                          specialLabel={this.isFieldRequired('client_phone') ? "Phone Number *" : "Phone Number"}
                          containerStyle={{ width: "100%" }}
                          inputStyle={{
                            width: "100%",
                            height: "56px",
                            backgroundColor: this.state.fccLoading ? "#f5f5f5" : "",
                            opacity: this.state.fccLoading ? 0.7 : 1,
                            borderColor:
                              this.state.errorClientPhone === "error" ? "red" : "",
                          }}
                          buttonStyle={{
                            backgroundColor: this.state.fccLoading ? "#f5f5f5" : "",
                            opacity: this.state.fccLoading ? 0.7 : 1,
                            borderColor:
                              this.state.errorClientPhone === "error" ? "red" : "",
                          }}
                          disabled={this.state.fccLoading}
                          isValid={this.state.errorClientPhone !== "error"}
                        />
                      </div>
                    </div>
                    {/*<div className="col-lg-4">
                      <div className="form-group">
                      
                        <TextField
                          label="Phone"
                          type="text"
                          error={this.state.errorClientPhone}
                          id="client_phone"
                          name="client_phone"
                          value={this.state.client_phone}
                          placeholder="Enter phone"
                          change={this.handleChange}
                          maxLength={20}
                        />
                      </div>
                    </div>*/}
                    <div className="col-lg-4">
                      <div className="nk-block-between-md g-4">
                        {this.state.address_autocomplete === "Yes" && (
                          <div className="nk-block-head-content">
                            <ul className="nk-block-tools gx-3">
                              <li>
                                <a
                                  onClick={this.handleToggle}
                                  className="text-primary fs-11"
                                  style={{
                                    cursor: "pointer",
                                    fontSize: "11px",
                                  }}
                                >
                                  {toggleButtonText}
                                </a>
                              </li>
                            </ul>
                          </div>
                        )}
                      </div>
                      <div className="form-group">
                        {this.state.address_autocomplete === "Yes" ? (
                          useGooglePlaces ? (
                            <GooglePlacesAutocomplete
                              apiKey={
                                process.env
                                  .REACT_APP_ADDRESS_AUTOCOMPLETE_API_KEY
                              }
                              apiOptions={{ loading: 'async' }}
                              selectProps={{
                                value: this.state.client_address
                                  ? {
                                      label: this.state.client_address,
                                      value: this.state.client_address,
                                    }
                                  : null,
                                onChange: this.handleAddressSelect,
                                placeholder: this.state.client_address
                                  ? null
                                  : "Enter your address *",
                                styles: {
                                  input: (provided) => ({
                                    ...provided,
                                    color: "black",
                                    height: "43px",
                                  }),
                                  option: (provided) => ({
                                    ...provided,
                                    color: "black",
                                  }),
                                  singleValue: (provided) => ({
                                    ...provided,
                                    color: "black",
                                  }),
                                  menu: (provided) => ({
                                    ...provided,
                                    zIndex: 9,
                                  }),
                                },
                              }}
                              className="googleLocation-autocomplete"
                            />
                          ) : (
                            <MutextField
                              id="client_address"
                              name="client_address"
                              type="text"
                              label="PO Box Address"
                              value={this.state.client_address}
                              onChange={this.handleChange}
                              inputProps={{ maxLength: 100 }}
                              variant="outlined"
                              fullWidth
                              error={this.state.errorClientAddress === "error"}
                            autoComplete="new-password"
                            />
                          )
                        ) : (
                          // address_autocomplete === "No" → show PO Box only
                          <MutextField
                            id="client_address"
                            name="client_address"
                            type="text"
                            label="Address"
                            value={this.state.client_address}
                            onChange={this.handleChange}
                            variant="outlined"
                            fullWidth
                            error={this.state.errorClientAddress === "error"}
                          autoComplete="new-password"
                          />
                        )}
                        {/*  */}
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="form-group">
                        <MutextField
                          label='Apartment, Suite, Etc.'
                          required={this.isFieldRequired('client_address2')}
                          type="text"
                          id="client_address2"
                          name="client_address2"
                          value={this.state.client_address2}
                          placeholder=""
                          onChange={this.handleChange}
                          inputProps={{ maxLength: 100 }}
                          variant="outlined"
                          fullWidth
                        autoComplete="new-password"
                        />
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="form-group">
                        <MutextField
                          label='City'
                          required={this.isFieldRequired('client_city')}
                          type="text"
                          error={this.state.errorClientCity === "error"}
                          id="client_city"
                          name="client_city"
                          value={this.state.client_city}
                          placeholder="Enter city"
                          onChange={this.handleChange}
                          inputProps={{ maxLength: 32 }}
                          disabled={this.state.fccLoading}
                          variant="outlined"
                          fullWidth
                        autoComplete="new-password"
                        />
                      </div>
                    </div>
                    <div className="col-lg-2">
                      <div className="form-group">
                        <MutextField
                          label='State'
                          required={this.isFieldRequired('client_state')}
                          type="text"
                          error={this.state.errorClientState === "error"}
                          id="client_state"
                          name="client_state"
                          value={this.state.client_state}
                          placeholder="Enter state"
                          onChange={this.handleChange}
                          inputProps={{ maxLength: 32 }}
                          disabled={this.state.fccLoading}
                          variant="outlined"
                          fullWidth
                        autoComplete="new-password"
                        />
                      </div>
                    </div>
                    <div className="col-lg-2">
                      <div className="form-group">
                        <MutextField
                          label='Zip Code'
                          required={this.isFieldRequired('client_zip')}
                          type="text"
                          error={this.state.errorClientZip === "error"}
                          id="client_zip"
                          name="client_zip"
                          value={this.state.client_zip}
                          placeholder="Enter zip code"
                          onChange={this.handleChange}
                          inputProps={{ maxLength: 9 }}
                          disabled={this.state.fccLoading}
                          variant="outlined"
                          fullWidth
                        autoComplete="new-password"
                        />
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="form-group">
                        <Autocomplete
                          id="client_country"
                          options={this.countryOptions}
                          getOptionLabel={(option) => option.label}
                          value={
                            this.state.client_country
                              ? this.countryOptions.find(opt => opt.label === this.state.client_country) || null
                              : null
                          }
                          onChange={(event, newValue) =>
                            this.handleChangeCountry(newValue)
                          }
                          disabled={this.state.fccLoading}
                          renderInput={(params) => (
                            <MutextField
                              {...params}
                              label={
                                this.isFieldRequired('client_country')
                                  ? "Country *"
                                  : "Country"
                              }
                              variant="outlined"
                              fullWidth
                              error={this.state.errorClientCountry === "error"}
                              helperText="Select country"
                            autoComplete="new-password"
                            />
                          )}
                        />
                      </div>
                    </div>
                    <div className="col-lg-4 small_select">
                      <div className="form-group">
                        <MutextField
                          id="client_account_status"
                          name="client_account_status"
                          select
                          label="Account Status *"
                          value={this.state.client_account_status}
                          onChange={this.handleChange}
                          SelectProps={{
                            native: true,
                          }}
                          variant="outlined"
                          fullWidth
                        autoComplete="new-password"
                        >
                          <option key="5" value="active">
                            Active
                          </option>
                          <option key="10" value="inactive">
                            Inactive
                          </option>
                        </MutextField>
                      </div>
                    </div>
                    <div className="col-lg-4 small_select">
                      <div className="form-group">
                        <MutextField
                          id="client_isVerified"
                          name="client_isVerified"
                          select
                          label="Verification"
                          value={this.state.client_isVerified}
                          onChange={this.handleChange}
                          SelectProps={{
                            native: true,
                          }}
                          variant="outlined"
                          fullWidth
                        autoComplete="new-password"
                        >
                          <option key="status1" value="Yes">
                            On
                          </option>
                          <option key="status0" value="No">
                            Off
                          </option>
                        </MutextField>
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="form-group">
                        <MutextField
                          label="Password"
                          type={this.state.passwordShown ? "text" : "password"}
                          error={this.state.errorClientPass === "error"}
                          id="client_password"
                          name="client_password"
                          value={this.state.client_password}
                          placeholder="Enter password"
                          onChange={this.handleChange}
                          inputProps={{ maxLength: 30 }}
                          variant="outlined"
                          fullWidth
                          helperText="Password must be at least 8 characters, with uppercase, lowercase, number & special character."
                        autoComplete="new-password"
                        />
                        <a
                          style={{
                            left: "auto",
                            top: "30px",
                            position: "absolute",
                            cursor: "pointer",
                          }}
                          tabIndex="-1"
                          onClick={this.togglePassword}
                          className="form-icon form-icon-right passcode-switch"
                          data-target="password"
                        >
                          {this.state.passwordShown ? (
                            <em className="icon ni ni-eye-off"></em>
                          ) : (
                            <em className="icon ni ni-eye"></em>
                          )}
                        </a>
                        <div style={{marginTop: "20px"}}>
                          <PasswordStrengthBar
                            password={this.state.client_password}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="form-group">
                        <MutextField
                          label="Confirm Password"
                          type={
                            this.state.confirmPasswordShown
                              ? "text"
                              : "password"
                          }
                          error={this.state.errorClientPass === "error"}
                          id="client_confirm_password"
                          name="client_confirm_password"
                          value={this.state.client_confirm_password}
                          placeholder="Enter confirm password"
                          onChange={this.handleChange}
                          inputProps={{ maxLength: 30 }}
                          variant="outlined"
                          fullWidth
                          helperText="Confirm Password must be at least 8 characters, with uppercase, lowercase, number & special character. Confirm Password must match the Password."
                        autoComplete="new-password"
                        />
                        <a
                          style={{
                            left: "auto",
                            top: "30px",
                            position: "absolute",
                            cursor: "pointer",
                          }}
                          tabIndex="-1"
                          onClick={() => {
                            this.toggleConfirmPassword();
                          }}
                          className="form-icon form-icon-right passcode-switch"
                          data-target="password"
                        >
                          {this.state.confirmPasswordShown ? (
                            <em className="icon ni ni-eye-off"></em>
                          ) : (
                            <em className="icon ni ni-eye"></em>
                          )}
                        </a>
                      </div>
                    </div>
                    <div className="col-lg-12" style={{ marginBottom: "15px" }}>
                      <div className="form-group">
                        <div className="custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="assignParentClientRole"
                            name="assignParentClientRole"
                            checked={this.state.assignParentClientRole}
                            onChange={(e) => {
                              this.setState({
                                assignParentClientRole: e.target.checked,
                                selectedParentClient: "",
                                errorClientMessageEdit: "",
                              });
                            }}
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="assignParentClientRole"
                          >
                            Assign as Sub-Client Under a Parent Client
                          </label>
                        </div>
                      </div>
                    </div>
                    {this.state.assignParentClientRole && (
                      <div className="col-lg-6" style={{ marginBottom: "15px" }}>
                        <div className="form-group">
                          <MutextField
                            id="selectedParentClient"
                            name="selectedParentClient"
                            select
                            value={this.state.selectedParentClient}
                            onChange={(e) => {
                              this.setState({
                                selectedParentClient: e.target.value,
                                errorClientMessageEdit: "",
                              });
                            }}
                            SelectProps={{
                              native: true,
                            }}
                            variant="outlined"
                            fullWidth
                            disabled={this.state.parentClientLoading}
                          >
                            <option key="" value="">
                              {this.state.parentClientLoading
                                ? "Loading clients..."
                                : "-- Select Parent Client --"}
                            </option>
                            {this.state.parentEligibleClients.map((client) => (
                              <option key={client[0]} value={client[0]}>
                                {client[1]} ({client[2]}) - {client[4]}
                              </option>
                            ))}
                          </MutextField>
                        </div>
                      </div>
                    )}
                    <div
                      className="custom-control custom-control-lg custom-checkbox col-lg-12"
                      style={{ padding: 0, marginLeft: "3rem" }}
                    >
                      <div className="form-group">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          id="customCheck2"
                          onChange={() => {
                            const isChecked = !this.state.notifyCheckBox;
                            this.setState({ notifyCheckBox: isChecked });
                            // console.log("Notify Checkbox Checked:", isChecked);
                          }}
                        />
                        <label
                          className="custom-control-label"
                          for="customCheck2"
                        >
                          Notify Client
                        </label>
                      </div>
                    </div>
                    <div
                      className="col-lg-12 no-padding-preview"
                      style={{
                        padding: 0,
                        cursor: "pointer",
                        color: "#0066cc",
                      }}
                      onClick={(e) => {
                        e.preventDefault();
                        this.preViewDefault();
                      }}
                    >
                      <span>Preview Notification Email </span>
                    </div>
                    <div className="col-lg-4">&nbsp;</div>
                    <div style={{ clear: "both" }}></div>
                    {/* <div className="form-group">
                        <label className="form-label" htmlFor="password">
                          Password
                        </label>
                        <div className="form-control-wrap">
                          <a
                            tabIndex="-1"
                            href="#"
                            className="form-icon form-icon-right passcode-switch"
                            data-target="password"
                          >
                            <em className="passcode-icon icon-show icon ni ni-eye"></em>
                            <em className="passcode-icon icon-hide icon ni ni-eye-off"></em>
                          </a>
                          <input
                            type="password"
                            className={
                              "form-control form-control-lg " +
                              this.state.errorPass
                            }
                            id="password"
                            name="password"
                            value={this.state.password}
                            onChange={this.handleChange}
                            placeholder="Enter your password"
                          />
                        </div>
                      </div> */}
                    <div className="col-lg-12 text-right">
                      <button
                        type="button"
                        className="btn btn-lg"
                        onClick={() => {
                          this.formUpdateClient();
                        }}
                        style={{
                          backgroundColor: THEME_COLOR,
                          color: THEME_TEXT_COLOR,
                          float: "right",
                        }}
                        disabled={this.state.disabled}
                      >
                        Update Profile
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal fade" tabIndex="-1" id="modalAlertResend">
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <a href="#" className="close" data-dismiss="modal">
                  <em className="icon ni ni-cross"></em>
                </a>
                <div className="modal-body modal-body-lg text-center">
                  <div className="nk-modal">
                    {this.state.activation_button === true ? (
                      <>
                        <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-check bg-warning"></em>
                        <h4 className="nk-modal-title">Sending!</h4>
                        <div className="nk-modal-text">
                          <div className="caption-text">
                            Please wait while we are processing your request
                          </div>
                          <span className="sub-text-sm"></span>
                        </div>
                        <div className="nk-modal-action"></div>
                      </>
                    ) : null}
                    {this.state.activation_tick === true ? (
                      <>
                        <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-check bg-success"></em>
                        <h4 className="nk-modal-title">Congratulations!</h4>
                        <div className="nk-modal-text">
                          <div className="caption-text">
                            Activation email has been sent successfully.
                          </div>
                          <span className="sub-text-sm"></span>
                        </div>
                        <div className="nk-modal-action"></div>
                      </>
                    ) : null}
                    {this.state.activation_cross === true ? (
                      <>
                        <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-cross bg-danger"></em>
                        <h4 className="nk-modal-title">Oops!</h4>
                        <div className="nk-modal-text">
                          <div className="caption-text">
                            There is some error while sending activation email.
                            Please try again later
                          </div>
                          <span className="sub-text-sm"></span>
                        </div>
                        <div className="nk-modal-action"></div>
                      </>
                    ) : null}
                  </div>
                </div>
                <div className="modal-footer bg-lighter">
                  <div className="text-center w-100">
                    <a
                      href="#"
                      className="btn btn-lg btn-mw btn-primary"
                      data-dismiss="modal"
                    >
                      Close
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Role Assignment Modal START */}
          <div className="modal fade" tabIndex="-1" id="modalAgentAssignRole">
            <div
              className="modal-dialog modal-xl modal-dialog-top"
              role="document"
            >
              <div className="modal-content">
                <div className="modal-header">
                  <div
                    className="modal-title"
                    style={{ textAlign: "center", fontSize: "20px" }}
                  >
                    <strong>
                      <em className="icon ni ni-grid-alt"></em>Client menu{" "}
                      <sup>
                        <small className="text-soft">
                          {this.state.rolesAgentName}
                        </small>
                      </sup>
                    </strong>
                  </div>
                  <a
                    href="#"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <em className="icon ni ni-cross"></em>
                  </a>
                </div>

                <div className="modal-body text-left">
                  <div className="nk-modal">
                    <div className="nk-modal-text">
                      {this.state.agentRoleLoader === true ? (
                        tableLoader()
                      ) : (
                        <>

                          <div className="card card-bordered card-preview">
                            <table className="table table-sm">
                              <thead className="tb-odr-head">
                                <tr className="tb-odr-item">
                                  <th
                                    width="35%"
                                    style={{
                                      borderRight: "1px solid #dbdfea",
                                    }}
                                  >
                                    <span className="tb-odr-action">
                                      Main Menu
                                    </span>
                                  </th>
                                  <th width="65%">
                                    <span className="tb-odr-action">
                                      Sub Menu
                                    </span>
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="tb-odr-body">
                                {this.state.allRoleData &&
                                this.state.allRoleData.length > 0 ? (
                                  <>
                                    {this.state.allRoleData.map(
                                      (role, index) => (
                                        <tr className="" key={`role${index}`}>
                                          <td
                                            style={{
                                              borderRight: "1px solid #dbdfea",
                                            }}
                                          >
                                            <FormControlLabel
                                              control={
                                                <Checkbox
                                                  checked={this.state.allRoleData.some(
                                                    (item) =>
                                                      item.alt === role.alt &&
                                                      item.isChecked,
                                                  )}
                                                  onChange={
                                                    this.changedAllRolesRights
                                                  }
                                                  disabled={
                                                    role.seqno === 1 &&
                                                    this.state.assignRoleData.some(
                                                      (subRole) =>
                                                        role.alt ===
                                                        subRole.alt,
                                                    )
                                                  }
                                                  name={role?.id?.toString()}
                                                  color="primary"
                                                />
                                              }
                                              style={{
                                                marginBottom: "0px",
                                              }}
                                              label={role.alt}
                                            />
                                          </td>
                                          <td
                                            style={{
                                              display: "flex",
                                              flexWrap: "wrap",
                                              paddingLeft: "16px",
                                            }}
                                          >
                                            {this.state.allSubRoleData
                                              .filter((subRole) => {
                                                return (
                                                  subRole.role_id === role.id
                                                );
                                              })
                                              .map((subRole, subIndex) => (
                                                <div key={`subRole${subIndex}`}>
                                                  <FormControlLabel
                                                    control={
                                                      <Checkbox
                                                        checked={this.state.allSubRoleData.some(
                                                          (item) =>
                                                            item.alt ===
                                                              subRole.alt &&
                                                            item.isChecked,
                                                        )}
                                                        onChange={
                                                          this
                                                            .changedAllSubRolesRights
                                                        }
                                                        name={subRole?.tabdetailid?.toString()}
                                                        color="primary"
                                                      />
                                                    }
                                                    style={{
                                                      marginBottom: "0px",
                                                    }}
                                                    label={subRole.alt}
                                                  />
                                                </div>
                                              ))}
                                          </td>
                                        </tr>
                                      ),
                                    )}
                                  </>
                                ) : null}
                              </tbody>
                            </table>
                          </div>
                          <div className="nk-modal-action  text-right">
                            {this.state.permissionsState &&
                            this.state.permissionsState.length > 0 &&
                            this.state.permission_edit_client_menu === 1 ? (
                              <a
                                href="#"
                                className="btn btn-lg btn-mw btn-primary "
                                onClick={() => {
                                  this.handleSubmitRoleCheckbox(
                                    this.state.checkedName,
                                    this.state.checkedEmail,
                                  );
                                }}
                                disabled={this.state.disableRoleBtn}
                              >
                                Save Changes
                              </a>
                            ) : null}
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Role Assignment Modal End */}
          {/**** Open Signee Details Modal ***/}
          <div className="modal fade" tabIndex="-1" id="modalOpenSignee">
            <div
              className="modal-dialog modal-xl modal-dialog-top"
              role="document"
            >
              <div className="modal-content">
                <a
                  href="#"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <em className="icon ni ni-cross"></em>
                </a>
                <div className="modal-header">
                  <h5 className="modal-title">Signee Details</h5>
                </div>
                <div className="modal-body">
                  <div className="g-4">
                    <div id="no-more-tables-new">
                      <table className="table table-bordered">
                        <thead className="thead-light">
                          <tr>
                            <th className="tb-col-os">
                              <span className="overline-title">Name</span>
                            </th>
                            <th className="tb-col-os">
                              <span className="overline-title">Email</span>
                            </th>
                            <th className="tb-col-os">
                              <span className="overline-title">Title</span>
                            </th>
                            <th className="tb-col-ip">
                              <span className="overline-title">
                                Signed Date
                              </span>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.signee_details &&
                          this.state.signee_details.length > 0 ? (
                            <>
                              {this.state.signee_details.map(
                                (details, index) => (
                                  <tr key={`idx${index}`}>
                                    <td className="tb-col-os">
                                      {details.signee_name}
                                    </td>
                                    <td className="tb-col-os">
                                      {details.signee_email}
                                    </td>
                                    <td className="tb-col-os">
                                      {details.signee_title &&
                                      details.signee_title !== ""
                                        ? details.signee_title
                                        : "---"}
                                    </td>
                                    <td className="tb-col-ip">
                                      {details.signed_date &&
                                      details.signed_date !== ""
                                        ? this.format_date(details.signed_date)
                                        : "---"}
                                    </td>
                                  </tr>
                                ),
                              )}
                            </>
                          ) : (
                            <tr>
                              <td className="tb-col-os" colSpan={4}>
                                <strong className="text-danger">
                                  Record not found
                                </strong>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/**** Open Signee Details Modal ***/}
          {/* PREVIEW DEFAULT MODAL  */}
          <div
            className="modal fade"
            tabIndex="-1"
            id="modalPreviewDefaultModal"
            style={{ zIndex: "9999" }}
          >
            <div
              className="modal-dialog modal-dialog-top modal-xl"
              role="document"
            >
              <div className="modal-content">
                <div
                  className="modal-header"
                  style={{ borderBottom: "1px solid #e5e9f2" }}
                >
                  <h5
                    className="modal-title"
                    style={{
                      fontFamily: "'DM Sans', sans-serif",
                      fontWeight: "700",
                      fontSize: "1.25rem",
                      color: "#364a63",
                    }}
                  >
                    Preview Notification Email
                  </h5>
                  <a
                    style={{ cursor: "pointer" }}
                    className="close"
                    onClick={() => this.closePreviewModal()}
                  >
                    <em className="icon ni ni-cross"></em>
                  </a>
                </div>
                <div className="modal-body" style={{ padding: "1.5rem" }}>
                  <div className="nk-block">
                    <div className="card card-bordered">
                      <div className="card-inner">
                        <div
                          className="email-preview"
                          style={{
                            maxHeight: "60vh",
                            overflow: "auto",
                            padding: "1rem",
                            backgroundColor: "#f5f6fa",
                            borderRadius: "4px",
                          }}
                        >
                          {this.state.isEditorReady ? (
                            <div
                              className="email-preview-content"
                              style={{
                                fontFamily: "'Roboto', sans-serif",
                                fontSize: "14px",
                                lineHeight: "1.65",
                                pointerEvents: "none",
                                userSelect: "none",
                              }}
                              dangerouslySetInnerHTML={{
                                __html: this.state.email_template,
                              }}
                            />
                          ) : (
                            tableLoader()
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="modal-footer"
                  style={{
                    borderTop: "1px solid #e5e9f2",
                    padding: "1rem 1.5rem",
                  }}
                >
                  <button
                    onClick={() => this.closePreviewModal()}
                    className="btn btn-primary"
                    style={{
                      fontFamily: "'DM Sans', sans-serif",
                      fontWeight: "500",
                    }}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* PREVIEW DEFAULT MODAL  */}
          {/**** Open Contract Modal ***/}
          <div
            className="modal fade"
            tabIndex="-1"
            id="modalOpenUploadContract"
          >
            <div
              className="modal-dialog modal-xl modal-dialog-top"
              role="document"
            >
              <div className="modal-content">
                <a
                  href="#"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <em className="icon ni ni-cross"></em>
                </a>
                <div className="modal-header">
                  <h5 className="modal-title">Upload Agreement</h5>
                </div>
                <div className="modal-body">
                  <div className="row g-gs">
                    <div className="col-md-12 mb-3">

                      <div
                        className="col-md-12 mb-2"
                        style={{ marginBottom: "20px", clear: "both" }}
                      >
                        <div className="form-group">
                          <div className="form-label-group">
                            <label className="form-label">
                              <Tooltip
                                title="Upload agreement directly."
                                placement="right"
                              >
                                <em
                                  className="icon ni ni-info"
                                  style={{
                                    color: "#6576ff",
                                  }}
                                ></em>
                              </Tooltip>{" "}
                              Upload Agreement <sup>*</sup>
                              <span className="text-danger"></span>
                            </label>
                          </div>
                          <div className="form-control-group signatory_upload mb-4">
                            <div className="custom-file">
                              <input
                                type="file"
                                className="custom-file-input"
                                id="add_picture"
                                name="add_picture"
                                defaultValue={this.state.add_picture}
                                accept=".png, .jpg, .jpeg, .doc, .docx, .pdf, .txt, .rtf, .zip"
                                onChange={this.handleFileChange}
                              autoComplete="new-password" />
                              <label
                                className="custom-file-label"
                                for="add_picture"
                              >
                                Choose file
                              </label>
                            </div>
                          </div>
                          <div className="form-note">
                            {this.state.add_picture_name}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12 mt-5">
                        <div className="example-alert">
                          <div className="alert alert-light">
                            <ul className="list">
                              <li>
                                Accepted Formats: PDF, DOC, DOCX, ZIP, TXT, RTF,
                                PNG, JPEG, JPG
                              </li>
                              <li>Recommended Size: 10MB</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="modal-footer"
                  style={{ justifyContent: "right" }}
                >
                  <div className="d-flex justify-content-end">
                    {this.state.upload_agreement_button === true ? (
                      <button className="btn btn-lg btn-primary" disabled>
                        <em className="icon ni ni-swap"></em> Saving
                        <div
                          className="spinner-grow spinner-grow-sm"
                          role="status"
                        >
                          <span className="sr-only">Loading...</span>
                        </div>
                      </button>
                    ) : (
                      <button
                        type="button"
                        className="btn btn-lg btn-primary"
                        onClick={() => this.submitClientContract()}
                      >
                        Save Agreement
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/**** Open Contract Modal ***/}
          {this.state.showLoginModal && (
            <div
              className="modal fade show"
              tabIndex="-1"
              id="modalDefaultLogin"
              style={{ display: "block" }}
              role="dialog"
            >
              <div
                className="modal-dialog modal-dialog-top modal-xl"
                role="document"
              >
                <div className="modal-content">
                  <a
                    onClick={() => this.closeLoginModal()}
                    className="close"
                    style={{ cursor: "pointer" }}
                    aria-label="Close"
                  >
                    <em className="icon ni ni-cross"></em>
                  </a>
                  <div className="modal-header">
                    <h5 className="modal-title">
                      <em
                        className="icon ni ni-signin"
                        style={{ marginRight: "15px" }}
                      ></em>{" "}
                      Login to the Client
                    </h5>
                  </div>
                  <div className="modal-body">
                    {this.state.loginErrorMessage === "" ? (
                      <div className="alert alert-pro alert-primary">
                        <div className="alert-text">
                          <h6>Connecting.....</h6>
                          <p>
                            Please wait while we are connecting to the client
                            Login. You will be redirected to the Client
                            dashboard after the authentication.
                          </p>
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          )}
          {this.state.showLoginModal && (
            <div className="modal-backdrop fade show"></div>
          )}
          {/* View Archived Details */}
          <div
            className="modal fade zoom"
            tabIndex="-1"
            id="modalArchivedDetails"
          >
            <div
              className="modal-dialog modal-xl modal-dialog-top"
              role="document"
            >
              <div className="modal-content">
                <div className="modal-header">
                  <div
                    className="modal-title"
                    style={{ textAlign: "center", fontSize: "20px" }}
                  >
                    <strong>
                      <em className="icon ni ni-list-round"></em> Agreement
                      Details <sup></sup>
                    </strong>
                  </div>
                  <a
                    href="#"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <em className="icon ni ni-cross"></em>
                  </a>
                </div>

                <div className="modal-body">
                  {/* NRC DIVS START */}

                  {this.state.viewLoader === true ? (
                    FormLoader()
                  ) : (
                    <>
                      <div>
                        <div className="card card-bordered">
                          <div className="card-inner-group">
                            {this.state.archivedAgreementsDetails &&
                            this.state.archivedAgreementsDetails.length > 0 ? (
                              <div className="card-inner">
                                <div className="sp-plan-head">
                                  <h6 className="title">Agreement Details</h6>
                                </div>
                                <div className="sp-plan-desc sp-plan-desc-mb">
                                  <table className="table table-bordered table-striped">
                                    {this.state.archivedAgreementsDetails.map(
                                      (general, index) => (
                                        <tbody
                                          key={index}
                                          className="text-dark"
                                        >
                                          <tr>
                                            <td>Agreement Name</td>
                                            <td>{general.agreement_title}</td>
                                          </tr>
                                          <tr>
                                            <td>Archived Date</td>
                                            <td>
                                              {this.format_date(
                                                general.archived_date,
                                              )}
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>Approved Date</td>
                                            <td>
                                              {this.format_date(
                                                general.approved_date,
                                              )}
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>Document Uploaded</td>
                                            <td>
                                              {general.is_uploaded &&
                                              general.is_uploaded === "Yes"
                                                ? "Document Uploaded"
                                                : "---"}
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>Signee name</td>
                                            <td>{general.signee_name}</td>
                                          </tr>
                                          <tr>
                                            <td>Signee Email</td>
                                            <td>
                                              {general.signee_email &&
                                              general.signee_email !== ""
                                                ? general.signee_email
                                                : "---"}
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>Signee Title</td>
                                            <td>
                                              {general.signee_title &&
                                              general.signee_title !== ""
                                                ? general.signee_title
                                                : "---"}
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>Reason</td>
                                            <td>{general.revoke_reason}</td>
                                          </tr>
                                        </tbody>
                                      ),
                                    )}
                                  </table>
                                </div>
                              </div>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
          {/* View Archived Details */}
          {/* DELETE ARCHIVE */}
          <div className="modal fade" tabIndex="-1" id="modalDeleteAlert">
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <a
                  style={{ cursor: "pointer" }}
                  className="close"
                  onClick={() => {
                    this.modalHideDel();
                  }}
                >
                  <em className="icon ni ni-cross"></em>
                </a>
                <div className="modal-body modal-body-lg text-center">
                  <div className="nk-modal">
                    <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-trash bg-success"></em>
                    <h4 className="nk-modal-title">
                      Delete archived agreement?
                    </h4>
                    <div className="nk-modal-text">
                      <div className="caption-text">
                        Are you sure you want to delete this archived agreement?
                      </div>
                    </div>
                    <div className="nk-modal-action">
                      <a
                        style={{ cursor: "pointer" }}
                        className="btn btn-lg btn-mw btn-primary"
                        onClick={() => {
                          this.modalHideDel();
                        }}
                        disabled={this.state.disabled}
                      >
                        CANCEL
                      </a>
                      {"  "}
                      <a
                        style={{ cursor: "pointer" }}
                        className="btn btn-lg btn-mw btn-danger"
                        onClick={() => {
                          this.delete_archived_agreement();
                        }}
                        disabled={this.state.disabled}
                      >
                        DELETE
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* DELETE ARCHIVE */}
          {/* Remove Contract */}
          <div className="modal fade" tabIndex="-1" id="modalRemoveContract">
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <a
                  style={{ cursor: "pointer" }}
                  className="close"
                  onClick={() => {
                    this.modalHideRemove();
                  }}
                >
                  <em className="icon ni ni-cross"></em>
                </a>
                <div className="modal-body modal-body-lg text-center">
                  <div className="nk-modal">
                    <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-trash bg-success"></em>
                    <h4 className="nk-modal-title">Remove agreement?</h4>
                    <div className="nk-modal-text">
                      <div className="caption-text">
                        Are you sure you want to delete this agreement?
                      </div>
                    </div>
                    <div className="nk-modal-action">
                      {this.state.remove_agreement_button === true ? (
                        <button
                          className="btn btn-lg btn-primary"
                          type="button"
                          disabled
                        >
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          <span> Loading... </span>
                        </button>
                      ) : (
                        <>
                          <a
                            style={{ cursor: "pointer" }}
                            className="btn btn-lg btn-mw btn-primary"
                            onClick={() => {
                              this.modalHideRemove();
                            }}
                            disabled={this.state.disabled}
                          >
                            CANCEL
                          </a>
                          {"  "}
                          <a
                            style={{ cursor: "pointer" }}
                            className="btn btn-lg btn-mw btn-danger"
                            onClick={() => {
                              this.remove_agreement();
                            }}
                            disabled={this.state.disabled}
                          >
                            REMOVE
                          </a>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Remove Contract */}
          {/* View Client Submissions */}
          <div
            className="modal fade zoom"
            tabIndex="-1"
            id="modalClientSubmission"
          >
            <div
              className="modal-dialog modal-xl modal-dialog-top"
              role="document"
            >
              <div className="modal-content">
                <div className="modal-header">
                  <div
                    className="modal-title"
                    style={{ textAlign: "center", fontSize: "20px" }}
                  >
                    <strong>
                      <em className="icon ni ni-list-round"></em> Submission
                      Details{" "}
                    </strong>
                  </div>
                  <a
                    href="#"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <em className="icon ni ni-cross"></em>
                  </a>
                </div>

                <div className="modal-body">
                  {/* NRC DIVS START */}

                  {this.state.viewLoader === true ? (
                    FormLoader()
                  ) : (
                    <>
                      <div>
                        <div className="card card-bordered">
                          <div className="card-inner-group">
                            {this.state.viewClientSubmissions &&
                            this.state.viewClientSubmissions.length > 0 ? (
                              <div className="card-inner">
                                <div className="sp-plan-head">
                                  <h6 className="title">
                                    Form Submission Details
                                  </h6>
                                </div>

                                <div className="sp-plan-desc sp-plan-desc-mb">
                                  <table className="table table-bordered table-striped">
                                    {this.state.viewClientSubmissions.map(
                                      (general, index) => (
                                        <tbody
                                          key={index}
                                          className="text-dark"
                                        >
                                          <tr>
                                            <td>Progress</td>
                                            <td>
                                              <div className="card card-bordered card-preview">
                                                <div className="card-inner viewClient_card-inner_customStyle">
                                                  <div className="progress progress-lg">
                                                    <div
                                                      className="progress-bar"
                                                      data-progress={
                                                        this.state
                                                          .progressPercentage
                                                      }
                                                      style={{
                                                        width: `${this.state.progressPercentage}%`,
                                                      }}
                                                    >
                                                      {
                                                        this.state
                                                          .progressPercentage
                                                      }
                                                      %
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>Sent To Name</td>
                                            <td>{general.submitter_name}</td>
                                          </tr>
                                          <tr>
                                            <td>Sent To Email</td>
                                            <td>{general.submitter_email}</td>
                                          </tr>
                                          <tr>
                                            <td>Sent By</td>
                                            <td>{general.sent_by_email}</td>
                                          </tr>
                                          <tr>
                                            <td>Sent Date</td>
                                            <td>
                                              {this.format_date(
                                                general.sent_on,
                                              )}
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>Submitted</td>
                                            <td>
                                              {general.is_submitted &&
                                              general.is_submitted === 1 ? (
                                                <span className="badge badge-dot badge-success">
                                                  Yes
                                                </span>
                                              ) : (
                                                <span className="badge badge-dot badge-danger">
                                                  No
                                                </span>
                                              )}
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>Submission Date</td>
                                            <td>
                                              {general.is_submitted &&
                                              general.is_submitted === 1
                                                ? this.format_date(
                                                    general.submitted_on,
                                                  )
                                                : "---"}
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>View PDF</td>
                                            <td>
                                              {general.is_submitted &&
                                              general.is_submitted === 1 ? (
                                                <a
                                                  style={{
                                                    cursor: "pointer",
                                                  }}
                                                  onClick={() =>
                                                    this.downloadPdfClient(
                                                      general.pdf_name,
                                                    )
                                                  }
                                                >
                                                  <span className="badge badge-outline-dark">
                                                    View
                                                  </span>
                                                </a>
                                              ) : (
                                                "---"
                                              )}
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>Extra Files</td>
                                            <td>
                                              {this.state.extra_files_clients &&
                                              this.state.extra_files_clients !==
                                                "" ? (
                                                <>
                                                  {this.state.extra_files_clients.map(
                                                    (file, index) => (
                                                      <>
                                                        {file.file_name &&
                                                        file.file_name !==
                                                          "" ? (
                                                          <div
                                                            key={index}
                                                            className="col-md-12"
                                                            style={{
                                                              paddingLeft:
                                                                "0px",
                                                            }}
                                                          >
                                                            {file.field_name.trim()}{" "}
                                                            <span
                                                              onClick={() =>
                                                                this.downloadPdfClient(
                                                                  file.file_name.trim(),
                                                                )
                                                              }
                                                              className="badge badge-outline-primary"
                                                              style={{
                                                                cursor:
                                                                  "pointer",
                                                              }}
                                                              title="Download / View"
                                                            >
                                                              <em className="icon ni ni-download"></em>{" "}
                                                              {file.file_name.trim()}
                                                            </span>
                                                          </div>
                                                        ) : null}
                                                      </>
                                                    ),
                                                  )}
                                                </>
                                              ) : (
                                                "---"
                                              )}
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>Sent Form Subject</td>
                                            <td>{general.email_subject}</td>
                                          </tr>
                                          <tr>
                                            <td>Sent Form Message</td>
                                            <td>{general.email_content}</td>
                                          </tr>
                                        </tbody>
                                      ),
                                    )}
                                  </table>
                                </div>
                              </div>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
          {/* View Client Submissions */}
          {/* View Client Submissions */}
          <div
            className="modal fade zoom"
            tabIndex="-1"
            id="modalClientArchivedSubmission"
          >
            <div
              className="modal-dialog modal-xl modal-dialog-top"
              role="document"
            >
              <div className="modal-content">
                <div className="modal-header">
                  <div
                    className="modal-title"
                    style={{ textAlign: "center", fontSize: "20px" }}
                  >
                    <strong>
                      <em className="icon ni ni-list-round"></em> Archived
                      Submission Details{" "}
                    </strong>
                  </div>
                  <a
                    href="#"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <em className="icon ni ni-cross"></em>
                  </a>
                </div>

                <div className="modal-body">
                  {/* NRC DIVS START */}

                  {this.state.viewLoader === true ? (
                    FormLoader()
                  ) : (
                    <>
                      <div>
                        <div className="card card-bordered">
                          <div className="card-inner-group">
                            <div className="card-inner">
                              <div className="sp-plan-head">
                                <h6 className="title">
                                  Form Submission Details
                                </h6>
                              </div>

                              <div className="sp-plan-desc sp-plan-desc-mb">
                                <table className="table table-bordered table-striped">
                                  <tbody key="arch1" className="text-dark">
                                    <tr>
                                      <td>Form Title</td>
                                      <td>{this.state.form_title}</td>
                                    </tr>
                                    <tr>
                                      <td>Archive Date</td>
                                      <td>
                                        {this.state.archive_date &&
                                        this.state.archive_date !== ""
                                          ? this.format_date(
                                              this.state.archive_date,
                                            )
                                          : "---"}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* View Client Submissions */}
          {/* Remove Service Contract */}
          <div
            className="modal fade"
            tabIndex="-1"
            id="modalRemoveServiceContract"
          >
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <a
                  style={{ cursor: "pointer" }}
                  className="close"
                  onClick={() => {
                    this.modalHideRemoveService();
                  }}
                >
                  <em className="icon ni ni-cross"></em>
                </a>
                <div className="modal-body modal-body-lg text-center">
                  <div className="nk-modal">
                    <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-trash bg-success"></em>
                    <h4 className="nk-modal-title">Remove agreement?</h4>
                    <div className="nk-modal-text">
                      
                      
                      <div className="caption-text">
                        Are you sure you want to remove this agreement?
                      </div>
                    </div>
                    <div className="nk-modal-action">
                      {this.state.remove_agreement_button === true ? (
                        <button
                          className="btn btn-lg btn-primary"
                          type="button"
                          disabled
                        >
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          <span> Loading... </span>
                        </button>
                      ) : (
                        <>
                          <a
                            style={{ cursor: "pointer" }}
                            className="btn btn-lg btn-mw btn-primary"
                            onClick={() => {
                              this.modalHideRemoveService();
                            }}
                            disabled={this.state.disabled}
                          >
                            CANCEL
                          </a>
                          {"  "}
                          <a
                            style={{ cursor: "pointer" }}
                            className="btn btn-lg btn-mw btn-danger"
                            onClick={() => {
                              this.remove_service_agreement();
                            }}
                            disabled={this.state.disabled}
                          >
                            REMOVE
                          </a>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Remove Service Contract */}
          {/* Add Service Contract */}
          <div
            className="modal fade"
            tabIndex="-1"
            id="modalAddServiceContract"
          >
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <a
                  style={{ cursor: "pointer" }}
                  className="close"
                  onClick={() => {
                    this.modalHideAddService();
                  }}
                >
                  <em className="icon ni ni-cross"></em>
                </a>
                <div className="modal-body modal-body-lg text-center">
                  <div className="nk-modal">
                    <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-file-doc bg-success"></em>
                    <h4 className="nk-modal-title">Add agreement?</h4>
                    <div className="nk-modal-text">
                      
                      
                      <div className="caption-text">
                        {this.state.add_service_text}
                        {this.state.editLink === "Yes" ? (
                          <>
                            No agreement assigned to this product.
                            <a
                              href={`${APP_URL}services/Editservice/${this.state.selected_service_id}`}
                            >
                              <strong>Click here</strong>{" "}
                            </a>
                            to assign agreement to the product.
                          </>
                        ) : null}
                      </div>
                    </div>
                    <div className="nk-modal-action">
                      {this.state.add_agreement_button === true ? (
                        <button
                          className="btn btn-lg btn-primary"
                          type="button"
                          disabled
                        >
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          <span> Loading... </span>
                        </button>
                      ) : (
                        <>
                          <a
                            style={{ cursor: "pointer" }}
                            className="btn btn-lg btn-mw btn-primary"
                            onClick={() => {
                              this.modalHideAddService();
                            }}
                            disabled={this.state.disabled}
                          >
                            CANCEL
                          </a>
                          {"  "}
                          {this.state.show_add_button === true ? (
                            <a
                              style={{ cursor: "pointer" }}
                              className="btn btn-lg btn-mw btn-success"
                              onClick={() => {
                                this.add_service_agreement();
                              }}
                              disabled={this.state.disabled}
                            >
                              ADD
                            </a>
                          ) : null}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Add Service Contract */}
          {/* START CLIENT REJECTIONS MODAL */}
          <div className="modal fade" tabIndex="-1" id="modalRejectionClients">
            <div
              className="modal-dialog modal-dialog-top modal-xl"
              role="document"
            >
              <div className="modal-content">
                <a
                  href="#"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <em className="icon ni ni-cross"></em>
                </a>
                <div className="modal-header">
                  <h5 className="modal-title">
                    All Rejections{" "} <small className='text-muted'>- {this.state.form_title}</small>
                  </h5>
                </div>
                <div className="modal-body">
                  <div id="revokeReasonItems">
                    {this.state.rejectionLoader === true ? (
                      FormLoader()
                    ) : (
                      <>
                        <div>
                          <div className="card card-bordered">
                            <div className="card-inner-group">
                              {this.state.allClientRejectionsListing &&
                              this.state.allClientRejectionsListing.length >
                                0 ? (
                                <div className="card-inner">
                                  <div className="sp-plan-head">
                                    <h6 className="title">All Rejections</h6>
                                  </div>
                                  <div className="sp-plan-desc sp-plan-desc-mb">
                                    <table className="table table-bordered table-striped">
                                      <thead>
                                        <th>Form Title</th>
                                        <th>Rejection date</th>
                                        <th>Reason</th>
                                        <th>Submitted PDF</th>
                                      </thead>
                                      {this.state.allClientRejectionsListing.map(
                                        (general, index) => (
                                          <tbody
                                            key={`ind${index}`}
                                            className="text-dark"
                                          >
                                            <tr>
                                              <td>{this.state.form_title}</td>
                                              <td>
                                                {this.format_date(
                                                  general.rejection_date,
                                                )}
                                              </td>
                                              <td>
                                                {general.rejection_reason}
                                              </td>
                                              <td>
                                                {general.is_submitted &&
                                                general.is_submitted === 1 ? (
                                                  <a
                                                    style={{
                                                      cursor: "pointer",
                                                    }}
                                                    onClick={() =>
                                                      this.downloadPdfClient(
                                                        general.pdf_name,
                                                      )
                                                    }
                                                  >
                                                    <span className="badge badge-outline-dark">
                                                      View
                                                    </span>
                                                  </a>
                                                ) : (
                                                  "---"
                                                )}
                                              </td>
                                            </tr>
                                          </tbody>
                                        ),
                                      )}
                                    </table>
                                  </div>
                                </div>
                              ) : (
                                <div className="alert alert-pro alert-primary">
                                  <div className="alert-text">
                                    <h6>No Rejection</h6>
                                    <p>
                                      Rejections are not available against this
                                      submission.
                                    </p>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* END REJECTIONS CLIENT MODAL */}

          {/* START APPROVE Client MODAL  */}
          <div
            className="modal fade"
            tabIndex="-1"
            id="modalApproveClientAlert"
          >
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <a
                  style={{ cursor: "pointer" }}
                  className="close"
                  onClick={() => {
                    this.modalHideAlll("modalApproveClientAlert");
                  }}
                >
                  <em className="icon ni ni-cross"></em>
                </a>
                <div className="modal-body modal-body-lg text-center">
                  <div className="nk-modal">
                    <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-done bg-success"></em>

                    <h4 className="nk-modal-title">Approve Submission?</h4>

                    <div className="nk-modal-text">
                      
                      

                      <div className="caption-text">
                        Are you sure you want to approve this submission
                      </div>

                      <div style={{ marginTop: "20px", textAlign: "left", marginBottom: "20px" }}>
                        <label style={{ fontWeight: "600", marginBottom: "10px", display: "block", fontSize: "14px", color: "#333" }}>
                          Approval Notes (Optional)
                        </label>
                        <TextareaAutosize
                          rowsMin={3}
                          placeholder="Enter approval notes..."
                          value={this.state.approvalNotes}
                          onChange={this.handleApprovalNotesChange}
                          style={{
                            width: "100%",
                            padding: "12px",
                            borderRadius: "4px",
                            border: this.state.approvalNotesError ? "1px solid #dc3545" : "1px solid #e0e0e0",
                            fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                            fontSize: "13px",
                            lineHeight: "1.5",
                            boxSizing: "border-box",
                            resize: "vertical",
                            backgroundColor: "#fff",
                            color: "#333",
                            height: "100px",
                            transition: "border-color 0.2s"
                          }}
                        />
                        {this.state.approvalNotesError && (
                          <div style={{ color: "#dc3545", fontSize: "12px", marginTop: "6px" }}>
                            {this.state.approvalNotesError}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="nk-modal-action">
                      {this.state.approve_client_button ? (
                        <button
                          className="btn btn-lg btn-primary"
                          type="button"
                          disabled
                        >
                          <span
                            className="spinner-grow spinner-grow-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          <span> Processing... </span>
                        </button>
                      ) : (
                        <>
                          <a
                            style={{ cursor: "pointer" }}
                            className="btn btn-lg btn-dim btn-outline-light"
                            onClick={() => {
                              this.modalHideAlll("modalApproveClientAlert");
                            }}
                          >
                            <em className="icon ni ni-cross-round"></em>{" "}
                            <span>Cancel</span>
                          </a>
                          {"  "}
                          <a
                            style={{ cursor: "pointer" }}
                            className="btn btn-lg btn-mw btn-primary"
                            onClick={() => {
                              this.approve_client_form();
                            }}
                            disabled={
                              this.state.disabled || this.state.isProcessing
                            } // disable button when processing
                          >
                            <em className="icon ni ni-done"></em>{" "}
                            <span>Approve</span>
                          </a>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* END APPROVE CLIENT MODAL  */}

          {/* START APPROVE Client Main MODAL  */}
          <div
            className="modal fade"
            tabIndex="-1"
            id="modalApproveClientMainAlert"
          >
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <a
                  style={{ cursor: "pointer" }}
                  className="close"
                  onClick={() => {
                    this.modalHideAlll("modalApproveClientMainAlert");
                  }}
                >
                  <em className="icon ni ni-cross"></em>
                </a>
                <div className="modal-body modal-body-lg text-center">
                  <div className="nk-modal">
                    <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-done bg-success"></em>

                    <h4 className="nk-modal-title">
                      Approve / Reject Client 499 Filer ID ?
                    </h4>

                    <div className="nk-modal-text">
                      
                      
                      
                      

                      <div className="caption-text">
                        {`Approve / Reject FCC 499 Filer ID `}
                        <strong>{this.state.filer_id}</strong>
                        {` for `}
                        <br />
                        <strong>{this.state.client_comp_name}</strong>
                        {` (`}
                        <strong>{this.state.client_update_email}</strong>
                        {`)`}
                        <br />
                      </div>

                      {this.state.showRejectReasonField && (
                        <div
                          className="form-group"
                          style={{ marginTop: "20px", textAlign: "left" }}
                        >
                          <label className="form-label" htmlFor="reject-reason">
                            Rejection Reason{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <div className="form-control-wrap">
                            <textarea
                              className="form-control"
                              id="reject-reason"
                              rows="4"
                              placeholder="Enter rejection reason..."
                              value={this.state.rejectClientReason}
                              onChange={this.handleRejectReasonChange}
                              disabled={this.state.rejectClientButtonLoading}
                            ></textarea>
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="nk-modal-action">
                      {this.state.rejectClientButtonLoading ? (
                        <button
                          className="btn btn-lg btn-danger"
                          type="button"
                          disabled
                        >
                          <span
                            className="spinner-grow spinner-grow-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          <span> Processing... </span>
                        </button>
                      ) : this.state.approveClientButtonLoading ? (
                        <button
                          className="btn btn-lg btn-primary"
                          type="button"
                          disabled
                        >
                          <span
                            className="spinner-grow spinner-grow-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          <span> Processing... </span>
                        </button>
                      ) : (
                        <>
                          {this.state.showRejectReasonField ? (
                            <button
                              style={{ cursor: "pointer" }}
                              className="btn btn-lg btn-mw btn-danger"
                              onClick={() => {
                                this.reject_client_main();
                              }}
                              disabled={!this.state.filer_id}
                            >
                              <em className="icon ni ni-cross"></em>{" "}
                              <span>Confirm Rejection</span>
                            </button>
                          ) : (
                            <>
                              <button
                                style={{ cursor: "pointer" }}
                                className="btn btn-lg btn-mw btn-danger"
                                onClick={() => {
                                  this.showRejectReasonField();
                                }}
                                disabled={
                                  !this.state.filer_id ||
                                  this.state
                                    .approveClientModalSuccessMessage !== ""
                                }
                              >
                                <em className="icon ni ni-cross"></em>{" "}
                                <span>Reject</span>
                              </button>
                              {"  "}
                              <button
                                style={{ cursor: "pointer" }}
                                className="btn btn-lg btn-mw btn-primary"
                                onClick={() => {
                                  this.approve_client_main();
                                }}
                                disabled={
                                  !this.state.filer_id ||
                                  this.state
                                    .approveClientModalSuccessMessage !== ""
                                }
                              >
                                <em className="icon ni ni-done"></em>{" "}
                                <span>Approve</span>
                              </button>
                            </>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* END APPROVE CLIENT MAIN MODAL  */}

          {this.state.showAddCreditModal ? (
          <div
            className="modal fade show"
            style={{ display: "block", background: "rgba(0,0,0,0.45)" }}
            tabIndex="-1"
            role="dialog"
            onClick={(e) => { if (e.target === e.currentTarget) this.closeAddCreditModal(); }}
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <a
                  style={{ cursor: "pointer" }}
                  className="close"
                  onClick={() => this.closeAddCreditModal()}
                >
                  <em className="icon ni ni-cross"></em>
                </a>
                <div className="modal-body modal-body-md">
                  <h5 className="title">Load Client Credit</h5>
                  <div className="text-soft" style={{ fontSize: "13px", marginBottom: "14px" }}>
                    Add a credit balance for this client.
                  </div>


                  <div className="row g-2 mb-3">
                    <div className="col-sm-6">
                      <div className="form-group" style={{ marginBottom: 0 }}>
                        <label className="form-label">
                          Credit Amount (USD) <span className="text-danger">*</span>
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          name="addCreditAmount"
                          value={this.state.addCreditAmount}
                          onChange={this.handleCreditFieldChange}
                          min="0"
                          step="any"
                          placeholder="0.00"
                          disabled={this.state.addCreditLoading}
                        />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="form-group" style={{ marginBottom: 0 }}>
                        <label className="form-label">
                          Date <span className="text-danger">*</span>
                        </label>
                        <input
                          type="date"
                          className="form-control"
                          name="addCreditDate"
                          value={this.state.addCreditDate}
                          onChange={this.handleCreditFieldChange}
                          disabled={this.state.addCreditLoading}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="form-group" style={{ marginTop: "1rem" }}>
                    <label className="form-label">Payment Method</label>
                    <select
                      className="form-control"
                      name="addCreditPaymentMethod"
                      value={this.state.addCreditPaymentMethod}
                      onChange={this.handleCreditFieldChange}
                      disabled={this.state.addCreditLoading}
                    >
                      <option>Bank ACH</option>
                      <option>Wire Transfer</option>
                      <option>Credit Card</option>
                      <option>Check</option>
                      <option>Other</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <label className="form-label">Reference / Note</label>
                    <input
                      type="text"
                      className="form-control"
                      name="addCreditReference"
                      placeholder="e.g. Wire transfer ref #1234, Check #5678…"
                      maxLength="500"
                      value={this.state.addCreditReference}
                      onChange={this.handleCreditFieldChange}
                      disabled={this.state.addCreditLoading}
                    />
                  </div>

                  <div className="form-group">
                    <label className="form-label">Internal Memo (optional)</label>
                    <textarea
                      className="form-control"
                      name="addCreditMemo"
                      rows="2"
                      placeholder="Internal notes about this credit load…"
                      maxLength="1000"
                      style={{ resize: "none" }}
                      value={this.state.addCreditMemo}
                      onChange={this.handleCreditFieldChange}
                      disabled={this.state.addCreditLoading}
                    />
                  </div>

                  <div className="form-group">
                    <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: "16px" }}>
                      <a
                        href="#cancel"
                        onClick={(e) => { e.preventDefault(); this.closeAddCreditModal(); }}
                        className="link link-light"
                      >
                        Cancel
                      </a>
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={this.submitAddCredit}
                        disabled={this.state.addCreditLoading}
                      >
                        {this.state.addCreditLoading ? (
                          <span>
                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                            <span> Saving…</span>
                          </span>
                        ) : (
                          <span>Load Credit</span>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          ) : null}

          {this.state.showLedgerModal ? (
          <div
            className="modal fade show"
            style={{ display: "block", background: "rgba(0,0,0,0.45)" }}
            tabIndex="-1"
            role="dialog"
            onClick={(e) => { if (e.target === e.currentTarget) this.closeLedgerModal(); }}
          >
            <div className="modal-dialog modal-xl modal-dialog-centered" role="document">
              <div className="modal-content">
                <a
                  style={{ cursor: "pointer" }}
                  className="close"
                  onClick={() => this.closeLedgerModal()}
                >
                  <em className="icon ni ni-cross"></em>
                </a>
                <div className="modal-body" style={{ padding: 0 }}>
                  {/* Header */}
                  <div style={{ padding: "20px 24px 12px" }}>
                    <h5 className="title" style={{ marginBottom: "2px" }}>
                      Credit Ledger
                      {this.state.client_name ? ` — ${this.state.client_name}` : ""}
                    </h5>
                    <div className="text-soft" style={{ fontSize: "13px" }}>
                      {this.state.client_comp_name ? `${this.state.client_comp_name} · ` : ""}
                      Current Balance:{" "}
                      <strong style={{ color: Number(this.state.creditSummary && this.state.creditSummary.balance) > 0 ? "#1c5bde" : "#9a9690" }}>
                        ${this.formatCreditAmount(this.state.creditSummary && this.state.creditSummary.balance)}
                      </strong>
                    </div>
                  </div>


                  {/* Summary strip — computed inline from ledgerRows */}
                  {(() => {
                    const chronoRows = [...(this.state.ledgerRows || [])].reverse();
                    let totalCredits = 0;
                    let totalDebits = 0;
                    chronoRows.forEach((r) => {
                      const amt = Number(r.amount) || 0;
                      if (amt > 0) totalCredits += amt;
                      else totalDebits += Math.abs(amt);
                    });
                    const currentBalance = Number(
                      this.state.creditSummary && this.state.creditSummary.balance
                    ) || 0;

                    let running = 0;
                    const displayRows = chronoRows.map((r) => {
                      running += Number(r.amount) || 0;
                      return { ...r, runningBalance: running };
                    });
                    const openingBalance = currentBalance - running;

                    const tdStyle = {
                      padding: "9px 14px",
                      fontSize: "13px",
                      borderBottom: "1px solid #f5f5f5",
                    };
                    const thStyle = {
                      padding: "8px 14px",
                      fontSize: "10.5px",
                      fontWeight: 700,
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                      color: "#9a9690",
                      background: "#fafaf9",
                      borderBottom: "1px solid #e5e5e5",
                    };

                    return (
                      <>
                        {/* Summary strip */}
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr 1fr 1fr",
                            gap: "1px",
                            background: "#e5e5e5",
                            borderTop: "1px solid #e5e5e5",
                            borderBottom: "1px solid #e5e5e5",
                          }}
                        >
                          {[
                            ["Total Credits", `+$${this.formatCreditAmount(totalCredits)}`, "#1a7a4a"],
                            ["Total Debits", `−$${this.formatCreditAmount(totalDebits)}`, "#e85347"],
                            ["Transactions", String(chronoRows.length), "#1c5bde"],
                            [
                              "Current Balance",
                              `$${this.formatCreditAmount(currentBalance)}`,
                              currentBalance > 0 ? "#1c5bde" : "#9a9690",
                            ],
                          ].map(([lbl, val, col], i) => (
                            <div key={i} style={{ padding: "12px 16px", background: "#fff" }}>
                              <div style={{ fontSize: "10.5px", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.05em", color: "#9a9690", marginBottom: "3px" }}>
                                {lbl}
                              </div>
                              <div style={{ fontSize: "18px", fontWeight: 800, color: col, letterSpacing: "-0.01em" }}>
                                {val}
                              </div>
                            </div>
                          ))}
                        </div>

                        {/* Ledger table */}
                        <div style={{ overflowX: "auto" }}>
                          {this.state.ledgerLoading ? (
                            <div style={{ padding: "32px", textAlign: "center", color: "#9a9690" }}>
                              <span className="spinner-border spinner-border-sm" role="status" />
                              <span style={{ marginLeft: "8px" }}>Loading…</span>
                            </div>
                          ) : displayRows.length === 0 ? (
                            <div style={{ padding: "40px", textAlign: "center", color: "#9a9690" }}>
                              <em className="icon ni ni-coin-alt" style={{ fontSize: "32px", display: "block", marginBottom: "10px" }} />
                              <div style={{ fontWeight: 600, color: "#526484" }}>No transactions yet</div>
                              <div style={{ fontSize: "13px", marginTop: "4px" }}>Load credit to start the ledger.</div>
                            </div>
                          ) : (
                            <table style={{ width: "100%", borderCollapse: "collapse", minWidth: "600px" }}>
                              <thead>
                                <tr>
                                  <th style={thStyle}>Date</th>
                                  <th style={{ ...thStyle, maxWidth: "260px" }}>Description</th>
                                  <th style={{ ...thStyle, textAlign: "center" }}>Type</th>
                                  <th style={{ ...thStyle, textAlign: "right", color: "#1a7a4a" }}>Credit (+)</th>
                                  <th style={{ ...thStyle, textAlign: "right", color: "#e85347" }}>Debit (−)</th>
                                  <th style={{ ...thStyle, textAlign: "right" }}>Balance</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr style={{ background: "#fafaf9" }}>
                                  <td colSpan={5} style={{ ...tdStyle, color: "#9a9690", fontStyle: "italic" }}>Opening Balance</td>
                                  <td style={{ ...tdStyle, textAlign: "right", fontWeight: 700, color: "#526484" }}>${this.formatCreditAmount(openingBalance)}</td>
                                </tr>
                                {displayRows.map((row, idx) => {
                                  const amt = Number(row.amount) || 0;
                                  const isCredit = amt >= 0;
                                  return (
                                    <tr key={row.id || idx} style={{ background: idx % 2 === 0 ? "#fff" : "#fafaf9" }}>
                                      <td style={{ ...tdStyle, color: "#526484", whiteSpace: "nowrap" }}>
                                        {this.formatLedgerDate(row.created_at)}
                                      </td>
                                      <td style={{ ...tdStyle, maxWidth: "260px", wordBreak: "break-word", whiteSpace: "normal" }}>
                                        {(() => {
                                          const dp = (row.description || "").split(" | ").filter(p => !p.startsWith("Date:") && !p.startsWith("[Memo:"));
                                          return dp.join(" ") || "—";
                                        })()}
                                      </td>
                                      <td style={{ ...tdStyle, textAlign: "center" }}>
                                        <span style={{ display: "inline-block", padding: "2px 8px", borderRadius: "4px", fontSize: "11px", fontWeight: 700, background: isCredit ? "#e6f4ec" : "#fde8e8", color: isCredit ? "#1a7a4a" : "#e85347", textTransform: "uppercase" }}>
                                          {isCredit ? "CREDIT" : "DEBIT"}
                                        </span>
                                      </td>
                                      <td style={{ ...tdStyle, textAlign: "right", fontWeight: 700, color: isCredit ? "#1a7a4a" : "#9a9690" }}>
                                        {isCredit ? `$${this.formatCreditAmount(amt)}` : "—"}
                                      </td>
                                      <td style={{ ...tdStyle, textAlign: "right", fontWeight: 700, color: !isCredit ? "#e85347" : "#9a9690" }}>
                                        {!isCredit ? `$${this.formatCreditAmount(Math.abs(amt))}` : "—"}
                                      </td>
                                      <td style={{ ...tdStyle, textAlign: "right", fontWeight: 800, color: row.runningBalance > 0 ? "#1c5bde" : "#9a9690" }}>
                                        ${this.formatCreditAmount(row.runningBalance)}
                                      </td>
                                    </tr>
                                  );
                                })}
                                <tr style={{ background: "#1c3558" }}>
                                  <td colSpan={5} style={{ ...tdStyle, fontWeight: 700, color: "rgba(255,255,255,0.75)", fontSize: "11px", textTransform: "uppercase", letterSpacing: "0.05em", borderBottom: "none" }}>
                                    CLOSING BALANCE
                                  </td>
                                  <td style={{ ...tdStyle, textAlign: "right", fontWeight: 900, fontSize: "15px", color: "#fff", borderBottom: "none" }}>
                                    ${this.formatCreditAmount(currentBalance)}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          )}
                        </div>
                      </>
                    );
                  })()}

                  {/* Footer */}
                  <div style={{ padding: "14px 20px", borderTop: "1px solid #e5e5e5", display: "flex", gap: "10px", alignItems: "center", justifyContent: "flex-end" }}>
                    <a
                      href="#close"
                      onClick={(e) => { e.preventDefault(); this.closeLedgerModal(); }}
                      className="link link-light"
                    >
                      Close
                    </a>
                    <button
                      type="button"
                      className="btn btn-dim btn-secondary"
                      onClick={() => {
                        const chronoRows = [...(this.state.ledgerRows || [])].reverse();
                        let running = 0;
                        const displayRows = chronoRows.map((r) => {
                          running += Number(r.amount) || 0;
                          return { ...r, runningBalance: running };
                        });
                        const escCsv = (v) => `"${String(v == null ? "" : v).replace(/"/g, '""')}`;
                        const cols = ["Date", "Description", "Type", "Credit", "Debit", "Balance"];
                        const rowsCsv = displayRows.map((r) => {
                          const amt = Number(r.amount) || 0;
                          const isCredit = amt >= 0;
                          return [
                            this.formatLedgerDate(r.created_at),
                            r.description || "",
                            isCredit ? "CREDIT" : "DEBIT",
                            isCredit ? this.formatCreditAmount(amt) : "",
                            !isCredit ? this.formatCreditAmount(Math.abs(amt)) : "",
                            this.formatCreditAmount(r.runningBalance),
                          ].map(escCsv).join(",");
                        });
                        const csv = [cols.map(escCsv).join(","), ...rowsCsv].join("\n");
                        const blob = new Blob([csv], { type: "text/csv" });
                        const url = URL.createObjectURL(blob);
                        const a = document.createElement("a");
                        a.href = url;
                        a.download = `ledger-${this.state.client_accountno || "export"}.csv`;
                        a.click();
                        URL.revokeObjectURL(url);
                      }}
                    >
                      <em className="icon ni ni-download"></em>
                      <span>Export CSV</span>
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={() => { this.closeLedgerModal(); this.openAddCreditModal(); }}
                    >
                      <em className="icon ni ni-plus"></em>
                      <span>Add Credit</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          ) : null}

          {/* START ADD FILER ID MODAL  */}
          <div className="modal fade" tabIndex="-1" id="modalAddFilerId">
            <div className="modal-dialog modal-lg" role="document">
              <div className="modal-content">
                <a
                  style={{ cursor: "pointer" }}
                  className="close"
                  onClick={() => {
                    this.closeAddFilerIdModal();
                  }}
                >
                  <em className="icon ni ni-cross"></em>
                </a>
                <div className="modal-body modal-body-lg">
                  <div className="nk-modal">
                    <h4 className="nk-modal-title">Add Filer ID</h4>

                    <div className="nk-modal-text">
                      
                      

                      <div className="form-group" style={{ marginTop: "20px" }}>
                        <FccFilerAutocomplete
                          value={this.state.addFilerIdValue}
                          onInputChange={this.handleAddFilerIdChange}
                          onSelect={this.handleAddFilerIdSelect}
                          onBlur={this.handleAddFilerIdBlur}
                          onFccDataLoading={this.handleAddFilerIdDataLoading}
                          onFccDataLoaded={this.handleAddFilerIdDataLoaded}
                          onFccDataError={this.handleAddFilerIdDataError}
                          disabled={this.state.addFilerIdLoading}
                          label="Filer ID"
                          required={true}
                          placeholder="Search by Company Name or Filer ID"
                          variant="default"
                        />
                        {this.state.addFilerIdLoading && (
                          <div
                            style={{
                              marginTop: "10px",
                              display: "flex",
                              alignItems: "center",
                              color: "#6576ff",
                            }}
                          >
                            <span
                              className="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                              style={{ marginRight: "8px" }}
                            ></span>
                            <span>Verifying Filer ID...</span>
                          </div>
                        )}
                        {this.state.addFilerIdSuccess && (
                          <div
                            style={{
                              marginTop: "10px",
                              display: "flex",
                              alignItems: "center",
                              color: "#1ee0ac",
                            }}
                          >
                            <em
                              className="icon ni ni-check-circle-fill"
                              style={{ fontSize: "16px", marginRight: "8px" }}
                            ></em>
                            <span>Filer ID verified successfully</span>
                          </div>
                        )}
                        <span className="form-note">
                          Search by company name or enter Filer ID directly. Tab out to verify.
                        </span>
                      </div>

                      {this.state.addFilerIdSuccess && (
                        <div
                          className="form-group"
                          style={{ marginTop: "20px" }}
                        >
                          <label className="form-label" htmlFor="ocnValues">
                            OCN(s)
                          </label>
                          <div className="form-control-wrap">
                            <Autocomplete
                              multiple
                              freeSolo
                              id="ocnValues"
                              value={this.state.ocnValues}
                              onChange={this.handleOcnChange}
                              options={[]}
                              renderTags={(value, getTagProps) =>
                                value.map((option, index) => {
                                  const isFixed =
                                    this.state.ocnFixedValues.includes(option);
                                  return (
                                    <Chip
                                      key={index}
                                      label={option}
                                      {...(isFixed
                                        ? {}
                                        : getTagProps({ index }))}
                                      disabled={isFixed}
                                      style={{
                                        backgroundColor: isFixed
                                          ? "#bdbdbd"
                                          : undefined,
                                        border: isFixed
                                          ? "1px solid #bdbdbd"
                                          : undefined,
                                        color: isFixed ? "#333" : undefined,
                                      }}
                                    />
                                  );
                                })
                              }
                              renderInput={(params) => (
                                <MuiTextField
                                  {...params}
                                  placeholder="Type OCN"
                                  inputProps={{
                                    ...params.inputProps,
                                    // Removed inputMode and pattern to allow alphanumeric input
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === "," || e.key === "Enter") {
                                      e.preventDefault();
                                      const value = e.target.value.trim();
                                      if (
                                        value &&
                                        /^[a-zA-Z0-9]+$/.test(value) &&
                                        !this.state.ocnValues.includes(value)
                                      ) {
                                        this.setState({
                                          ocnValues: [
                                            ...this.state.ocnValues,
                                            value,
                                          ],
                                        });
                                        e.target.value = "";
                                      }
                                    }
                                  }}
                                autoComplete="new-password"
                                />
                              )}
                            />
                          </div>
                          <span className="form-note">
                            Locked values are from the FCC database. You can add
                            additional OCNs by typing and pressing enter.
                          </span>
                        </div>
                      )}
                    </div>

                    <div className="nk-modal-action mt-4">
                      {this.state.addFilerIdLoading &&
                      !this.state.addFilerIdSuccess ? (
                        <button
                          className="btn btn-lg btn-primary"
                          type="button"
                          disabled
                        >
                          <span
                            className="spinner-grow spinner-grow-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          <span> Verifying... </span>
                        </button>
                      ) : (
                        <>
                          <a
                            style={{ cursor: "pointer" }}
                            className="btn btn-lg btn-dim btn-outline-light"
                            onClick={() => {
                              this.closeAddFilerIdModal();
                            }}
                          >
                            <em className="icon ni ni-cross-round"></em>{" "}
                            <span>Cancel</span>
                          </a>
                          {"  "}
                          <button
                            style={{ cursor: "pointer" }}
                            className="btn btn-lg btn-mw btn-primary"
                            onClick={() => {
                              this.submitAddFilerId();
                            }}
                            disabled={
                              !this.state.addFilerIdSuccess ||
                              this.state.addFilerIdLoading
                            }
                          >
                            <em className="icon ni ni-save"></em>{" "}
                            <span>Submit</span>
                          </button>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* END ADD FILER ID MODAL  */}

          {/* START UPDATE OCN MODAL  */}
          <div className="modal fade" tabIndex="-1" id="modalUpdateOcn">
            <div className="modal-dialog modal-lg" role="document">
              <div className="modal-content">
                <a
                  style={{ cursor: "pointer" }}
                  className="close"
                  onClick={() => {
                    this.closeUpdateOcnModal();
                  }}
                >
                  <em className="icon ni ni-cross"></em>
                </a>
                <div className="modal-body modal-body-lg">
                  <div className="nk-modal">
                    <h4 className="nk-modal-title">Update OCN(s)</h4>

                    <div className="nk-modal-text">
                      
                      
                      

                      <div className="form-group" style={{ marginTop: "20px" }}>
                        <label className="form-label" htmlFor="updateOcnValues">
                          OCN(s)
                        </label>
                        <div className="form-control-wrap">
                          {this.state.updateOcnLoading ? (
                            <div
                              style={{ textAlign: "center", padding: "20px" }}
                            >
                              <span
                                className="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                              ></span>
                              <span style={{ marginLeft: "10px" }}>
                                Loading OCNs...
                              </span>
                            </div>
                          ) : (
                            <Autocomplete
                              multiple
                              freeSolo
                              id="updateOcnValues"
                              value={this.state.updateOcnValues}
                              onChange={this.handleUpdateOcnChange}
                              options={[]}
                              renderTags={(value, getTagProps) =>
                                value.map((option, index) => (
                                  <Chip
                                    key={index}
                                    label={option}
                                    {...getTagProps({ index })}
                                  />
                                ))
                              }
                              renderInput={(params) => (
                                <MuiTextField
                                  {...params}
                                  placeholder="Type OCN"
                                  inputProps={{
                                    ...params.inputProps,
                                    // Removed inputMode and pattern to allow alphanumeric input
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === "," || e.key === "Enter") {
                                      e.preventDefault();
                                      const value = e.target.value.trim();
                                      if (
                                        value &&
                                        /^[a-zA-Z0-9]+$/.test(value) &&
                                        !this.state.updateOcnValues.includes(
                                          value,
                                        )
                                      ) {
                                        this.setState({
                                          updateOcnValues: [
                                            ...this.state.updateOcnValues,
                                            value,
                                          ],
                                        });
                                        e.target.value = "";
                                      }
                                    }
                                  }}
                                autoComplete="new-password"
                                />
                              )}
                            />
                          )}
                        </div>
                        <span className="form-note">
                          You can add, remove, or modify OCNs. Type and press
                          enter to add new ones.
                        </span>
                      </div>
                    </div>

                    <div className="nk-modal-action mt-4 text-right">
                      <a
                        style={{ cursor: "pointer" }}
                        className="btn btn-lg btn-dim btn-outline-light mr-1"
                        onClick={() => {
                          this.closeUpdateOcnModal();
                        }}
                      >
                        <em className="icon ni ni-cross-round"></em>{" "}
                        <span>Cancel</span>
                      </a>
                      {"  "}
                      <button
                        style={{ cursor: "pointer" }}
                        className="btn btn-lg btn-mw btn-primary"
                        onClick={() => {
                          this.submitUpdateOcn();
                        }}
                        disabled={this.state.updateOcnLoading}
                      >
                        {this.state.updateOcnLoading ? (
                          <>
                            <span
                              className="spinner-grow spinner-grow-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            <span> Saving...</span>
                          </>
                        ) : (
                          <>
                            <em className="icon ni ni-save"></em>{" "}
                            <span>Save</span>
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* END UPDATE OCN MODAL  */}

          {/* START REVOKE FCC MODAL  */}
          <div className="modal fade" tabIndex="-1" id="modalRevokeFcc">
            <div className="modal-dialog modal-lg" role="document">
              <div className="modal-content">
                <a
                  style={{ cursor: "pointer" }}
                  className="close"
                  onClick={() => {
                    this.closeRevokeFccModal();
                  }}
                >
                  <em className="icon ni ni-cross"></em>
                </a>
                <div className="modal-body modal-body-lg">
                  <div className="nk-modal">
                    <h4 className="nk-modal-title">Revoke FCC 499 Approval</h4>

                    <div className="nk-modal-text">
                      
                      

                      <p style={{ marginTop: "20px" }}>
                        Are you sure you want to revoke the FCC 499 approval for
                        this client? This action will:
                      </p>
                      <ul style={{ marginLeft: "20px" }}>
                        <li>- Set the approval status back to pending</li>
                        <li>- Disable related integrations</li>
                      </ul>
                    </div>
                  </div>

                  <div className="nk-modal-action mt-4 text-right">
                    <a
                      style={{ cursor: "pointer" }}
                      className="btn btn-lg btn-dim btn-outline-light mr-1"
                      onClick={() => {
                        this.closeRevokeFccModal();
                      }}
                      disabled={this.state.revokeClientFccLoading}
                    >
                      <em className="icon ni ni-cross-round"></em> <span>Cancel</span>
                    </a>
                    {"  "}
                    <button
                      style={{ cursor: "pointer" }}
                      className="btn btn-lg btn-mw btn-danger"
                      onClick={() => {
                        this.submitRevokeFcc();
                      }}
                      disabled={this.state.revokeClientFccLoading}
                    >
                      {this.state.revokeClientFccLoading ? (
                        <>
                          <span
                            className="spinner-grow spinner-grow-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          <span> Revoking...</span>
                        </>
                      ) : (
                        <>
                          <em className="icon ni ni-cross-circle"></em>{" "}
                          <span>Revoke Approval</span>
                        </>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* END REVOKE FCC MODAL  */}

          {/* START FCC DATA VIEWER MODAL  */}
          <div className="modal fade" tabIndex="-1" id="modalFccDataViewer">
            <div className="modal-dialog modal-xl" role="document">
              <div className="modal-content">
                <a
                  style={{ cursor: "pointer" }}
                  className="close"
                  onClick={() => {
                    this.closeFccDataModal();
                  }}
                >
                  <em className="icon ni ni-cross"></em>
                </a>
                <div className="modal-body modal-body-lg">
                  <div className="nk-modal">
                    <h4 className="nk-modal-title">
                      FCC / Robocall Mitigation Data
                    </h4>

                    <div className="nk-modal-text">
                      

                      {this.state.fccDataModalLoading ? (
                        <div
                          style={{ textAlign: "center", padding: "40px" }}
                        >
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          <span style={{ marginLeft: "10px" }}>
                            Loading FCC data...
                          </span>
                        </div>
                      ) : this.state.fccDataModalData ? (
                        <div style={{ marginTop: "15px", maxHeight: "65vh", overflowY: "auto" }}>
                          {/* Basic DB fields */}
                          <h6
                            style={{
                              marginBottom: "10px",
                              padding: "8px 12px",
                              backgroundColor: "#364a63",
                              color: "#fff",
                              borderRadius: "4px",
                              fontSize: "14px",
                              fontWeight: 600,
                            }}
                          >
                            Account FCC Info
                          </h6>
                          <table className="table table-bordered">
                            <tbody>
                              <tr>
                                <th
                                  style={{
                                    width: "35%",
                                    backgroundColor: "#f5f6fa",
                                  }}
                                >
                                  Filer ID
                                </th>
                                <td>
                                  {this.state.fccDataModalData.filer_id ||
                                    "-"}
                                </td>
                              </tr>
                              <tr>
                                <th
                                  style={{ backgroundColor: "#f5f6fa" }}
                                >
                                  OCN(s)
                                </th>
                                <td>
                                  {this.state.fccDataModalData.ocn
                                    ? this.state.fccDataModalData.ocn
                                        .split(",")
                                        .map((ocn, idx) => (
                                          <span
                                            key={idx}
                                            className="badge badge-primary"
                                            style={{
                                              marginRight: "5px",
                                              marginBottom: "3px",
                                              display: "inline-block",
                                            }}
                                          >
                                            {ocn.trim()}
                                          </span>
                                        ))
                                    : "-"}
                                </td>
                              </tr>
                              <tr>
                                <th style={{ backgroundColor: "#f5f6fa" }}>Contact Email</th>
                                <td>
                                  {this.state.fccDataModalData.contact_email || "-"}
                                </td>
                              </tr>
                            </tbody>
                          </table>

                          {/* Dynamic rendering of full FCC API response */}
                          {(() => {
                            try {
                              const rawData = this.state.fccDataModalData.fcc_raw_data;
                              if (!rawData) return null;
                              const parsed = typeof rawData === "string" ? JSON.parse(rawData) : rawData;
                              if (!parsed || typeof parsed !== "object") return null;
                              return (
                                <>
                                  {parsed.robocall_data && typeof parsed.robocall_data === "object" ? (
                                    this.renderFccSection(parsed.robocall_data, "Robocall Mitigation Data")
                                  ) : null}
                                  {parsed["499_filer_data"] && typeof parsed["499_filer_data"] === "object" ? (
                                    this.renderFccSection(parsed["499_filer_data"], "FCC 499 Filer Data")
                                  ) : null}
                                </>
                              );
                            } catch (e) {
                              console.error("Error parsing fcc_raw_data:", e);
                              return (
                                <div className="alert alert-warning mt-2">
                                  <small>Unable to parse extended FCC data.</small>
                                </div>
                              );
                            }
                          })()}
                        </div>
                      ) : null}
                    </div>

                    <div className="nk-modal-action mt-4 text-right">
                      <a
                        style={{ cursor: "pointer" }}
                        className="btn btn-lg btn-dim btn-outline-light"
                        onClick={() => {
                          this.closeFccDataModal();
                        }}
                      >
                        <em className="icon ni ni-cross-round"></em>{" "}
                        <span>Close</span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* END FCC DATA VIEWER MODAL  */}

          {/* START REJECTION CLIENT MODAL */}
          <div
            className="modal fade"
            tabIndex="-1"
            id="modalRejectionClientAlert"
          >
            <div
              className="modal-dialog modal-dialog-top modal-xl"
              role="document"
            >
              <div className="modal-content">
                <a
                  href="#"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <em className="icon ni ni-cross"></em>
                </a>
                <div className="modal-header">
                  <h5 className="modal-title">
                    {this.state.rejection_client_title}{" "}
                    <sup className="text-primary">{this.state.form_title}</sup>
                  </h5>
                </div>
                <div className="modal-body">
                  <div id="revokeReasonItems">
                    <div className="tb-odr-id">Reason to reject</div>
                    <div className="card card-bordered card-preview mt-1">
                      <TextareaAutosize
                        maxrows={4}
                        name="reject_client_reason"
                        id="reject_client_reason"
                        aria-label=""
                        placeholder=""
                        value={this.state.reject_client_reason}
                        helperText="Reason to reject this submission"
                        onChange={this.handleChange}
                        style={{
                          width: "100%",
                          height: "100px",
                          borderColor: "rgba(0, 0, 0, 0.125)",
                          borderRadius: "4px",
                        }}
                        variant="outlined"
                      />
                    </div>
                    <div className="form-group text-right mt-2 mb-2">
                      {this.state.reject_client_button === true ? (
                        <button
                          className="btn btn-primary"
                          type="button"
                          disabled
                        >
                          <span
                            className="spinner-grow spinner-grow-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          <span> Loading... </span>
                        </button>
                      ) : (
                        <>
                          <button
                            type="button"
                            className="btn btn-light"
                            onClick={() => {
                              this.modalHideAlll("modalRejectionClientAlert");
                            }}
                            style={{ marginRight: "10px" }}
                          >
                            <em className="icon ni ni-cross-round"></em>{" "}
                            <span>Cancel</span>
                          </button>
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() => {
                              this.reject_client_form();
                            }}
                            disabled={this.state.disabled}
                          >
                            <em className="icon ni ni-cross-circle"></em>{" "}
                            <span>Reject</span>
                          </button>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* END REJECTION CLIENT MODAL */}
          {/* START REJECTION CLIENT MODAL */}
          <div
            className="modal fade"
            tabIndex="-1"
            id="modalUnarchiveClientAlert"
          >
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <a
                  style={{ cursor: "pointer" }}
                  className="close"
                  onClick={() => {
                    this.modalHideAlll("modalUnarchiveClientAlert");
                  }}
                >
                  <em className="icon ni ni-cross"></em>
                </a>
                <div className="modal-body modal-body-lg text-center">
                  <div className="nk-modal">
                    <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-unarchive bg-success"></em>

                    <h4 className="nk-modal-title">Unarchive Submission?</h4>

                    <div className="nk-modal-text">
                      
                      

                      <div className="caption-text">
                        Are you certain you want to unarchive this form
                        submission?
                      </div>
                    </div>
                    <div className="nk-modal-action">
                      <a
                        style={{ cursor: "pointer" }}
                        className="btn btn-lg btn-mw btn-primary"
                        onClick={() => {
                          this.modalHideAlll("modalUnarchiveClientAlert");
                        }}
                      >
                        Cancel
                      </a>
                      {"  "}
                      <a
                        style={{ cursor: "pointer" }}
                        className="btn btn-lg btn-mw btn-success"
                        onClick={() => {
                          this.unarchiveClientSubmission();
                        }}
                        disabled={
                          this.state.disabled ||
                          this.state.isProcessingUnarchive
                        } // disable button when processing
                      >
                        {this.state.isProcessingUnarchive ? (
                          <span>Processing...</span>
                        ) : (
                          <span>Unarchive</span>
                        )}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* END REJECTION CLIENT MODAL */}

          {/* START UNREVOKE SUBMISSION MODAL */}
          <div
            className="modal fade"
            tabIndex="-1"
            id="modalUnrevokeSubmissionAlert"
          >
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <a
                  style={{ cursor: "pointer" }}
                  className="close"
                  onClick={() => {
                    this.modalHideAlll("modalUnrevokeSubmissionAlert");
                  }}
                >
                  <em className="icon ni ni-cross"></em>
                </a>
                <div className="modal-body modal-body-lg text-center">
                  <div className="nk-modal">
                    <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-unarchive bg-success"></em>

                    <h4 className="nk-modal-title">Restore Submission?</h4>

                    <div className="nk-modal-text">
                      
                      

                      <div className="caption-text">
                        Are you certain you want to restore this revoked
                        submission?
                      </div>
                    </div>
                    <div className="nk-modal-action">
                      <a
                        style={{ cursor: "pointer" }}
                        className="btn btn-lg btn-mw btn-primary"
                        onClick={() => {
                          this.modalHideAlll("modalUnrevokeSubmissionAlert");
                        }}
                      >
                        Cancel
                      </a>
                      {"  "}
                      <a
                        style={{ cursor: "pointer" }}
                        className="btn btn-lg btn-mw btn-success"
                        onClick={() => {
                          this.unrevokeClientSubmissionAction();
                        }}
                        disabled={
                          this.state.disabled ||
                          this.state.isProcessingUnrevoke
                        }
                      >
                        {this.state.isProcessingUnrevoke ? (
                          <span>Processing...</span>
                        ) : (
                          <span>Restore</span>
                        )}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* END UNREVOKE SUBMISSION MODAL */}

          {/* MODAL ASSIGN FORM */}
          <div className="modal fade" tabIndex="-1" id="modalAssignFormClient">
            <div
              className="modal-dialog modal-xl modal-dialog-top"
              role="document"
            >
              <div className="modal-content">
                <div className="modal-header">
                  <div
                    className="modal-title"
                    style={{ textAlign: "center", fontSize: "20px" }}
                  >
                    <strong>
                      <em className="icon ni ni-clipboad-check"></em>Assign Form
                      to {this.state.client_update_name} (
                      {this.state.client_comp_name}){" "}
                    </strong>
                  </div>
                  <a
                    href="#"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <em className="icon ni ni-cross"></em>
                  </a>
                </div>

                <div className="modal-body text-left">
                  <div className="nk-modal">
                    <div className="nk-modal-text">
                      {this.state.assignModalLoader === true ? (
                        FormLoader()
                      ) : (
                        <>
                          
                          

                          <div className="card card-bordered card-preview">
                            <table className="table table-orders">
                              <thead className="tb-odr-head">
                                <tr className="tb-odr-item">
                                  <th>
                                    <span className="tb-odr-action">Forms</span>
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="tb-odr-body">
                                {this.state.clientsList &&
                                this.state.clientsList.length > 0 ? (
                                  <tr className="tb-odr-item customStyle_tb-odr-item_forms">
                                    <td
                                      style={{
                                        paddingLeft: "16px",
                                      }}
                                    >
                                      {this.state.clientsList &&
                                      this.state.clientsList.length > 0 ? (
                                        <div
                                          className="form-group"
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                          }}
                                        >
                                          {/*<FormControlLabel
                                                control={
                                                  <Checkbox
                                                    checked={
                                                      this.state
                                                        .selectAllClients
                                                    }
                                                    onChange={
                                                      this
                                                        .handleSelectAllClientsChange
                                                    }
                                                    name="selectAll"
                                                    color="primary"
                                                  />
                                                }
                                                label="Select all Clients"
                                                style={{
                                                  width: "max-content",
                                                  marginBottom: "10px",
                                                  float: "right",
                                                }}
                                              />*/}
                                          <Autocomplete
                                            multiple
                                            id="clients-autocomplete"
                                            options={this.state.clientsList}
                                            disableCloseOnSelect
                                            getOptionLabel={(option) =>
                                              option.label
                                            }
                                            value={this.state.clientsList.filter(
                                              (client) =>
                                                this.state.selectedForms.includes(
                                                  client.value,
                                                ),
                                            )}
                                            onChange={this.handleClientChange}
                                            getOptionSelected={(
                                              option,
                                              value,
                                            ) => option.value === value.value}
                                            renderOption={(
                                              option,
                                              { selected },
                                            ) => (
                                              <Fragment>
                                                <Checkbox
                                                  icon={icon}
                                                  checkedIcon={checkedIcon}
                                                  style={{ marginRight: 8 }}
                                                  checked={selected}
                                                />
                                                {option.label}
                                              </Fragment>
                                            )}
                                            style={{ width: "100%" }}
                                            renderInput={(params) => (
                                              <MutextField
                                                {...params}
                                                label="Select Forms"
                                                placeholder=""
                                              autoComplete="new-password"
                                              />
                                            )}
                                          />
                                        </div>
                                      ) : null}
                                    </td>
                                  </tr>
                                ) : null}
                                {this.state.clientsList &&
                                this.state.clientsList.length > 0 ? (
                                  <>
                                    <tr>
                                      <td>
                                        <div className="nk-modal-action  text-right">
                                          <a
                                            href="#"
                                            className="btn btn-lg btn-mw btn-primary "
                                            onClick={() => {
                                              this.handleSubmitAssignFormClient();
                                            }}
                                            disabled={
                                              this.state.disableAssignBtn
                                            }
                                          >
                                            Assign to Client
                                          </a>
                                        </div>
                                      </td>
                                    </tr>
                                  </>
                                ) : null}
                              </tbody>
                            </table>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* MODAL ASSIGN FORM */}

          {/* Integration Permission Modal START */}
          <div className="modal fade" tabIndex="-1" id="modalEditIntegration">
            <div
              className="modal-dialog modal-xl modal-dialog-top"
              role="document"
            >
              <div className="modal-content">
                <div className="modal-header">
                  <div
                    className="modal-title"
                    style={{ textAlign: "center", fontSize: "20px" }}
                  >
                    <strong>
                      <em className="icon ni ni-exchange"></em>
                      Manage Integrations{" "}
                    </strong>
                  </div>
                  <a
                    href="#"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <em className="icon ni ni-cross"></em>
                  </a>
                </div>

                <div className="modal-body text-left">
                  <div className="nk-modal">
                    <div className="nk-modal-text">
                      <>
                        
                        

                        <div className="card card-bordered card-preview">
                          <table className="table table-sm">
                            <thead className="tb-odr-head">
                              <tr className="tb-odr-item">
                                <th
                                  width="25%"
                                  style={{
                                    borderRight: "1px solid #dbdfea",
                                    textAlign: "center",
                                    padding: "15px",
                                  }}
                                >
                                  <span className="tb-odr-action">
                                    Enable/Disable
                                  </span>
                                </th>
                                <th
                                  width="50%"
                                  style={{
                                    borderRight: "1px solid #dbdfea",
                                    textAlign: "center",
                                    padding: "15px",
                                  }}
                                >
                                  <span className="tb-odr-action">Title</span>
                                </th>
                                <th
                                  width="25%"
                                  style={{
                                    textAlign: "center",
                                    padding: "15px",
                                  }}
                                >
                                  <span className="tb-odr-action">
                                    Save Changes
                                  </span>
                                </th>
                              </tr>
                            </thead>
                            <tbody className="tb-odr-body">
                              {this.state.va_intergation === "Yes" ? (
                                <tr>
                                  <td
                                    style={{
                                      borderRight: "1px solid #dbdfea",
                                      textAlign: "center",
                                      padding: "15px",
                                    }}
                                  >
                                    <div className="custom-control custom-checkbox">
                                      <div className="form-group">
                                        <input
                                          type="checkbox"
                                          className="custom-control-input"
                                          id="customCheckPermission"
                                          checked={this.state.isEnableChecked}
                                          onChange={this.handleEnableChange}
                                        autoComplete="new-password" />
                                        <label
                                          className="custom-control-label"
                                          htmlFor="customCheckPermission"
                                        ></label>
                                      </div>
                                    </div>
                                  </td>
                                  <td
                                    style={{
                                      borderRight: "1px solid #dbdfea",
                                      textAlign: "center",
                                      padding: "15px",
                                    }}
                                  >
                                    VoiceAlerts Dashboard for{" "}
                                    {this.state.client_update_name} (
                                    {this.state.client_comp_name})
                                  </td>
                                  <td
                                    className="text-center"
                                    style={{ padding: "15px" }}
                                  >
                                    <button
                                      href="#"
                                      className="btn btn-sm btn-mw btn-primary"
                                      onClick={() => {
                                        this.updateClientPremission();
                                      }}
                                      disabled={this.state.disabled}
                                    >
                                      Save Changes
                                    </button>
                                  </td>
                                </tr>
                              ) : null}

                              {this.state.va_intergation === "Yes" ? (
                                <tr>
                                  <td
                                    style={{
                                      borderRight: "1px solid #dbdfea",
                                      textAlign: "center",
                                      padding: "15px",
                                    }}
                                  >
                                    <div className="custom-control custom-checkbox">
                                      <div className="form-group">
                                        <input
                                          type="checkbox"
                                          className="custom-control-input"
                                          id="customCheckPermissionDirect"
                                          checked={
                                            this.state.isEnableCheckedDirect
                                          }
                                          onChange={
                                            this.handleEnableChangeDirect
                                          }
                                        autoComplete="new-password" />
                                        <label
                                          className="custom-control-label"
                                          htmlFor="customCheckPermissionDirect"
                                        ></label>
                                      </div>
                                    </div>
                                  </td>
                                  <td
                                    style={{
                                      borderRight: "1px solid #dbdfea",
                                      textAlign: "center",
                                      padding: "15px",
                                    }}
                                  >
                                    Direct VoiceAlerts SSO for{" "}
                                    {this.state.client_update_name} (
                                    {this.state.client_comp_name})
                                  </td>
                                  <td
                                    className="text-center"
                                    style={{ padding: "15px" }}
                                  >
                                    <button
                                      href="#"
                                      className="btn btn-sm btn-mw btn-primary"
                                      onClick={() => {
                                        this.updateClientPremissionDirect();
                                      }}
                                      disabled={this.state.disabledDirect}
                                    >
                                      Save Changes
                                    </button>
                                  </td>
                                </tr>
                              ) : null}

                              {this.state.meta_intergation === "Yes" ? (
                                <tr>
                                  <td
                                    style={{
                                      borderRight: "1px solid #dbdfea",
                                      textAlign: "center",
                                      padding: "15px",
                                    }}
                                  >
                                    <div className="custom-control custom-checkbox">
                                      <div className="form-group">
                                        <input
                                          type="checkbox"
                                          className="custom-control-input"
                                          id="customCheckPermissionMeta"
                                          checked={
                                            this.state.isEnableCheckedMeta
                                          }
                                          onChange={this.handleEnableChangeMeta}
                                        autoComplete="new-password" />
                                        <label
                                          className="custom-control-label"
                                          htmlFor="customCheckPermissionMeta"
                                        ></label>
                                      </div>
                                    </div>
                                  </td>
                                  <td
                                    style={{
                                      borderRight: "1px solid #dbdfea",
                                      textAlign: "center",
                                      padding: "15px",
                                    }}
                                  >
                                    Metabase Integration for{" "}
                                    {this.state.client_update_name} (
                                    {this.state.client_comp_name})
                                  </td>
                                  <td
                                    className="text-center"
                                    style={{ padding: "15px" }}
                                  >
                                    <button
                                      href="#"
                                      className="btn btn-sm btn-mw btn-primary"
                                      onClick={() => {
                                        this.updateClientPremissionMeta();
                                      }}
                                      disabled={this.state.disabledMeta}
                                    >
                                      Save Changes
                                    </button>
                                  </td>
                                </tr>
                              ) : null}
                            </tbody>
                          </table>
                        </div>
                      </>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Integration Permission Modal End */}
          {/* Notification Links Modal START */}
          <div
            className="modal fade"
            tabIndex="-1"
            id="modalNotificationLinks"
          >
            <div
              className="modal-dialog modal-lg modal-dialog-top"
              role="document"
            >
              <div className="modal-content rounded-3 shadow">
                {/* Header */}
                <div className="modal-header border-0 pb-0">
                  <h5
                    className="modal-title d-flex align-items-center"
                    style={{ fontSize: "20px" }}
                  >
                    <em className="icon ni ni-link-alt mr-2"></em>
                    Notification Links
                  </h5>
                  <a
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <em className="icon ni ni-cross"></em>
                  </a>
                </div>

                {/* Body */}
                <div className="modal-body">
                  {this.state.successMessage && (
                    <div className="alert alert-success mb-3">
                      <strong>Success:</strong> {this.state.successMessage}
                    </div>
                  )}
                  {this.state.errorMessage && (
                    <div className="alert alert-danger mb-3">
                      <strong>Error:</strong> {this.state.errorMessage}
                    </div>
                  )}

                  {/* Login URL Section */}
                  <div className="mb-4">
                    <label className="form-label font-weight-bold">
                      <em className="icon ni ni-signin mr-2"></em>
                      Login URL
                    </label>
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        value={this.state.loginUrl}
                        readOnly
                        style={{ fontSize: "14px" }}
                        autoComplete="new-password"
                      />
                      <div className="input-group-append">
                        <Tooltip title="Copy Link">
                          <a
                            className="btn border"
                            onClick={() => this.copyToClipboard("login")}
                            style={{ cursor: "pointer" }}
                          >
                            {this.state.copiedLogin ? (
                              <em className="icon ni ni-check text-success"></em>
                            ) : (
                              <em className="icon ni ni-copy"></em>
                            )}
                          </a>
                        </Tooltip>
                        <Tooltip title="Email Link">
                          <a
                            className="btn border"
                            onClick={() => this.sendEmailUrl("login")}
                            disabled={this.state.sendingLoginEmail}
                            style={{ cursor: "pointer" }}
                          >
                            {this.state.sendingLoginEmail ? (
                              <em className="icon ni ni-loader" />
                            ) : this.state.loginEmailSent ? (
                              <em className="icon ni ni-check text-success"></em>
                            ) : (
                              <em className="icon ni ni-mail"></em>
                            )}
                          </a>
                        </Tooltip>
                      </div>
                    </div>
                  </div>

                  {/* Reset Password URL Section */}
                  <div className="mb-3">
                    <label className="form-label font-weight-bold">
                      <em className="icon ni ni-lock-alt mr-2"></em>
                      Reset Password URL
                    </label>
                    {this.state.resetLink ? (
                      <>
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control"
                            value={this.state.resetLink}
                            readOnly
                            style={{ fontSize: "14px" }}
                            autoComplete="new-password"
                          />
                          <div className="input-group-append">
                            <Tooltip title="Copy Link">
                              <a
                                className="btn border"
                                onClick={() => this.copyToClipboard("resetPassword")}
                                style={{ cursor: "pointer" }}
                              >
                                {this.state.copiedResetPassword ? (
                                  <em className="icon ni ni-check text-success"></em>
                                ) : (
                                  <em className="icon ni ni-copy"></em>
                                )}
                              </a>
                            </Tooltip>
                            <Tooltip title="Email Link">
                              <a
                                className="btn border"
                                onClick={() => this.sendEmailUrl("resetPassword")}
                                disabled={this.state.sendingResetPasswordEmail}
                                style={{ cursor: "pointer" }}
                              >
                                {this.state.sendingResetPasswordEmail ? (
                                  <em className="icon ni ni-loader" />
                                ) : this.state.resetPasswordEmailSent ? (
                                  <em className="icon ni ni-check text-success"></em>
                                ) : (
                                  <em className="icon ni ni-mail"></em>
                                )}
                              </a>
                            </Tooltip>
                          </div>
                        </div>
                      </>
                    ) : (
                      <div className="text-center py-3">
                        <span className="spinner-border spinner-border-sm mr-2"></span>
                        <span>Loading reset password link...</span>
                      </div>
                    )}
                  </div>
                </div>

                {/* Footer */}
                <div className="modal-footer border-0 pt-0 d-flex flex-column align-items-start w-100">
                  <div className="card card-bordered w-100">
                    <div className="card-inner p-3">
                      <ul className="list-unstyled mb-0">
                        <li className="d-flex align-items-start mb-2">
                          <span
                            className="dot mr-2"
                            style={{
                              height: "8px",
                              width: "8px",
                              borderRadius: "50%",
                              backgroundColor: "#526484",
                              marginTop: "6px",
                            }}
                          ></span>
                          <span>
                            Use the <strong>Copy</strong> icon to copy links to clipboard.
                          </span>
                        </li>
                        <li className="d-flex align-items-start mb-2">
                          <span
                            className="dot mr-2"
                            style={{
                              height: "8px",
                              width: "8px",
                              borderRadius: "50%",
                              backgroundColor: "#526484",
                              marginTop: "6px",
                            }}
                          ></span>
                          <span>
                            Use the <strong>Email</strong> icon to send the link directly to the client.
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Notification Links Modal End */}

          {/* { MODAL LOGIN DETAILS } */}
          <div
            className="modal fade"
            id="modalLoginDetail"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="modalLoginDetailLabel"
            aria-hidden="true"
          >
            <div
              className="modal-dialog modal-xl modal-dialog-top"
              role="document"
            >
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="modalLoginDetailLabel">
                    Login Details
                  </h5>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  {/* Table to Display Login Details */}
                  <div className="table-responsive">
                    <table className="table table-bordered">
                      <thead className="thead-light">
                        <tr>
                          <th>IP Address</th>
                          <th>Country</th>
                          <th>State</th>
                          <th>City</th>
                          <th>Timezone</th>
                          <th>Login Time</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.loginDetails &&
                        this.state.loginDetails.length > 0 ? (
                          this.state.loginDetails.map((detail, index) => (
                            <tr key={index}>
                              <td>{detail.ip_address}</td>
                              <td>{detail.country}</td>
                              <td>{detail.state}</td>
                              <td>{detail.city}</td>
                              <td>{detail.time_zone}</td>
                              <td>
                                {new Date(detail.login_time)
                                  .toLocaleDateString("en-US", {
                                    month: "long",
                                    day: "numeric",
                                    year: "numeric",
                                  })
                                  .replace(/(\d+)(?=,)/, "$1th")}
                                ,{" "}
                                {new Date(detail.login_time).toLocaleTimeString(
                                  "en-US",
                                )}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="6" className="text-center">
                              No login details found.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* { MODAL LOGIN DETAILS } */}
          {/* MODAL ASSIGN AGREEMENT */}
          <div
            className="modal fade"
            tabIndex="-1"
            id="modalAssignAgreementClient"
          >
            <div
              className="modal-dialog modal-xl modal-dialog-top"
              role="document"
            >
              <div className="modal-content">
                <div className="modal-header">
                  <div
                    className="modal-title"
                    style={{ textAlign: "center", fontSize: "20px" }}
                  >
                    <strong>
                      <em className="icon ni ni-clipboad-check"></em>Assign
                      Agreement to {this.state.client_update_name} (
                      {this.state.client_comp_name}){" "}
                    </strong>
                  </div>
                  <a
                    href="#"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <em className="icon ni ni-cross"></em>
                  </a>
                </div>

                <div className="modal-body text-left">
                  <div className="nk-modal">
                    <div className="nk-modal-text">
                      {this.state.assignModalLoader === true ? (
                        FormLoader()
                      ) : (
                        <>
                          
                          

                          <div className="card card-bordered card-preview">
                            <table className="table table-orders">
                              <thead className="tb-odr-head">
                                <tr className="tb-odr-item">
                                  <th>
                                    <span className="tb-odr-action">
                                      Agreements
                                    </span>
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="tb-odr-body">
                                {this.state.clientsList &&
                                this.state.clientsList.length > 0 ? (
                                  <tr className="tb-odr-item customStyle_tb-odr-item_forms">
                                    <td
                                      style={{
                                        paddingLeft: "16px",
                                      }}
                                    >
                                      {this.state.clientsList &&
                                      this.state.clientsList.length > 0 ? (
                                        <div
                                          className="form-group"
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                          }}
                                        >
                                          <Autocomplete
                                            multiple
                                            id="clients-autocomplete"
                                            options={this.state.clientsList}
                                            disableCloseOnSelect
                                            getOptionLabel={(option) =>
                                              option.label
                                            }
                                            value={this.state.clientsList.filter(
                                              (client) =>
                                                this.state.selectedAgreements.includes(
                                                  client.value,
                                                ),
                                            )}
                                            onChange={
                                              this.handleClientChangeAgreement
                                            }
                                            getOptionSelected={(
                                              option,
                                              value,
                                            ) => option.value === value.value}
                                            renderOption={(
                                              option,
                                              { selected },
                                            ) => (
                                              <Fragment>
                                                <Checkbox
                                                  icon={icon}
                                                  checkedIcon={checkedIcon}
                                                  style={{ marginRight: 8 }}
                                                  checked={selected}
                                                />
                                                {option.label}
                                              </Fragment>
                                            )}
                                            style={{ width: "100%" }}
                                            renderInput={(params) => (
                                              <MutextField
                                                {...params}
                                                label="Select Agreements"
                                                placeholder=""
                                              autoComplete="new-password"
                                              />
                                            )}
                                          />
                                        </div>
                                      ) : null}
                                    </td>
                                  </tr>
                                ) : null}
                                {this.state.clientsList &&
                                this.state.clientsList.length > 0 ? (
                                  <>
                                    <tr>
                                      <td>
                                        <div className="nk-modal-action  text-right">
                                          <a
                                            href="#"
                                            className="btn btn-lg btn-mw btn-primary "
                                            onClick={() => {
                                              this.handleSubmitAssignAgreementClient();
                                            }}
                                            disabled={
                                              this.state.disableAssignBtn
                                            }
                                          >
                                            Assign to Client
                                          </a>
                                        </div>
                                      </td>
                                    </tr>
                                  </>
                                ) : null}
                              </tbody>
                            </table>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* MODAL ASSIGN AGREEMENT */}
          {/* MODAL REASSIGN AGREEMENT */}
          <div className="modal fade" tabIndex="-1" id="modalReassignAlert">
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <a
                  style={{ cursor: "pointer" }}
                  className="close"
                  onClick={() => {
                    this.modalHideReassign();
                  }}
                >
                  <em className="icon ni ni-cross"></em>
                </a>
                <div className="modal-body modal-body-lg text-center">
                  <div className="nk-modal">
                    <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-repeat bg-success"></em>
                    <h4 className="nk-modal-title">Reassign the agreement?</h4>
                    <div className="nk-modal-text">
                      
                      
                      <div className="caption-text">
                        Reassigning this archived agreement will replace the
                        existing one if it's already assigned to the client.
                      </div>
                    </div>
                    <div className="nk-modal-action">
                      {this.state.disabled === true ? (
                        <button
                          className="btn btn-lg btn-primary"
                          type="button"
                          disabled
                        >
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          <span> Loading... </span>
                        </button>
                      ) : (
                        <>
                          <a
                            style={{ cursor: "pointer" }}
                            className="btn btn-lg btn-mw btn-primary"
                            onClick={() => {
                              this.modalHideReassign();
                            }}
                            disabled={this.state.disabled}
                          >
                            CANCEL
                          </a>
                          {"  "}
                          <a
                            style={{ cursor: "pointer" }}
                            className="btn btn-lg btn-mw btn-success"
                            onClick={() => {
                              this.reassign_archived_agreement();
                            }}
                            disabled={this.state.disabled}
                          >
                            SUBMIT
                          </a>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* MODAL REASSIGN AGREEMENT */}
          {/* Send Email to Client Signee Modal */}
          <div className="modal fade" tabIndex="-1" id="modalClientSendSignee">
            <div className="modal-dialog modal-dialog-top modal-xl" role="document">
              <div className="modal-content">
                <a href="#" className="close" data-dismiss="modal" aria-label="Close">
                  <em className="icon ni ni-cross"></em>
                </a>
                <div className="modal-header">
                  <h5 className="modal-title">Send Agreement Email</h5>
                </div>
                <div className="modal-body">
                  <div className="card card-bordered">
                    <div className="card-inner-group">
                      <div className="card-inner">
                        <div className="sp-plan-head">
                          <h6 className="title">Copy Agreement Link</h6>
                        </div>

                        <div className="sp-plan-desc sp-plan-desc-mb d-flex align-items-center justify-content-between">
                          <p style={{ marginBottom: "0", wordBreak: "break-all" }}>
                            {this.state.signee_signing_url ? (
                              <a href={this.state.signee_signing_url} target="_blank" rel="noreferrer">
                                {this.state.signee_signing_url}
                              </a>
                            ) : (
                              <span className="text-muted">Generating secure link…</span>
                            )}
                          </p>
                          <div className="d-flex align-items-center ml-3">
                            {/* Copy Icon */}
                            <a
                              onClick={() => this.copyClientSigneeUrl()}
                              style={{
                                cursor: this.state.signee_signing_url ? "pointer" : "not-allowed",
                                marginRight: "10px",
                                opacity: this.state.signee_signing_url ? 1 : 0.4,
                              }}
                              title="Copy link to clipboard"
                            >
                              {this.state.signee_url_copied ? (
                                <em className="icon ni ni-check text-success" style={{ fontSize: "18px" }}></em>
                              ) : (
                                <em className="icon ni ni-copy" style={{ fontSize: "18px" }}></em>
                              )}
                            </a>
                            {/* Email Icon */}
                            <a
                              onClick={() => {
                                if (this.state.signee_signing_url) {
                                  this.setState({ signee_show_email_form: !this.state.signee_show_email_form });
                                }
                              }}
                              style={{
                                cursor: this.state.signee_signing_url ? "pointer" : "not-allowed",
                                opacity: this.state.signee_signing_url ? 1 : 0.4,
                              }}
                              title="Send via email"
                            >
                              <em className="icon ni ni-mail" style={{ fontSize: "18px" }}></em>
                            </a>
                          </div>
                        </div>

                        {/* Inline Email Form */}
                        {this.state.signee_show_email_form && (
                          <div className="mt-4">
                            {/* Info alert */}
                            <div className="example-alert mb-4">
                              <div className="alert alert-pro alert-info">
                                <div className="alert-text">
                                  <div className="d-flex align-items-center">
                                    <em className="icon ni ni-info text-info mr-1" style={{ fontSize: "20px"}}></em>
                                    <h5>Send Agreement by Email</h5>
                                  </div>
                                  <p>
                                    This will send a new agreement sign request. Any previously sent request for this agreement will be discarded.
                                  </p>
                                </div>
                              </div>
                            </div>

                            <div className="row g-4">
                              {/* To Name */}
                              <div className="col-lg-6">
                                <div className="form-group">
                                  <MutextField
                                    required
                                    id="signee_name"
                                    name="signee_name"
                                    type="text"
                                    label="To Name"
                                    value={this.state.signee_name}
                                    onChange={(e) => this.setState({ signee_name: e.target.value, signee_name_error: "" })}
                                    variant="outlined"
                                    fullWidth
                                    autoComplete="new-password"
                                    inputProps={{ maxLength: 50 }}
                                    error={!!this.state.signee_name_error}
                                    helperText={this.state.signee_name_error || "Pre-filled from client profile. Edit to send to someone else."}
                                  />
                                </div>
                              </div>

                              {/* To Email */}
                              <div className="col-lg-6">
                                <div className="form-group">
                                  <MutextField
                                    required
                                    id="signee_email"
                                    name="signee_email"
                                    type="text"
                                    label="To Email Address"
                                    value={this.state.signee_email}
                                    onChange={(e) => this.setState({ signee_email: e.target.value, signee_email_error: "" })}
                                    variant="outlined"
                                    fullWidth
                                    autoComplete="new-password"
                                    inputProps={{ maxLength: 50 }}
                                    error={!!this.state.signee_email_error}
                                    helperText={this.state.signee_email_error || "Pre-filled from client profile. Edit to send to someone else."}
                                  />
                                </div>
                              </div>

                              {/* Title */}
                              <div className="col-lg-6">
                                <div className="form-group">
                                  <MutextField
                                    id="signee_title"
                                    name="signee_title"
                                    type="text"
                                    label="Title (Optional)"
                                    value={this.state.signee_title}
                                    onChange={(e) => this.setState({ signee_title: e.target.value })}
                                    variant="outlined"
                                    fullWidth
                                    autoComplete="new-password"
                                  />
                                </div>
                              </div>

                              {/* Comment */}
                              <div className="col-lg-12">
                                <div className="form-group">
                                  <textarea
                                    className="form-control"
                                    id="signee_comment"
                                    name="signee_comment"
                                    onChange={this.handleClientSigneeTextArea}
                                    placeholder="Comments (Optional)"
                                    maxLength={1000}
                                    value={this.state.signee_comment}
                                    rows={3}
                                  />
                                  <div className="form-note">
                                    {this.state.signee_comment.length}/{this.state.client_charLimit} characters
                                  </div>
                                  {this.state.client_characterExceededMessage ? (
                                    <div className="form-note">
                                      <code>{this.state.client_characterExceededMessage}</code>
                                    </div>
                                  ) : null}
                                </div>
                              </div>

                              <div className="col-lg-12 text-right">
                                <button
                                  type="button"
                                  className="btn btn-light"
                                  style={{ marginRight: "10px" }}
                                  onClick={() => this.close_client_signee()}
                                >
                                  <em className="icon ni ni-cross-round mr-1"></em> Cancel
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-primary"
                                  onClick={() => this.send_client_email()}
                                  disabled={this.state.client_signee_disabled}
                                >
                                  <em className="icon ni ni-send mr-1"></em> Send Email
                                </button>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* End Send Email to Client Signee Modal */}
          {/* Signee Toast */}
          <NotificationToast
            message={this.state.signeeToastMessage}
            type={this.state.signeeToastType}
            onDismiss={() => this.setState({ signeeToastMessage: "" })}
          />
          {/* FCC Reject / Revoke Toast */}
          <NotificationToast
            message={this.state.fccToastMessage}
            type={this.state.fccToastType}
            onDismiss={() => this.setState({ fccToastMessage: "" })}
          />

          {/* get Submission Link */}
          <div
            className="modal fade zoom"
            tabIndex="-1"
            id="modalSubmissionLink"
          >
            <div
              className="modal-dialog modal-xl modal-dialog-top"
              role="document"
            >
              <div className="modal-content">
                <div className="modal-header">
                  <div
                    className="modal-title"
                    style={{ textAlign: "center", fontSize: "20px" }}
                  >
                    <strong>
                      <em className="icon ni ni-copy"></em> Submission Link{" "}
                    </strong>
                  </div>
                  <a
                    href="#"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <em className="icon ni ni-cross"></em>
                  </a>
                </div>

                <div className="modal-body">
                  {this.state.deleteLoader === true ? (
                    FormLoader()
                  ) : (
                    <>
                      <div>
                        <div className="card card-bordered">
                          <div className="card-inner-group">
                            <div className="card-inner">
                              <div className="sp-plan-head">
                                <h6 className="title">Copy Submission link</h6>
                              </div>
                              {this.state.successMessageSub !== "" ? (
                                <div
                                  className="example-alert "
                                  style={{
                                    marginBottom: "20px",
                                    marginTop: "20px",
                                  }}
                                >
                                  {this.state.successMessageSub && (
                                    <div className="alert alert-success mb-3">
                                      <strong>Success:</strong>{" "}
                                      {this.state.successMessageSub}
                                    </div>
                                  )}
                                </div>
                              ) : null}

                              <div className="sp-plan-desc sp-plan-desc-mb d-flex align-items-center justify-content-between">
                                <p
                                  style={{
                                    marginBottom: "0",
                                    wordBreak: "break-all",
                                  }}
                                >
                                  <a
                                    href={this.state.submission_link}
                                    target="_blank"
                                    rel="noreferrer"
                                  >
                                    {this.state.submission_link}
                                  </a>
                                </p>
                                <div className="d-flex align-items-center ml-3">
                                  {/* Copy Icon */}
                                  <a
                                    onClick={this.copySubmissionLink}
                                    style={{
                                      cursor: "pointer",
                                      marginRight: "10px",
                                    }}
                                  >
                                    {this.state.copiedSub ? (
                                      <em
                                        className="icon ni ni-check"
                                        style={{ fontSize: "18px" }}
                                      ></em>
                                    ) : (
                                      <em
                                        className="icon ni ni-copy"
                                        style={{ fontSize: "18px" }}
                                      ></em>
                                    )}
                                  </a>

                                  {/* Mail Icon */}
                                  <a
                                    onClick={() =>
                                      this.setState({
                                        showMailForm: !this.state.showMailForm,
                                      })
                                    }
                                    style={{ cursor: "pointer" }}
                                  >
                                    <em
                                      className="icon ni ni-mail"
                                      style={{ fontSize: "18px" }}
                                    ></em>
                                  </a>
                                </div>
                              </div>

                              {/* Inline Mail Form */}
                              {this.state.showMailForm && (
                                <div className="mt-4">
                                  
                                  

                                  <div className="form-group">
                                    <label>
                                      Name{" "}
                                      <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={this.state.mailName}
                                      onChange={(e) =>
                                        this.setState({
                                          mailName: e.target.value,
                                        })
                                      }
                                    />
                                  </div>

                                  <div className="form-group">
                                    <label>
                                      Email{" "}
                                      <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input
                                      type="email"
                                      className="form-control"
                                      value={this.state.mailEmail}
                                      onChange={(e) =>
                                        this.setState({
                                          mailEmail: e.target.value,
                                        })
                                      }
                                      autoComplete="off"
                                    />
                                  </div>

                                  <div className="form-group">
                                    <label>
                                      Comment{" "}
                                      <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <textarea
                                      className="form-control"
                                      value={this.state.mailComment}
                                      onChange={(e) =>
                                        this.setState({
                                          mailComment: e.target.value,
                                        })
                                      }
                                    />
                                  </div>

                                  <button
                                    className="btn btn-primary"
                                    onClick={this.sendSubmissionLinkByEmail}
                                  >
                                    Send Link
                                  </button>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>


          </div>
          {/* View Client Submissions */}

          {/* NOTIFICATION MODAL */}
          <div
            className="modal fade"
            tabIndex="-1"
            id="modalNotificationSchedule"
          >
            <div
              className="modal-dialog modal-dialog-top modal-xl"
              role="document"
            >
              <div className="modal-content">
                <a
                  href="#"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <em className="icon ni ni-cross"></em>
                </a>
                <div className="modal-header">
                  <h5 className="modal-title">
                    <em className="icon ni ni-bell"></em>{" "}
                    <span>
                      Schedule Notifications of{" "} <small className='text-muted'>- {this.state.user_details}</small>
                    </span>
                  </h5>
                </div>
                <div className="modal-body">
                  {this.state.missing_form_settings === "Yes" ? (
                    <div className="alert alert-pro alert-danger mb-3">
                      <div className="alert-text">
                        <h6>Missing Form Settings</h6>
                        <p>
                          Form notification settings are missing. Please{" "}
                          <a
                            href={`${APP_URL}forms/edit_form/${this.state.form_accountno}`}
                            className="text-primary"
                            target="_blank"
                          >
                            <b>click here</b>
                          </a>{" "}
                          to update the notification schedule.
                        </p>
                      </div>
                    </div>
                  ) : null}
                  {this.state.missing_form_settings === "No" ? (
                    <>
                      <div className="col-md-12 mb-4">
                        <div className="custom-control custom-control-lg custom-checkbox">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="notification_scheduler"
                            onChange={this.handleNotificationSchedule}
                            value={this.state.notification_scheduler}
                            checked={this.state.notification_scheduler}
                          autoComplete="new-password" />
                          <label
                            className="custom-control-label"
                            for="notification_scheduler"
                          >
                            Enable Notification Scheduler
                          </label>
                        </div>
                      </div>
                      {this.state.schedule_div === true ? (
                        <div className="row g-4 mb-4">
                          <div className="col-md-6">
                            <div className="form-group">
                              <label
                                className="form-label"
                                for="initial_reminder_interval"
                              >
                                Initial Reminder (Hours)
                              </label>
                              <div className="form-control-wrap">
                                <input
                                  type="text"
                                  className="form-control"
                                  id="initial_reminder_interval"
                                  name="initial_reminder_interval"
                                  placeholder="Allowed values between 1 to 24"
                                  onChange={this.handleChangeInitialReminder}
                                  value={this.state.initial_reminder_interval}
                                  maxLength={2}
                                autoComplete="new-password" />
                              </div>
                              <div className="form-note"></div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label
                                className="form-label"
                                for="repeat_interval"
                              >
                                Repeat Reminder (Hours)
                              </label>
                              <div className="form-control-wrap">
                                <input
                                  type="text"
                                  className="form-control"
                                  id="repeat_interval"
                                  name="repeat_interval"
                                  placeholder="Allowed values between 1 to 48"
                                  value={this.state.repeat_interval}
                                  onChange={this.handleChangeRepeatReminder}
                                  maxLength={2}
                                autoComplete="new-password" />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label className="form-label" for="repeat_count">
                                Maximum Days
                              </label>
                              <div className="form-control-wrap">
                                <input
                                  type="text"
                                  className="form-control"
                                  id="repeat_count"
                                  name="repeat_count"
                                  placeholder="Allowed values between 1 to 12 days"
                                  value={this.state.repeat_count}
                                  onChange={this.handleChangeRepeatDays}
                                  maxLength={2}
                                autoComplete="new-password" />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group text-right">
                              {this.state.notification_loader === true ? (
                                <button
                                  className="btn btn-primary"
                                  type="button"
                                  disabled
                                >
                                  <span
                                    className="spinner-grow spinner-grow-sm"
                                    role="status"
                                    aria-hidden="true"
                                  ></span>
                                  <span> Saving... </span>
                                </button>
                              ) : (
                                <button
                                  type="button"
                                  onClick={() => this.submitNotifications()}
                                  className="btn btn-primary"
                                >
                                  Submit
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      ) : null}
                    </>
                  ) : null}
                </div>
              </div>
            </div>
          </div>

          {/* NOTIFICATION MODAL */}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    defaultSettings: state.settings,
    is_msa_signed: state.is_msa_signed,
    userRoleItems: state.userRoleItems,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addSettings: (payload) => dispatch(addSettings(payload)),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(ViewClient));
